unit Contracts;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.ComCtrls,
  Vcl.StdCtrls, WEBLib.StdCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, WEBLib.DBCtrls, Vcl.Mask, WEBLib.Mask,
  VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  System.Rtti, VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData,
  VCL.TMSFNCDataGridBase, VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, VCL.TMSFNCBitmapContainer,
  WEBLib.Buttons, WEBLib.REST;

type
  TfrmContracts = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    wpcContractInfo: TPageControl;
    wpcsClosedContracts: TTabSheet;
    wpcsContractInportSetup: TTabSheet;
    wpcsActiveContracts: TTabSheet;
    wpcsGlobalPriceIncrease: TTabSheet;
    WebPanel4: TPanel;
    WebPanel5: TPanel;
    WebPanel7: TPanel;
    wpcActiveContracts: TPageControl;
    wpcsContractInfo: TTabSheet;
    wpcsAdditionalInfo: TTabSheet;
    WebPanel8: TPanel;
    WebPanel9: TPanel;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    dbedtClientName: TDBEdit;
    dbedtShortdescription: TDBEdit;
    dbedtLongDescription: TDBEdit;
    WebDBEdit5: TDBEdit;
    dbedtLoadType: TDBEdit;
    WebDBRadioGroup1: TDBRadioGroup;
    WebGroupBox1: TGroupBox;
    WebGroupBox2: TGroupBox;
    WebDBEdit7: TDBEdit;
    WebDBEdit8: TDBEdit;
    WebDBEdit9: TDBEdit;
    WebDBEdit10: TDBEdit;
    WebDBEdit11: TDBEdit;
    WebDBEdit12: TDBEdit;
    WebDBEdit13: TDBEdit;
    WebDBEdit14: TDBEdit;
    WebButton3: TButton;
    WebButton4: TButton;
    WebButton5: TButton;
    WebButton6: TButton;
    WebButton7: TButton;
    WebButton8: TButton;
    WebButton9: TButton;
    WebButton10: TButton;
    wcAContracts: TXDataWebClient;
    wdsAContracts: TXDataWebDataSet;
    dsAContracts: TDataSource;
    WebGroupBox3: TGroupBox;
    WebDBEdit15: TDBEdit;
    WebButton11: TButton;
    dbedtCpatureType: TDBEdit;
    WebDBEdit17: TDBEdit;
    WebDBEdit18: TDBEdit;
    WebDBEdit19: TDBEdit;
    WebDBEdit20: TDBEdit;
    WebDBEdit21: TDBEdit;
    WebDBEdit23: TDBEdit;
    WebDBEdit24: TDBEdit;
    WebDBEdit25: TDBEdit;
    WebDBDateTimePicker1: TDBDateTimePicker;
    WebButton12: TButton;
    cbxDedicated: TDBCheckBox;
    cbxADHOC: TDBCheckBox;
    WebButton13: TButton;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebDBEdit22: TDBEdit;
    WebDBEdit26: TDBEdit;
    WebDBEdit27: TDBEdit;
    WebLabel16: TLabel;
    WebLabel17: TLabel;
    WebLabel18: TLabel;
    WebDBMaskEdit1: TDBMaskEdit;
    WebLabel19: TLabel;
    WebButton14: TButton;
    WebButton15: TButton;
    WebButton16: TButton;
    WebDBEdit28: TDBEdit;
    WebDBEdit29: TDBEdit;
    WebDBEdit30: TDBEdit;
    WebDBEdit31: TDBEdit;
    WebDBEdit32: TDBEdit;
    WebDBEdit33: TDBEdit;
    WebDBEdit34: TDBEdit;
    WebDBEdit35: TDBEdit;
    WebDBEdit36: TDBEdit;
    WebDBEdit37: TDBEdit;
    WebLabel20: TLabel;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebLabel24: TLabel;
    WebLabel25: TLabel;
    WebLabel26: TLabel;
    WebLabel27: TLabel;
    WebLabel28: TLabel;
    WebLabel29: TLabel;
    wpcsBillingInformation: TTabSheet;
    WebPanel11: TPanel;
    WebGroupBox4: TGroupBox;
    WebDBEdit38: TDBEdit;
    WebLabel30: TLabel;
    cbxMiltiLoadInvopice: TDBCheckBox;
    gbMiltiLoadInv: TGroupBox;
    WebDBCheckBox4: TDBCheckBox;
    WebDBCheckBox5: TDBCheckBox;
    WebPageControl1: TPageControl;
    wpcsSageLinkInformation1: TTabSheet;
    wpcsSageLinkInformation2: TTabSheet;
    WebPanel12: TPanel;
    WebPanel13: TPanel;
    WebDBCheckBox6: TDBCheckBox;
    WebLabel31: TLabel;
    WebDBEdit39: TDBEdit;
    WebDBEdit40: TDBEdit;
    WebDBCheckBox7: TDBCheckBox;
    WebLabel32: TLabel;
    WebDBEdit41: TDBEdit;
    WebDBEdit42: TDBEdit;
    WebLabel33: TLabel;
    WebDBEdit44: TDBEdit;
    WebButton18: TButton;
    WebLabel34: TLabel;
    WebDBEdit46: TDBEdit;
    WebButton20: TButton;
    WebDBRadioGroup2: TDBRadioGroup;
    WebDBEdit47: TDBEdit;
    WebGroupBox6: TGroupBox;
    WebDBCheckBox8: TDBCheckBox;
    WebDBCheckBox9: TDBCheckBox;
    WebDBCheckBox10: TDBCheckBox;
    WebDBCheckBox11: TDBCheckBox;
    WebDBCheckBox12: TDBCheckBox;
    WebLabel35: TLabel;
    WebLabel36: TLabel;
    WebLabel37: TLabel;
    edtInvoiceSelection: TDBEdit;
    WebDBEdit49: TDBEdit;
    WebDBEdit50: TDBEdit;
    WebButton21: TButton;
    WebButton22: TButton;
    WebButton23: TButton;
    WebDBCheckBox13: TDBCheckBox;
    WebDBCheckBox14: TDBCheckBox;
    WebDBCheckBox15: TDBCheckBox;
    WebDBCheckBox16: TDBCheckBox;
    WebDBCheckBox17: TDBCheckBox;
    WebDBCheckBox18: TDBCheckBox;
    WebDBCheckBox19: TDBCheckBox;
    WebDBCheckBox20: TDBCheckBox;
    WebDBCheckBox21: TDBCheckBox;
    WebDBCheckBox22: TDBCheckBox;
    WebDBCheckBox23: TDBCheckBox;
    WebDBCheckBox24: TDBCheckBox;
    WebDBCheckBox25: TDBCheckBox;
    WebDBCheckBox26: TDBCheckBox;
    WebDBCheckBox27: TDBCheckBox;
    WebDBCheckBox28: TDBCheckBox;
    WebDBCheckBox29: TDBCheckBox;
    WebDBCheckBox30: TDBCheckBox;
    WebGroupBox7: TGroupBox;
    WebLabel38: TLabel;
    WebLabel39: TLabel;
    WebLabel40: TLabel;
    WebDBEdit51: TDBEdit;
    WebDBEdit52: TDBEdit;
    WebDBEdit53: TDBEdit;
    WebButton24: TButton;
    WebButton25: TButton;
    WebButton26: TButton;
    wpcsContractPricing: TTabSheet;
    WebPanel14: TPanel;
    WebPanel15: TPanel;
    WebButton27: TButton;
    WebButton29: TButton;
    WebButton31: TButton;
    WebButton32: TButton;
    dgContractPrices: TTMSFNCDataGrid;
    dgdbaContractPrices: TTMSFNCDataGridDatabaseAdapter;
    wcContractPrices: TXDataWebClient;
    wdsContractPrices: TXDataWebDataSet;
    dsContractPrices: TDataSource;
    BitMapContainer1: TTMSFNCBitmapContainer;
    wpcsDirections: TTabSheet;
    WebPanel16: TPanel;
    WebDBMemo1: TDBMemo;
    WebButton33: TButton;
    WebButton34: TButton;
    WebPanel17: TPanel;
    btnOpenContract: TButton;
    WebLabel41: TLabel;
    WebButton36: TButton;
    WebLabel42: TLabel;
    edtSearchContractDescription: TEdit;
    dgClosedContracts: TTMSFNCDataGrid;
    WebPanel21: TPanel;
    WebGroupBox11: TGroupBox;
    WebGroupBox12: TGroupBox;
    WebRadioGroup1: TRadioGroup;
    WebPanel22: TPanel;
    WebPanel23: TPanel;
    TMSFNCDataGrid4: TTMSFNCDataGrid;
    WebPanel24: TPanel;
    WebDBEdit65: TDBEdit;
    WebButton42: TButton;
    WebRadioGroup2: TRadioGroup;
    WebButton43: TButton;
    WebButton44: TButton;
    WebButton45: TButton;
    WebButton46: TButton;
    WebButton47: TButton;
    WebLabel54: TLabel;
    WebLabel56: TLabel;
    WebLabel58: TLabel;
    WebLabel60: TLabel;
    WebLabel62: TLabel;
    WebLabel64: TLabel;
    WebLabel66: TLabel;
    WebLabel68: TLabel;
    WebDBLabel4: TDBLabel;
    WebDBLabel5: TDBLabel;
    WebDBLabel6: TDBLabel;
    WebDBLabel7: TDBLabel;
    WebDBLabel8: TDBLabel;
    WebDBLabel9: TDBLabel;
    WebDBLabel10: TDBLabel;
    WebDBLabel11: TDBLabel;
    wdsAContractsCONTRACTNO: TIntegerField;
    wdsAContractsCONTRACTNAME: TStringField;
    wdsAContractsDEBCODE: TStringField;
    wdsAContractsCOMMODITIESNO: TIntegerField;
    wdsAContractsLOADCOUNTRYNO: TIntegerField;
    wdsAContractsLOADPROVINCENO: TIntegerField;
    wdsAContractsLOADCITYNO: TIntegerField;
    wdsAContractsLOADINGNO: TIntegerField;
    wdsAContractsOFFLOADCOUNTRYNO: TIntegerField;
    wdsAContractsOFFLOADPROVINCENO: TIntegerField;
    wdsAContractsOFFLOADCITYNO: TIntegerField;
    wdsAContractsOFFLOADINGNO: TIntegerField;
    wdsAContractsINVLOADING: TStringField;
    wdsAContractsINVOFFLOADING: TStringField;
    wdsAContractsTOTALTONS: TFloatField;
    wdsAContractsTOTALTONSORDER: TFloatField;
    wdsAContractsTOTALTONSLOADED: TFloatField;
    wdsAContractsTOTALTONSOFFLOADED: TFloatField;
    wdsAContractsTOTALTONSINVOICED: TFloatField;
    wdsAContractsCOMPLETED: TStringField;
    wdsAContractsCONTROLLER: TStringField;
    wdsAContractsAVGTONS: TFloatField;
    wdsAContractsTOTALLOADS: TIntegerField;
    wdsAContractsLOADSORDER: TIntegerField;
    wdsAContractsLOADSLOADED: TIntegerField;
    wdsAContractsLOADSOFFLOADED: TIntegerField;
    wdsAContractsLOADSINVOICED: TIntegerField;
    wdsAContractsPAYMENTTERMS: TIntegerField;
    wdsAContractsPAYMENTTYPE: TIntegerField;
    wdsAContractsADDHOC: TStringField;
    wdsAContractsDEDICATED: TStringField;
    wdsAContractsORDERNO: TStringField;
    wdsAContractsINVVAT: TStringField;
    wdsAContractsMULTILOADINV: TStringField;
    wdsAContractsSENDED: TStringField;
    wdsAContractsPRELISTING: TStringField;
    wdsAContractsPOSTLISTING: TStringField;
    wdsAContractsINVOICETYPE: TStringField;
    wdsAContractsDISTANCE: TFloatField;
    wdsAContractsDRIVERRATIO: TSmallintField;
    wdsAContractsCUTOFF1: TSmallintField;
    wdsAContractsCUTOFFPERIOD1: TIntegerField;
    wdsAContractsCUTOFF2: TSmallintField;
    wdsAContractsCUTOFFPERIOD2: TIntegerField;
    wdsAContractsSAGEINVENTORY: TStringField;
    wdsAContractsSAGEGL: TStringField;
    wdsAContractsSAGECODE: TStringField;
    wdsAContractsSAGEEXPCODE: TStringField;
    wdsAContractsSTRATERATE: TStringField;
    wdsAContractsCHGOFFLOAD: TStringField;
    wdsAContractsCHGPRICE: TStringField;
    wdsAContractsCAPTURETONS: TStringField;
    wdsAContractsINVOICETONS: TStringField;
    wdsAContractsCHGSUBPRICE: TStringField;
    wdsAContractsMAXLOADORDERS: TIntegerField;
    wdsAContractsADDDESCRIPTION: TStringField;
    wdsAContractsVARIANCETYPE: TIntegerField;
    wdsAContractsVARIANCEVALUE: TFloatField;
    wdsAContractsPRINTLC: TStringField;
    wdsAContractsPRINTDN: TStringField;
    wdsAContractsPRINTTS: TStringField;
    wdsAContractsDNTYPE: TStringField;
    wdsAContractsTSTYPE: TStringField;
    wdsAContractsSHORTDESC: TStringField;
    wdsAContractsOLDLOADSCREEN: TStringField;
    wdsAContractsSHOWBOOKINGS: TStringField;
    wdsAContractsSHOWADDITIONAL: TStringField;
    wdsAContractsPRICETYPE: TIntegerField;
    wdsAContractsUSEDOCKETINVNO: TStringField;
    wdsAContractsSAGECODE2: TStringField;
    wdsAContractsSAGEEXPCODE2: TStringField;
    wdsAContractsSAGEINVENTORY2: TStringField;
    wdsAContractsSAGEGL2: TStringField;
    wdsAContractsHAULAGETYPE: TStringField;
    wdsAContractsLINKZEROML: TStringField;
    wdsAContractsATTACHEDEMAIL: TStringField;
    wdsAContractsCLIENTLINKCONTRACT: TIntegerField;
    wdsAContractsQUOTEREFNO: TStringField;
    wdsAContractsSORTLOADDATE: TStringField;
    wdsAContractsSORTOFFDATE: TStringField;
    wdsAContractsSORTLOADWAY: TStringField;
    wdsAContractsSORTOFFWAY: TStringField;
    wdsAContractsSORTDOCKET: TStringField;
    wdsAContractsSINVVAT: TStringField;
    wdsAContractsLOADINSTRUCTQTY: TFloatField;
    wdsAContractsCHGLOAD: TStringField;
    wdsAContractssoanalysiscat1: TStringField;
    wdsAContractssoanalysiscat2: TStringField;
    wdsAContractssoanalysiscat3: TStringField;
    wdsAContractsmaxdrivetime: TStringField;
    wdsAContractsmaxtrafeltime: TTimeField;
    wdsAContractsfirstwarning: TIntegerField;
    wdsAContractssecondwarning: TIntegerField;
    wdsAContractsslots: TIntegerField;
    WebDBLabel12: TDBLabel;
    WebDBLabel13: TDBLabel;
    wdsAContractsSTARTDATE: TDateField;
    wdsAContractsCOMPDATE: TDateField;
    wdsAContractsSENDEDDATE: TDateField;
    WebDateTimePicker1: TDateTimePicker;
    wpcsAllActiveContracts: TTabSheet;
    WebPanel25: TPanel;
    WebPanel26: TPanel;
    WebButton48: TButton;
    btnSaveContract5: TButton;
    WebButton50: TButton;
    WebPanel27: TPanel;
    WebButton51: TButton;
    btnSaveContract4: TButton;
    WebButton53: TButton;
    WebPanel10: TPanel;
    WebButton54: TButton;
    btnSaveContract3: TButton;
    WebButton56: TButton;
    WebPanel28: TPanel;
    WebButton57: TButton;
    btnSaveContract2: TButton;
    WebButton59: TButton;
    WebPanel29: TPanel;
    WebButton60: TButton;
    btnSaveContract1: TButton;
    WebButton62: TButton;
    WebPanel30: TPanel;
    dgActiveContractsList: TTMSFNCDataGrid;
    dgdbaActiveContractsList: TTMSFNCDataGridDatabaseAdapter;
    WebButton63: TButton;
    WebButton65: TButton;
    btnCloseContract: TButton;
    WebButton67: TButton;
    edtSearchDescription: TEdit;
    WebButton68: TButton;
    WebLabel55: TLabel;
    WebLabel57: TLabel;
    WebPanel31: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    edtActiveContractsPageCount: TEdit;
    WebSpeedButton5: TSpeedButton;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton7: TSpeedButton;
    WebSpeedButton8: TSpeedButton;
    edtContractPriceListPC: TEdit;
    wdsContractPricesAUTONO: TIntegerField;
    wdsContractPricesCONTRACTNO: TIntegerField;
    wdsContractPricesSTARTDATE: TStringField;
    wdsContractPricesENDDATE: TStringField;
    wdsContractPricesCOSTPRICE: TFloatField;
    wdsContractPricesSUBPRICE: TFloatField;
    wdsContractPricesDEDPRICE: TFloatField;
    wdsContractPricesSPEPRICE: TFloatField;
    wdsContractPricesCONFIREMED: TStringField;
    wdsContractPricesPRICELOADDATE: TStringField;
    wdsContractPricesPRICELOADBY: TStringField;
    wdsContractPricesPRICECONFIRMDATE: TStringField;
    wdsContractPricesPRICECONFIRMBY: TStringField;
    wdsContractPriceskmsprice: TFloatField;
    wdsContractPricestollprice: TFloatField;
    wdsAContractsDEB_CODE: TStringField;
    wdsAContractsDEB_NAME: TStringField;
    wdsAContractsSUSPENDED: TStringField;
    wdsAContractsCREDITLIMIT: TFloatField;
    wdsAContractsORDERBALANCE: TFloatField;
    wdsAContractsINVOICEBALANCE: TFloatField;
    wdsAContractsAVAILIBLECL: TFloatField;
    wdsAContractsCLIENTMULTILOADINV: TStringField;
    wdsAContractsMULTILOADDESC: TStringField;
    wdsAContractsCLIENTINVOICETYPE: TStringField;
    wdsAContractsMULTICONTRACT: TStringField;
    wdsAContractsCLIENTLINKED: TStringField;
    wdsAContractsCLIENTEMAIL: TStringField;
    wdsAContractsLINKEDCONFIG: TStringField;
    wdsAContractsACCOUNTNUMBER: TStringField;
    wdsAContractsMAINBALANCE: TFloatField;
    wdsAContractsMAINTENANCELINKACCOUNT: TStringField;
    wdsAContractsEXPORTLIST: TStringField;
    wdsAContractsEXPORTLOADS: TStringField;
    wdsAContractsRENAMEFIELD: TStringField;
    wdsAContractsEXPORTPATH: TStringField;
    wdsAContractsPREVCL: TFloatField;
    wdsAContractsSECUREBOOK: TStringField;
    wdsAContractsQUOTESYSTEM: TStringField;
    wdsAContractsQUOTETYPE: TStringField;
    wdsAContractsEMAILLOADDOCS: TStringField;
    wdsAContractsSTATEMENTTYPE: TStringField;
    wdsAContractsSHOWRECLOADS: TStringField;
    wdsAContractsLINKEDINVTYPE: TStringField;
    wdsAContractsDEFINVCOMPNO: TIntegerField;
    wdsAContractsinvoicetypenoncon: TStringField;
    wdsAContractssinglenoncon: TStringField;
    wdsAContractsLINKSERIAL: TStringField;
    wdsAContractsLINKAPI: TStringField;
    wdsAContractsserverip: TStringField;
    wdsAContractsserverport: TIntegerField;
    wdsAContractsserveruser: TStringField;
    wdsAContractsserverpassword: TStringField;
    wdsAContractsserveraccount: TStringField;
    wdsAContractsaltserverip: TStringField;
    wdsAContractsaltserverport: TIntegerField;
    wdsAContractsaltserveruser: TStringField;
    wdsAContractsaltserverpassword: TStringField;
    wdsAContractsserversystem: TStringField;
    wdsAContractsNo: TIntegerField;
    wdsAContractsNAME: TStringField;
    wdsAContractsITEMCODE: TStringField;
    wdsAContractsSTORE: TIntegerField;
    wdsAContractsUNITNUMBER: TStringField;
    wdsAContractsDENSITY: TFloatField;
    wdsClosedContracts: TXDataWebDataSet;
    IntegerField1: TIntegerField;
    StringField1: TStringField;
    StringField2: TStringField;
    IntegerField2: TIntegerField;
    IntegerField3: TIntegerField;
    IntegerField4: TIntegerField;
    IntegerField5: TIntegerField;
    IntegerField6: TIntegerField;
    IntegerField7: TIntegerField;
    IntegerField8: TIntegerField;
    IntegerField9: TIntegerField;
    IntegerField10: TIntegerField;
    StringField3: TStringField;
    StringField4: TStringField;
    FloatField1: TFloatField;
    FloatField2: TFloatField;
    FloatField3: TFloatField;
    FloatField4: TFloatField;
    FloatField5: TFloatField;
    StringField5: TStringField;
    StringField6: TStringField;
    FloatField6: TFloatField;
    IntegerField11: TIntegerField;
    IntegerField12: TIntegerField;
    IntegerField13: TIntegerField;
    IntegerField14: TIntegerField;
    IntegerField15: TIntegerField;
    IntegerField16: TIntegerField;
    IntegerField17: TIntegerField;
    StringField7: TStringField;
    StringField8: TStringField;
    StringField9: TStringField;
    StringField10: TStringField;
    StringField11: TStringField;
    StringField12: TStringField;
    StringField13: TStringField;
    StringField14: TStringField;
    StringField15: TStringField;
    FloatField7: TFloatField;
    SmallintField1: TSmallintField;
    SmallintField2: TSmallintField;
    IntegerField18: TIntegerField;
    SmallintField3: TSmallintField;
    IntegerField19: TIntegerField;
    StringField16: TStringField;
    StringField17: TStringField;
    StringField18: TStringField;
    StringField19: TStringField;
    StringField20: TStringField;
    StringField21: TStringField;
    StringField22: TStringField;
    StringField23: TStringField;
    StringField24: TStringField;
    StringField25: TStringField;
    IntegerField20: TIntegerField;
    StringField26: TStringField;
    IntegerField21: TIntegerField;
    FloatField8: TFloatField;
    StringField27: TStringField;
    StringField28: TStringField;
    StringField29: TStringField;
    StringField30: TStringField;
    StringField31: TStringField;
    StringField32: TStringField;
    StringField33: TStringField;
    StringField34: TStringField;
    StringField35: TStringField;
    IntegerField22: TIntegerField;
    StringField36: TStringField;
    StringField37: TStringField;
    StringField38: TStringField;
    StringField39: TStringField;
    StringField40: TStringField;
    StringField41: TStringField;
    StringField42: TStringField;
    StringField43: TStringField;
    IntegerField23: TIntegerField;
    StringField44: TStringField;
    StringField45: TStringField;
    StringField46: TStringField;
    StringField47: TStringField;
    StringField48: TStringField;
    StringField49: TStringField;
    StringField50: TStringField;
    FloatField9: TFloatField;
    StringField51: TStringField;
    StringField52: TStringField;
    StringField53: TStringField;
    StringField54: TStringField;
    StringField55: TStringField;
    TimeField1: TTimeField;
    IntegerField24: TIntegerField;
    IntegerField25: TIntegerField;
    IntegerField26: TIntegerField;
    DateField1: TDateField;
    DateField2: TDateField;
    DateField3: TDateField;
    StringField56: TStringField;
    StringField57: TStringField;
    StringField58: TStringField;
    FloatField10: TFloatField;
    FloatField11: TFloatField;
    FloatField12: TFloatField;
    FloatField13: TFloatField;
    StringField59: TStringField;
    StringField60: TStringField;
    StringField61: TStringField;
    StringField62: TStringField;
    StringField63: TStringField;
    StringField64: TStringField;
    StringField65: TStringField;
    StringField66: TStringField;
    FloatField14: TFloatField;
    StringField67: TStringField;
    StringField68: TStringField;
    StringField69: TStringField;
    StringField70: TStringField;
    StringField71: TStringField;
    FloatField15: TFloatField;
    StringField72: TStringField;
    StringField73: TStringField;
    StringField74: TStringField;
    StringField75: TStringField;
    StringField76: TStringField;
    StringField77: TStringField;
    StringField78: TStringField;
    IntegerField27: TIntegerField;
    StringField79: TStringField;
    StringField80: TStringField;
    StringField81: TStringField;
    StringField82: TStringField;
    StringField83: TStringField;
    IntegerField28: TIntegerField;
    StringField84: TStringField;
    StringField85: TStringField;
    StringField86: TStringField;
    StringField87: TStringField;
    IntegerField29: TIntegerField;
    StringField88: TStringField;
    StringField89: TStringField;
    StringField90: TStringField;
    IntegerField30: TIntegerField;
    StringField91: TStringField;
    StringField92: TStringField;
    IntegerField31: TIntegerField;
    StringField93: TStringField;
    FloatField16: TFloatField;
    wcClosedContracts: TXDataWebClient;
    WebPanel32: TPanel;
    edtClosedContractsPC: TEdit;
    WebSpeedButton9: TSpeedButton;
    WebSpeedButton10: TSpeedButton;
    WebSpeedButton11: TSpeedButton;
    WebSpeedButton12: TSpeedButton;
    edtSearchActiveContracts: TEdit;
    dsClosedContracts: TDataSource;
    edtSearchClosedContracts: TEdit;
    wdsAContractsLoadCountryName: TStringField;
    wdsAContractsLoadProvinceName: TStringField;
    wdsAContractsLoadCityName: TStringField;
    wdsAContractsLoadInfoName: TStringField;
    wdsAContractsOffLoadCountryName: TStringField;
    wdsAContractsOffLoadProvinceName: TStringField;
    wdsAContractsOffLoadCityName: TStringField;
    wdsAContractsOffLoadInfoName: TStringField;
    msgdlgContractPriceList: TMessageDlg;
    WebRESTClient1: TRESTClient;
    dgdbaClosedContracts: TTMSFNCDataGridDatabaseAdapter;
    wdsAContractsCommodityName: TStringField;
    wdsAContractsPayTermsName: TStringField;
    wdsAContractsCONTROLLERName: TStringField;
    WebDBComboBox1: TDBComboBox;
    WebDBComboBox2: TDBComboBox;
    wdsAContractsCutOffPeriodDesc1: TStringField;
    wdsAContractsCutOffPeriodDesc2: TIntegerField;
    wdsAContractsCutOffPeriodDesc22: TStringField;
    cbbInvoiceSelection: TDBComboBox;
    WebPanel6: TPanel;
    WebPanel18: TPanel;
    WebPanel19: TPanel;
    dgContractImportsetup: TTMSFNCDataGrid;
    edtActiveContractsImportSearch: TEdit;
    WebButton17: TButton;
    WebRadioGroup3: TRadioGroup;
    WebButton19: TButton;
    WebButton28: TButton;
    WebLabel43: TLabel;
    wcAContractImportSetup: TXDataWebClient;
    wdsAContractImportSetup: TXDataWebDataSet;
    IntegerField32: TIntegerField;
    StringField94: TStringField;
    StringField95: TStringField;
    IntegerField33: TIntegerField;
    IntegerField34: TIntegerField;
    IntegerField35: TIntegerField;
    IntegerField36: TIntegerField;
    IntegerField37: TIntegerField;
    IntegerField38: TIntegerField;
    IntegerField39: TIntegerField;
    IntegerField40: TIntegerField;
    IntegerField41: TIntegerField;
    StringField96: TStringField;
    StringField97: TStringField;
    FloatField17: TFloatField;
    FloatField18: TFloatField;
    FloatField19: TFloatField;
    FloatField20: TFloatField;
    FloatField21: TFloatField;
    StringField98: TStringField;
    StringField99: TStringField;
    FloatField22: TFloatField;
    IntegerField42: TIntegerField;
    IntegerField43: TIntegerField;
    IntegerField44: TIntegerField;
    IntegerField45: TIntegerField;
    IntegerField46: TIntegerField;
    IntegerField47: TIntegerField;
    IntegerField48: TIntegerField;
    StringField100: TStringField;
    StringField101: TStringField;
    StringField102: TStringField;
    StringField103: TStringField;
    StringField104: TStringField;
    StringField105: TStringField;
    StringField106: TStringField;
    StringField107: TStringField;
    StringField108: TStringField;
    FloatField23: TFloatField;
    SmallintField4: TSmallintField;
    SmallintField5: TSmallintField;
    IntegerField49: TIntegerField;
    SmallintField6: TSmallintField;
    IntegerField50: TIntegerField;
    StringField109: TStringField;
    StringField110: TStringField;
    StringField111: TStringField;
    StringField112: TStringField;
    StringField113: TStringField;
    StringField114: TStringField;
    StringField115: TStringField;
    StringField116: TStringField;
    StringField117: TStringField;
    StringField118: TStringField;
    IntegerField51: TIntegerField;
    StringField119: TStringField;
    IntegerField52: TIntegerField;
    FloatField24: TFloatField;
    StringField120: TStringField;
    StringField121: TStringField;
    StringField122: TStringField;
    StringField123: TStringField;
    StringField124: TStringField;
    StringField125: TStringField;
    StringField126: TStringField;
    StringField127: TStringField;
    StringField128: TStringField;
    IntegerField53: TIntegerField;
    StringField129: TStringField;
    StringField130: TStringField;
    StringField131: TStringField;
    StringField132: TStringField;
    StringField133: TStringField;
    StringField134: TStringField;
    StringField135: TStringField;
    StringField136: TStringField;
    IntegerField54: TIntegerField;
    StringField137: TStringField;
    StringField138: TStringField;
    StringField139: TStringField;
    StringField140: TStringField;
    StringField141: TStringField;
    StringField142: TStringField;
    StringField143: TStringField;
    FloatField25: TFloatField;
    StringField144: TStringField;
    StringField145: TStringField;
    StringField146: TStringField;
    StringField147: TStringField;
    StringField148: TStringField;
    TimeField2: TTimeField;
    IntegerField55: TIntegerField;
    IntegerField56: TIntegerField;
    IntegerField57: TIntegerField;
    DateField4: TDateField;
    DateField5: TDateField;
    DateField6: TDateField;
    StringField149: TStringField;
    StringField150: TStringField;
    StringField151: TStringField;
    FloatField26: TFloatField;
    FloatField27: TFloatField;
    FloatField28: TFloatField;
    FloatField29: TFloatField;
    StringField152: TStringField;
    StringField153: TStringField;
    StringField154: TStringField;
    StringField155: TStringField;
    StringField156: TStringField;
    StringField157: TStringField;
    StringField158: TStringField;
    StringField159: TStringField;
    FloatField30: TFloatField;
    StringField160: TStringField;
    StringField161: TStringField;
    StringField162: TStringField;
    StringField163: TStringField;
    StringField164: TStringField;
    FloatField31: TFloatField;
    StringField165: TStringField;
    StringField166: TStringField;
    StringField167: TStringField;
    StringField168: TStringField;
    StringField169: TStringField;
    StringField170: TStringField;
    StringField171: TStringField;
    IntegerField58: TIntegerField;
    StringField172: TStringField;
    StringField173: TStringField;
    StringField174: TStringField;
    StringField175: TStringField;
    StringField176: TStringField;
    IntegerField59: TIntegerField;
    StringField177: TStringField;
    StringField178: TStringField;
    StringField179: TStringField;
    StringField180: TStringField;
    IntegerField60: TIntegerField;
    StringField181: TStringField;
    StringField182: TStringField;
    StringField183: TStringField;
    IntegerField61: TIntegerField;
    StringField184: TStringField;
    StringField185: TStringField;
    IntegerField62: TIntegerField;
    StringField186: TStringField;
    FloatField32: TFloatField;
    StringField187: TStringField;
    StringField188: TStringField;
    StringField189: TStringField;
    StringField190: TStringField;
    StringField191: TStringField;
    StringField192: TStringField;
    StringField193: TStringField;
    StringField194: TStringField;
    StringField195: TStringField;
    StringField196: TStringField;
    StringField197: TStringField;
    StringField198: TStringField;
    IntegerField63: TIntegerField;
    StringField199: TStringField;
    dsAContractImportSetup: TDataSource;
    dgdbaContractImportSetup: TTMSFNCDataGridDatabaseAdapter;
    WebSpeedButton13: TSpeedButton;
    WebSpeedButton14: TSpeedButton;
    WebSpeedButton15: TSpeedButton;
    WebSpeedButton16: TSpeedButton;
    edtActiveContractImportPC: TEdit;
    WebButton30: TButton;
    wdsAContractsClientName: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure btnSaveContract1Click(Sender: TObject);
    procedure btnSaveContract2Click(Sender: TObject);
    procedure btnSaveContract3Click(Sender: TObject);
    procedure btnSaveContract4Click(Sender: TObject);
    procedure btnSaveContract5Click(Sender: TObject);
    procedure edtSearchDescriptionChange(Sender: TObject);
    procedure WebButton63Click(Sender: TObject);
    procedure WebButton64Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebButton3Click(Sender: TObject);
    procedure WebButton4Click(Sender: TObject);
    procedure WebButton5Click(Sender: TObject);
    procedure WebButton6Click(Sender: TObject);
    procedure WebButton10Click(Sender: TObject);
    procedure WebButton9Click(Sender: TObject);
    procedure WebButton8Click(Sender: TObject);
    procedure WebButton7Click(Sender: TObject);
    procedure WebSpeedButton9Click(Sender: TObject);
    procedure WebSpeedButton10Click(Sender: TObject);
    procedure WebSpeedButton11Click(Sender: TObject);
    procedure WebSpeedButton12Click(Sender: TObject);
    procedure WebButton36Click(Sender: TObject);
    procedure edtSearchContractDescriptionChange(Sender: TObject);
    procedure WebButton67Click(Sender: TObject);
    procedure WebButton62Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure dgActiveContractsListGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure dgActiveContractsListCellClick(Sender: TObject; AColumn,
      ARow: Integer);
    procedure WebDBCheckBox13Click(Sender: TObject);
    procedure WebDBCheckBox14Click(Sender: TObject);
    procedure WebDBCheckBox15Click(Sender: TObject);
    procedure WebDBCheckBox16Click(Sender: TObject);
    procedure WebDBCheckBox17Click(Sender: TObject);
    procedure WebDBCheckBox18Click(Sender: TObject);
    procedure WebDBCheckBox19Click(Sender: TObject);
    procedure WebDBCheckBox20Click(Sender: TObject);
    procedure WebDBCheckBox21Click(Sender: TObject);
    procedure WebDBCheckBox22Click(Sender: TObject);
    procedure WebDBCheckBox24Click(Sender: TObject);
    procedure WebDBCheckBox23Click(Sender: TObject);
    procedure WebDBCheckBox25Click(Sender: TObject);
    procedure WebDBCheckBox26Click(Sender: TObject);
    procedure WebDBCheckBox27Click(Sender: TObject);
    procedure WebDBCheckBox28Click(Sender: TObject);
    procedure WebDBCheckBox29Click(Sender: TObject);
    procedure WebDBCheckBox30Click(Sender: TObject);
    procedure dgContractPricesGetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure WebButton59Click(Sender: TObject);
    procedure WebButton56Click(Sender: TObject);
    procedure WebButton53Click(Sender: TObject);
    procedure WebButton50Click(Sender: TObject);
    procedure dgContractPricesCellClick(Sender: TObject; AColumn,
      ARow: Integer);
    procedure WebButton27Click(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure dgActiveContractsListSelectCell(Sender: TObject; AStartCell,
      AEndCell: TTMSFNCDataGridCellCoord);
    procedure dgContractPricesSelectCell(Sender: TObject; AStartCell,
      AEndCell: TTMSFNCDataGridCellCoord);
    procedure WebButton29Click(Sender: TObject);
    procedure dgContractPricesGetCellLayout(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
    procedure WebButton31Click(Sender: TObject);
    procedure btnCloseContractClick(Sender: TObject);
    procedure btnOpenContractClick(Sender: TObject);
    procedure dgClosedContractsSelectCell(Sender: TObject; AStartCell,
      AEndCell: TTMSFNCDataGridCellCoord);
    procedure dgClosedContractsCellClick(Sender: TObject; AColumn,
      ARow: Integer);
    procedure WebButton34Click(Sender: TObject);
    procedure cbxDedicatedClick(Sender: TObject);
    procedure cbxADHOCClick(Sender: TObject);
    procedure WebButton33Click(Sender: TObject);
    procedure WebButton15Click(Sender: TObject);
    procedure WebButton16Click(Sender: TObject);
    procedure WebButton12Click(Sender: TObject);
    procedure WebButton14Click(Sender: TObject);
    procedure WebButton18Click(Sender: TObject);
    procedure WebButton20Click(Sender: TObject);
    procedure cbxMiltiLoadInvopiceClick(Sender: TObject);
    procedure WebButton28Click(Sender: TObject);
    procedure WebSpeedButton13Click(Sender: TObject);
    procedure WebSpeedButton14Click(Sender: TObject);
    procedure WebSpeedButton15Click(Sender: TObject);
    procedure WebSpeedButton16Click(Sender: TObject);
    procedure dgContractImportsetupSelectCell(Sender: TObject; AStartCell,
      AEndCell: TTMSFNCDataGridCellCoord);
    procedure WebButton17Click(Sender: TObject);
    procedure WebButton30Click(Sender: TObject);
    procedure WebButton19Click(Sender: TObject);
    procedure dgContractImportsetupCellClick(Sender: TObject; AColumn,
      ARow: Integer);
    procedure wpcContractInfoChange(Sender: TObject);
  private
    { Private declarations }

    iActiveContractsPC, iActiveContractsMaxPC : Integer;

    iClosedContractsPC, iClosedContractsMaxPC : Integer;

    iContractPriceListPC, iContractPriceListMaxPC : Integer;

    iActiveContractState : Integer;
    iPriceListContractNo : Integer;
    iContractPriceAutoNo, iContractPriceARow : Integer;

    iActiveContractNo , iClosedContractNo : Integer;

    iActiveContractImportPC , iActiveContractImportMaxPC : Integer;

    iSelectedClosedContractNo : Integer;

    iOldRowActiveContract : Integer;
    iOldRowContractPrice : Integer;
    iOldRowClosedContract : Integer;
    iOldRowActiveContractImport : Integer;

    iContractImportNo : Integer;
    DEBCode : String;



    procedure LoadActiveContracts(ContractNo : Integer; sSearchContract : String;ContractPageCount : Integer);

    procedure LoadClosedContracts(ContractNo : Integer; sSearchContract : String; ContractPageCount : Integer);
    procedure LoadContractPriceList(ContractNo, AutoNo : Integer);

    procedure LoadActiveContractsImport(ContractNo : Integer; sSearchContract : String;ContractPageCount : Integer);

    procedure SaveActiveContracts;

    procedure EnableSaveButtons(bEnabled : Boolean);
    procedure ContractSetup(bFlag : Boolean);

    function Get_Log_Text : String;

    //procedure populateInvoiceSelection(Sender: TObject; FromPage,ToPage: Integer; var AllowChange: Boolean);

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmContracts: TfrmContracts;

implementation

{$R *.dfm}
uses
    stfmssystem.connection, share.common, Province, Country, City, Place, share.classes,
    System.StrUtils, ContractPriceSetup, Commodities, LoadTypes, PayTerms, Search.controller,
    Search.PeriodTypes, Search.Clients, ContractImportSetup;

procedure TfrmContracts.SaveActiveContracts;
var
  sLog : String;

   procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Contract Successfully Saved');
      ContractSetup(false);
      LoadActiveContracts(-1,'*',iActiveContractsPC);
      EnableSaveButtons(true);
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
      ContractSetup(false);
    end;
begin

  case iActiveContractState of
    1:  Begin
          wcAContracts.RawInvoke('IstfmsloadsService.Put_Acontracts_Insert',[GetJsonFromDataSet(wdsAContracts),Get_Log_Text],@OnSuccess,@OnError);
        End;

    2:  Begin
          wcAContracts.RawInvoke('IstfmsloadsService.Put_AContracts_Edit',[GetJsonFromDataSet(wdsAContracts),Get_Log_Text],@OnSuccess,@OnError);
        End;

  end;


end;

procedure TfrmContracts.dgContractImportsetupCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  dgdbaContractPrices.SetActiveRecord(ARow);

  iContractImportNo := dgdbaContractImportSetup.FieldAtColumn[1].AsInteger;
end;

procedure TfrmContracts.dgContractImportsetupSelectCell(Sender: TObject; AStartCell,
  AEndCell: TTMSFNCDataGridCellCoord);
begin
  If AStartCell.Row >= 1 then
    begin
      dgContractImportsetup.Cells[0,iOldRowActiveContractImport] := '';
      dgContractImportsetup.Cells[0,AStartCell.Row] := '->';
      iOldRowActiveContractImport := AStartCell.Row;

    end;
end;

procedure TfrmContracts.WebButton10Click(Sender: TObject);
var
  newform : TfrmPlace;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sPlace <> '' then
            begin
              wdsAContracts.FieldByName('OFFLOADINGNO').AsInteger := iPlaceNo;
              wdsAContracts.FieldByName('OffLoadInfoName').AsString := sPlace;
            end
          else
            begin
              wdsAContracts.FieldByName('OFFLOADINGNO').AsInteger := 0;
              wdsAContracts.FieldByName('OffLoadInfoName').AsString := '';
            end;
        end;
    end;
begin
  newform := TfrmPlace.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton12Click(Sender: TObject);
var
  newform : TfrmPayType;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iPayTermsAutoNo > -1 then
            begin
              wdsAContracts.FieldByName('PAYMENTTERMS').AsInteger := iPayTermsAutoNo;
              wdsAContracts.FieldByName('PayTermsName').AsString := sPayTermsDescription;
            end
          else
            begin
              wdsAContracts.FieldByName('PAYMENTTERMS').AsInteger := -1;
              wdsAContracts.FieldByName('PayTermsName').AsString := '';
            end;
        end;
    end;
begin
  newform := TfrmPayType.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton14Click(Sender: TObject);
var
  newform : TfrmSearchController;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sCode <> '' then
            begin
              wdsAContracts.FieldByName('CONTROLLER').AsString := sCode;
              wdsAContracts.FieldByName('CONTROLLERName').AsString := sName;
            end
          else
            begin
              wdsAContracts.FieldByName('CONTROLLER').AsString := '';
              wdsAContracts.FieldByName('CONTROLLERName').AsString := '';
            end;
        end;
    end;
begin
  newform := TfrmSearchController.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton15Click(Sender: TObject);
var
  newform : TfrmLoadTypes;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sLoadtype <> '' then
            begin

              wdsAContracts.FieldByName('CAPTURETONS').AsString := sLoadtype;

            end
          else
            begin

              wdsAContracts.FieldByName('CAPTURETONS').AsString := '';

            end;
        end;
    end;
begin
  newform := TfrmLoadTypes.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton16Click(Sender: TObject);
var
  newform : TfrmLoadTypes;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sLoadtype <> '' then
            begin

              wdsAContracts.FieldByName('INVOICETONS').AsString := sLoadtype;

            end
          else
            begin

              wdsAContracts.FieldByName('INVOICETONS').AsString := '';

            end;
        end;
    end;
begin
  newform := TfrmLoadTypes.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton17Click(Sender: TObject);
var
newform : TfrmSearchClients;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sDEBName <> '' then
            begin
              edtActiveContractsImportSearch.Text := sDEBName;
              iActiveContractImportPC := 1;
              LoadActiveContractsImport(-1,sDEBName,1);
            end
          else
            begin
              edtActiveContractsImportSearch.Text := '';
              LoadActiveContractsImport(-1,'',1);
            end;
        end;
    end;
begin
  newform := TfrmSearchClients.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton18Click(Sender: TObject);
var
  newform : TfrmPeriodTypes;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iPeriodTypeAutoNo > -1 then
            begin
              wdsAContracts.FieldByName('CUTOFFPERIOD1').AsInteger := iPeriodTypeAutoNo;
              wdsAContracts.FieldByName('CutOffPeriodDesc1').AsString := sPeriodTypeDescription;
            end
          else
            begin
              wdsAContracts.FieldByName('CUTOFFPERIOD1').AsString := '';
              wdsAContracts.FieldByName('CutOffPeriodDesc1').AsString := '';
            end;
        end;
    end;
begin
  newform := TfrmPeriodTypes.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton19Click(Sender: TObject);
var
newform : TfrmImportSetup;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      {with newform do
        begin
          if sDEBName <> '' then
            begin

            end
          else
            begin
              edtActiveContractsImportSearch.Text := '';
              LoadActiveContractsImport(-1,'',1);
            end;
        end;}
    end;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          ContractNo := iContractImportNo;
          ImportTypeRec := -1;
          ImportType := -1;
        end;
    end;
begin

  if iContractImportNo > -1 then
    Begin
      newform := TfrmImportSetup.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.ShowModal(@AfterShowModal);

    End
  else
    Begin
      ShowMessage('Please Select a Contract!');
    End;

end;

procedure TfrmContracts.WebButton20Click(Sender: TObject);
var
  newform : TfrmPeriodTypes;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iPeriodTypeAutoNo > -1 then
            begin
              wdsAContracts.FieldByName('CUTOFFPERIOD2').AsInteger := iPeriodTypeAutoNo;
              wdsAContracts.FieldByName('CutOffPeriodDesc2').AsString := sPeriodTypeDescription;
            end
          else
            begin
              wdsAContracts.FieldByName('CUTOFFPERIOD2').AsString := '';
              wdsAContracts.FieldByName('CutOffPeriodDesc2').AsString := '';
            end;
        end;
    end;
begin
  newform := TfrmPeriodTypes.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton27Click(Sender: TObject);
var
  newform : TfrmContractPriceSetup;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadContractPriceList(iPriceListContractNo,-1)
    end;

    procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iPriceSetupState := 1;
          iPriceSetupContractNo := iPriceListContractNo;
        end;
    end;
begin
  newform := TfrmContractPriceSetup.CreateNew(@AfterCreate);
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton28Click(Sender: TObject);
begin
  LoadActiveContractsImport(-1,edtActiveContractsImportSearch.Text,iActiveContractImportPC);
end;

procedure TfrmContracts.WebButton29Click(Sender: TObject);
var
  ConfirmPriceListParams : TConfirmPriceListParams;
  sJsonparams : String;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Price Successfully confirmed');
      LoadContractPriceList(iPriceListContractNo,-1);
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;
begin
  dgdbaContractPrices.SetActiveRecord(iContractPriceARow);

  if  iContractPriceAutoNo <= 0 then
    Begin
      ShowMessage('Please select a record!');
    End
  else
    Begin
      if (dgdbaContractPrices.FieldAtColumn[9].AsString = 'N') then
        Begin
          ConfirmPriceListParams := TConfirmPriceListParams.Create;
          ConfirmPriceListParams.AUTONO := iContractPriceAutoNo;

           sJsonparams := ConvertObjToJson(ConfirmPriceListParams).ToJSON;

          wcContractPrices.RawInvoke('IstfmsloadsService.Put_ContractsPriceList_ConfirmPrice',[sJsonparams],@OnSuccess,@OnError);
        End
      else
        begin
          ShowMessage('This price is already confirmed!');
        end;
    End;

end;

procedure TfrmContracts.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmContracts.WebButton30Click(Sender: TObject);
var
newform : TfrmSearchClients;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sDEBName <> '' then
            begin
              wdsSearchClients.FieldByName('DEBCODE').AsString := sDEBCode;
              dbedtClientName.Text := sDEBName
            end
          else
            begin
              wdsSearchClients.FieldByName('DEBCODE').AsString := '';

            end;
        end;
    end;
begin
  newform := TfrmSearchClients.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton31Click(Sender: TObject);
var
  OpenContractPriceListParams : TOpenContractPriceListParams;
  sJsonparams : String;

  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Price Successfully opened');
      LoadContractPriceList(iPriceListContractNo,-1);
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
    end;

begin

  dgdbaContractPrices.SetActiveRecord(iContractPriceARow);

  if  iContractPriceAutoNo <= 0 then
    Begin
      ShowMessage('Please select a record!');
    End
  else
    Begin
      if (dgdbaContractPrices.FieldAtColumn[9].AsString = 'Y') then
        Begin
          OpenContractPriceListParams := TOpenContractPriceListParams.Create;
          OpenContractPriceListParams.AUTONO := iContractPriceAutoNo;
          console.log(ConvertObjToJson(OpenContractPriceListParams).ToJSON);

          wcContractPrices.RawInvoke('IstfmsloadsService.Put_ContractPriceList_OpenPrice',[ConvertObjToJson(OpenContractPriceListParams).ToJSON],@OnSuccess,@OnError);
        End
      else
        begin
          ShowMessage('This price is already Opened!');
        end;
    End;
end;

procedure TfrmContracts.WebButton33Click(Sender: TObject);
var
  newform : TfrmLoadTypes;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sLoadtype <> '' then
            begin

              wdsAContracts.FieldByName('HAULAGETYPE').AsString := sLoadtype;

            end
          else
            begin

              wdsAContracts.FieldByName('HAULAGETYPE').AsString := '';

            end;
        end;
    end;
begin
  newform := TfrmLoadTypes.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton34Click(Sender: TObject);
var
  newform : TfrmComodities;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if iCommodityNo > -1 then
            begin
              wdsAContracts.FieldByName('commoditiesNO').AsInteger := iCommodityNo;
              wdsAContracts.FieldByName('CommodityName').AsString := sCommodityName;
            end
          else
            begin
              wdsAContracts.FieldByName('commoditiesNO').AsInteger := 0;
              wdsAContracts.FieldByName('CommodityName').AsString := '';
            end;
        end;
    end;
begin
  newform := TfrmComodities.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.btnOpenContractClick(Sender: TObject);
var
  OPenCloseContractsParams : TOPenCloseContractsParams;
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      ShowMessage('Contract Successfully opened');
      btnOpenContract.Enabled := true;
      LoadContractPriceList(iPriceListContractNo,1);
      LoadActiveContracts(-1,'*',1);
      LoadClosedContracts(-1,'*',1);
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      btnOpenContract.Enabled := true;
      ShowMessage(Error.ErrorMessage);
    end;
begin
  btnOpenContract.Enabled := false;

  OPenCloseContractsParams := TOPenCloseContractsParams.Create;
  OPenCloseContractsParams.ContractNo := iSelectedClosedContractNo;
  OPenCloseContractsParams.LogText := Get_Log_Text;

  if True then
    Begin
      wcAContracts.RawInvoke('IstfmsloadsService.Put_AContracts_OpenContracts',[ConvertObjToJson(OPenCloseContractsParams).ToJSON],@OnSuccess,@OnError);
    End;
end;

procedure TfrmContracts.WebButton36Click(Sender: TObject);
begin
  if edtClosedContractsPC.Text = '' then
    Begin
      LoadClosedContracts(-1,'*',iClosedContractsPC);
    End
  else
    Begin
      LoadClosedContracts(-1,edtSearchClosedContracts.Text,iClosedContractsPC);
    End;
end;

procedure TfrmContracts.WebButton3Click(Sender: TObject);
var
  newform : TfrmCountry;


  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sCountry <> '' then
            begin

              wdsAContracts.FieldByName('LOADcountryNO').AsInteger := iLoadCountryNo;
              wdsAContracts.FieldByName('LoadCountryName').AsString := sCountry;

            end
          else
            begin
              wdsAContracts.FieldByName('LOADcountryNO').AsInteger := 0;
              wdsAContracts.FieldByName('LoadCountryName').AsString := '';
            end;
        end;
    end;
begin
  newform := TfrmCountry.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);


end;

procedure TfrmContracts.btnSaveContract5Click(Sender: TObject);
begin
  SaveActiveContracts;
  EnableSaveButtons(false);
end;

procedure TfrmContracts.cbxADHOCClick(Sender: TObject);
begin
   wdsAContracts.FieldByName('DEDICATED').AsString := IfThen(cbxADHOC.Checked,'N','Y');
   wdsAContracts.FieldByName('ADDHOC').AsString := IfThen(cbxADHOC.Checked,'Y','N');
end;

procedure TfrmContracts.cbxDedicatedClick(Sender: TObject);
begin
  wdsAContracts.FieldByName('DEDICATED').AsString := IfThen(cbxDedicated.Checked,'Y','N');
  wdsAContracts.FieldByName('ADDHOC').AsString := IfThen(cbxDedicated.Checked,'N','Y');

end;

procedure TfrmContracts.WebButton4Click(Sender: TObject);
var
  newform : TfrmProvince;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sProvince <> '' then
            begin
              wdsAContracts.FieldByName('LOADprovinceNO').AsInteger := iProvinceNo;
              wdsAContracts.FieldByName('LoadProvinceName').AsString := sProvince;
            end
          else
            begin
              wdsAContracts.FieldByName('LOADprovinceNO').AsInteger := 0;
              wdsAContracts.FieldByName('LoadProvinceName').AsString := '';
            end;
        end;
    end;
begin
  newform := TfrmProvince.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton50Click(Sender: TObject);
begin
  ContractSetup(false);
  edtSearchActiveContracts.Text :='';
  LoadActiveContracts(-1,'*',1);
end;

procedure TfrmContracts.btnSaveContract4Click(Sender: TObject);
begin
  SaveActiveContracts;
  EnableSaveButtons(false);
end;

procedure TfrmContracts.WebButton53Click(Sender: TObject);
begin
  ContractSetup(false);
  edtSearchActiveContracts.Text :='';
  LoadActiveContracts(-1,'*',1);
end;

procedure TfrmContracts.btnSaveContract3Click(Sender: TObject);
begin
  SaveActiveContracts;
  EnableSaveButtons(false);
end;

procedure TfrmContracts.WebButton56Click(Sender: TObject);
begin
  ContractSetup(false);
  edtSearchActiveContracts.Text :='';
  LoadActiveContracts(-1,'*',1);
end;

procedure TfrmContracts.btnSaveContract2Click(Sender: TObject);
begin
  SaveActiveContracts;
  EnableSaveButtons(false);
end;

procedure TfrmContracts.WebButton59Click(Sender: TObject);
begin
  ContractSetup(false);
  edtSearchActiveContracts.Text :='';
  LoadActiveContracts(-1,'*',1);
end;

procedure TfrmContracts.WebButton5Click(Sender: TObject);
var
  newform : TfrmCity;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sCity <> '' then
            begin
              wdsAContracts.FieldByName('LOADcityNO').AsInteger := iCityNo;
              wdsAContracts.FieldByName('LoadCityName').AsString := sCity;

            end
          else
            begin
              wdsAContracts.FieldByName('LOADcityNO').AsInteger := 0;
              wdsAContracts.FieldByName('LoadCityName').AsString := '';
            end;
        end;
    end;
begin
  newform := TfrmCity.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.btnSaveContract1Click(Sender: TObject);
begin
  SaveActiveContracts;
  EnableSaveButtons(false);
end;

procedure TfrmContracts.WebButton62Click(Sender: TObject);
begin
  ContractSetup(false);
  edtSearchActiveContracts.Text :='';
  LoadActiveContracts(-1,'*',1);
end;

procedure TfrmContracts.WebButton63Click(Sender: TObject);
begin
  ContractSetup(true);
  wdsAContracts.Insert;
  iActiveContractState := 1;

  gbMiltiLoadInv.Visible := false;
end;

procedure TfrmContracts.WebButton64Click(Sender: TObject);
begin
  ContractSetup(true);


end;

procedure TfrmContracts.btnCloseContractClick(Sender: TObject);
var
  OPenCloseContractsParams : TOPenCloseContractsParams;
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      btnCloseContract.Enabled := true;
      ShowMessage('Contract successfully Completed');
      LoadActiveContracts(-1,'*',1);
      LoadClosedContracts(-1,'*',1);
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      btnCloseContract.Enabled := true;
      ShowMessage(Error.ErrorMessage);
    end;
begin
  btnCloseContract.Enabled := false;
  OPenCloseContractsParams := TOPenCloseContractsParams.Create;
  OPenCloseContractsParams.ContractNo := iPriceListContractNo;
  OPenCloseContractsParams.LogText := Get_Log_Text;

  if True then
    Begin
      wcAContracts.RawInvoke('IstfmsloadsService.Put_AContracts_CloseContracts',[ConvertObjToJson(OPenCloseContractsParams).ToJSON],@OnSuccess,@OnError);
    End;
end;

procedure TfrmContracts.WebButton67Click(Sender: TObject);
var
  sSearch : String;
begin
  if edtSearchActiveContracts.Text = '' then
    sSearch := '*'
  else
    sSearch := edtSearchActiveContracts.Text;


  iActiveContractsPC := 1;

  LoadActiveContracts(-1,sSearch,iActiveContractsPC);
end;

procedure TfrmContracts.WebButton6Click(Sender: TObject);
var
  newform : TfrmPlace;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sPlace <> '' then
           begin
              wdsAContracts.FieldByName('LOADINGNO').AsInteger := iPlaceNo;
              wdsAContracts.FieldByName('LoadInfoName').AsString := sPlace;
            end
          else
            begin
              wdsAContracts.FieldByName('LOADINGNO').AsInteger := 0;
              wdsAContracts.FieldByName('LoadInfoName').AsString := '';
            end;
        end;
    end;
begin
  newform := TfrmPlace.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton7Click(Sender: TObject);
var
  newform : TfrmCountry;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sCountry <> '' then
            begin
              wdsAContracts.FieldByName('OFFLOADcountryNO').AsInteger := iLoadCountryNo;
              wdsAContracts.FieldByName('OffLoadCountryName').AsString := sCountry;

            end
          else
            begin
              wdsAContracts.FieldByName('OFFLOADcountryNO').AsInteger := iLoadCountryNo;
              wdsAContracts.FieldByName('OffLoadCountryName').AsString := sCountry;
            end;
        end;
    end;
begin
  newform := TfrmCountry.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton8Click(Sender: TObject);
var
  newform : TfrmProvince;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sProvince  <> '' then
            begin
              wdsAContracts.FieldByName('OFFLOADprovinceNO').AsInteger := iProvinceNo;
              wdsAContracts.FieldByName('OffLoadProvinceName').AsString := sProvince;
            end
          else
            begin
              wdsAContracts.FieldByName('OFFLOADprovinceNO').AsInteger := iProvinceNo;
              wdsAContracts.FieldByName('OffLoadProvinceName').AsString := sProvince;
            end;
        end;
    end;
begin
  newform := TfrmProvince.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebButton9Click(Sender: TObject);
var
  newform : TfrmCity;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          if sCity <> '' then
            begin
              wdsAContracts.FieldByName('OFFLOADCITYNO').AsInteger := iCityNo;
              wdsAContracts.FieldByName('OffLoadCityName').AsString := sCity;

            end
          else
            begin
              wdsAContracts.FieldByName('OFFLOADCITYNO').AsInteger := 0;
              wdsAContracts.FieldByName('OffLoadCityName').AsString := '';
            end;
        end;
    end;
begin
  newform := TfrmCity.CreateNew;
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmContracts.WebDBCheckBox13Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('INVLOADING').AsString := IfThen(WebDBCheckBox13.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox14Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('INVOFFLOADING').AsString := IfThen(WebDBCheckBox14.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox15Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('STRATERATE').AsString := IfThen(WebDBCheckBox15.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox16Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('CHGOFFLOAD').AsString := IfThen(WebDBCheckBox16.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox17Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('CHGLOAD').AsString := IfThen(WebDBCheckBox17.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox18Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('CHGPRICE').AsString := IfThen(WebDBCheckBox18.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox19Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('CHGSUBPRICE').AsString := IfThen(WebDBCheckBox19.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox20Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('INVVAT').AsString := IfThen(WebDBCheckBox20.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox21Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('SINVVAT').AsString := IfThen(WebDBCheckBox21.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox22Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('PRINTLC').AsString := IfThen(WebDBCheckBox22.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox23Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('PRINTDN').AsString := IfThen(WebDBCheckBox23.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox24Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('PRINTTS').AsString := IfThen(WebDBCheckBox24.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox25Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('OLDLOADSCREEN').AsString := IfThen(WebDBCheckBox25.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox26Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('SHOWBOOKINGS').AsString := IfThen(WebDBCheckBox26.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox27Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('SHOWADDITIONAL').AsString := IfThen(WebDBCheckBox27.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox28Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('USEDOCKETINVNO').AsString := IfThen(WebDBCheckBox28.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox29Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('LINKZEROML').AsString := IfThen(WebDBCheckBox29.Checked,'Y','N');
end;

procedure TfrmContracts.WebDBCheckBox30Click(Sender: TObject);
begin
  wdsAContracts.FieldByName('ATTACHEDEMAIL').AsString := IfThen(WebDBCheckBox30.Checked,'Y','N');
end;

procedure TfrmContracts.cbxMiltiLoadInvopiceClick(Sender: TObject);
begin
  if wdsAContracts.FieldByName('MULTILOADINV').AsString = 'Y' then
    gbMiltiLoadInv.Visible := true
  else
    gbMiltiLoadInv.Visible := false;

end;

procedure TfrmContracts.ContractSetup(bFlag : Boolean);
begin
  wpcsAdditionalInfo.TabVisible := bFlag;
  wpcsBillingInformation.TabVisible := bFlag;
  wpcsContractInfo.TabVisible := bFlag;
  wpcsContractPricing.TabVisible := bFlag;
  wpcsDirections.TabVisible := bFlag;
  wpcsAllActiveContracts.TabVisible := (NOT bFlag);

  wpcContractInfo.TabIndex := 0;

  if bFlag then
    wpcActiveContracts.TabIndex := 0
  else
    wpcActiveContracts.TabIndex := 5;


end;

procedure TfrmContracts.dgActiveContractsListCellClick(Sender: TObject; AColumn,
  ARow: Integer);
 
begin
  dgdbaActiveContractsList.SetActiveRecord(ARow);
  iPriceListContractNo := dgdbaActiveContractsList.FieldAtColumn[1].AsInteger;

  if AColumn = 89 then
    Begin

      ContractSetup(true);

      iActiveContractState := 2;

      LoadActiveContracts(iPriceListContractNo,'*',-1);

    End;
end;

procedure TfrmContracts.dgActiveContractsListGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dgdbaActiveContractsList.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 89 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[1];

      if ACell.Column = 90 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0];
    end;
end;

procedure TfrmContracts.dgActiveContractsListSelectCell(Sender: TObject;
  AStartCell, AEndCell: TTMSFNCDataGridCellCoord);
begin
  If AStartCell.Row >= 1 then
    begin
      dgActiveContractsList.Cells[0,iOldRowActiveContract] := '';
      dgActiveContractsList.Cells[0,AStartCell.Row] := '->';
      iOldRowActiveContract := AStartCell.Row;
    end;
end;

procedure TfrmContracts.dgClosedContractsCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  dgdbaClosedContracts.SetActiveRecord(ARow);
  iSelectedClosedContractNo := dgdbaClosedContracts.FieldAtColumn[1].AsInteger;
end;

procedure TfrmContracts.dgClosedContractsSelectCell(Sender: TObject; AStartCell,
  AEndCell: TTMSFNCDataGridCellCoord);
begin
  If AStartCell.Row >= 1 then
    begin
      dgClosedContracts.Cells[0,iOldRowClosedContract] := '';
      dgClosedContracts.Cells[0,AStartCell.Row] := '->';
      iOldRowClosedContract := AStartCell.Row;
    end;
end;

procedure TfrmContracts.dgContractPricesCellClick(Sender: TObject; AColumn,
  ARow: Integer);
var
  newform : TfrmContractPriceSetup;
  PricelistParams : TPriceListParams;
  sJsonParams : String;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      LoadContractPriceList(iPriceListContractNo,-1)
    end;

  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin

          iAutoNo := dgdbaContractPrices.FieldAtColumn[1].AsInteger;
          iPriceSetupState := 2;
        end;
    end;

  procedure OnResult(Value : TModalResult);
    begin
      If Value = mrYes then
        Begin
          PriceListParams := TPriceListParams.Create;
          PriceListParams.ContractNo := -1;
          PriceListParams.AutoNo := iContractPriceAutoNo;

          sJsonParams := ConvertObjToJson(PriceListParams).ToJSON;

          wcContractPrices.RawInvoke('IstfmsloadsService.Put_ContractPriceList_Delete',[sJsonParams]);

          LoadContractPriceList(iPriceListContractNo,-1);
        End
      else
        Exit;
    end;
begin
  dgdbaContractPrices.SetActiveRecord(Arow);
  iContractPriceARow := ARow;
  iContractPriceAutoNo := dgdbaContractPrices.FieldAtColumn[1].AsInteger;

  if AColumn = 16 then
    Begin
      if (dgdbaContractPrices.FieldAtColumn[9].AsString = 'N') then
        Begin
          newform := TfrmContractPriceSetup.CreateNew(@AfterCreate);
          newform.Popup := true;
          newform.PopupOpacity := 0.2;
          newform.ShowModal(@AfterShowModal);
        End
      else
        Begin
          ShowMessage('a Confirmed price can not be changed!');
        End;


    End;

  if AColumn = 17 then
    Begin
      msgdlgContractPriceList.ShowDialog('Do you want to delete this record', WEBLib.Dialogs.mtWarning,[mbYes, mbNo], @OnResult);
    End;

end;

procedure TfrmContracts.dgContractPricesGetCellLayout(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
  var
  sFromDate, sToDate : String;
  dtFromDate, dtToDate : TDateTime;
begin
   if dgdbaContractPrices.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column IN [0,16,17] then
        Exit;

      dgdbaContractPrices.SetActiveRecord(ACell.Row);

      sFromDate := dgdbaContractPrices.FieldAtColumn[3].AsString;
      sToDate := dgdbaContractPrices.FieldAtColumn[4].AsString;

      dtFromDate := WebRESTClient1.IsoToDateTime(sFromDate);
      dtToDate := WebRESTClient1.IsoToDateTime(sToDate);//StrToDate(sformatedDate);

      if dgdbaContractPrices.FieldAtColumn[9].AsString = 'Y' then
        begin
          if (dtFromDate <= Date) AND (dtToDate >= Date) then
             begin
              //ACell.Layout.Fill.Kind := gfkSolid;
              ACell.Layout.Fill.Color := gcLightGreen;
              ACell.Layout.Font.Color := gcBlack;
             end
          else
            begin
              //ACell.Layout.Fill.Kind := gfkSolid;
              ACell.Layout.Fill.Color := gcBlack;
              ACell.Layout.Font.Color := gcWhite;
            end;
        end
      else
        begin
          //ACell.Layout.Fill.Kind := gfkSolid;
          ACell.Layout.Fill.Color := gcRed;
          ACell.Layout.Font.Color := gcWhite;
        end;

    end;
end;

procedure TfrmContracts.dgContractPricesGetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dgdbaContractPrices.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 16 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[1];

      if ACell.Column = 17 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0];
    end;
end;

procedure TfrmContracts.dgContractPricesSelectCell(Sender: TObject; AStartCell,
  AEndCell: TTMSFNCDataGridCellCoord);
begin
   If AStartCell.Row >= 1 then
    begin
      dgContractPrices.Cells[0,iOldRowContractPrice] := '';
      dgContractPrices.Cells[0,AStartCell.Row] := '->';
      iOldRowContractPrice := AStartCell.Row;
    end;
end;

procedure TfrmContracts.edtSearchContractDescriptionChange(Sender: TObject);
begin
  if edtSearchClosedContracts.Text <> '' then
    begin
      case dgClosedContracts.Selection.StartCell.Column of
        1 : wdsClosedContracts.Locate('ContractName', edtSearchClosedContracts.Text, [loPartialKey]);
      end;
    end;
end;

procedure TfrmContracts.edtSearchDescriptionChange(Sender: TObject);
begin
  if edtSearchDescription.Text <> '' then
    begin
      case dgActiveContractsList.Selection.StartCell.Column of
        1 : wdsAContracts.Locate('ContractName', edtSearchDescription.Text, [loPartialKey]);
      end;
    end;
end;

procedure TfrmContracts.EnableSaveButtons(bEnabled: Boolean);
begin
  btnSaveContract1.Enabled := bEnabled;
  btnSaveContract2.Enabled := bEnabled;
  btnSaveContract3.Enabled := bEnabled;
  btnSaveContract4.Enabled := bEnabled;
  btnSaveContract5.Enabled := bEnabled;
end;

function TfrmContracts.Get_Log_Text: String;
var
  CLIENT,
  SDESC,
  LDESC,
  PROD,
  LTYPE,
  LCOUNT,
  LPROV,
  LCITY,
  LPOINT,
  OCOUNT,
  OPROV,
  OCITY,
  OPOINT,
  CTYPE,
  ITYPE,
  INVLQTY,
  INVOQTY,
  INVSRATE,
   COLI,
   CLI,
   CCP,
   CSP,
   CIWV,
   SIWV,
   PLC,
   PDN,
   PTS,
   NAIS,
   SBS,
   SAS,
   UDNFIN,
   AZEROOML,
   ADFE,
   ADESC,
   CCL,
   MLVD,
   Dist,
   QRef,
   LIAQ,
   AQ,
   Dedic,
   ADHOC,
   CONTR,
   PAYTE,
   PAYT,
   ROUTP,
   ORDNO,
   MultiL,
   PREL,
   POSTL,
   INVS,
   DELN,
   TRPS  : STRING;
begin
  CLIENT   := dbedtClientName.Text;                                //Client Name
   SDESC    := dbedtShortdescription.Text;                         //Short Description
   LDESC    := dbedtLongDescription.Text;                          //Long Description
   PROD     := WebDBEdit5.Text;                                                 //Product
   LTYPE    := dbedtLoadType.Text;                                 //Load Type
   LCOUNT   := WebDBEdit7.Text;                                    //Loading Country
   LPROV    := WebDBEdit8.Text;                                    //Loading Province
   LCITY    := WebDBEdit9.Text;                                    //Loading City
   LPOINT   := WebDBEdit10.Text;                                   //Loading point
   OCOUNT   := WebDBEdit11.Text;                                   //OffLoading Country
   OPROV    := WebDBEdit12.Text;                                   //OffLoading Province
   OCITY    := WebDBEdit13.Text;                                   //OffLoading City
   OPOINT   := WebDBEdit14.Text;                                   //OffLoading Point
   CTYPE    := dbedtCpatureType.Text;                              //Capture Type
   ITYPE    := WebDBEdit17.Text;                                   //Invoice Type

   INVLQTY  := IfThen(WebDBCheckBox13.Checked,'Y','N');            //Invoice on Loading
   INVOQTY  := IfThen(WebDBCheckBox14.Checked,'Y','N');            //Invoice on offLoading
   INVSRATE := IfThen(WebDBCheckBox15.Checked,'Y','N');            //Invoice straight rate
   COLI     := IfThen(WebDBCheckBox16.Checked,'Y','N');            //change off loading in
   CLI      := IfThen(WebDBCheckBox17.Checked,'Y','N');            //Change loading info
   CCP      := IfThen(WebDBCheckBox18.Checked,'Y','N');            //Change Client Price
   CSP      := IfThen(WebDBCheckBox19.Checked,'Y','N');            //Change sub price
   CIWV     := IfThen(WebDBCheckBox20.Checked,'Y','N');            //Customer invoice without vat
   SIWV     := IfThen(WebDBCheckBox21.Checked,'Y','N');            //supplier invoice without vat
   PLC      := IfThen(WebDBCheckBox22.Checked,'Y','N');            //print load confirmation
   PDN      := IfThen(WebDBCheckBox23.Checked,'Y','N');            //print delivery note
   PTS      := IfThen(WebDBCheckBox24.Checked,'Y','N');            //Print trip sheet
   NAIS     := IfThen(WebDBCheckBox25.Checked,'Y','N');            //No Additional invocie screen
   SBS      := IfThen(WebDBCheckBox26.Checked,'Y','N');            //shown booking screen
   SAS      := IfThen(WebDBCheckBox27.Checked,'Y','N');            //show additional screen
   UDNFIN   := IfThen(WebDBCheckBox28.Checked,'Y','N');            //use docket no for Invoice No
   AZEROOML := IfThen(WebDBCheckBox29.Checked,'Y','N');            //allow 0.00 load link on ml
   ADFE     := IfThen(WebDBCheckBox30.Checked,'Y','N');            //Attach Dockets for email

   CCL      := WebDBEdit15.Text;                                   //Cliented Link Contract
   ADESC    := WebDBEdit18.Text;                                   //Additional Description
   MLVD     := WebDBEdit23.Text;                                   //Max Loads Vehicle/Day
   Dist     := WebDBEdit24.Text;                                   //Distance
   QRef     := WebDBEdit22.Text;                                   //Quote Ref
   LIAQ     := WebDBEdit26.Text;                                   //Load instruction AVG QTY
   AQ       := WebDBEdit20.Text;                                   //Avg QTY
   Dedic    := IfThen(cbxDedicated.Checked,'Y','N');               //Dedicated
   ADHOC    := IfThen(cbxADHOC.Checked,'Y','N');                   //AdHoc
   CONTR    := wdsAContracts.FieldByName('CONTROLLER').AsString;   //Controller
   PAYTE    := wdsAContracts.FieldByName('PAYMENTTERMS').AsString; //Payterms
   PAYT     := wdsAContracts.FieldByName('PAYMENTTYPE').AsString;  //PayType
   ORDNO    := WebDBEdit38.Text;                                   //OrderNo

   MultiL   := IfThen(cbxMiltiLoadInvopice.checked,'Y','N');       //Multi Load
   PREL     := IfThen(WebDBCheckBox4.checked,'Y','N');             //Pre Listed
   POSTL    := IfThen(WebDBCheckBox5.checked,'Y','N');             //Post Listed

   INVS    :=  wdsAContracts.FieldByName('INVOICETYPE').AsString;  //Invoice Selection
   DELN     := wdsAContracts.FieldByName('DNTYPE').AsString;       //Delivery Note Selection
   TRPS     := wdsAContracts.FieldByName('TSTYPE').AsString;       //Tripsheet Selection
   ROUTP    := WebDBMemo1.Text;                                    //Route Plan/Direction

    result := 'CLIENT-' + CLIENT + ';SDESC-' + SDESC + ';LDESC-' + LDESC + ';PROD-' + PROD + ';LTYPE-' + LTYPE + ';LCOUNT-' + LCOUNT +
             ';LPROV-' + LPROV + ';LCITY-' + LCITY + ';LPOINT-' + LPOINT + ';OCOUNT-' + OCOUNT + ';OPROV-' + OPROV + ';OCITY-' + OCITY +
             ';OPOINT-' + OPOINT + ';CTYPE-' + CTYPE + ';ITYPE-' + ITYPE + ';INVLQTY-' + INVLQTY + ';INVOQTY-' + INVOQTY +
             ';INVSRATE-' + INVSRATE + ';COLI-' + COLI + ';CLI-' + CLI + ';CCP-' + CCP + ';CIWV-' + CIWV + ';SIWV-' + SIWV +
             ';PLC-' + PLC + ';PDN-' + PDN + ';PTS-' + PTS + ';NAIS-' + NAIS + ';SBS-' + SBS + ';SAS-' + SAS + ';UDNFIN-' + UDNFIN +
             ';AZEROOML-' + AZEROOML +  ';ADFE-' + ADFE + ';CCL-' + CCL + ';ADESC-' +  ';MLVD-' + MLVD + ';Dist-' + Dist +
             ';QRef-' + QRef +  ';LIAQ-' + LIAQ + ';AQ-' + AQ + ';Dedic-' + Dedic +  ';ADHOC-' + ADHOC + ';CONTR-' + CONTR +
             ';PAYTE-' + PAYTE + ';PAYT-' + PAYT + ';ORDNO-' + ORDNO +  ';MultiL-' + MultiL + ';PREL-' + PREL + ';POSTL-' + POSTL +
             ';INVS-' + INVS + ';DELN-' + DELN + ';TRPS-' + TRPS + ';ROUTP-' + ROUTP + ';' ;


end;

procedure TfrmContracts.LoadActiveContracts(ContractNo : Integer; sSearchContract : String;
                                            ContractPageCount : Integer);
var
  ContractsParams : TContractsParams;
  paramsJson : String;

  procedure OnError(Error: TXDataClientError);
    begin
      LoadActiveContracts(ContractNo,sSearchContract,ContractPageCount);
    end;
  procedure OnResult(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadActiveContracts(ContractNo,sSearchContract,ContractPageCount);
        end
      else
        begin
          wdsAContracts.Close;
          wdsAContracts.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsAContracts.Open;

          if iActiveContractState = 2 then
          Begin
            if wdsAContracts.FieldByName('MULTILOADINV').AsString = 'Y' then
              gbMiltiLoadInv.Visible := true
            else
              gbMiltiLoadInv.Visible := false;
            wdsAContracts.Edit;
          End;

          LoadContractPriceList(ContractNo,-1);
        end;
    end;

  procedure OnResultPC(Response : TXDataClientResponse);
    begin
      iActiveContractsMaxPC := Integer(TJSObject(Response.Result)['value']);

      edtActiveContractsPageCount.Text := IntToStr(iActiveContractsPC) + ' of ' + IntToStr(iActiveContractsMaxPC);

      wcAContracts.RawInvoke('IstfmsloadsService.Get_AContract_View',[ParamsJSON],@OnResult,@OnError);

      ContractsParams.Free;
    end;

begin

  ContractsParams := TContractsParams.Create;
  ContractsParams.SearchContract := sSearchContract;
  ContractsParams.Completed := 'N';                   {"ContractNo":-1,"SearchContract":"*","Completed":"N","PageCount":1}
  ContractsParams.ContractNo := ContractNo;
  ContractsParams.PageCount := iActiveContractsPC;

  ParamsJSON :=  ConvertObjToJson(ContractsParams).ToJSON;

  wcAContracts.RawInvoke('IstfmsloadsService.Get_AContract_MaxPC',[ParamsJSON],@OnResultPC,@OnError);

end;

procedure TfrmContracts.LoadActiveContractsImport(ContractNo: Integer;
  sSearchContract: String; ContractPageCount: Integer);
var
  ContractsParams : TContractsParams;
  paramsJson : String;

  procedure OnError(Error: TXDataClientError);
    begin
      LoadActiveContractsImport(ContractNo,sSearchContract,ContractPageCount);
    end;
  procedure OnResult(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadActiveContractsImport(ContractNo,sSearchContract,ContractPageCount);
        end
      else
        begin
          wdsAContractImportSetup.Close;
          wdsAContractImportSetup.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsAContractImportSetup.Open;

        end;
    end;

  procedure OnResultPC(Response : TXDataClientResponse);
    begin
      iActiveContractImportMaxPC := Integer(TJSObject(Response.Result)['value']);

      edtActiveContractImportPC.Text := IntToStr(iActiveContractImportPC) + ' of ' + IntToStr(iActiveContractImportMaxPC);

      wcAContracts.RawInvoke('IstfmsloadsService.Get_AContract_View',[ParamsJSON],@OnResult,@OnError);

      ContractsParams.Free;
    end;

begin

  ContractsParams := TContractsParams.Create;
  ContractsParams.SearchContract := sSearchContract;
  ContractsParams.Completed := 'N';                   {"ContractNo":-1,"SearchContract":"*","Completed":"N","PageCount":1}
  ContractsParams.ContractNo := ContractNo;
  ContractsParams.PageCount := iActiveContractsPC;

  ParamsJSON :=  ConvertObjToJson(ContractsParams).ToJSON;

  wcAContracts.RawInvoke('IstfmsloadsService.Get_AContract_MaxPC',[ParamsJSON],@OnResultPC,@OnError);
end;

procedure TfrmContracts.LoadClosedContracts(ContractNo: Integer;
  sSearchContract: String; ContractPageCount: Integer);
var
  ContractsParams : TContractsParams;
  paramsJson : String;

  procedure OnError(Error: TXDataClientError);
    begin
      LoadClosedContracts(ContractNo,sSearchContract,ContractPageCount);
    end;
  procedure OnResult(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadClosedContracts(ContractNo,sSearchContract,ContractPageCount);
        end
      else
        begin
          wdsClosedContracts.Close;
          wdsClosedContracts.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsClosedContracts.Open;

        end;
    end;

  procedure OnResultPC(Response : TXDataClientResponse);
    begin
      iClosedContractsPC := Integer(TJSObject(Response.Result)['value']);

      edtClosedContractsPC.Text := IntToStr(iClosedContractsPC) + ' of ' + IntToStr(iClosedContractsMaxPC);


      wcClosedContracts.RawInvoke('IstfmsloadsService.Get_AContract_View',[ParamsJSON],@OnResult,@OnError);

      ContractsParams.Free;
    end;

begin

  ContractsParams := TContractsParams.Create;
  ContractsParams.SearchContract := sSearchContract;
  ContractsParams.Completed := 'Y';                   {"ContractNo":-1,"SearchContract":"*","Completed":"Y","PageCount":1}
  ContractsParams.ContractNo := ContractNo;
  ContractsParams.PageCount := iActiveContractsPC;

  ParamsJSON :=  ConvertObjToJson(ContractsParams).ToJSON;



  wcClosedContracts.RawInvoke('IstfmsloadsService.Get_AContract_MaxPC',[ParamsJSON],@OnResultPC,@OnError);
end;

procedure TfrmContracts.LoadContractPriceList(ContractNo, AutoNo: Integer);
var
  PriceListParams : TPriceListParams;
  sJsonParams : String;
  procedure OnError(Error: TXDataClientError);
    begin
      LoadContractPriceList(ContractNo, AutoNo);
    end;

  procedure OnResult(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadContractPriceList(ContractNo, AutoNo);
        end
      else
        begin
          wdsContractPrices.Close;
          wdsContractPrices.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsContractPrices.Open;

        end;
    end;

  procedure OnResultPC(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadContractPriceList(ContractNo, AutoNo);
        end
      else
        begin
          iContractPriceListMaxPC := Integer(TJSObject(Response.Result)['value']);

          wcContractPrices.RawInvoke('IstfmsloadsService.Get_ContractPriceList_View',[sJsonParams],@OnResult,@OnError);

        end;
    end;

begin
  PriceListParams := TPriceListParams.Create;
  PriceListParams.ContractNo := ContractNo;
  PriceListParams.AutoNo := AutoNo;
  PriceListParams.PageCount := iContractPriceListPC;
  sJsonParams := ConvertObjToJson(PriceListParams).ToJSON;

  wcContractPrices.RawInvoke('IstfmsloadsService.Get_ContractPriceList_MaxPC',[sJsonParams],@OnResultPC,@OnError);
end;

{
procedure TfrmContracts.populateInvoiceSelection(Sender: TObject; FromPage,ToPage : Integer; var AllowChange: Boolean);
  var
    Path,
    sValue : string;
    SR : TSearchRec;
    infolist : TStringList;
    I : Integer;
begin
  if ToPage = 1 then
    begin
      sValue := wdsAContracts.FieldByName('InvoiceType').AsString;
      if cbxMiltiLoadInvopice.Checked = true then
        begin
          cbbInvoiceSelection.Items.Clear;
          Path := ExtractFilePath(Application.ExeName) + 'invoices\multiloads\*.rtm';
          if FindFirst(Path, faAnyFile, SR) = 0 then
            begin
              repeat
                if (SR.Attr <> faDirectory) then
                  begin
                    cbbInvoiceSelection.Items.Add(SR.Name);
                  end;
              until FindNext(SR) <> 0;
              FindClose(SR);
            end;
        end
      else
        begin
          cbbInvoiceSelection.Items.Clear;
          Path := ExtractFilePath(Application.ExeName) + 'invoices\*.rtm';
          if FindFirst(Path, faAnyFile, SR) = 0 then
            begin
              repeat
                if (SR.Attr <> faDirectory) then
                  begin
                    cbbInvoiceSelection.Items.Add(SR.Name);
                  end;
              until FindNext(SR) <> 0;
              FindClose(SR);
            end;
        end;
      cbbInvoiceSelection.ItemIndex := cbbInvoiceSelection.Items.IndexOf(sValue);

      if qCompany.FieldbyName('USEfinlinksystem').AsString = 'Y' then
        begin
          if qCompany.FieldbyName('finlinksystem').asInteger = 8 then
            begin
              gbSageOnline.Visible := True;
              infolist := TStringlist.Create;
              infolist.Clear;
              infolist.Text := qCompany.FieldByName('FINDBSETUP').AsAnsiString;
              for I := 0 to infolist.Count - 1 do
                begin
                  sValue := infolist.Strings[I];
                  if Pos('[LINKURL]', sValue) <> 0 then
                    begin
                      sValue := StringReplace(sValue, '[LINKURL]', '', [rfReplaceAll]);
                      sValue := StringReplace(sValue, ';', '', [rfReplaceAll]);
                      sLinkURL := sValue;
                    end;
                  if Pos('[LINKCOMPANY]', sValue) <> 0 then
                    begin
                      sValue := StringReplace(sValue, '[LINKCOMPANY]', '', [rfReplaceAll]);
                      sValue := StringReplace(sValue, ';', '', [rfReplaceAll]);
                      sLinkCompany := sValue;
                    end;
                  if Pos('[LINKUSER]', sValue) <> 0 then
                    begin
                      sValue := StringReplace(sValue, '[LINKUSER]', '', [rfReplaceAll]);
                      sValue := StringReplace(sValue, ';', '', [rfReplaceAll]);
                      sLinkUser := sValue;
                    end;
                  if Pos('[LINKPASSWORD]', sValue) <> 0 then
                    begin
                      sValue := StringReplace(sValue, '[LINKPASSWORD]', '', [rfReplaceAll]);
                      sValue := StringReplace(sValue, ';', '', [rfReplaceAll]);
                      sLinkPassword := sValue;
                    end;
                  if Pos('[LINKAPI]', sValue) <> 0 then
                    begin
                      sValue := StringReplace(sValue, '[LINKAPI]', '', [rfReplaceAll]);
                      sValue := StringReplace(sValue, ';', '', [rfReplaceAll]);
                      sLinkAPI := sValue;
                    end;
                end;
              infolist.Free;
            end
          else
            gbSageOnline.Visible := False;
        end;
    end;
end;           }

procedure TfrmContracts.WebFormShow(Sender: TObject);

begin
  iActiveContractsPC := 1;
  iClosedContractsPC := 1;

  iActiveContractImportPC := 1;

  iOldRowActiveContract := 1;
  iOldRowContractPrice := 1;
  iOldRowClosedContract := 1;

  iContractPriceAutoNo := 0;

  ContractSetup(false);
  LoadActiveContracts(-1,'*',1);
  LoadClosedContracts(-1,'*',1);
  LoadActiveContractsImport(-1,'*',1);
end;

procedure TfrmContracts.WebSpeedButton10Click(Sender: TObject);
begin
  if iClosedContractsPC > 1 then
    Begin
      Inc(iClosedContractsPC);

      LoadClosedContracts(-1,'*',iClosedContractsPC);
    End;
end;

procedure TfrmContracts.WebSpeedButton11Click(Sender: TObject);
begin
  if iClosedContractsPC < iClosedContractsMaxPC then
    Begin
      Inc(iClosedContractsPC);

      LoadClosedContracts(-1,'*',iClosedContractsPC);
    End;
end;

procedure TfrmContracts.WebSpeedButton12Click(Sender: TObject);
begin
  iClosedContractsPC := iClosedContractsMaxPC;

  LoadClosedContracts(-1,'*',iClosedContractsPC);
end;

procedure TfrmContracts.WebSpeedButton13Click(Sender: TObject);
begin
  iActiveContractImportPC := 1;
  LoadActiveContractsImport(-1,edtActiveContractsImportSearch.Text,iActiveContractImportPC);
end;

procedure TfrmContracts.WebSpeedButton14Click(Sender: TObject);
begin
  if iActiveContractImportPC > 1 then
    Begin
      Dec(iActiveContractImportPC);

      LoadActiveContractsImport(-1,edtActiveContractsImportSearch.Text,iActiveContractImportPC);
    End;
end;

procedure TfrmContracts.WebSpeedButton15Click(Sender: TObject);
begin
  if iActiveContractImportPC < iActiveContractImportMaxPC then
    Begin
      Inc(iActiveContractImportPC);

      LoadActiveContractsImport(-1,edtActiveContractsImportSearch.Text,iActiveContractImportPC);
    End;
end;

procedure TfrmContracts.WebSpeedButton16Click(Sender: TObject);
begin
  iActiveContractImportPC := iActiveContractImportMaxPC;

  LoadActiveContractsImport(-1,edtActiveContractsImportSearch.Text,iActiveContractImportPC);
end;

procedure TfrmContracts.WebSpeedButton1Click(Sender: TObject);
var
  sSearch : String;
begin
  if edtSearchActiveContracts.Text = '' then
    sSearch := '*'
  else
    sSearch := edtSearchActiveContracts.Text;

  iActiveContractsPC := 1;

  LoadActiveContracts(-1,sSearch,iActiveContractsPC);

  edtActiveContractsPageCount.Text := IntToStr(iActiveContractsPC) + ' of ' + IntToStr(iActiveContractsMaxPC);
end;

procedure TfrmContracts.WebSpeedButton2Click(Sender: TObject);
var
  sSearch : String;
begin
  if edtSearchActiveContracts.Text = '' then
    sSearch := '*'
  else
    sSearch := edtSearchActiveContracts.Text;

  if iActiveContractsPC > 1 then
    begin
      Dec(iActiveContractsPC);
      LoadActiveContracts(-1,sSearch,iActiveContractsPC);
    end;

  edtActiveContractsPageCount.Text := IntToStr(iActiveContractsPC) + ' of ' + IntToStr(iActiveContractsMaxPC);
end;

procedure TfrmContracts.WebSpeedButton3Click(Sender: TObject);
var
  sSearch : String;
begin
  if edtSearchActiveContracts.Text = '' then
    sSearch := '*'
  else
    sSearch := edtSearchActiveContracts.Text;


  if iActiveContractsPC < iActiveContractsMaxPC then
    begin
      Inc(iActiveContractsPC);
      LoadActiveContracts(-1,sSearch,iActiveContractsPC);
    end;

  edtActiveContractsPageCount.Text := IntToStr(iActiveContractsPC) + ' of ' + IntToStr(iActiveContractsMaxPC);
end;

procedure TfrmContracts.WebSpeedButton4Click(Sender: TObject);
var
  sSearch : String;
begin
  if edtSearchActiveContracts.Text = '' then
    sSearch := '*'
  else
    sSearch := edtSearchActiveContracts.Text;

  iActiveContractsPC := iActiveContractsMaxPC;

  LoadActiveContracts(-1,sSearch,iActiveContractsPC);

  edtActiveContractsPageCount.Text := IntToStr(iActiveContractsPC) + ' of ' + IntToStr(iActiveContractsMaxPC);
end;

procedure TfrmContracts.WebSpeedButton5Click(Sender: TObject);
begin
  iContractPriceListPC := 1;
  LoadContractPriceList(iPriceListContractNo,-1);
end;

procedure TfrmContracts.WebSpeedButton6Click(Sender: TObject);
begin
  if iContractPriceListPC > 1 then
    Begin
      Inc(iContractPriceListPC);
      LoadContractPriceList(iPriceListContractNo,-1);
    End;
end;

procedure TfrmContracts.WebSpeedButton7Click(Sender: TObject);
begin
  if iContractPriceListPC < iContractPriceListMaxPC then
    Begin
      LoadContractPriceList(iPriceListContractNo,-1);
    End;
end;

procedure TfrmContracts.WebSpeedButton8Click(Sender: TObject);
begin
  iContractPriceListPC := iContractPriceListMaxPC;
  LoadContractPriceList(iPriceListContractNo,-1);
end;

procedure TfrmContracts.WebSpeedButton9Click(Sender: TObject);
begin
  iClosedContractsPC := 1;

  LoadClosedContracts(-1,'*',1);

end;

procedure TfrmContracts.wpcContractInfoChange(Sender: TObject);
begin
  iContractImportNo := -1;
end;

procedure TfrmContracts.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebDBLabel12 := TDBLabel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  BitMapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebSpeedButton13 := TSpeedButton.Create(Self);
  WebSpeedButton14 := TSpeedButton.Create(Self);
  WebSpeedButton15 := TSpeedButton.Create(Self);
  WebSpeedButton16 := TSpeedButton.Create(Self);
  edtActiveContractImportPC := TEdit.Create(Self);
  wpcContractInfo := TPageControl.Create(Self);
  wpcsActiveContracts := TTabSheet.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  wpcActiveContracts := TPageControl.Create(Self);
  wpcsContractInfo := TTabSheet.Create(Self);
  WebPanel8 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebDBLabel13 := TDBLabel.Create(Self);
  dbedtClientName := TDBEdit.Create(Self);
  dbedtShortdescription := TDBEdit.Create(Self);
  dbedtLongDescription := TDBEdit.Create(Self);
  WebDBEdit5 := TDBEdit.Create(Self);
  dbedtLoadType := TDBEdit.Create(Self);
  WebDBRadioGroup1 := TDBRadioGroup.Create(Self);
  WebGroupBox1 := TGroupBox.Create(Self);
  WebDBEdit7 := TDBEdit.Create(Self);
  WebDBEdit8 := TDBEdit.Create(Self);
  WebDBEdit9 := TDBEdit.Create(Self);
  WebDBEdit10 := TDBEdit.Create(Self);
  WebButton3 := TButton.Create(Self);
  WebButton4 := TButton.Create(Self);
  WebButton5 := TButton.Create(Self);
  WebButton6 := TButton.Create(Self);
  WebGroupBox2 := TGroupBox.Create(Self);
  WebDBEdit11 := TDBEdit.Create(Self);
  WebDBEdit12 := TDBEdit.Create(Self);
  WebDBEdit13 := TDBEdit.Create(Self);
  WebDBEdit14 := TDBEdit.Create(Self);
  WebButton7 := TButton.Create(Self);
  WebButton8 := TButton.Create(Self);
  WebButton9 := TButton.Create(Self);
  WebButton10 := TButton.Create(Self);
  WebGroupBox3 := TGroupBox.Create(Self);
  WebDBEdit15 := TDBEdit.Create(Self);
  WebButton11 := TButton.Create(Self);
  WebButton33 := TButton.Create(Self);
  WebButton34 := TButton.Create(Self);
  WebPanel29 := TPanel.Create(Self);
  WebButton60 := TButton.Create(Self);
  btnSaveContract1 := TButton.Create(Self);
  WebButton62 := TButton.Create(Self);
  WebButton30 := TButton.Create(Self);
  wpcsAdditionalInfo := TTabSheet.Create(Self);
  WebPanel9 := TPanel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel24 := TLabel.Create(Self);
  WebLabel25 := TLabel.Create(Self);
  WebLabel26 := TLabel.Create(Self);
  WebLabel27 := TLabel.Create(Self);
  WebLabel28 := TLabel.Create(Self);
  WebLabel29 := TLabel.Create(Self);
  dbedtCpatureType := TDBEdit.Create(Self);
  WebDBEdit17 := TDBEdit.Create(Self);
  WebDBEdit18 := TDBEdit.Create(Self);
  WebDBEdit19 := TDBEdit.Create(Self);
  WebDBEdit20 := TDBEdit.Create(Self);
  WebDBEdit21 := TDBEdit.Create(Self);
  WebDBEdit23 := TDBEdit.Create(Self);
  WebDBEdit24 := TDBEdit.Create(Self);
  WebDBEdit25 := TDBEdit.Create(Self);
  WebDBDateTimePicker1 := TDBDateTimePicker.Create(Self);
  WebButton12 := TButton.Create(Self);
  cbxDedicated := TDBCheckBox.Create(Self);
  cbxADHOC := TDBCheckBox.Create(Self);
  WebButton13 := TButton.Create(Self);
  WebDBEdit22 := TDBEdit.Create(Self);
  WebDBEdit26 := TDBEdit.Create(Self);
  WebDBEdit27 := TDBEdit.Create(Self);
  WebDBMaskEdit1 := TDBMaskEdit.Create(Self);
  WebButton14 := TButton.Create(Self);
  WebButton15 := TButton.Create(Self);
  WebButton16 := TButton.Create(Self);
  WebDBEdit28 := TDBEdit.Create(Self);
  WebDBEdit29 := TDBEdit.Create(Self);
  WebDBEdit30 := TDBEdit.Create(Self);
  WebDBEdit31 := TDBEdit.Create(Self);
  WebDBEdit32 := TDBEdit.Create(Self);
  WebDBEdit33 := TDBEdit.Create(Self);
  WebDBEdit34 := TDBEdit.Create(Self);
  WebDBEdit35 := TDBEdit.Create(Self);
  WebDBEdit36 := TDBEdit.Create(Self);
  WebDBEdit37 := TDBEdit.Create(Self);
  WebPanel28 := TPanel.Create(Self);
  WebButton57 := TButton.Create(Self);
  btnSaveContract2 := TButton.Create(Self);
  WebButton59 := TButton.Create(Self);
  wpcsBillingInformation := TTabSheet.Create(Self);
  WebPanel11 := TPanel.Create(Self);
  WebLabel30 := TLabel.Create(Self);
  WebLabel33 := TLabel.Create(Self);
  WebLabel34 := TLabel.Create(Self);
  WebLabel35 := TLabel.Create(Self);
  WebLabel36 := TLabel.Create(Self);
  WebLabel37 := TLabel.Create(Self);
  WebGroupBox4 := TGroupBox.Create(Self);
  WebDBCheckBox13 := TDBCheckBox.Create(Self);
  WebDBCheckBox14 := TDBCheckBox.Create(Self);
  WebDBCheckBox15 := TDBCheckBox.Create(Self);
  WebDBCheckBox16 := TDBCheckBox.Create(Self);
  WebDBCheckBox17 := TDBCheckBox.Create(Self);
  WebDBCheckBox18 := TDBCheckBox.Create(Self);
  WebDBCheckBox19 := TDBCheckBox.Create(Self);
  WebDBCheckBox20 := TDBCheckBox.Create(Self);
  WebDBCheckBox21 := TDBCheckBox.Create(Self);
  WebDBCheckBox22 := TDBCheckBox.Create(Self);
  WebDBCheckBox23 := TDBCheckBox.Create(Self);
  WebDBCheckBox24 := TDBCheckBox.Create(Self);
  WebDBCheckBox25 := TDBCheckBox.Create(Self);
  WebDBCheckBox26 := TDBCheckBox.Create(Self);
  WebDBCheckBox27 := TDBCheckBox.Create(Self);
  WebDBCheckBox28 := TDBCheckBox.Create(Self);
  WebDBCheckBox29 := TDBCheckBox.Create(Self);
  WebDBCheckBox30 := TDBCheckBox.Create(Self);
  WebDBEdit38 := TDBEdit.Create(Self);
  cbxMiltiLoadInvopice := TDBCheckBox.Create(Self);
  gbMiltiLoadInv := TGroupBox.Create(Self);
  WebDBCheckBox4 := TDBCheckBox.Create(Self);
  WebDBCheckBox5 := TDBCheckBox.Create(Self);
  WebPageControl1 := TPageControl.Create(Self);
  wpcsSageLinkInformation1 := TTabSheet.Create(Self);
  WebPanel12 := TPanel.Create(Self);
  WebLabel31 := TLabel.Create(Self);
  WebDBCheckBox6 := TDBCheckBox.Create(Self);
  WebDBEdit39 := TDBEdit.Create(Self);
  WebDBEdit40 := TDBEdit.Create(Self);
  wpcsSageLinkInformation2 := TTabSheet.Create(Self);
  WebPanel13 := TPanel.Create(Self);
  WebLabel32 := TLabel.Create(Self);
  WebDBCheckBox7 := TDBCheckBox.Create(Self);
  WebDBEdit41 := TDBEdit.Create(Self);
  WebDBEdit42 := TDBEdit.Create(Self);
  WebDBEdit44 := TDBEdit.Create(Self);
  WebButton18 := TButton.Create(Self);
  WebDBEdit46 := TDBEdit.Create(Self);
  WebButton20 := TButton.Create(Self);
  WebDBRadioGroup2 := TDBRadioGroup.Create(Self);
  WebDBEdit47 := TDBEdit.Create(Self);
  WebGroupBox6 := TGroupBox.Create(Self);
  WebDBCheckBox8 := TDBCheckBox.Create(Self);
  WebDBCheckBox9 := TDBCheckBox.Create(Self);
  WebDBCheckBox10 := TDBCheckBox.Create(Self);
  WebDBCheckBox11 := TDBCheckBox.Create(Self);
  WebDBCheckBox12 := TDBCheckBox.Create(Self);
  edtInvoiceSelection := TDBEdit.Create(Self);
  WebDBEdit49 := TDBEdit.Create(Self);
  WebDBEdit50 := TDBEdit.Create(Self);
  WebButton21 := TButton.Create(Self);
  WebButton22 := TButton.Create(Self);
  WebButton23 := TButton.Create(Self);
  WebGroupBox7 := TGroupBox.Create(Self);
  WebLabel38 := TLabel.Create(Self);
  WebLabel39 := TLabel.Create(Self);
  WebLabel40 := TLabel.Create(Self);
  WebDBEdit51 := TDBEdit.Create(Self);
  WebDBEdit52 := TDBEdit.Create(Self);
  WebDBEdit53 := TDBEdit.Create(Self);
  WebButton24 := TButton.Create(Self);
  WebButton25 := TButton.Create(Self);
  WebButton26 := TButton.Create(Self);
  WebPanel10 := TPanel.Create(Self);
  WebButton54 := TButton.Create(Self);
  btnSaveContract3 := TButton.Create(Self);
  WebButton56 := TButton.Create(Self);
  WebDBComboBox1 := TDBComboBox.Create(Self);
  WebDBComboBox2 := TDBComboBox.Create(Self);
  cbbInvoiceSelection := TDBComboBox.Create(Self);
  wpcsContractPricing := TTabSheet.Create(Self);
  WebPanel14 := TPanel.Create(Self);
  WebPanel15 := TPanel.Create(Self);
  WebButton27 := TButton.Create(Self);
  WebButton29 := TButton.Create(Self);
  WebButton31 := TButton.Create(Self);
  WebButton32 := TButton.Create(Self);
  dgContractPrices := TTMSFNCDataGrid.Create(Self);
  dgdbaContractPrices := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  msgdlgContractPriceList := TMessageDlg.Create(Self);
  WebPanel27 := TPanel.Create(Self);
  WebButton51 := TButton.Create(Self);
  btnSaveContract4 := TButton.Create(Self);
  WebButton53 := TButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  edtContractPriceListPC := TEdit.Create(Self);
  wpcsDirections := TTabSheet.Create(Self);
  WebPanel16 := TPanel.Create(Self);
  WebDBMemo1 := TDBMemo.Create(Self);
  WebPanel26 := TPanel.Create(Self);
  WebButton48 := TButton.Create(Self);
  btnSaveContract5 := TButton.Create(Self);
  WebButton50 := TButton.Create(Self);
  wpcsAllActiveContracts := TTabSheet.Create(Self);
  WebPanel25 := TPanel.Create(Self);
  WebPanel30 := TPanel.Create(Self);
  WebLabel55 := TLabel.Create(Self);
  WebLabel57 := TLabel.Create(Self);
  WebButton63 := TButton.Create(Self);
  WebButton65 := TButton.Create(Self);
  btnCloseContract := TButton.Create(Self);
  WebButton67 := TButton.Create(Self);
  edtSearchDescription := TEdit.Create(Self);
  WebButton68 := TButton.Create(Self);
  edtSearchActiveContracts := TEdit.Create(Self);
  dgActiveContractsList := TTMSFNCDataGrid.Create(Self);
  dgdbaActiveContractsList := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPanel31 := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  edtActiveContractsPageCount := TEdit.Create(Self);
  wpcsClosedContracts := TTabSheet.Create(Self);
  WebPanel5 := TPanel.Create(Self);
  WebPanel17 := TPanel.Create(Self);
  WebLabel41 := TLabel.Create(Self);
  WebLabel42 := TLabel.Create(Self);
  btnOpenContract := TButton.Create(Self);
  WebButton36 := TButton.Create(Self);
  edtSearchContractDescription := TEdit.Create(Self);
  edtSearchClosedContracts := TEdit.Create(Self);
  dgClosedContracts := TTMSFNCDataGrid.Create(Self);
  dgdbaClosedContracts := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  WebPanel32 := TPanel.Create(Self);
  edtClosedContractsPC := TEdit.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebSpeedButton11 := TSpeedButton.Create(Self);
  WebSpeedButton12 := TSpeedButton.Create(Self);
  wpcsContractInportSetup := TTabSheet.Create(Self);
  WebPanel6 := TPanel.Create(Self);
  WebPanel18 := TPanel.Create(Self);
  WebLabel43 := TLabel.Create(Self);
  edtActiveContractsImportSearch := TEdit.Create(Self);
  WebButton17 := TButton.Create(Self);
  WebRadioGroup3 := TRadioGroup.Create(Self);
  WebButton19 := TButton.Create(Self);
  WebButton28 := TButton.Create(Self);
  WebPanel19 := TPanel.Create(Self);
  dgContractImportsetup := TTMSFNCDataGrid.Create(Self);
  dgdbaContractImportSetup := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wpcsGlobalPriceIncrease := TTabSheet.Create(Self);
  WebPanel7 := TPanel.Create(Self);
  WebPanel21 := TPanel.Create(Self);
  WebGroupBox11 := TGroupBox.Create(Self);
  WebDBEdit65 := TDBEdit.Create(Self);
  WebButton42 := TButton.Create(Self);
  WebGroupBox12 := TGroupBox.Create(Self);
  WebRadioGroup1 := TRadioGroup.Create(Self);
  WebPanel22 := TPanel.Create(Self);
  WebRadioGroup2 := TRadioGroup.Create(Self);
  WebPanel23 := TPanel.Create(Self);
  WebButton43 := TButton.Create(Self);
  WebButton44 := TButton.Create(Self);
  WebButton45 := TButton.Create(Self);
  WebButton46 := TButton.Create(Self);
  WebButton47 := TButton.Create(Self);
  WebDateTimePicker1 := TDateTimePicker.Create(Self);
  TMSFNCDataGrid4 := TTMSFNCDataGrid.Create(Self);
  WebPanel24 := TPanel.Create(Self);
  WebLabel54 := TLabel.Create(Self);
  WebLabel56 := TLabel.Create(Self);
  WebLabel58 := TLabel.Create(Self);
  WebLabel60 := TLabel.Create(Self);
  WebLabel62 := TLabel.Create(Self);
  WebLabel64 := TLabel.Create(Self);
  WebLabel66 := TLabel.Create(Self);
  WebLabel68 := TLabel.Create(Self);
  WebDBLabel4 := TDBLabel.Create(Self);
  WebDBLabel5 := TDBLabel.Create(Self);
  WebDBLabel6 := TDBLabel.Create(Self);
  WebDBLabel7 := TDBLabel.Create(Self);
  WebDBLabel8 := TDBLabel.Create(Self);
  WebDBLabel9 := TDBLabel.Create(Self);
  WebDBLabel10 := TDBLabel.Create(Self);
  WebDBLabel11 := TDBLabel.Create(Self);
  wcAContracts := TXDataWebClient.Create(Self);
  wdsAContracts := TXDataWebDataSet.Create(Self);
  wdsAContractsCONTRACTNO := TIntegerField.Create(Self);
  wdsAContractsCONTRACTNAME := TStringField.Create(Self);
  wdsAContractsDEBCODE := TStringField.Create(Self);
  wdsAContractsCOMMODITIESNO := TIntegerField.Create(Self);
  wdsAContractsLOADCOUNTRYNO := TIntegerField.Create(Self);
  wdsAContractsLOADPROVINCENO := TIntegerField.Create(Self);
  wdsAContractsLOADCITYNO := TIntegerField.Create(Self);
  wdsAContractsLOADINGNO := TIntegerField.Create(Self);
  wdsAContractsOFFLOADCOUNTRYNO := TIntegerField.Create(Self);
  wdsAContractsOFFLOADPROVINCENO := TIntegerField.Create(Self);
  wdsAContractsOFFLOADCITYNO := TIntegerField.Create(Self);
  wdsAContractsOFFLOADINGNO := TIntegerField.Create(Self);
  wdsAContractsINVLOADING := TStringField.Create(Self);
  wdsAContractsINVOFFLOADING := TStringField.Create(Self);
  wdsAContractsTOTALTONS := TFloatField.Create(Self);
  wdsAContractsTOTALTONSORDER := TFloatField.Create(Self);
  wdsAContractsTOTALTONSLOADED := TFloatField.Create(Self);
  wdsAContractsTOTALTONSOFFLOADED := TFloatField.Create(Self);
  wdsAContractsTOTALTONSINVOICED := TFloatField.Create(Self);
  wdsAContractsCOMPLETED := TStringField.Create(Self);
  wdsAContractsCONTROLLER := TStringField.Create(Self);
  wdsAContractsAVGTONS := TFloatField.Create(Self);
  wdsAContractsTOTALLOADS := TIntegerField.Create(Self);
  wdsAContractsLOADSORDER := TIntegerField.Create(Self);
  wdsAContractsLOADSLOADED := TIntegerField.Create(Self);
  wdsAContractsLOADSOFFLOADED := TIntegerField.Create(Self);
  wdsAContractsLOADSINVOICED := TIntegerField.Create(Self);
  wdsAContractsPAYMENTTERMS := TIntegerField.Create(Self);
  wdsAContractsPAYMENTTYPE := TIntegerField.Create(Self);
  wdsAContractsADDHOC := TStringField.Create(Self);
  wdsAContractsDEDICATED := TStringField.Create(Self);
  wdsAContractsORDERNO := TStringField.Create(Self);
  wdsAContractsINVVAT := TStringField.Create(Self);
  wdsAContractsMULTILOADINV := TStringField.Create(Self);
  wdsAContractsSENDED := TStringField.Create(Self);
  wdsAContractsPRELISTING := TStringField.Create(Self);
  wdsAContractsPOSTLISTING := TStringField.Create(Self);
  wdsAContractsINVOICETYPE := TStringField.Create(Self);
  wdsAContractsDISTANCE := TFloatField.Create(Self);
  wdsAContractsDRIVERRATIO := TSmallintField.Create(Self);
  wdsAContractsCUTOFF1 := TSmallintField.Create(Self);
  wdsAContractsCUTOFFPERIOD1 := TIntegerField.Create(Self);
  wdsAContractsCUTOFF2 := TSmallintField.Create(Self);
  wdsAContractsCUTOFFPERIOD2 := TIntegerField.Create(Self);
  wdsAContractsSAGEINVENTORY := TStringField.Create(Self);
  wdsAContractsSAGEGL := TStringField.Create(Self);
  wdsAContractsSAGECODE := TStringField.Create(Self);
  wdsAContractsSAGEEXPCODE := TStringField.Create(Self);
  wdsAContractsSTRATERATE := TStringField.Create(Self);
  wdsAContractsCHGOFFLOAD := TStringField.Create(Self);
  wdsAContractsCHGPRICE := TStringField.Create(Self);
  wdsAContractsCAPTURETONS := TStringField.Create(Self);
  wdsAContractsINVOICETONS := TStringField.Create(Self);
  wdsAContractsCHGSUBPRICE := TStringField.Create(Self);
  wdsAContractsMAXLOADORDERS := TIntegerField.Create(Self);
  wdsAContractsADDDESCRIPTION := TStringField.Create(Self);
  wdsAContractsVARIANCETYPE := TIntegerField.Create(Self);
  wdsAContractsVARIANCEVALUE := TFloatField.Create(Self);
  wdsAContractsPRINTLC := TStringField.Create(Self);
  wdsAContractsPRINTDN := TStringField.Create(Self);
  wdsAContractsPRINTTS := TStringField.Create(Self);
  wdsAContractsDNTYPE := TStringField.Create(Self);
  wdsAContractsTSTYPE := TStringField.Create(Self);
  wdsAContractsSHORTDESC := TStringField.Create(Self);
  wdsAContractsOLDLOADSCREEN := TStringField.Create(Self);
  wdsAContractsSHOWBOOKINGS := TStringField.Create(Self);
  wdsAContractsSHOWADDITIONAL := TStringField.Create(Self);
  wdsAContractsPRICETYPE := TIntegerField.Create(Self);
  wdsAContractsUSEDOCKETINVNO := TStringField.Create(Self);
  wdsAContractsSAGECODE2 := TStringField.Create(Self);
  wdsAContractsSAGEEXPCODE2 := TStringField.Create(Self);
  wdsAContractsSAGEINVENTORY2 := TStringField.Create(Self);
  wdsAContractsSAGEGL2 := TStringField.Create(Self);
  wdsAContractsHAULAGETYPE := TStringField.Create(Self);
  wdsAContractsLINKZEROML := TStringField.Create(Self);
  wdsAContractsATTACHEDEMAIL := TStringField.Create(Self);
  wdsAContractsCLIENTLINKCONTRACT := TIntegerField.Create(Self);
  wdsAContractsQUOTEREFNO := TStringField.Create(Self);
  wdsAContractsSORTLOADDATE := TStringField.Create(Self);
  wdsAContractsSORTOFFDATE := TStringField.Create(Self);
  wdsAContractsSORTLOADWAY := TStringField.Create(Self);
  wdsAContractsSORTOFFWAY := TStringField.Create(Self);
  wdsAContractsSORTDOCKET := TStringField.Create(Self);
  wdsAContractsSINVVAT := TStringField.Create(Self);
  wdsAContractsLOADINSTRUCTQTY := TFloatField.Create(Self);
  wdsAContractsCHGLOAD := TStringField.Create(Self);
  wdsAContractssoanalysiscat1 := TStringField.Create(Self);
  wdsAContractssoanalysiscat2 := TStringField.Create(Self);
  wdsAContractssoanalysiscat3 := TStringField.Create(Self);
  wdsAContractsmaxdrivetime := TStringField.Create(Self);
  wdsAContractsmaxtrafeltime := TTimeField.Create(Self);
  wdsAContractsfirstwarning := TIntegerField.Create(Self);
  wdsAContractssecondwarning := TIntegerField.Create(Self);
  wdsAContractsslots := TIntegerField.Create(Self);
  wdsAContractsSTARTDATE := TDateField.Create(Self);
  wdsAContractsCOMPDATE := TDateField.Create(Self);
  wdsAContractsSENDEDDATE := TDateField.Create(Self);
  wdsAContractsDEB_CODE := TStringField.Create(Self);
  wdsAContractsDEB_NAME := TStringField.Create(Self);
  wdsAContractsSUSPENDED := TStringField.Create(Self);
  wdsAContractsCREDITLIMIT := TFloatField.Create(Self);
  wdsAContractsORDERBALANCE := TFloatField.Create(Self);
  wdsAContractsINVOICEBALANCE := TFloatField.Create(Self);
  wdsAContractsAVAILIBLECL := TFloatField.Create(Self);
  wdsAContractsCLIENTMULTILOADINV := TStringField.Create(Self);
  wdsAContractsMULTILOADDESC := TStringField.Create(Self);
  wdsAContractsCLIENTINVOICETYPE := TStringField.Create(Self);
  wdsAContractsMULTICONTRACT := TStringField.Create(Self);
  wdsAContractsCLIENTLINKED := TStringField.Create(Self);
  wdsAContractsCLIENTEMAIL := TStringField.Create(Self);
  wdsAContractsLINKEDCONFIG := TStringField.Create(Self);
  wdsAContractsACCOUNTNUMBER := TStringField.Create(Self);
  wdsAContractsMAINBALANCE := TFloatField.Create(Self);
  wdsAContractsMAINTENANCELINKACCOUNT := TStringField.Create(Self);
  wdsAContractsEXPORTLIST := TStringField.Create(Self);
  wdsAContractsEXPORTLOADS := TStringField.Create(Self);
  wdsAContractsRENAMEFIELD := TStringField.Create(Self);
  wdsAContractsEXPORTPATH := TStringField.Create(Self);
  wdsAContractsPREVCL := TFloatField.Create(Self);
  wdsAContractsSECUREBOOK := TStringField.Create(Self);
  wdsAContractsQUOTESYSTEM := TStringField.Create(Self);
  wdsAContractsQUOTETYPE := TStringField.Create(Self);
  wdsAContractsEMAILLOADDOCS := TStringField.Create(Self);
  wdsAContractsSTATEMENTTYPE := TStringField.Create(Self);
  wdsAContractsSHOWRECLOADS := TStringField.Create(Self);
  wdsAContractsLINKEDINVTYPE := TStringField.Create(Self);
  wdsAContractsDEFINVCOMPNO := TIntegerField.Create(Self);
  wdsAContractsinvoicetypenoncon := TStringField.Create(Self);
  wdsAContractssinglenoncon := TStringField.Create(Self);
  wdsAContractsLINKSERIAL := TStringField.Create(Self);
  wdsAContractsLINKAPI := TStringField.Create(Self);
  wdsAContractsserverip := TStringField.Create(Self);
  wdsAContractsserverport := TIntegerField.Create(Self);
  wdsAContractsserveruser := TStringField.Create(Self);
  wdsAContractsserverpassword := TStringField.Create(Self);
  wdsAContractsserveraccount := TStringField.Create(Self);
  wdsAContractsaltserverip := TStringField.Create(Self);
  wdsAContractsaltserverport := TIntegerField.Create(Self);
  wdsAContractsaltserveruser := TStringField.Create(Self);
  wdsAContractsaltserverpassword := TStringField.Create(Self);
  wdsAContractsserversystem := TStringField.Create(Self);
  wdsAContractsNo := TIntegerField.Create(Self);
  wdsAContractsNAME := TStringField.Create(Self);
  wdsAContractsITEMCODE := TStringField.Create(Self);
  wdsAContractsSTORE := TIntegerField.Create(Self);
  wdsAContractsUNITNUMBER := TStringField.Create(Self);
  wdsAContractsDENSITY := TFloatField.Create(Self);
  wdsAContractsLoadCountryName := TStringField.Create(Self);
  wdsAContractsLoadProvinceName := TStringField.Create(Self);
  wdsAContractsLoadCityName := TStringField.Create(Self);
  wdsAContractsLoadInfoName := TStringField.Create(Self);
  wdsAContractsOffLoadCountryName := TStringField.Create(Self);
  wdsAContractsOffLoadProvinceName := TStringField.Create(Self);
  wdsAContractsOffLoadCityName := TStringField.Create(Self);
  wdsAContractsOffLoadInfoName := TStringField.Create(Self);
  wdsAContractsCommodityName := TStringField.Create(Self);
  wdsAContractsPayTermsName := TStringField.Create(Self);
  wdsAContractsCONTROLLERName := TStringField.Create(Self);
  wdsAContractsCutOffPeriodDesc1 := TStringField.Create(Self);
  wdsAContractsCutOffPeriodDesc2 := TIntegerField.Create(Self);
  wdsAContractsCutOffPeriodDesc22 := TStringField.Create(Self);
  wdsAContractsClientName := TStringField.Create(Self);
  dsAContracts := TDataSource.Create(Self);
  wcContractPrices := TXDataWebClient.Create(Self);
  wdsContractPrices := TXDataWebDataSet.Create(Self);
  wdsContractPricesAUTONO := TIntegerField.Create(Self);
  wdsContractPricesCONTRACTNO := TIntegerField.Create(Self);
  wdsContractPricesSTARTDATE := TStringField.Create(Self);
  wdsContractPricesENDDATE := TStringField.Create(Self);
  wdsContractPricesCOSTPRICE := TFloatField.Create(Self);
  wdsContractPricesSUBPRICE := TFloatField.Create(Self);
  wdsContractPricesDEDPRICE := TFloatField.Create(Self);
  wdsContractPricesSPEPRICE := TFloatField.Create(Self);
  wdsContractPricesCONFIREMED := TStringField.Create(Self);
  wdsContractPricesPRICELOADDATE := TStringField.Create(Self);
  wdsContractPricesPRICELOADBY := TStringField.Create(Self);
  wdsContractPricesPRICECONFIRMDATE := TStringField.Create(Self);
  wdsContractPricesPRICECONFIRMBY := TStringField.Create(Self);
  wdsContractPriceskmsprice := TFloatField.Create(Self);
  wdsContractPricestollprice := TFloatField.Create(Self);
  dsContractPrices := TDataSource.Create(Self);
  wdsClosedContracts := TXDataWebDataSet.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  StringField1 := TStringField.Create(Self);
  StringField2 := TStringField.Create(Self);
  IntegerField2 := TIntegerField.Create(Self);
  IntegerField3 := TIntegerField.Create(Self);
  IntegerField4 := TIntegerField.Create(Self);
  IntegerField5 := TIntegerField.Create(Self);
  IntegerField6 := TIntegerField.Create(Self);
  IntegerField7 := TIntegerField.Create(Self);
  IntegerField8 := TIntegerField.Create(Self);
  IntegerField9 := TIntegerField.Create(Self);
  IntegerField10 := TIntegerField.Create(Self);
  StringField3 := TStringField.Create(Self);
  StringField4 := TStringField.Create(Self);
  FloatField1 := TFloatField.Create(Self);
  FloatField2 := TFloatField.Create(Self);
  FloatField3 := TFloatField.Create(Self);
  FloatField4 := TFloatField.Create(Self);
  FloatField5 := TFloatField.Create(Self);
  StringField5 := TStringField.Create(Self);
  StringField6 := TStringField.Create(Self);
  FloatField6 := TFloatField.Create(Self);
  IntegerField11 := TIntegerField.Create(Self);
  IntegerField12 := TIntegerField.Create(Self);
  IntegerField13 := TIntegerField.Create(Self);
  IntegerField14 := TIntegerField.Create(Self);
  IntegerField15 := TIntegerField.Create(Self);
  IntegerField16 := TIntegerField.Create(Self);
  IntegerField17 := TIntegerField.Create(Self);
  StringField7 := TStringField.Create(Self);
  StringField8 := TStringField.Create(Self);
  StringField9 := TStringField.Create(Self);
  StringField10 := TStringField.Create(Self);
  StringField11 := TStringField.Create(Self);
  StringField12 := TStringField.Create(Self);
  StringField13 := TStringField.Create(Self);
  StringField14 := TStringField.Create(Self);
  StringField15 := TStringField.Create(Self);
  FloatField7 := TFloatField.Create(Self);
  SmallintField1 := TSmallintField.Create(Self);
  SmallintField2 := TSmallintField.Create(Self);
  IntegerField18 := TIntegerField.Create(Self);
  SmallintField3 := TSmallintField.Create(Self);
  IntegerField19 := TIntegerField.Create(Self);
  StringField16 := TStringField.Create(Self);
  StringField17 := TStringField.Create(Self);
  StringField18 := TStringField.Create(Self);
  StringField19 := TStringField.Create(Self);
  StringField20 := TStringField.Create(Self);
  StringField21 := TStringField.Create(Self);
  StringField22 := TStringField.Create(Self);
  StringField23 := TStringField.Create(Self);
  StringField24 := TStringField.Create(Self);
  StringField25 := TStringField.Create(Self);
  IntegerField20 := TIntegerField.Create(Self);
  StringField26 := TStringField.Create(Self);
  IntegerField21 := TIntegerField.Create(Self);
  FloatField8 := TFloatField.Create(Self);
  StringField27 := TStringField.Create(Self);
  StringField28 := TStringField.Create(Self);
  StringField29 := TStringField.Create(Self);
  StringField30 := TStringField.Create(Self);
  StringField31 := TStringField.Create(Self);
  StringField32 := TStringField.Create(Self);
  StringField33 := TStringField.Create(Self);
  StringField34 := TStringField.Create(Self);
  StringField35 := TStringField.Create(Self);
  IntegerField22 := TIntegerField.Create(Self);
  StringField36 := TStringField.Create(Self);
  StringField37 := TStringField.Create(Self);
  StringField38 := TStringField.Create(Self);
  StringField39 := TStringField.Create(Self);
  StringField40 := TStringField.Create(Self);
  StringField41 := TStringField.Create(Self);
  StringField42 := TStringField.Create(Self);
  StringField43 := TStringField.Create(Self);
  IntegerField23 := TIntegerField.Create(Self);
  StringField44 := TStringField.Create(Self);
  StringField45 := TStringField.Create(Self);
  StringField46 := TStringField.Create(Self);
  StringField47 := TStringField.Create(Self);
  StringField48 := TStringField.Create(Self);
  StringField49 := TStringField.Create(Self);
  StringField50 := TStringField.Create(Self);
  FloatField9 := TFloatField.Create(Self);
  StringField51 := TStringField.Create(Self);
  StringField52 := TStringField.Create(Self);
  StringField53 := TStringField.Create(Self);
  StringField54 := TStringField.Create(Self);
  StringField55 := TStringField.Create(Self);
  TimeField1 := TTimeField.Create(Self);
  IntegerField24 := TIntegerField.Create(Self);
  IntegerField25 := TIntegerField.Create(Self);
  IntegerField26 := TIntegerField.Create(Self);
  DateField1 := TDateField.Create(Self);
  DateField2 := TDateField.Create(Self);
  DateField3 := TDateField.Create(Self);
  StringField56 := TStringField.Create(Self);
  StringField57 := TStringField.Create(Self);
  StringField58 := TStringField.Create(Self);
  FloatField10 := TFloatField.Create(Self);
  FloatField11 := TFloatField.Create(Self);
  FloatField12 := TFloatField.Create(Self);
  FloatField13 := TFloatField.Create(Self);
  StringField59 := TStringField.Create(Self);
  StringField60 := TStringField.Create(Self);
  StringField61 := TStringField.Create(Self);
  StringField62 := TStringField.Create(Self);
  StringField63 := TStringField.Create(Self);
  StringField64 := TStringField.Create(Self);
  StringField65 := TStringField.Create(Self);
  StringField66 := TStringField.Create(Self);
  FloatField14 := TFloatField.Create(Self);
  StringField67 := TStringField.Create(Self);
  StringField68 := TStringField.Create(Self);
  StringField69 := TStringField.Create(Self);
  StringField70 := TStringField.Create(Self);
  StringField71 := TStringField.Create(Self);
  FloatField15 := TFloatField.Create(Self);
  StringField72 := TStringField.Create(Self);
  StringField73 := TStringField.Create(Self);
  StringField74 := TStringField.Create(Self);
  StringField75 := TStringField.Create(Self);
  StringField76 := TStringField.Create(Self);
  StringField77 := TStringField.Create(Self);
  StringField78 := TStringField.Create(Self);
  IntegerField27 := TIntegerField.Create(Self);
  StringField79 := TStringField.Create(Self);
  StringField80 := TStringField.Create(Self);
  StringField81 := TStringField.Create(Self);
  StringField82 := TStringField.Create(Self);
  StringField83 := TStringField.Create(Self);
  IntegerField28 := TIntegerField.Create(Self);
  StringField84 := TStringField.Create(Self);
  StringField85 := TStringField.Create(Self);
  StringField86 := TStringField.Create(Self);
  StringField87 := TStringField.Create(Self);
  IntegerField29 := TIntegerField.Create(Self);
  StringField88 := TStringField.Create(Self);
  StringField89 := TStringField.Create(Self);
  StringField90 := TStringField.Create(Self);
  IntegerField30 := TIntegerField.Create(Self);
  StringField91 := TStringField.Create(Self);
  StringField92 := TStringField.Create(Self);
  IntegerField31 := TIntegerField.Create(Self);
  StringField93 := TStringField.Create(Self);
  FloatField16 := TFloatField.Create(Self);
  wcClosedContracts := TXDataWebClient.Create(Self);
  dsClosedContracts := TDataSource.Create(Self);
  WebRESTClient1 := TRESTClient.Create(Self);
  wcAContractImportSetup := TXDataWebClient.Create(Self);
  wdsAContractImportSetup := TXDataWebDataSet.Create(Self);
  IntegerField32 := TIntegerField.Create(Self);
  StringField94 := TStringField.Create(Self);
  StringField95 := TStringField.Create(Self);
  IntegerField33 := TIntegerField.Create(Self);
  IntegerField34 := TIntegerField.Create(Self);
  IntegerField35 := TIntegerField.Create(Self);
  IntegerField36 := TIntegerField.Create(Self);
  IntegerField37 := TIntegerField.Create(Self);
  IntegerField38 := TIntegerField.Create(Self);
  IntegerField39 := TIntegerField.Create(Self);
  IntegerField40 := TIntegerField.Create(Self);
  IntegerField41 := TIntegerField.Create(Self);
  StringField96 := TStringField.Create(Self);
  StringField97 := TStringField.Create(Self);
  FloatField17 := TFloatField.Create(Self);
  FloatField18 := TFloatField.Create(Self);
  FloatField19 := TFloatField.Create(Self);
  FloatField20 := TFloatField.Create(Self);
  FloatField21 := TFloatField.Create(Self);
  StringField98 := TStringField.Create(Self);
  StringField99 := TStringField.Create(Self);
  FloatField22 := TFloatField.Create(Self);
  IntegerField42 := TIntegerField.Create(Self);
  IntegerField43 := TIntegerField.Create(Self);
  IntegerField44 := TIntegerField.Create(Self);
  IntegerField45 := TIntegerField.Create(Self);
  IntegerField46 := TIntegerField.Create(Self);
  IntegerField47 := TIntegerField.Create(Self);
  IntegerField48 := TIntegerField.Create(Self);
  StringField100 := TStringField.Create(Self);
  StringField101 := TStringField.Create(Self);
  StringField102 := TStringField.Create(Self);
  StringField103 := TStringField.Create(Self);
  StringField104 := TStringField.Create(Self);
  StringField105 := TStringField.Create(Self);
  StringField106 := TStringField.Create(Self);
  StringField107 := TStringField.Create(Self);
  StringField108 := TStringField.Create(Self);
  FloatField23 := TFloatField.Create(Self);
  SmallintField4 := TSmallintField.Create(Self);
  SmallintField5 := TSmallintField.Create(Self);
  IntegerField49 := TIntegerField.Create(Self);
  SmallintField6 := TSmallintField.Create(Self);
  IntegerField50 := TIntegerField.Create(Self);
  StringField109 := TStringField.Create(Self);
  StringField110 := TStringField.Create(Self);
  StringField111 := TStringField.Create(Self);
  StringField112 := TStringField.Create(Self);
  StringField113 := TStringField.Create(Self);
  StringField114 := TStringField.Create(Self);
  StringField115 := TStringField.Create(Self);
  StringField116 := TStringField.Create(Self);
  StringField117 := TStringField.Create(Self);
  StringField118 := TStringField.Create(Self);
  IntegerField51 := TIntegerField.Create(Self);
  StringField119 := TStringField.Create(Self);
  IntegerField52 := TIntegerField.Create(Self);
  FloatField24 := TFloatField.Create(Self);
  StringField120 := TStringField.Create(Self);
  StringField121 := TStringField.Create(Self);
  StringField122 := TStringField.Create(Self);
  StringField123 := TStringField.Create(Self);
  StringField124 := TStringField.Create(Self);
  StringField125 := TStringField.Create(Self);
  StringField126 := TStringField.Create(Self);
  StringField127 := TStringField.Create(Self);
  StringField128 := TStringField.Create(Self);
  IntegerField53 := TIntegerField.Create(Self);
  StringField129 := TStringField.Create(Self);
  StringField130 := TStringField.Create(Self);
  StringField131 := TStringField.Create(Self);
  StringField132 := TStringField.Create(Self);
  StringField133 := TStringField.Create(Self);
  StringField134 := TStringField.Create(Self);
  StringField135 := TStringField.Create(Self);
  StringField136 := TStringField.Create(Self);
  IntegerField54 := TIntegerField.Create(Self);
  StringField137 := TStringField.Create(Self);
  StringField138 := TStringField.Create(Self);
  StringField139 := TStringField.Create(Self);
  StringField140 := TStringField.Create(Self);
  StringField141 := TStringField.Create(Self);
  StringField142 := TStringField.Create(Self);
  StringField143 := TStringField.Create(Self);
  FloatField25 := TFloatField.Create(Self);
  StringField144 := TStringField.Create(Self);
  StringField145 := TStringField.Create(Self);
  StringField146 := TStringField.Create(Self);
  StringField147 := TStringField.Create(Self);
  StringField148 := TStringField.Create(Self);
  TimeField2 := TTimeField.Create(Self);
  IntegerField55 := TIntegerField.Create(Self);
  IntegerField56 := TIntegerField.Create(Self);
  IntegerField57 := TIntegerField.Create(Self);
  DateField4 := TDateField.Create(Self);
  DateField5 := TDateField.Create(Self);
  DateField6 := TDateField.Create(Self);
  StringField149 := TStringField.Create(Self);
  StringField150 := TStringField.Create(Self);
  StringField151 := TStringField.Create(Self);
  FloatField26 := TFloatField.Create(Self);
  FloatField27 := TFloatField.Create(Self);
  FloatField28 := TFloatField.Create(Self);
  FloatField29 := TFloatField.Create(Self);
  StringField152 := TStringField.Create(Self);
  StringField153 := TStringField.Create(Self);
  StringField154 := TStringField.Create(Self);
  StringField155 := TStringField.Create(Self);
  StringField156 := TStringField.Create(Self);
  StringField157 := TStringField.Create(Self);
  StringField158 := TStringField.Create(Self);
  StringField159 := TStringField.Create(Self);
  FloatField30 := TFloatField.Create(Self);
  StringField160 := TStringField.Create(Self);
  StringField161 := TStringField.Create(Self);
  StringField162 := TStringField.Create(Self);
  StringField163 := TStringField.Create(Self);
  StringField164 := TStringField.Create(Self);
  FloatField31 := TFloatField.Create(Self);
  StringField165 := TStringField.Create(Self);
  StringField166 := TStringField.Create(Self);
  StringField167 := TStringField.Create(Self);
  StringField168 := TStringField.Create(Self);
  StringField169 := TStringField.Create(Self);
  StringField170 := TStringField.Create(Self);
  StringField171 := TStringField.Create(Self);
  IntegerField58 := TIntegerField.Create(Self);
  StringField172 := TStringField.Create(Self);
  StringField173 := TStringField.Create(Self);
  StringField174 := TStringField.Create(Self);
  StringField175 := TStringField.Create(Self);
  StringField176 := TStringField.Create(Self);
  IntegerField59 := TIntegerField.Create(Self);
  StringField177 := TStringField.Create(Self);
  StringField178 := TStringField.Create(Self);
  StringField179 := TStringField.Create(Self);
  StringField180 := TStringField.Create(Self);
  IntegerField60 := TIntegerField.Create(Self);
  StringField181 := TStringField.Create(Self);
  StringField182 := TStringField.Create(Self);
  StringField183 := TStringField.Create(Self);
  IntegerField61 := TIntegerField.Create(Self);
  StringField184 := TStringField.Create(Self);
  StringField185 := TStringField.Create(Self);
  IntegerField62 := TIntegerField.Create(Self);
  StringField186 := TStringField.Create(Self);
  FloatField32 := TFloatField.Create(Self);
  StringField187 := TStringField.Create(Self);
  StringField188 := TStringField.Create(Self);
  StringField189 := TStringField.Create(Self);
  StringField190 := TStringField.Create(Self);
  StringField191 := TStringField.Create(Self);
  StringField192 := TStringField.Create(Self);
  StringField193 := TStringField.Create(Self);
  StringField194 := TStringField.Create(Self);
  StringField195 := TStringField.Create(Self);
  StringField196 := TStringField.Create(Self);
  StringField197 := TStringField.Create(Self);
  StringField198 := TStringField.Create(Self);
  IntegerField63 := TIntegerField.Create(Self);
  StringField199 := TStringField.Create(Self);
  dsAContractImportSetup := TDataSource.Create(Self);

  WebDBLabel12.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  BitMapContainer1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebSpeedButton13.BeforeLoadDFMValues;
  WebSpeedButton14.BeforeLoadDFMValues;
  WebSpeedButton15.BeforeLoadDFMValues;
  WebSpeedButton16.BeforeLoadDFMValues;
  edtActiveContractImportPC.BeforeLoadDFMValues;
  wpcContractInfo.BeforeLoadDFMValues;
  wpcsActiveContracts.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  wpcActiveContracts.BeforeLoadDFMValues;
  wpcsContractInfo.BeforeLoadDFMValues;
  WebPanel8.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebDBLabel13.BeforeLoadDFMValues;
  dbedtClientName.BeforeLoadDFMValues;
  dbedtShortdescription.BeforeLoadDFMValues;
  dbedtLongDescription.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  dbedtLoadType.BeforeLoadDFMValues;
  WebDBRadioGroup1.BeforeLoadDFMValues;
  WebGroupBox1.BeforeLoadDFMValues;
  WebDBEdit7.BeforeLoadDFMValues;
  WebDBEdit8.BeforeLoadDFMValues;
  WebDBEdit9.BeforeLoadDFMValues;
  WebDBEdit10.BeforeLoadDFMValues;
  WebButton3.BeforeLoadDFMValues;
  WebButton4.BeforeLoadDFMValues;
  WebButton5.BeforeLoadDFMValues;
  WebButton6.BeforeLoadDFMValues;
  WebGroupBox2.BeforeLoadDFMValues;
  WebDBEdit11.BeforeLoadDFMValues;
  WebDBEdit12.BeforeLoadDFMValues;
  WebDBEdit13.BeforeLoadDFMValues;
  WebDBEdit14.BeforeLoadDFMValues;
  WebButton7.BeforeLoadDFMValues;
  WebButton8.BeforeLoadDFMValues;
  WebButton9.BeforeLoadDFMValues;
  WebButton10.BeforeLoadDFMValues;
  WebGroupBox3.BeforeLoadDFMValues;
  WebDBEdit15.BeforeLoadDFMValues;
  WebButton11.BeforeLoadDFMValues;
  WebButton33.BeforeLoadDFMValues;
  WebButton34.BeforeLoadDFMValues;
  WebPanel29.BeforeLoadDFMValues;
  WebButton60.BeforeLoadDFMValues;
  btnSaveContract1.BeforeLoadDFMValues;
  WebButton62.BeforeLoadDFMValues;
  WebButton30.BeforeLoadDFMValues;
  wpcsAdditionalInfo.BeforeLoadDFMValues;
  WebPanel9.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebLabel26.BeforeLoadDFMValues;
  WebLabel27.BeforeLoadDFMValues;
  WebLabel28.BeforeLoadDFMValues;
  WebLabel29.BeforeLoadDFMValues;
  dbedtCpatureType.BeforeLoadDFMValues;
  WebDBEdit17.BeforeLoadDFMValues;
  WebDBEdit18.BeforeLoadDFMValues;
  WebDBEdit19.BeforeLoadDFMValues;
  WebDBEdit20.BeforeLoadDFMValues;
  WebDBEdit21.BeforeLoadDFMValues;
  WebDBEdit23.BeforeLoadDFMValues;
  WebDBEdit24.BeforeLoadDFMValues;
  WebDBEdit25.BeforeLoadDFMValues;
  WebDBDateTimePicker1.BeforeLoadDFMValues;
  WebButton12.BeforeLoadDFMValues;
  cbxDedicated.BeforeLoadDFMValues;
  cbxADHOC.BeforeLoadDFMValues;
  WebButton13.BeforeLoadDFMValues;
  WebDBEdit22.BeforeLoadDFMValues;
  WebDBEdit26.BeforeLoadDFMValues;
  WebDBEdit27.BeforeLoadDFMValues;
  WebDBMaskEdit1.BeforeLoadDFMValues;
  WebButton14.BeforeLoadDFMValues;
  WebButton15.BeforeLoadDFMValues;
  WebButton16.BeforeLoadDFMValues;
  WebDBEdit28.BeforeLoadDFMValues;
  WebDBEdit29.BeforeLoadDFMValues;
  WebDBEdit30.BeforeLoadDFMValues;
  WebDBEdit31.BeforeLoadDFMValues;
  WebDBEdit32.BeforeLoadDFMValues;
  WebDBEdit33.BeforeLoadDFMValues;
  WebDBEdit34.BeforeLoadDFMValues;
  WebDBEdit35.BeforeLoadDFMValues;
  WebDBEdit36.BeforeLoadDFMValues;
  WebDBEdit37.BeforeLoadDFMValues;
  WebPanel28.BeforeLoadDFMValues;
  WebButton57.BeforeLoadDFMValues;
  btnSaveContract2.BeforeLoadDFMValues;
  WebButton59.BeforeLoadDFMValues;
  wpcsBillingInformation.BeforeLoadDFMValues;
  WebPanel11.BeforeLoadDFMValues;
  WebLabel30.BeforeLoadDFMValues;
  WebLabel33.BeforeLoadDFMValues;
  WebLabel34.BeforeLoadDFMValues;
  WebLabel35.BeforeLoadDFMValues;
  WebLabel36.BeforeLoadDFMValues;
  WebLabel37.BeforeLoadDFMValues;
  WebGroupBox4.BeforeLoadDFMValues;
  WebDBCheckBox13.BeforeLoadDFMValues;
  WebDBCheckBox14.BeforeLoadDFMValues;
  WebDBCheckBox15.BeforeLoadDFMValues;
  WebDBCheckBox16.BeforeLoadDFMValues;
  WebDBCheckBox17.BeforeLoadDFMValues;
  WebDBCheckBox18.BeforeLoadDFMValues;
  WebDBCheckBox19.BeforeLoadDFMValues;
  WebDBCheckBox20.BeforeLoadDFMValues;
  WebDBCheckBox21.BeforeLoadDFMValues;
  WebDBCheckBox22.BeforeLoadDFMValues;
  WebDBCheckBox23.BeforeLoadDFMValues;
  WebDBCheckBox24.BeforeLoadDFMValues;
  WebDBCheckBox25.BeforeLoadDFMValues;
  WebDBCheckBox26.BeforeLoadDFMValues;
  WebDBCheckBox27.BeforeLoadDFMValues;
  WebDBCheckBox28.BeforeLoadDFMValues;
  WebDBCheckBox29.BeforeLoadDFMValues;
  WebDBCheckBox30.BeforeLoadDFMValues;
  WebDBEdit38.BeforeLoadDFMValues;
  cbxMiltiLoadInvopice.BeforeLoadDFMValues;
  gbMiltiLoadInv.BeforeLoadDFMValues;
  WebDBCheckBox4.BeforeLoadDFMValues;
  WebDBCheckBox5.BeforeLoadDFMValues;
  WebPageControl1.BeforeLoadDFMValues;
  wpcsSageLinkInformation1.BeforeLoadDFMValues;
  WebPanel12.BeforeLoadDFMValues;
  WebLabel31.BeforeLoadDFMValues;
  WebDBCheckBox6.BeforeLoadDFMValues;
  WebDBEdit39.BeforeLoadDFMValues;
  WebDBEdit40.BeforeLoadDFMValues;
  wpcsSageLinkInformation2.BeforeLoadDFMValues;
  WebPanel13.BeforeLoadDFMValues;
  WebLabel32.BeforeLoadDFMValues;
  WebDBCheckBox7.BeforeLoadDFMValues;
  WebDBEdit41.BeforeLoadDFMValues;
  WebDBEdit42.BeforeLoadDFMValues;
  WebDBEdit44.BeforeLoadDFMValues;
  WebButton18.BeforeLoadDFMValues;
  WebDBEdit46.BeforeLoadDFMValues;
  WebButton20.BeforeLoadDFMValues;
  WebDBRadioGroup2.BeforeLoadDFMValues;
  WebDBEdit47.BeforeLoadDFMValues;
  WebGroupBox6.BeforeLoadDFMValues;
  WebDBCheckBox8.BeforeLoadDFMValues;
  WebDBCheckBox9.BeforeLoadDFMValues;
  WebDBCheckBox10.BeforeLoadDFMValues;
  WebDBCheckBox11.BeforeLoadDFMValues;
  WebDBCheckBox12.BeforeLoadDFMValues;
  edtInvoiceSelection.BeforeLoadDFMValues;
  WebDBEdit49.BeforeLoadDFMValues;
  WebDBEdit50.BeforeLoadDFMValues;
  WebButton21.BeforeLoadDFMValues;
  WebButton22.BeforeLoadDFMValues;
  WebButton23.BeforeLoadDFMValues;
  WebGroupBox7.BeforeLoadDFMValues;
  WebLabel38.BeforeLoadDFMValues;
  WebLabel39.BeforeLoadDFMValues;
  WebLabel40.BeforeLoadDFMValues;
  WebDBEdit51.BeforeLoadDFMValues;
  WebDBEdit52.BeforeLoadDFMValues;
  WebDBEdit53.BeforeLoadDFMValues;
  WebButton24.BeforeLoadDFMValues;
  WebButton25.BeforeLoadDFMValues;
  WebButton26.BeforeLoadDFMValues;
  WebPanel10.BeforeLoadDFMValues;
  WebButton54.BeforeLoadDFMValues;
  btnSaveContract3.BeforeLoadDFMValues;
  WebButton56.BeforeLoadDFMValues;
  WebDBComboBox1.BeforeLoadDFMValues;
  WebDBComboBox2.BeforeLoadDFMValues;
  cbbInvoiceSelection.BeforeLoadDFMValues;
  wpcsContractPricing.BeforeLoadDFMValues;
  WebPanel14.BeforeLoadDFMValues;
  WebPanel15.BeforeLoadDFMValues;
  WebButton27.BeforeLoadDFMValues;
  WebButton29.BeforeLoadDFMValues;
  WebButton31.BeforeLoadDFMValues;
  WebButton32.BeforeLoadDFMValues;
  dgContractPrices.BeforeLoadDFMValues;
  dgdbaContractPrices.BeforeLoadDFMValues;
  msgdlgContractPriceList.BeforeLoadDFMValues;
  WebPanel27.BeforeLoadDFMValues;
  WebButton51.BeforeLoadDFMValues;
  btnSaveContract4.BeforeLoadDFMValues;
  WebButton53.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  edtContractPriceListPC.BeforeLoadDFMValues;
  wpcsDirections.BeforeLoadDFMValues;
  WebPanel16.BeforeLoadDFMValues;
  WebDBMemo1.BeforeLoadDFMValues;
  WebPanel26.BeforeLoadDFMValues;
  WebButton48.BeforeLoadDFMValues;
  btnSaveContract5.BeforeLoadDFMValues;
  WebButton50.BeforeLoadDFMValues;
  wpcsAllActiveContracts.BeforeLoadDFMValues;
  WebPanel25.BeforeLoadDFMValues;
  WebPanel30.BeforeLoadDFMValues;
  WebLabel55.BeforeLoadDFMValues;
  WebLabel57.BeforeLoadDFMValues;
  WebButton63.BeforeLoadDFMValues;
  WebButton65.BeforeLoadDFMValues;
  btnCloseContract.BeforeLoadDFMValues;
  WebButton67.BeforeLoadDFMValues;
  edtSearchDescription.BeforeLoadDFMValues;
  WebButton68.BeforeLoadDFMValues;
  edtSearchActiveContracts.BeforeLoadDFMValues;
  dgActiveContractsList.BeforeLoadDFMValues;
  dgdbaActiveContractsList.BeforeLoadDFMValues;
  WebPanel31.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  edtActiveContractsPageCount.BeforeLoadDFMValues;
  wpcsClosedContracts.BeforeLoadDFMValues;
  WebPanel5.BeforeLoadDFMValues;
  WebPanel17.BeforeLoadDFMValues;
  WebLabel41.BeforeLoadDFMValues;
  WebLabel42.BeforeLoadDFMValues;
  btnOpenContract.BeforeLoadDFMValues;
  WebButton36.BeforeLoadDFMValues;
  edtSearchContractDescription.BeforeLoadDFMValues;
  edtSearchClosedContracts.BeforeLoadDFMValues;
  dgClosedContracts.BeforeLoadDFMValues;
  dgdbaClosedContracts.BeforeLoadDFMValues;
  WebPanel32.BeforeLoadDFMValues;
  edtClosedContractsPC.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebSpeedButton11.BeforeLoadDFMValues;
  WebSpeedButton12.BeforeLoadDFMValues;
  wpcsContractInportSetup.BeforeLoadDFMValues;
  WebPanel6.BeforeLoadDFMValues;
  WebPanel18.BeforeLoadDFMValues;
  WebLabel43.BeforeLoadDFMValues;
  edtActiveContractsImportSearch.BeforeLoadDFMValues;
  WebButton17.BeforeLoadDFMValues;
  WebRadioGroup3.BeforeLoadDFMValues;
  WebButton19.BeforeLoadDFMValues;
  WebButton28.BeforeLoadDFMValues;
  WebPanel19.BeforeLoadDFMValues;
  dgContractImportsetup.BeforeLoadDFMValues;
  dgdbaContractImportSetup.BeforeLoadDFMValues;
  wpcsGlobalPriceIncrease.BeforeLoadDFMValues;
  WebPanel7.BeforeLoadDFMValues;
  WebPanel21.BeforeLoadDFMValues;
  WebGroupBox11.BeforeLoadDFMValues;
  WebDBEdit65.BeforeLoadDFMValues;
  WebButton42.BeforeLoadDFMValues;
  WebGroupBox12.BeforeLoadDFMValues;
  WebRadioGroup1.BeforeLoadDFMValues;
  WebPanel22.BeforeLoadDFMValues;
  WebRadioGroup2.BeforeLoadDFMValues;
  WebPanel23.BeforeLoadDFMValues;
  WebButton43.BeforeLoadDFMValues;
  WebButton44.BeforeLoadDFMValues;
  WebButton45.BeforeLoadDFMValues;
  WebButton46.BeforeLoadDFMValues;
  WebButton47.BeforeLoadDFMValues;
  WebDateTimePicker1.BeforeLoadDFMValues;
  TMSFNCDataGrid4.BeforeLoadDFMValues;
  WebPanel24.BeforeLoadDFMValues;
  WebLabel54.BeforeLoadDFMValues;
  WebLabel56.BeforeLoadDFMValues;
  WebLabel58.BeforeLoadDFMValues;
  WebLabel60.BeforeLoadDFMValues;
  WebLabel62.BeforeLoadDFMValues;
  WebLabel64.BeforeLoadDFMValues;
  WebLabel66.BeforeLoadDFMValues;
  WebLabel68.BeforeLoadDFMValues;
  WebDBLabel4.BeforeLoadDFMValues;
  WebDBLabel5.BeforeLoadDFMValues;
  WebDBLabel6.BeforeLoadDFMValues;
  WebDBLabel7.BeforeLoadDFMValues;
  WebDBLabel8.BeforeLoadDFMValues;
  WebDBLabel9.BeforeLoadDFMValues;
  WebDBLabel10.BeforeLoadDFMValues;
  WebDBLabel11.BeforeLoadDFMValues;
  wcAContracts.BeforeLoadDFMValues;
  wdsAContracts.BeforeLoadDFMValues;
  wdsAContractsCONTRACTNO.BeforeLoadDFMValues;
  wdsAContractsCONTRACTNAME.BeforeLoadDFMValues;
  wdsAContractsDEBCODE.BeforeLoadDFMValues;
  wdsAContractsCOMMODITIESNO.BeforeLoadDFMValues;
  wdsAContractsLOADCOUNTRYNO.BeforeLoadDFMValues;
  wdsAContractsLOADPROVINCENO.BeforeLoadDFMValues;
  wdsAContractsLOADCITYNO.BeforeLoadDFMValues;
  wdsAContractsLOADINGNO.BeforeLoadDFMValues;
  wdsAContractsOFFLOADCOUNTRYNO.BeforeLoadDFMValues;
  wdsAContractsOFFLOADPROVINCENO.BeforeLoadDFMValues;
  wdsAContractsOFFLOADCITYNO.BeforeLoadDFMValues;
  wdsAContractsOFFLOADINGNO.BeforeLoadDFMValues;
  wdsAContractsINVLOADING.BeforeLoadDFMValues;
  wdsAContractsINVOFFLOADING.BeforeLoadDFMValues;
  wdsAContractsTOTALTONS.BeforeLoadDFMValues;
  wdsAContractsTOTALTONSORDER.BeforeLoadDFMValues;
  wdsAContractsTOTALTONSLOADED.BeforeLoadDFMValues;
  wdsAContractsTOTALTONSOFFLOADED.BeforeLoadDFMValues;
  wdsAContractsTOTALTONSINVOICED.BeforeLoadDFMValues;
  wdsAContractsCOMPLETED.BeforeLoadDFMValues;
  wdsAContractsCONTROLLER.BeforeLoadDFMValues;
  wdsAContractsAVGTONS.BeforeLoadDFMValues;
  wdsAContractsTOTALLOADS.BeforeLoadDFMValues;
  wdsAContractsLOADSORDER.BeforeLoadDFMValues;
  wdsAContractsLOADSLOADED.BeforeLoadDFMValues;
  wdsAContractsLOADSOFFLOADED.BeforeLoadDFMValues;
  wdsAContractsLOADSINVOICED.BeforeLoadDFMValues;
  wdsAContractsPAYMENTTERMS.BeforeLoadDFMValues;
  wdsAContractsPAYMENTTYPE.BeforeLoadDFMValues;
  wdsAContractsADDHOC.BeforeLoadDFMValues;
  wdsAContractsDEDICATED.BeforeLoadDFMValues;
  wdsAContractsORDERNO.BeforeLoadDFMValues;
  wdsAContractsINVVAT.BeforeLoadDFMValues;
  wdsAContractsMULTILOADINV.BeforeLoadDFMValues;
  wdsAContractsSENDED.BeforeLoadDFMValues;
  wdsAContractsPRELISTING.BeforeLoadDFMValues;
  wdsAContractsPOSTLISTING.BeforeLoadDFMValues;
  wdsAContractsINVOICETYPE.BeforeLoadDFMValues;
  wdsAContractsDISTANCE.BeforeLoadDFMValues;
  wdsAContractsDRIVERRATIO.BeforeLoadDFMValues;
  wdsAContractsCUTOFF1.BeforeLoadDFMValues;
  wdsAContractsCUTOFFPERIOD1.BeforeLoadDFMValues;
  wdsAContractsCUTOFF2.BeforeLoadDFMValues;
  wdsAContractsCUTOFFPERIOD2.BeforeLoadDFMValues;
  wdsAContractsSAGEINVENTORY.BeforeLoadDFMValues;
  wdsAContractsSAGEGL.BeforeLoadDFMValues;
  wdsAContractsSAGECODE.BeforeLoadDFMValues;
  wdsAContractsSAGEEXPCODE.BeforeLoadDFMValues;
  wdsAContractsSTRATERATE.BeforeLoadDFMValues;
  wdsAContractsCHGOFFLOAD.BeforeLoadDFMValues;
  wdsAContractsCHGPRICE.BeforeLoadDFMValues;
  wdsAContractsCAPTURETONS.BeforeLoadDFMValues;
  wdsAContractsINVOICETONS.BeforeLoadDFMValues;
  wdsAContractsCHGSUBPRICE.BeforeLoadDFMValues;
  wdsAContractsMAXLOADORDERS.BeforeLoadDFMValues;
  wdsAContractsADDDESCRIPTION.BeforeLoadDFMValues;
  wdsAContractsVARIANCETYPE.BeforeLoadDFMValues;
  wdsAContractsVARIANCEVALUE.BeforeLoadDFMValues;
  wdsAContractsPRINTLC.BeforeLoadDFMValues;
  wdsAContractsPRINTDN.BeforeLoadDFMValues;
  wdsAContractsPRINTTS.BeforeLoadDFMValues;
  wdsAContractsDNTYPE.BeforeLoadDFMValues;
  wdsAContractsTSTYPE.BeforeLoadDFMValues;
  wdsAContractsSHORTDESC.BeforeLoadDFMValues;
  wdsAContractsOLDLOADSCREEN.BeforeLoadDFMValues;
  wdsAContractsSHOWBOOKINGS.BeforeLoadDFMValues;
  wdsAContractsSHOWADDITIONAL.BeforeLoadDFMValues;
  wdsAContractsPRICETYPE.BeforeLoadDFMValues;
  wdsAContractsUSEDOCKETINVNO.BeforeLoadDFMValues;
  wdsAContractsSAGECODE2.BeforeLoadDFMValues;
  wdsAContractsSAGEEXPCODE2.BeforeLoadDFMValues;
  wdsAContractsSAGEINVENTORY2.BeforeLoadDFMValues;
  wdsAContractsSAGEGL2.BeforeLoadDFMValues;
  wdsAContractsHAULAGETYPE.BeforeLoadDFMValues;
  wdsAContractsLINKZEROML.BeforeLoadDFMValues;
  wdsAContractsATTACHEDEMAIL.BeforeLoadDFMValues;
  wdsAContractsCLIENTLINKCONTRACT.BeforeLoadDFMValues;
  wdsAContractsQUOTEREFNO.BeforeLoadDFMValues;
  wdsAContractsSORTLOADDATE.BeforeLoadDFMValues;
  wdsAContractsSORTOFFDATE.BeforeLoadDFMValues;
  wdsAContractsSORTLOADWAY.BeforeLoadDFMValues;
  wdsAContractsSORTOFFWAY.BeforeLoadDFMValues;
  wdsAContractsSORTDOCKET.BeforeLoadDFMValues;
  wdsAContractsSINVVAT.BeforeLoadDFMValues;
  wdsAContractsLOADINSTRUCTQTY.BeforeLoadDFMValues;
  wdsAContractsCHGLOAD.BeforeLoadDFMValues;
  wdsAContractssoanalysiscat1.BeforeLoadDFMValues;
  wdsAContractssoanalysiscat2.BeforeLoadDFMValues;
  wdsAContractssoanalysiscat3.BeforeLoadDFMValues;
  wdsAContractsmaxdrivetime.BeforeLoadDFMValues;
  wdsAContractsmaxtrafeltime.BeforeLoadDFMValues;
  wdsAContractsfirstwarning.BeforeLoadDFMValues;
  wdsAContractssecondwarning.BeforeLoadDFMValues;
  wdsAContractsslots.BeforeLoadDFMValues;
  wdsAContractsSTARTDATE.BeforeLoadDFMValues;
  wdsAContractsCOMPDATE.BeforeLoadDFMValues;
  wdsAContractsSENDEDDATE.BeforeLoadDFMValues;
  wdsAContractsDEB_CODE.BeforeLoadDFMValues;
  wdsAContractsDEB_NAME.BeforeLoadDFMValues;
  wdsAContractsSUSPENDED.BeforeLoadDFMValues;
  wdsAContractsCREDITLIMIT.BeforeLoadDFMValues;
  wdsAContractsORDERBALANCE.BeforeLoadDFMValues;
  wdsAContractsINVOICEBALANCE.BeforeLoadDFMValues;
  wdsAContractsAVAILIBLECL.BeforeLoadDFMValues;
  wdsAContractsCLIENTMULTILOADINV.BeforeLoadDFMValues;
  wdsAContractsMULTILOADDESC.BeforeLoadDFMValues;
  wdsAContractsCLIENTINVOICETYPE.BeforeLoadDFMValues;
  wdsAContractsMULTICONTRACT.BeforeLoadDFMValues;
  wdsAContractsCLIENTLINKED.BeforeLoadDFMValues;
  wdsAContractsCLIENTEMAIL.BeforeLoadDFMValues;
  wdsAContractsLINKEDCONFIG.BeforeLoadDFMValues;
  wdsAContractsACCOUNTNUMBER.BeforeLoadDFMValues;
  wdsAContractsMAINBALANCE.BeforeLoadDFMValues;
  wdsAContractsMAINTENANCELINKACCOUNT.BeforeLoadDFMValues;
  wdsAContractsEXPORTLIST.BeforeLoadDFMValues;
  wdsAContractsEXPORTLOADS.BeforeLoadDFMValues;
  wdsAContractsRENAMEFIELD.BeforeLoadDFMValues;
  wdsAContractsEXPORTPATH.BeforeLoadDFMValues;
  wdsAContractsPREVCL.BeforeLoadDFMValues;
  wdsAContractsSECUREBOOK.BeforeLoadDFMValues;
  wdsAContractsQUOTESYSTEM.BeforeLoadDFMValues;
  wdsAContractsQUOTETYPE.BeforeLoadDFMValues;
  wdsAContractsEMAILLOADDOCS.BeforeLoadDFMValues;
  wdsAContractsSTATEMENTTYPE.BeforeLoadDFMValues;
  wdsAContractsSHOWRECLOADS.BeforeLoadDFMValues;
  wdsAContractsLINKEDINVTYPE.BeforeLoadDFMValues;
  wdsAContractsDEFINVCOMPNO.BeforeLoadDFMValues;
  wdsAContractsinvoicetypenoncon.BeforeLoadDFMValues;
  wdsAContractssinglenoncon.BeforeLoadDFMValues;
  wdsAContractsLINKSERIAL.BeforeLoadDFMValues;
  wdsAContractsLINKAPI.BeforeLoadDFMValues;
  wdsAContractsserverip.BeforeLoadDFMValues;
  wdsAContractsserverport.BeforeLoadDFMValues;
  wdsAContractsserveruser.BeforeLoadDFMValues;
  wdsAContractsserverpassword.BeforeLoadDFMValues;
  wdsAContractsserveraccount.BeforeLoadDFMValues;
  wdsAContractsaltserverip.BeforeLoadDFMValues;
  wdsAContractsaltserverport.BeforeLoadDFMValues;
  wdsAContractsaltserveruser.BeforeLoadDFMValues;
  wdsAContractsaltserverpassword.BeforeLoadDFMValues;
  wdsAContractsserversystem.BeforeLoadDFMValues;
  wdsAContractsNo.BeforeLoadDFMValues;
  wdsAContractsNAME.BeforeLoadDFMValues;
  wdsAContractsITEMCODE.BeforeLoadDFMValues;
  wdsAContractsSTORE.BeforeLoadDFMValues;
  wdsAContractsUNITNUMBER.BeforeLoadDFMValues;
  wdsAContractsDENSITY.BeforeLoadDFMValues;
  wdsAContractsLoadCountryName.BeforeLoadDFMValues;
  wdsAContractsLoadProvinceName.BeforeLoadDFMValues;
  wdsAContractsLoadCityName.BeforeLoadDFMValues;
  wdsAContractsLoadInfoName.BeforeLoadDFMValues;
  wdsAContractsOffLoadCountryName.BeforeLoadDFMValues;
  wdsAContractsOffLoadProvinceName.BeforeLoadDFMValues;
  wdsAContractsOffLoadCityName.BeforeLoadDFMValues;
  wdsAContractsOffLoadInfoName.BeforeLoadDFMValues;
  wdsAContractsCommodityName.BeforeLoadDFMValues;
  wdsAContractsPayTermsName.BeforeLoadDFMValues;
  wdsAContractsCONTROLLERName.BeforeLoadDFMValues;
  wdsAContractsCutOffPeriodDesc1.BeforeLoadDFMValues;
  wdsAContractsCutOffPeriodDesc2.BeforeLoadDFMValues;
  wdsAContractsCutOffPeriodDesc22.BeforeLoadDFMValues;
  wdsAContractsClientName.BeforeLoadDFMValues;
  dsAContracts.BeforeLoadDFMValues;
  wcContractPrices.BeforeLoadDFMValues;
  wdsContractPrices.BeforeLoadDFMValues;
  wdsContractPricesAUTONO.BeforeLoadDFMValues;
  wdsContractPricesCONTRACTNO.BeforeLoadDFMValues;
  wdsContractPricesSTARTDATE.BeforeLoadDFMValues;
  wdsContractPricesENDDATE.BeforeLoadDFMValues;
  wdsContractPricesCOSTPRICE.BeforeLoadDFMValues;
  wdsContractPricesSUBPRICE.BeforeLoadDFMValues;
  wdsContractPricesDEDPRICE.BeforeLoadDFMValues;
  wdsContractPricesSPEPRICE.BeforeLoadDFMValues;
  wdsContractPricesCONFIREMED.BeforeLoadDFMValues;
  wdsContractPricesPRICELOADDATE.BeforeLoadDFMValues;
  wdsContractPricesPRICELOADBY.BeforeLoadDFMValues;
  wdsContractPricesPRICECONFIRMDATE.BeforeLoadDFMValues;
  wdsContractPricesPRICECONFIRMBY.BeforeLoadDFMValues;
  wdsContractPriceskmsprice.BeforeLoadDFMValues;
  wdsContractPricestollprice.BeforeLoadDFMValues;
  dsContractPrices.BeforeLoadDFMValues;
  wdsClosedContracts.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  StringField2.BeforeLoadDFMValues;
  IntegerField2.BeforeLoadDFMValues;
  IntegerField3.BeforeLoadDFMValues;
  IntegerField4.BeforeLoadDFMValues;
  IntegerField5.BeforeLoadDFMValues;
  IntegerField6.BeforeLoadDFMValues;
  IntegerField7.BeforeLoadDFMValues;
  IntegerField8.BeforeLoadDFMValues;
  IntegerField9.BeforeLoadDFMValues;
  IntegerField10.BeforeLoadDFMValues;
  StringField3.BeforeLoadDFMValues;
  StringField4.BeforeLoadDFMValues;
  FloatField1.BeforeLoadDFMValues;
  FloatField2.BeforeLoadDFMValues;
  FloatField3.BeforeLoadDFMValues;
  FloatField4.BeforeLoadDFMValues;
  FloatField5.BeforeLoadDFMValues;
  StringField5.BeforeLoadDFMValues;
  StringField6.BeforeLoadDFMValues;
  FloatField6.BeforeLoadDFMValues;
  IntegerField11.BeforeLoadDFMValues;
  IntegerField12.BeforeLoadDFMValues;
  IntegerField13.BeforeLoadDFMValues;
  IntegerField14.BeforeLoadDFMValues;
  IntegerField15.BeforeLoadDFMValues;
  IntegerField16.BeforeLoadDFMValues;
  IntegerField17.BeforeLoadDFMValues;
  StringField7.BeforeLoadDFMValues;
  StringField8.BeforeLoadDFMValues;
  StringField9.BeforeLoadDFMValues;
  StringField10.BeforeLoadDFMValues;
  StringField11.BeforeLoadDFMValues;
  StringField12.BeforeLoadDFMValues;
  StringField13.BeforeLoadDFMValues;
  StringField14.BeforeLoadDFMValues;
  StringField15.BeforeLoadDFMValues;
  FloatField7.BeforeLoadDFMValues;
  SmallintField1.BeforeLoadDFMValues;
  SmallintField2.BeforeLoadDFMValues;
  IntegerField18.BeforeLoadDFMValues;
  SmallintField3.BeforeLoadDFMValues;
  IntegerField19.BeforeLoadDFMValues;
  StringField16.BeforeLoadDFMValues;
  StringField17.BeforeLoadDFMValues;
  StringField18.BeforeLoadDFMValues;
  StringField19.BeforeLoadDFMValues;
  StringField20.BeforeLoadDFMValues;
  StringField21.BeforeLoadDFMValues;
  StringField22.BeforeLoadDFMValues;
  StringField23.BeforeLoadDFMValues;
  StringField24.BeforeLoadDFMValues;
  StringField25.BeforeLoadDFMValues;
  IntegerField20.BeforeLoadDFMValues;
  StringField26.BeforeLoadDFMValues;
  IntegerField21.BeforeLoadDFMValues;
  FloatField8.BeforeLoadDFMValues;
  StringField27.BeforeLoadDFMValues;
  StringField28.BeforeLoadDFMValues;
  StringField29.BeforeLoadDFMValues;
  StringField30.BeforeLoadDFMValues;
  StringField31.BeforeLoadDFMValues;
  StringField32.BeforeLoadDFMValues;
  StringField33.BeforeLoadDFMValues;
  StringField34.BeforeLoadDFMValues;
  StringField35.BeforeLoadDFMValues;
  IntegerField22.BeforeLoadDFMValues;
  StringField36.BeforeLoadDFMValues;
  StringField37.BeforeLoadDFMValues;
  StringField38.BeforeLoadDFMValues;
  StringField39.BeforeLoadDFMValues;
  StringField40.BeforeLoadDFMValues;
  StringField41.BeforeLoadDFMValues;
  StringField42.BeforeLoadDFMValues;
  StringField43.BeforeLoadDFMValues;
  IntegerField23.BeforeLoadDFMValues;
  StringField44.BeforeLoadDFMValues;
  StringField45.BeforeLoadDFMValues;
  StringField46.BeforeLoadDFMValues;
  StringField47.BeforeLoadDFMValues;
  StringField48.BeforeLoadDFMValues;
  StringField49.BeforeLoadDFMValues;
  StringField50.BeforeLoadDFMValues;
  FloatField9.BeforeLoadDFMValues;
  StringField51.BeforeLoadDFMValues;
  StringField52.BeforeLoadDFMValues;
  StringField53.BeforeLoadDFMValues;
  StringField54.BeforeLoadDFMValues;
  StringField55.BeforeLoadDFMValues;
  TimeField1.BeforeLoadDFMValues;
  IntegerField24.BeforeLoadDFMValues;
  IntegerField25.BeforeLoadDFMValues;
  IntegerField26.BeforeLoadDFMValues;
  DateField1.BeforeLoadDFMValues;
  DateField2.BeforeLoadDFMValues;
  DateField3.BeforeLoadDFMValues;
  StringField56.BeforeLoadDFMValues;
  StringField57.BeforeLoadDFMValues;
  StringField58.BeforeLoadDFMValues;
  FloatField10.BeforeLoadDFMValues;
  FloatField11.BeforeLoadDFMValues;
  FloatField12.BeforeLoadDFMValues;
  FloatField13.BeforeLoadDFMValues;
  StringField59.BeforeLoadDFMValues;
  StringField60.BeforeLoadDFMValues;
  StringField61.BeforeLoadDFMValues;
  StringField62.BeforeLoadDFMValues;
  StringField63.BeforeLoadDFMValues;
  StringField64.BeforeLoadDFMValues;
  StringField65.BeforeLoadDFMValues;
  StringField66.BeforeLoadDFMValues;
  FloatField14.BeforeLoadDFMValues;
  StringField67.BeforeLoadDFMValues;
  StringField68.BeforeLoadDFMValues;
  StringField69.BeforeLoadDFMValues;
  StringField70.BeforeLoadDFMValues;
  StringField71.BeforeLoadDFMValues;
  FloatField15.BeforeLoadDFMValues;
  StringField72.BeforeLoadDFMValues;
  StringField73.BeforeLoadDFMValues;
  StringField74.BeforeLoadDFMValues;
  StringField75.BeforeLoadDFMValues;
  StringField76.BeforeLoadDFMValues;
  StringField77.BeforeLoadDFMValues;
  StringField78.BeforeLoadDFMValues;
  IntegerField27.BeforeLoadDFMValues;
  StringField79.BeforeLoadDFMValues;
  StringField80.BeforeLoadDFMValues;
  StringField81.BeforeLoadDFMValues;
  StringField82.BeforeLoadDFMValues;
  StringField83.BeforeLoadDFMValues;
  IntegerField28.BeforeLoadDFMValues;
  StringField84.BeforeLoadDFMValues;
  StringField85.BeforeLoadDFMValues;
  StringField86.BeforeLoadDFMValues;
  StringField87.BeforeLoadDFMValues;
  IntegerField29.BeforeLoadDFMValues;
  StringField88.BeforeLoadDFMValues;
  StringField89.BeforeLoadDFMValues;
  StringField90.BeforeLoadDFMValues;
  IntegerField30.BeforeLoadDFMValues;
  StringField91.BeforeLoadDFMValues;
  StringField92.BeforeLoadDFMValues;
  IntegerField31.BeforeLoadDFMValues;
  StringField93.BeforeLoadDFMValues;
  FloatField16.BeforeLoadDFMValues;
  wcClosedContracts.BeforeLoadDFMValues;
  dsClosedContracts.BeforeLoadDFMValues;
  WebRESTClient1.BeforeLoadDFMValues;
  wcAContractImportSetup.BeforeLoadDFMValues;
  wdsAContractImportSetup.BeforeLoadDFMValues;
  IntegerField32.BeforeLoadDFMValues;
  StringField94.BeforeLoadDFMValues;
  StringField95.BeforeLoadDFMValues;
  IntegerField33.BeforeLoadDFMValues;
  IntegerField34.BeforeLoadDFMValues;
  IntegerField35.BeforeLoadDFMValues;
  IntegerField36.BeforeLoadDFMValues;
  IntegerField37.BeforeLoadDFMValues;
  IntegerField38.BeforeLoadDFMValues;
  IntegerField39.BeforeLoadDFMValues;
  IntegerField40.BeforeLoadDFMValues;
  IntegerField41.BeforeLoadDFMValues;
  StringField96.BeforeLoadDFMValues;
  StringField97.BeforeLoadDFMValues;
  FloatField17.BeforeLoadDFMValues;
  FloatField18.BeforeLoadDFMValues;
  FloatField19.BeforeLoadDFMValues;
  FloatField20.BeforeLoadDFMValues;
  FloatField21.BeforeLoadDFMValues;
  StringField98.BeforeLoadDFMValues;
  StringField99.BeforeLoadDFMValues;
  FloatField22.BeforeLoadDFMValues;
  IntegerField42.BeforeLoadDFMValues;
  IntegerField43.BeforeLoadDFMValues;
  IntegerField44.BeforeLoadDFMValues;
  IntegerField45.BeforeLoadDFMValues;
  IntegerField46.BeforeLoadDFMValues;
  IntegerField47.BeforeLoadDFMValues;
  IntegerField48.BeforeLoadDFMValues;
  StringField100.BeforeLoadDFMValues;
  StringField101.BeforeLoadDFMValues;
  StringField102.BeforeLoadDFMValues;
  StringField103.BeforeLoadDFMValues;
  StringField104.BeforeLoadDFMValues;
  StringField105.BeforeLoadDFMValues;
  StringField106.BeforeLoadDFMValues;
  StringField107.BeforeLoadDFMValues;
  StringField108.BeforeLoadDFMValues;
  FloatField23.BeforeLoadDFMValues;
  SmallintField4.BeforeLoadDFMValues;
  SmallintField5.BeforeLoadDFMValues;
  IntegerField49.BeforeLoadDFMValues;
  SmallintField6.BeforeLoadDFMValues;
  IntegerField50.BeforeLoadDFMValues;
  StringField109.BeforeLoadDFMValues;
  StringField110.BeforeLoadDFMValues;
  StringField111.BeforeLoadDFMValues;
  StringField112.BeforeLoadDFMValues;
  StringField113.BeforeLoadDFMValues;
  StringField114.BeforeLoadDFMValues;
  StringField115.BeforeLoadDFMValues;
  StringField116.BeforeLoadDFMValues;
  StringField117.BeforeLoadDFMValues;
  StringField118.BeforeLoadDFMValues;
  IntegerField51.BeforeLoadDFMValues;
  StringField119.BeforeLoadDFMValues;
  IntegerField52.BeforeLoadDFMValues;
  FloatField24.BeforeLoadDFMValues;
  StringField120.BeforeLoadDFMValues;
  StringField121.BeforeLoadDFMValues;
  StringField122.BeforeLoadDFMValues;
  StringField123.BeforeLoadDFMValues;
  StringField124.BeforeLoadDFMValues;
  StringField125.BeforeLoadDFMValues;
  StringField126.BeforeLoadDFMValues;
  StringField127.BeforeLoadDFMValues;
  StringField128.BeforeLoadDFMValues;
  IntegerField53.BeforeLoadDFMValues;
  StringField129.BeforeLoadDFMValues;
  StringField130.BeforeLoadDFMValues;
  StringField131.BeforeLoadDFMValues;
  StringField132.BeforeLoadDFMValues;
  StringField133.BeforeLoadDFMValues;
  StringField134.BeforeLoadDFMValues;
  StringField135.BeforeLoadDFMValues;
  StringField136.BeforeLoadDFMValues;
  IntegerField54.BeforeLoadDFMValues;
  StringField137.BeforeLoadDFMValues;
  StringField138.BeforeLoadDFMValues;
  StringField139.BeforeLoadDFMValues;
  StringField140.BeforeLoadDFMValues;
  StringField141.BeforeLoadDFMValues;
  StringField142.BeforeLoadDFMValues;
  StringField143.BeforeLoadDFMValues;
  FloatField25.BeforeLoadDFMValues;
  StringField144.BeforeLoadDFMValues;
  StringField145.BeforeLoadDFMValues;
  StringField146.BeforeLoadDFMValues;
  StringField147.BeforeLoadDFMValues;
  StringField148.BeforeLoadDFMValues;
  TimeField2.BeforeLoadDFMValues;
  IntegerField55.BeforeLoadDFMValues;
  IntegerField56.BeforeLoadDFMValues;
  IntegerField57.BeforeLoadDFMValues;
  DateField4.BeforeLoadDFMValues;
  DateField5.BeforeLoadDFMValues;
  DateField6.BeforeLoadDFMValues;
  StringField149.BeforeLoadDFMValues;
  StringField150.BeforeLoadDFMValues;
  StringField151.BeforeLoadDFMValues;
  FloatField26.BeforeLoadDFMValues;
  FloatField27.BeforeLoadDFMValues;
  FloatField28.BeforeLoadDFMValues;
  FloatField29.BeforeLoadDFMValues;
  StringField152.BeforeLoadDFMValues;
  StringField153.BeforeLoadDFMValues;
  StringField154.BeforeLoadDFMValues;
  StringField155.BeforeLoadDFMValues;
  StringField156.BeforeLoadDFMValues;
  StringField157.BeforeLoadDFMValues;
  StringField158.BeforeLoadDFMValues;
  StringField159.BeforeLoadDFMValues;
  FloatField30.BeforeLoadDFMValues;
  StringField160.BeforeLoadDFMValues;
  StringField161.BeforeLoadDFMValues;
  StringField162.BeforeLoadDFMValues;
  StringField163.BeforeLoadDFMValues;
  StringField164.BeforeLoadDFMValues;
  FloatField31.BeforeLoadDFMValues;
  StringField165.BeforeLoadDFMValues;
  StringField166.BeforeLoadDFMValues;
  StringField167.BeforeLoadDFMValues;
  StringField168.BeforeLoadDFMValues;
  StringField169.BeforeLoadDFMValues;
  StringField170.BeforeLoadDFMValues;
  StringField171.BeforeLoadDFMValues;
  IntegerField58.BeforeLoadDFMValues;
  StringField172.BeforeLoadDFMValues;
  StringField173.BeforeLoadDFMValues;
  StringField174.BeforeLoadDFMValues;
  StringField175.BeforeLoadDFMValues;
  StringField176.BeforeLoadDFMValues;
  IntegerField59.BeforeLoadDFMValues;
  StringField177.BeforeLoadDFMValues;
  StringField178.BeforeLoadDFMValues;
  StringField179.BeforeLoadDFMValues;
  StringField180.BeforeLoadDFMValues;
  IntegerField60.BeforeLoadDFMValues;
  StringField181.BeforeLoadDFMValues;
  StringField182.BeforeLoadDFMValues;
  StringField183.BeforeLoadDFMValues;
  IntegerField61.BeforeLoadDFMValues;
  StringField184.BeforeLoadDFMValues;
  StringField185.BeforeLoadDFMValues;
  IntegerField62.BeforeLoadDFMValues;
  StringField186.BeforeLoadDFMValues;
  FloatField32.BeforeLoadDFMValues;
  StringField187.BeforeLoadDFMValues;
  StringField188.BeforeLoadDFMValues;
  StringField189.BeforeLoadDFMValues;
  StringField190.BeforeLoadDFMValues;
  StringField191.BeforeLoadDFMValues;
  StringField192.BeforeLoadDFMValues;
  StringField193.BeforeLoadDFMValues;
  StringField194.BeforeLoadDFMValues;
  StringField195.BeforeLoadDFMValues;
  StringField196.BeforeLoadDFMValues;
  StringField197.BeforeLoadDFMValues;
  StringField198.BeforeLoadDFMValues;
  IntegerField63.BeforeLoadDFMValues;
  StringField199.BeforeLoadDFMValues;
  dsAContractImportSetup.BeforeLoadDFMValues;
  try
    Name := 'frmContracts';
    Width := 1137;
    Height := 637;
    Caption := '0';
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebDBLabel12.SetParentComponent(Self);
    WebDBLabel12.Name := 'WebDBLabel12';
    WebDBLabel12.Left := 184;
    WebDBLabel12.Top := 128;
    WebDBLabel12.Width := 79;
    WebDBLabel12.Height := 15;
    WebDBLabel12.Caption := 'WebDBLabel12';
    WebDBLabel12.HeightPercent := 100.000000000000000000;
    WebDBLabel12.WidthPercent := 100.000000000000000000;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 1137;
    WebPanel1.Height := 637;
    WebPanel1.Align := alClient;
    WebPanel1.Caption := 'Field Name';
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 1137;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Contract Information per Client';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    BitMapContainer1.SetParentComponent(WebPanel2);
    BitMapContainer1.Name := 'BitMapContainer1';
    BitMapContainer1.Left := 992;
    BitMapContainer1.Top := 16;
    BitMapContainer1.Width := 26;
    BitMapContainer1.Height := 26;
    BitMapContainer1.Visible := True;
    BitMapContainer1.Items.Clear;
    with BitMapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('Contracts.BitMapContainer1.Items.Bitmap.svg');
      Name := 'delete.svg';
      Tag := 0;
    end;
    with BitMapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('Contracts.BitMapContainer1.Items.Bitmap_1.svg');
      Name := 'edit.svg';
      Tag := 0;
    end;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 577;
    WebPanel3.Width := 1137;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 32;
    WebButton1.Top := 16;
    WebButton1.Width := 121;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Contract Price Report';
    WebButton1.Color := clSkyBlue;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 168;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Close';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebSpeedButton13.SetParentComponent(WebPanel3);
    WebSpeedButton13.Name := 'WebSpeedButton13';
    WebSpeedButton13.Left := 328;
    WebSpeedButton13.Top := 16;
    WebSpeedButton13.Width := 24;
    WebSpeedButton13.Height := 24;
    WebSpeedButton13.Caption := '<<';
    WebSpeedButton13.Color := clNone;
    WebSpeedButton13.HeightPercent := 100.000000000000000000;
    WebSpeedButton13.TabOrder := 2;
    WebSpeedButton13.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton13, Self, 'OnClick', 'WebSpeedButton13Click');
    WebSpeedButton14.SetParentComponent(WebPanel3);
    WebSpeedButton14.Name := 'WebSpeedButton14';
    WebSpeedButton14.Left := 358;
    WebSpeedButton14.Top := 16;
    WebSpeedButton14.Width := 24;
    WebSpeedButton14.Height := 24;
    WebSpeedButton14.Caption := '<';
    WebSpeedButton14.Color := clNone;
    WebSpeedButton14.HeightPercent := 100.000000000000000000;
    WebSpeedButton14.TabOrder := 3;
    WebSpeedButton14.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton14, Self, 'OnClick', 'WebSpeedButton14Click');
    WebSpeedButton15.SetParentComponent(WebPanel3);
    WebSpeedButton15.Name := 'WebSpeedButton15';
    WebSpeedButton15.Left := 461;
    WebSpeedButton15.Top := 16;
    WebSpeedButton15.Width := 24;
    WebSpeedButton15.Height := 24;
    WebSpeedButton15.Caption := '>';
    WebSpeedButton15.Color := clNone;
    WebSpeedButton15.HeightPercent := 100.000000000000000000;
    WebSpeedButton15.TabOrder := 4;
    WebSpeedButton15.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton15, Self, 'OnClick', 'WebSpeedButton15Click');
    WebSpeedButton16.SetParentComponent(WebPanel3);
    WebSpeedButton16.Name := 'WebSpeedButton16';
    WebSpeedButton16.Left := 491;
    WebSpeedButton16.Top := 16;
    WebSpeedButton16.Width := 24;
    WebSpeedButton16.Height := 24;
    WebSpeedButton16.Caption := '>>';
    WebSpeedButton16.Color := clNone;
    WebSpeedButton16.HeightPercent := 100.000000000000000000;
    WebSpeedButton16.TabOrder := 5;
    WebSpeedButton16.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton16, Self, 'OnClick', 'WebSpeedButton16Click');
    edtActiveContractImportPC.SetParentComponent(WebPanel3);
    edtActiveContractImportPC.Name := 'edtActiveContractImportPC';
    edtActiveContractImportPC.Left := 388;
    edtActiveContractImportPC.Top := 16;
    edtActiveContractImportPC.Width := 67;
    edtActiveContractImportPC.Height := 22;
    edtActiveContractImportPC.ChildOrder := 6;
    edtActiveContractImportPC.HeightPercent := 100.000000000000000000;
    edtActiveContractImportPC.Text := '0 of 0';
    edtActiveContractImportPC.WidthPercent := 100.000000000000000000;
    wpcContractInfo.SetParentComponent(WebPanel1);
    wpcContractInfo.Name := 'wpcContractInfo';
    wpcContractInfo.Left := 0;
    wpcContractInfo.Top := 60;
    wpcContractInfo.Width := 1137;
    wpcContractInfo.Height := 517;
    wpcContractInfo.Align := alClient;
    wpcContractInfo.ChildOrder := 2;
    wpcContractInfo.TabIndex := 0;
    wpcContractInfo.TabOrder := 2;
    SetEvent(wpcContractInfo, Self, 'OnChange', 'wpcContractInfoChange');
    wpcsActiveContracts.SetParentComponent(wpcContractInfo);
    wpcsActiveContracts.Name := 'wpcsActiveContracts';
    wpcsActiveContracts.Left := 0;
    wpcsActiveContracts.Top := 20;
    wpcsActiveContracts.Width := 1137;
    wpcsActiveContracts.Height := 497;
    wpcsActiveContracts.Caption := 'Active Contracts';
    WebPanel4.SetParentComponent(wpcsActiveContracts);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 0;
    WebPanel4.Width := 1137;
    WebPanel4.Height := 497;
    WebPanel4.Align := alClient;
    WebPanel4.TabOrder := 0;
    wpcActiveContracts.SetParentComponent(WebPanel4);
    wpcActiveContracts.Name := 'wpcActiveContracts';
    wpcActiveContracts.Left := 0;
    wpcActiveContracts.Top := 0;
    wpcActiveContracts.Width := 1137;
    wpcActiveContracts.Height := 497;
    wpcActiveContracts.Align := alClient;
    wpcActiveContracts.TabIndex := 0;
    wpcActiveContracts.TabOrder := 0;
    wpcsContractInfo.SetParentComponent(wpcActiveContracts);
    wpcsContractInfo.Name := 'wpcsContractInfo';
    wpcsContractInfo.Left := 0;
    wpcsContractInfo.Top := 20;
    wpcsContractInfo.Width := 1137;
    wpcsContractInfo.Height := 477;
    wpcsContractInfo.Caption := 'Contract Info';
    WebPanel8.SetParentComponent(wpcsContractInfo);
    WebPanel8.Name := 'WebPanel8';
    WebPanel8.Left := 0;
    WebPanel8.Top := 0;
    WebPanel8.Width := 1137;
    WebPanel8.Height := 477;
    WebPanel8.Align := alClient;
    WebPanel8.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel8);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 48;
    WebLabel1.Top := 32;
    WebLabel1.Width := 68;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Contract No:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel8);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 48;
    WebLabel2.Top := 95;
    WebLabel2.Width := 69;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Client Name:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel8);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 48;
    WebLabel3.Top := 165;
    WebLabel3.Width := 112;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Contract Description:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel8);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 44;
    WebLabel4.Top := 255;
    WebLabel4.Width := 56;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Comodity:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel8);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 380;
    WebLabel5.Top := 255;
    WebLabel5.Width := 57;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'Load Type:';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebDBLabel13.SetParentComponent(WebPanel8);
    WebDBLabel13.Name := 'WebDBLabel13';
    WebDBLabel13.Left := 120;
    WebDBLabel13.Top := 32;
    WebDBLabel13.Width := 79;
    WebDBLabel13.Height := 15;
    WebDBLabel13.Caption := 'WebDBLabel13';
    WebDBLabel13.HeightPercent := 100.000000000000000000;
    WebDBLabel13.WidthPercent := 100.000000000000000000;
    WebDBLabel13.DataField := 'CONTRACTNO';
    WebDBLabel13.DataSource := dsAContracts;
    dbedtClientName.SetParentComponent(WebPanel8);
    dbedtClientName.Name := 'dbedtClientName';
    dbedtClientName.Left := 122;
    dbedtClientName.Top := 92;
    dbedtClientName.Width := 319;
    dbedtClientName.Height := 22;
    dbedtClientName.ChildOrder := 6;
    dbedtClientName.HeightPercent := 100.000000000000000000;
    dbedtClientName.Text := 'dbedtClientName';
    dbedtClientName.WidthPercent := 100.000000000000000000;
    dbedtClientName.DataField := 'DEBCODE';
    dbedtClientName.DataSource := dsAContracts;
    dbedtShortdescription.SetParentComponent(WebPanel8);
    dbedtShortdescription.Name := 'dbedtShortdescription';
    dbedtShortdescription.Left := 48;
    dbedtShortdescription.Top := 184;
    dbedtShortdescription.Width := 153;
    dbedtShortdescription.Height := 22;
    dbedtShortdescription.ChildOrder := 7;
    dbedtShortdescription.HeightPercent := 100.000000000000000000;
    dbedtShortdescription.Text := 'dbedtShortdescription';
    dbedtShortdescription.WidthPercent := 100.000000000000000000;
    dbedtShortdescription.DataField := 'SHORTDESC';
    dbedtShortdescription.DataSource := dsAContracts;
    dbedtLongDescription.SetParentComponent(WebPanel8);
    dbedtLongDescription.Name := 'dbedtLongDescription';
    dbedtLongDescription.Left := 207;
    dbedtLongDescription.Top := 184;
    dbedtLongDescription.Width := 346;
    dbedtLongDescription.Height := 22;
    dbedtLongDescription.ChildOrder := 8;
    dbedtLongDescription.HeightPercent := 100.000000000000000000;
    dbedtLongDescription.Text := 'dbedtLongDescription';
    dbedtLongDescription.WidthPercent := 100.000000000000000000;
    dbedtLongDescription.DataField := 'CONTRACTNAME';
    dbedtLongDescription.DataSource := dsAContracts;
    WebDBEdit5.SetParentComponent(WebPanel8);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 44;
    WebDBEdit5.Top := 276;
    WebDBEdit5.Width := 281;
    WebDBEdit5.Height := 22;
    WebDBEdit5.ChildOrder := 9;
    WebDBEdit5.HeightPercent := 100.000000000000000000;
    WebDBEdit5.Text := 'WebDBEdit5';
    WebDBEdit5.WidthPercent := 100.000000000000000000;
    WebDBEdit5.DataField := 'CommodityName';
    WebDBEdit5.DataSource := dsAContracts;
    dbedtLoadType.SetParentComponent(WebPanel8);
    dbedtLoadType.Name := 'dbedtLoadType';
    dbedtLoadType.Left := 380;
    dbedtLoadType.Top := 276;
    dbedtLoadType.Width := 273;
    dbedtLoadType.Height := 22;
    dbedtLoadType.ChildOrder := 10;
    dbedtLoadType.HeightPercent := 100.000000000000000000;
    dbedtLoadType.Text := 'dbedtLoadType';
    dbedtLoadType.WidthPercent := 100.000000000000000000;
    dbedtLoadType.DataField := 'HAULAGETYPE';
    dbedtLoadType.DataSource := dsAContracts;
    WebDBRadioGroup1.SetParentComponent(WebPanel8);
    WebDBRadioGroup1.Name := 'WebDBRadioGroup1';
    WebDBRadioGroup1.Left := 536;
    WebDBRadioGroup1.Top := 91;
    WebDBRadioGroup1.Width := 241;
    WebDBRadioGroup1.Height := 49;
    WebDBRadioGroup1.Caption := 'Contract Price Type Selection';
    WebDBRadioGroup1.ChildOrder := 11;
    WebDBRadioGroup1.Columns := 1;
    WebDBRadioGroup1.ItemIndex := 0;
    WebDBRadioGroup1.Items.BeginUpdate;
    try
      WebDBRadioGroup1.Items.Clear;
      WebDBRadioGroup1.Items.Add('Single Price Type');
    finally
      WebDBRadioGroup1.Items.EndUpdate;
    end;
    WebDBRadioGroup1.Role := '';
    WebDBRadioGroup1.TabOrder := 5;
    WebGroupBox1.SetParentComponent(WebPanel8);
    WebGroupBox1.Name := 'WebGroupBox1';
    WebGroupBox1.Left := 813;
    WebGroupBox1.Top := 39;
    WebGroupBox1.Width := 270;
    WebGroupBox1.Height := 161;
    WebGroupBox1.BorderColor := clSilver;
    WebGroupBox1.Caption := 'Loading Information';
    WebGroupBox1.ChildOrder := 12;
    WebDBEdit7.SetParentComponent(WebGroupBox1);
    WebDBEdit7.Name := 'WebDBEdit7';
    WebDBEdit7.Left := 16;
    WebDBEdit7.Top := 24;
    WebDBEdit7.Width := 200;
    WebDBEdit7.Height := 22;
    WebDBEdit7.HeightPercent := 100.000000000000000000;
    WebDBEdit7.Text := 'WebDBEdit7';
    WebDBEdit7.WidthPercent := 100.000000000000000000;
    WebDBEdit7.DataField := 'LoadCountryName';
    WebDBEdit7.DataSource := dsAContracts;
    WebDBEdit8.SetParentComponent(WebGroupBox1);
    WebDBEdit8.Name := 'WebDBEdit8';
    WebDBEdit8.Left := 16;
    WebDBEdit8.Top := 56;
    WebDBEdit8.Width := 200;
    WebDBEdit8.Height := 22;
    WebDBEdit8.ChildOrder := 1;
    WebDBEdit8.HeightPercent := 100.000000000000000000;
    WebDBEdit8.Text := 'WebDBEdit8';
    WebDBEdit8.WidthPercent := 100.000000000000000000;
    WebDBEdit8.DataField := 'LoadProvinceName';
    WebDBEdit8.DataSource := dsAContracts;
    WebDBEdit9.SetParentComponent(WebGroupBox1);
    WebDBEdit9.Name := 'WebDBEdit9';
    WebDBEdit9.Left := 16;
    WebDBEdit9.Top := 88;
    WebDBEdit9.Width := 200;
    WebDBEdit9.Height := 22;
    WebDBEdit9.ChildOrder := 2;
    WebDBEdit9.HeightPercent := 100.000000000000000000;
    WebDBEdit9.Text := 'WebDBEdit9';
    WebDBEdit9.WidthPercent := 100.000000000000000000;
    WebDBEdit9.DataField := 'LoadCityName';
    WebDBEdit9.DataSource := dsAContracts;
    WebDBEdit10.SetParentComponent(WebGroupBox1);
    WebDBEdit10.Name := 'WebDBEdit10';
    WebDBEdit10.Left := 16;
    WebDBEdit10.Top := 120;
    WebDBEdit10.Width := 200;
    WebDBEdit10.Height := 22;
    WebDBEdit10.ChildOrder := 3;
    WebDBEdit10.HeightPercent := 100.000000000000000000;
    WebDBEdit10.Text := 'WebDBEdit10';
    WebDBEdit10.WidthPercent := 100.000000000000000000;
    WebDBEdit10.DataField := 'LoadInfoName';
    WebDBEdit10.DataSource := dsAContracts;
    WebButton3.SetParentComponent(WebGroupBox1);
    WebButton3.Name := 'WebButton3';
    WebButton3.Left := 224;
    WebButton3.Top := 23;
    WebButton3.Width := 25;
    WebButton3.Height := 25;
    WebButton3.Caption := '...';
    WebButton3.ChildOrder := 4;
    WebButton3.HeightPercent := 100.000000000000000000;
    WebButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton3, Self, 'OnClick', 'WebButton3Click');
    WebButton4.SetParentComponent(WebGroupBox1);
    WebButton4.Name := 'WebButton4';
    WebButton4.Left := 222;
    WebButton4.Top := 56;
    WebButton4.Width := 25;
    WebButton4.Height := 25;
    WebButton4.Caption := '...';
    WebButton4.ChildOrder := 5;
    WebButton4.HeightPercent := 100.000000000000000000;
    WebButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton4, Self, 'OnClick', 'WebButton4Click');
    WebButton5.SetParentComponent(WebGroupBox1);
    WebButton5.Name := 'WebButton5';
    WebButton5.Left := 224;
    WebButton5.Top := 87;
    WebButton5.Width := 25;
    WebButton5.Height := 25;
    WebButton5.Caption := '...';
    WebButton5.ChildOrder := 6;
    WebButton5.HeightPercent := 100.000000000000000000;
    WebButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton5, Self, 'OnClick', 'WebButton5Click');
    WebButton6.SetParentComponent(WebGroupBox1);
    WebButton6.Name := 'WebButton6';
    WebButton6.Left := 224;
    WebButton6.Top := 119;
    WebButton6.Width := 25;
    WebButton6.Height := 25;
    WebButton6.Caption := '...';
    WebButton6.ChildOrder := 7;
    WebButton6.HeightPercent := 100.000000000000000000;
    WebButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton6, Self, 'OnClick', 'WebButton6Click');
    WebGroupBox2.SetParentComponent(WebPanel8);
    WebGroupBox2.Name := 'WebGroupBox2';
    WebGroupBox2.Left := 813;
    WebGroupBox2.Top := 224;
    WebGroupBox2.Width := 270;
    WebGroupBox2.Height := 161;
    WebGroupBox2.BorderColor := clSilver;
    WebGroupBox2.Caption := 'Off-Loading Information';
    WebGroupBox2.ChildOrder := 13;
    WebDBEdit11.SetParentComponent(WebGroupBox2);
    WebDBEdit11.Name := 'WebDBEdit11';
    WebDBEdit11.Left := 16;
    WebDBEdit11.Top := 24;
    WebDBEdit11.Width := 200;
    WebDBEdit11.Height := 22;
    WebDBEdit11.HeightPercent := 100.000000000000000000;
    WebDBEdit11.Text := 'WebDBEdit11';
    WebDBEdit11.WidthPercent := 100.000000000000000000;
    WebDBEdit11.DataField := 'OffLoadCountryName';
    WebDBEdit11.DataSource := dsAContracts;
    WebDBEdit12.SetParentComponent(WebGroupBox2);
    WebDBEdit12.Name := 'WebDBEdit12';
    WebDBEdit12.Left := 16;
    WebDBEdit12.Top := 56;
    WebDBEdit12.Width := 201;
    WebDBEdit12.Height := 22;
    WebDBEdit12.ChildOrder := 1;
    WebDBEdit12.HeightPercent := 100.000000000000000000;
    WebDBEdit12.Text := 'WebDBEdit12';
    WebDBEdit12.WidthPercent := 100.000000000000000000;
    WebDBEdit12.DataField := 'OffLoadProvinceName';
    WebDBEdit12.DataSource := dsAContracts;
    WebDBEdit13.SetParentComponent(WebGroupBox2);
    WebDBEdit13.Name := 'WebDBEdit13';
    WebDBEdit13.Left := 16;
    WebDBEdit13.Top := 88;
    WebDBEdit13.Width := 201;
    WebDBEdit13.Height := 22;
    WebDBEdit13.ChildOrder := 2;
    WebDBEdit13.HeightPercent := 100.000000000000000000;
    WebDBEdit13.Text := 'WebDBEdit13';
    WebDBEdit13.WidthPercent := 100.000000000000000000;
    WebDBEdit13.DataField := 'OffLoadCityName';
    WebDBEdit13.DataSource := dsAContracts;
    WebDBEdit14.SetParentComponent(WebGroupBox2);
    WebDBEdit14.Name := 'WebDBEdit14';
    WebDBEdit14.Left := 16;
    WebDBEdit14.Top := 120;
    WebDBEdit14.Width := 201;
    WebDBEdit14.Height := 22;
    WebDBEdit14.ChildOrder := 3;
    WebDBEdit14.HeightPercent := 100.000000000000000000;
    WebDBEdit14.Text := 'WebDBEdit14';
    WebDBEdit14.WidthPercent := 100.000000000000000000;
    WebDBEdit14.DataField := 'OffLoadInfoName';
    WebDBEdit14.DataSource := dsAContracts;
    WebButton7.SetParentComponent(WebGroupBox2);
    WebButton7.Name := 'WebButton7';
    WebButton7.Left := 229;
    WebButton7.Top := 23;
    WebButton7.Width := 25;
    WebButton7.Height := 25;
    WebButton7.Caption := '...';
    WebButton7.ChildOrder := 4;
    WebButton7.HeightPercent := 100.000000000000000000;
    WebButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton7, Self, 'OnClick', 'WebButton7Click');
    WebButton8.SetParentComponent(WebGroupBox2);
    WebButton8.Name := 'WebButton8';
    WebButton8.Left := 229;
    WebButton8.Top := 56;
    WebButton8.Width := 25;
    WebButton8.Height := 25;
    WebButton8.Caption := '...';
    WebButton8.ChildOrder := 5;
    WebButton8.HeightPercent := 100.000000000000000000;
    WebButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton8, Self, 'OnClick', 'WebButton8Click');
    WebButton9.SetParentComponent(WebGroupBox2);
    WebButton9.Name := 'WebButton9';
    WebButton9.Left := 229;
    WebButton9.Top := 88;
    WebButton9.Width := 25;
    WebButton9.Height := 25;
    WebButton9.Caption := '...';
    WebButton9.ChildOrder := 6;
    WebButton9.HeightPercent := 100.000000000000000000;
    WebButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton9, Self, 'OnClick', 'WebButton9Click');
    WebButton10.SetParentComponent(WebGroupBox2);
    WebButton10.Name := 'WebButton10';
    WebButton10.Left := 229;
    WebButton10.Top := 120;
    WebButton10.Width := 25;
    WebButton10.Height := 25;
    WebButton10.Caption := '...';
    WebButton10.ChildOrder := 7;
    WebButton10.HeightPercent := 100.000000000000000000;
    WebButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton10, Self, 'OnClick', 'WebButton10Click');
    WebGroupBox3.SetParentComponent(WebPanel8);
    WebGroupBox3.Name := 'WebGroupBox3';
    WebGroupBox3.Left := 44;
    WebGroupBox3.Top := 336;
    WebGroupBox3.Width := 609;
    WebGroupBox3.Height := 62;
    WebGroupBox3.BorderColor := clSilver;
    WebGroupBox3.Caption := 'Link Client Contract';
    WebGroupBox3.ChildOrder := 14;
    WebDBEdit15.SetParentComponent(WebGroupBox3);
    WebDBEdit15.Name := 'WebDBEdit15';
    WebDBEdit15.Left := 16;
    WebDBEdit15.Top := 24;
    WebDBEdit15.Width := 539;
    WebDBEdit15.Height := 22;
    WebDBEdit15.HeightPercent := 100.000000000000000000;
    WebDBEdit15.Text := 'WebDBEdit15';
    WebDBEdit15.WidthPercent := 100.000000000000000000;
    WebDBEdit15.DataField := 'CLIENTLINKCONTRACT';
    WebDBEdit15.DataSource := dsAContracts;
    WebButton11.SetParentComponent(WebGroupBox3);
    WebButton11.Name := 'WebButton11';
    WebButton11.Left := 566;
    WebButton11.Top := 23;
    WebButton11.Width := 25;
    WebButton11.Height := 25;
    WebButton11.Caption := '...';
    WebButton11.ChildOrder := 1;
    WebButton11.HeightPercent := 100.000000000000000000;
    WebButton11.WidthPercent := 100.000000000000000000;
    WebButton33.SetParentComponent(WebPanel8);
    WebButton33.Name := 'WebButton33';
    WebButton33.Left := 659;
    WebButton33.Top := 273;
    WebButton33.Width := 25;
    WebButton33.Height := 25;
    WebButton33.Caption := '...';
    WebButton33.ChildOrder := 15;
    WebButton33.HeightPercent := 100.000000000000000000;
    WebButton33.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton33, Self, 'OnClick', 'WebButton33Click');
    WebButton34.SetParentComponent(WebPanel8);
    WebButton34.Name := 'WebButton34';
    WebButton34.Left := 331;
    WebButton34.Top := 274;
    WebButton34.Width := 25;
    WebButton34.Height := 25;
    WebButton34.Caption := '...';
    WebButton34.ChildOrder := 16;
    WebButton34.HeightPercent := 100.000000000000000000;
    WebButton34.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton34, Self, 'OnClick', 'WebButton34Click');
    WebPanel29.SetParentComponent(WebPanel8);
    WebPanel29.Name := 'WebPanel29';
    WebPanel29.Left := 0;
    WebPanel29.Top := 417;
    WebPanel29.Width := 1137;
    WebPanel29.Height := 60;
    WebPanel29.Align := alBottom;
    WebPanel29.ChildOrder := 1;
    WebPanel29.Color := clSilver;
    WebPanel29.TabOrder := 11;
    WebButton60.SetParentComponent(WebPanel29);
    WebButton60.Name := 'WebButton60';
    WebButton60.Left := 20;
    WebButton60.Top := 16;
    WebButton60.Width := 96;
    WebButton60.Height := 25;
    WebButton60.Caption := 'Price List';
    WebButton60.Color := clSkyBlue;
    WebButton60.HeightPercent := 100.000000000000000000;
    WebButton60.WidthPercent := 100.000000000000000000;
    btnSaveContract1.SetParentComponent(WebPanel29);
    btnSaveContract1.Name := 'btnSaveContract1';
    btnSaveContract1.Left := 142;
    btnSaveContract1.Top := 16;
    btnSaveContract1.Width := 96;
    btnSaveContract1.Height := 25;
    btnSaveContract1.Caption := 'Save';
    btnSaveContract1.Color := clGreenyellow;
    btnSaveContract1.ChildOrder := 1;
    btnSaveContract1.HeightPercent := 100.000000000000000000;
    btnSaveContract1.WidthPercent := 100.000000000000000000;
    SetEvent(btnSaveContract1, Self, 'OnClick', 'btnSaveContract1Click');
    WebButton62.SetParentComponent(WebPanel29);
    WebButton62.Name := 'WebButton62';
    WebButton62.Left := 259;
    WebButton62.Top := 16;
    WebButton62.Width := 96;
    WebButton62.Height := 25;
    WebButton62.Caption := 'Cancel';
    WebButton62.Color := clRed;
    WebButton62.ChildOrder := 2;
    WebButton62.HeightPercent := 100.000000000000000000;
    WebButton62.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton62, Self, 'OnClick', 'WebButton62Click');
    WebButton30.SetParentComponent(WebPanel8);
    WebButton30.Name := 'WebButton30';
    WebButton30.Left := 445;
    WebButton30.Top := 94;
    WebButton30.Width := 25;
    WebButton30.Height := 25;
    WebButton30.Caption := '...';
    WebButton30.ChildOrder := 18;
    WebButton30.HeightPercent := 100.000000000000000000;
    WebButton30.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton30, Self, 'OnClick', 'WebButton30Click');
    wpcsAdditionalInfo.SetParentComponent(wpcActiveContracts);
    wpcsAdditionalInfo.Name := 'wpcsAdditionalInfo';
    wpcsAdditionalInfo.Left := 0;
    wpcsAdditionalInfo.Top := 20;
    wpcsAdditionalInfo.Width := 1137;
    wpcsAdditionalInfo.Height := 477;
    wpcsAdditionalInfo.Caption := 'Additional Information';
    wpcsAdditionalInfo.ChildOrder := 1;
    WebPanel9.SetParentComponent(wpcsAdditionalInfo);
    WebPanel9.Name := 'WebPanel9';
    WebPanel9.Left := 0;
    WebPanel9.Top := 0;
    WebPanel9.Width := 1137;
    WebPanel9.Height := 477;
    WebPanel9.Align := alClient;
    WebPanel9.TabOrder := 0;
    WebLabel6.SetParentComponent(WebPanel9);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 61;
    WebLabel6.Top := 20;
    WebLabel6.Width := 70;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'Capture Type';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel9);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 237;
    WebLabel7.Top := 20;
    WebLabel7.Width := 69;
    WebLabel7.Height := 15;
    WebLabel7.Caption := 'Invoice Type:';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebPanel9);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 405;
    WebLabel8.Top := 20;
    WebLabel8.Width := 118;
    WebLabel8.Height := 15;
    WebLabel8.Caption := 'Additional Description';
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(WebPanel9);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 53;
    WebLabel9.Top := 71;
    WebLabel9.Width := 51;
    WebLabel9.Height := 15;
    WebLabel9.Caption := 'Start Date';
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(WebPanel9);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 191;
    WebLabel10.Top := 71;
    WebLabel10.Width := 93;
    WebLabel10.Height := 15;
    WebLabel10.Caption := 'AVG Qty Per Load';
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebLabel11.SetParentComponent(WebPanel9);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 351;
    WebLabel11.Top := 71;
    WebLabel11.Width := 47;
    WebLabel11.Height := 15;
    WebLabel11.Caption := 'Pay Type';
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebLabel12.SetParentComponent(WebPanel9);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 520;
    WebLabel12.Top := 71;
    WebLabel12.Width := 82;
    WebLabel12.Height := 15;
    WebLabel12.Caption := 'Payment Terms';
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(WebPanel9);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 371;
    WebLabel13.Top := 125;
    WebLabel13.Width := 121;
    WebLabel13.Height := 15;
    WebLabel13.Caption := 'Max Loads Vehicle/Day';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(WebPanel9);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 536;
    WebLabel14.Top := 125;
    WebLabel14.Width := 45;
    WebLabel14.Height := 15;
    WebLabel14.Caption := 'Distance';
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel15.SetParentComponent(WebPanel9);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 630;
    WebLabel15.Top := 125;
    WebLabel15.Width := 61;
    WebLabel15.Height := 15;
    WebLabel15.Caption := 'Driver Ratio';
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(WebPanel9);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 817;
    WebLabel16.Top := 185;
    WebLabel16.Width := 53;
    WebLabel16.Height := 15;
    WebLabel16.Caption := 'Controller';
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebLabel17.SetParentComponent(WebPanel9);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 53;
    WebLabel17.Top := 185;
    WebLabel17.Width := 88;
    WebLabel17.Height := 15;
    WebLabel17.Caption := 'Quote Reference';
    WebLabel17.HeightPercent := 100.000000000000000000;
    WebLabel17.WidthPercent := 100.000000000000000000;
    WebLabel18.SetParentComponent(WebPanel9);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 387;
    WebLabel18.Top := 185;
    WebLabel18.Width := 132;
    WebLabel18.Height := 15;
    WebLabel18.Caption := 'Load Instruction Avg Qty';
    WebLabel18.HeightPercent := 100.000000000000000000;
    WebLabel18.WidthPercent := 100.000000000000000000;
    WebLabel19.SetParentComponent(WebPanel9);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 651;
    WebLabel19.Top := 184;
    WebLabel19.Width := 82;
    WebLabel19.Height := 15;
    WebLabel19.Caption := 'Max Drive Time';
    WebLabel19.HeightPercent := 100.000000000000000000;
    WebLabel19.WidthPercent := 100.000000000000000000;
    WebLabel20.SetParentComponent(WebPanel9);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 54;
    WebLabel20.Top := 252;
    WebLabel20.Width := 48;
    WebLabel20.Height := 15;
    WebLabel20.Caption := 'Total Qty';
    WebLabel20.HeightPercent := 100.000000000000000000;
    WebLabel20.Visible := False;
    WebLabel20.WidthPercent := 100.000000000000000000;
    WebLabel21.SetParentComponent(WebPanel9);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 241;
    WebLabel21.Top := 252;
    WebLabel21.Width := 72;
    WebLabel21.Height := 15;
    WebLabel21.Caption := 'Qty Allocated';
    WebLabel21.HeightPercent := 100.000000000000000000;
    WebLabel21.Visible := False;
    WebLabel21.WidthPercent := 100.000000000000000000;
    WebLabel22.SetParentComponent(WebPanel9);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 453;
    WebLabel22.Top := 252;
    WebLabel22.Width := 61;
    WebLabel22.Height := 15;
    WebLabel22.Caption := 'Qty Loaded';
    WebLabel22.HeightPercent := 100.000000000000000000;
    WebLabel22.Visible := False;
    WebLabel22.WidthPercent := 100.000000000000000000;
    WebLabel23.SetParentComponent(WebPanel9);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 669;
    WebLabel23.Top := 252;
    WebLabel23.Width := 83;
    WebLabel23.Height := 15;
    WebLabel23.Caption := 'Qty Off-Loaded';
    WebLabel23.HeightPercent := 100.000000000000000000;
    WebLabel23.Visible := False;
    WebLabel23.WidthPercent := 100.000000000000000000;
    WebLabel24.SetParentComponent(WebPanel9);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 897;
    WebLabel24.Top := 252;
    WebLabel24.Width := 67;
    WebLabel24.Height := 15;
    WebLabel24.Caption := 'Qty Invoiced';
    WebLabel24.HeightPercent := 100.000000000000000000;
    WebLabel24.Visible := False;
    WebLabel24.WidthPercent := 100.000000000000000000;
    WebLabel25.SetParentComponent(WebPanel9);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 897;
    WebLabel25.Top := 324;
    WebLabel25.Width := 79;
    WebLabel25.Height := 15;
    WebLabel25.Caption := 'Loads Invoiced';
    WebLabel25.HeightPercent := 100.000000000000000000;
    WebLabel25.Visible := False;
    WebLabel25.WidthPercent := 100.000000000000000000;
    WebLabel26.SetParentComponent(WebPanel9);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 669;
    WebLabel26.Top := 324;
    WebLabel26.Width := 95;
    WebLabel26.Height := 15;
    WebLabel26.Caption := 'Loads Off-Loaded';
    WebLabel26.HeightPercent := 100.000000000000000000;
    WebLabel26.Visible := False;
    WebLabel26.WidthPercent := 100.000000000000000000;
    WebLabel27.SetParentComponent(WebPanel9);
    WebLabel27.Name := 'WebLabel27';
    WebLabel27.Left := 453;
    WebLabel27.Top := 324;
    WebLabel27.Width := 73;
    WebLabel27.Height := 15;
    WebLabel27.Caption := 'Loads Loaded';
    WebLabel27.HeightPercent := 100.000000000000000000;
    WebLabel27.Visible := False;
    WebLabel27.WidthPercent := 100.000000000000000000;
    WebLabel28.SetParentComponent(WebPanel9);
    WebLabel28.Name := 'WebLabel28';
    WebLabel28.Left := 241;
    WebLabel28.Top := 324;
    WebLabel28.Width := 84;
    WebLabel28.Height := 15;
    WebLabel28.Caption := 'Loads Allocated';
    WebLabel28.HeightPercent := 100.000000000000000000;
    WebLabel28.Visible := False;
    WebLabel28.WidthPercent := 100.000000000000000000;
    WebLabel29.SetParentComponent(WebPanel9);
    WebLabel29.Name := 'WebLabel29';
    WebLabel29.Left := 54;
    WebLabel29.Top := 324;
    WebLabel29.Width := 60;
    WebLabel29.Height := 15;
    WebLabel29.Caption := 'Total Loads';
    WebLabel29.HeightPercent := 100.000000000000000000;
    WebLabel29.Visible := False;
    WebLabel29.WidthPercent := 100.000000000000000000;
    dbedtCpatureType.SetParentComponent(WebPanel9);
    dbedtCpatureType.Name := 'dbedtCpatureType';
    dbedtCpatureType.Left := 53;
    dbedtCpatureType.Top := 37;
    dbedtCpatureType.Width := 121;
    dbedtCpatureType.Height := 22;
    dbedtCpatureType.HeightPercent := 100.000000000000000000;
    dbedtCpatureType.Text := 'dbedtCpatureType';
    dbedtCpatureType.WidthPercent := 100.000000000000000000;
    dbedtCpatureType.DataField := 'CAPTURETONS';
    dbedtCpatureType.DataSource := dsAContracts;
    WebDBEdit17.SetParentComponent(WebPanel9);
    WebDBEdit17.Name := 'WebDBEdit17';
    WebDBEdit17.Left := 234;
    WebDBEdit17.Top := 37;
    WebDBEdit17.Width := 121;
    WebDBEdit17.Height := 22;
    WebDBEdit17.ChildOrder := 1;
    WebDBEdit17.HeightPercent := 100.000000000000000000;
    WebDBEdit17.Text := 'WebDBEdit17';
    WebDBEdit17.WidthPercent := 100.000000000000000000;
    WebDBEdit17.DataField := 'INVOICETONS';
    WebDBEdit17.DataSource := dsAContracts;
    WebDBEdit18.SetParentComponent(WebPanel9);
    WebDBEdit18.Name := 'WebDBEdit18';
    WebDBEdit18.Left := 405;
    WebDBEdit18.Top := 37;
    WebDBEdit18.Width := 513;
    WebDBEdit18.Height := 22;
    WebDBEdit18.ChildOrder := 2;
    WebDBEdit18.HeightPercent := 100.000000000000000000;
    WebDBEdit18.Text := 'WebDBEdit18';
    WebDBEdit18.WidthPercent := 100.000000000000000000;
    WebDBEdit18.DataField := 'ADDDESCRIPTION';
    WebDBEdit18.DataSource := dsAContracts;
    WebDBEdit19.SetParentComponent(WebPanel9);
    WebDBEdit19.Name := 'WebDBEdit19';
    WebDBEdit19.Left := 351;
    WebDBEdit19.Top := 92;
    WebDBEdit19.Width := 110;
    WebDBEdit19.Height := 22;
    WebDBEdit19.ChildOrder := 3;
    WebDBEdit19.HeightPercent := 100.000000000000000000;
    WebDBEdit19.Text := 'WebDBEdit19';
    WebDBEdit19.WidthPercent := 100.000000000000000000;
    WebDBEdit19.DataField := 'PAYMENTTYPE';
    WebDBEdit19.DataSource := dsAContracts;
    WebDBEdit20.SetParentComponent(WebPanel9);
    WebDBEdit20.Name := 'WebDBEdit20';
    WebDBEdit20.Left := 191;
    WebDBEdit20.Top := 92;
    WebDBEdit20.Width := 138;
    WebDBEdit20.Height := 22;
    WebDBEdit20.ChildOrder := 4;
    WebDBEdit20.HeightPercent := 100.000000000000000000;
    WebDBEdit20.Text := 'WebDBEdit20';
    WebDBEdit20.WidthPercent := 100.000000000000000000;
    WebDBEdit20.DataField := 'AVGTONS';
    WebDBEdit20.DataSource := dsAContracts;
    WebDBEdit21.SetParentComponent(WebPanel9);
    WebDBEdit21.Name := 'WebDBEdit21';
    WebDBEdit21.Left := 520;
    WebDBEdit21.Top := 92;
    WebDBEdit21.Width := 147;
    WebDBEdit21.Height := 22;
    WebDBEdit21.ChildOrder := 5;
    WebDBEdit21.HeightPercent := 100.000000000000000000;
    WebDBEdit21.Text := 'WebDBEdit21';
    WebDBEdit21.WidthPercent := 100.000000000000000000;
    WebDBEdit21.DataField := 'PayTermsName';
    WebDBEdit21.DataSource := dsAContracts;
    WebDBEdit23.SetParentComponent(WebPanel9);
    WebDBEdit23.Name := 'WebDBEdit23';
    WebDBEdit23.Left := 371;
    WebDBEdit23.Top := 146;
    WebDBEdit23.Width := 121;
    WebDBEdit23.Height := 22;
    WebDBEdit23.ChildOrder := 7;
    WebDBEdit23.HeightPercent := 100.000000000000000000;
    WebDBEdit23.Text := 'WebDBEdit23';
    WebDBEdit23.WidthPercent := 100.000000000000000000;
    WebDBEdit23.DataField := 'MAXLOADORDERS';
    WebDBEdit23.DataSource := dsAContracts;
    WebDBEdit24.SetParentComponent(WebPanel9);
    WebDBEdit24.Name := 'WebDBEdit24';
    WebDBEdit24.Left := 536;
    WebDBEdit24.Top := 146;
    WebDBEdit24.Width := 60;
    WebDBEdit24.Height := 22;
    WebDBEdit24.ChildOrder := 8;
    WebDBEdit24.HeightPercent := 100.000000000000000000;
    WebDBEdit24.Text := 'WebDBEdit24';
    WebDBEdit24.WidthPercent := 100.000000000000000000;
    WebDBEdit24.DataField := 'DISTANCE';
    WebDBEdit24.DataSource := dsAContracts;
    WebDBEdit25.SetParentComponent(WebPanel9);
    WebDBEdit25.Name := 'WebDBEdit25';
    WebDBEdit25.Left := 630;
    WebDBEdit25.Top := 146;
    WebDBEdit25.Width := 60;
    WebDBEdit25.Height := 22;
    WebDBEdit25.ChildOrder := 9;
    WebDBEdit25.HeightPercent := 100.000000000000000000;
    WebDBEdit25.Text := 'WebDBEdit25';
    WebDBEdit25.WidthPercent := 100.000000000000000000;
    WebDBEdit25.DataField := 'DRIVERRATIO';
    WebDBEdit25.DataSource := dsAContracts;
    WebDBDateTimePicker1.SetParentComponent(WebPanel9);
    WebDBDateTimePicker1.Name := 'WebDBDateTimePicker1';
    WebDBDateTimePicker1.Left := 53;
    WebDBDateTimePicker1.Top := 92;
    WebDBDateTimePicker1.Width := 132;
    WebDBDateTimePicker1.Height := 22;
    WebDBDateTimePicker1.BorderStyle := bsSingle;
    WebDBDateTimePicker1.ChildOrder := 10;
    WebDBDateTimePicker1.Color := clWhite;
    WebDBDateTimePicker1.Date := 45922.607382395840000000;
    WebDBDateTimePicker1.Role := '';
    WebDBDateTimePicker1.Text := '';
    WebDBDateTimePicker1.DataField := 'STARTDATE';
    WebDBDateTimePicker1.DataSource := dsAContracts;
    WebButton12.SetParentComponent(WebPanel9);
    WebButton12.Name := 'WebButton12';
    WebButton12.Left := 673;
    WebButton12.Top := 91;
    WebButton12.Width := 25;
    WebButton12.Height := 25;
    WebButton12.Caption := '...';
    WebButton12.ChildOrder := 11;
    WebButton12.HeightPercent := 100.000000000000000000;
    WebButton12.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton12, Self, 'OnClick', 'WebButton12Click');
    cbxDedicated.SetParentComponent(WebPanel9);
    cbxDedicated.Name := 'cbxDedicated';
    cbxDedicated.Left := 52;
    cbxDedicated.Top := 147;
    cbxDedicated.Width := 128;
    cbxDedicated.Height := 22;
    cbxDedicated.Caption := 'Dedicated Contract';
    cbxDedicated.ChildOrder := 12;
    cbxDedicated.HeightPercent := 100.000000000000000000;
    cbxDedicated.WidthPercent := 100.000000000000000000;
    SetEvent(cbxDedicated, Self, 'OnClick', 'cbxDedicatedClick');
    cbxDedicated.DataField := 'DEDICATED';
    cbxDedicated.DataSource := dsAContracts;
    cbxDedicated.ValueChecked := 'Y';
    cbxDedicated.ValueUnChecked := 'N';
    cbxADHOC.SetParentComponent(WebPanel9);
    cbxADHOC.Name := 'cbxADHOC';
    cbxADHOC.Left := 186;
    cbxADHOC.Top := 147;
    cbxADHOC.Width := 128;
    cbxADHOC.Height := 22;
    cbxADHOC.Caption := 'ADHOC Contract';
    cbxADHOC.ChildOrder := 13;
    cbxADHOC.HeightPercent := 100.000000000000000000;
    cbxADHOC.WidthPercent := 100.000000000000000000;
    SetEvent(cbxADHOC, Self, 'OnClick', 'cbxADHOCClick');
    cbxADHOC.DataField := 'ADDHOC';
    cbxADHOC.DataSource := dsAContracts;
    cbxADHOC.ValueChecked := 'Y';
    cbxADHOC.ValueUnChecked := 'N';
    WebButton13.SetParentComponent(WebPanel9);
    WebButton13.Name := 'WebButton13';
    WebButton13.Left := 467;
    WebButton13.Top := 91;
    WebButton13.Width := 25;
    WebButton13.Height := 25;
    WebButton13.Caption := '...';
    WebButton13.ChildOrder := 14;
    WebButton13.HeightPercent := 100.000000000000000000;
    WebButton13.WidthPercent := 100.000000000000000000;
    WebDBEdit22.SetParentComponent(WebPanel9);
    WebDBEdit22.Name := 'WebDBEdit22';
    WebDBEdit22.Left := 53;
    WebDBEdit22.Top := 206;
    WebDBEdit22.Width := 258;
    WebDBEdit22.Height := 22;
    WebDBEdit22.ChildOrder := 24;
    WebDBEdit22.HeightPercent := 100.000000000000000000;
    WebDBEdit22.Text := 'WebDBEdit22';
    WebDBEdit22.WidthPercent := 100.000000000000000000;
    WebDBEdit22.DataField := 'QUOTEREFNO';
    WebDBEdit22.DataSource := dsAContracts;
    WebDBEdit26.SetParentComponent(WebPanel9);
    WebDBEdit26.Name := 'WebDBEdit26';
    WebDBEdit26.Left := 387;
    WebDBEdit26.Top := 206;
    WebDBEdit26.Width := 201;
    WebDBEdit26.Height := 22;
    WebDBEdit26.ChildOrder := 25;
    WebDBEdit26.HeightPercent := 100.000000000000000000;
    WebDBEdit26.Text := 'WebDBEdit26';
    WebDBEdit26.WidthPercent := 100.000000000000000000;
    WebDBEdit26.DataField := 'LOADINSTRUCTQTY';
    WebDBEdit26.DataSource := dsAContracts;
    WebDBEdit27.SetParentComponent(WebPanel9);
    WebDBEdit27.Name := 'WebDBEdit27';
    WebDBEdit27.Left := 817;
    WebDBEdit27.Top := 206;
    WebDBEdit27.Width := 226;
    WebDBEdit27.Height := 22;
    WebDBEdit27.ChildOrder := 26;
    WebDBEdit27.HeightPercent := 100.000000000000000000;
    WebDBEdit27.Text := 'WebDBEdit27';
    WebDBEdit27.WidthPercent := 100.000000000000000000;
    WebDBEdit27.DataField := 'CONTROLLERName';
    WebDBEdit27.DataSource := dsAContracts;
    WebDBMaskEdit1.SetParentComponent(WebPanel9);
    WebDBMaskEdit1.Name := 'WebDBMaskEdit1';
    WebDBMaskEdit1.Left := 651;
    WebDBMaskEdit1.Top := 205;
    WebDBMaskEdit1.Width := 121;
    WebDBMaskEdit1.Height := 23;
    WebDBMaskEdit1.TabOrder := 17;
    WebDBMaskEdit1.Text := 'WebDBMaskEdit1';
    WebDBMaskEdit1.HeightPercent := 100.000000000000000000;
    WebDBMaskEdit1.WidthPercent := 100.000000000000000000;
    WebDBMaskEdit1.DataField := 'maxdrivetime';
    WebDBMaskEdit1.DataSource := dsAContracts;
    WebButton14.SetParentComponent(WebPanel9);
    WebButton14.Name := 'WebButton14';
    WebButton14.Left := 1049;
    WebButton14.Top := 204;
    WebButton14.Width := 25;
    WebButton14.Height := 25;
    WebButton14.Caption := '...';
    WebButton14.ChildOrder := 32;
    WebButton14.HeightPercent := 100.000000000000000000;
    WebButton14.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton14, Self, 'OnClick', 'WebButton14Click');
    WebButton15.SetParentComponent(WebPanel9);
    WebButton15.Name := 'WebButton15';
    WebButton15.Left := 180;
    WebButton15.Top := 36;
    WebButton15.Width := 25;
    WebButton15.Height := 25;
    WebButton15.Caption := '...';
    WebButton15.ChildOrder := 33;
    WebButton15.HeightPercent := 100.000000000000000000;
    WebButton15.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton15, Self, 'OnClick', 'WebButton15Click');
    WebButton16.SetParentComponent(WebPanel9);
    WebButton16.Name := 'WebButton16';
    WebButton16.Left := 361;
    WebButton16.Top := 36;
    WebButton16.Width := 25;
    WebButton16.Height := 25;
    WebButton16.Caption := '...';
    WebButton16.ChildOrder := 34;
    WebButton16.HeightPercent := 100.000000000000000000;
    WebButton16.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton16, Self, 'OnClick', 'WebButton16Click');
    WebDBEdit28.SetParentComponent(WebPanel9);
    WebDBEdit28.Name := 'WebDBEdit28';
    WebDBEdit28.Left := 53;
    WebDBEdit28.Top := 273;
    WebDBEdit28.Width := 121;
    WebDBEdit28.Height := 22;
    WebDBEdit28.ChildOrder := 35;
    WebDBEdit28.HeightPercent := 100.000000000000000000;
    WebDBEdit28.Text := 'WebDBEdit28';
    WebDBEdit28.Visible := False;
    WebDBEdit28.WidthPercent := 100.000000000000000000;
    WebDBEdit28.DataField := 'TOTALTONS';
    WebDBEdit28.DataSource := dsAContracts;
    WebDBEdit29.SetParentComponent(WebPanel9);
    WebDBEdit29.Name := 'WebDBEdit29';
    WebDBEdit29.Left := 53;
    WebDBEdit29.Top := 345;
    WebDBEdit29.Width := 121;
    WebDBEdit29.Height := 22;
    WebDBEdit29.ChildOrder := 36;
    WebDBEdit29.HeightPercent := 100.000000000000000000;
    WebDBEdit29.Text := 'WebDBEdit29';
    WebDBEdit29.Visible := False;
    WebDBEdit29.WidthPercent := 100.000000000000000000;
    WebDBEdit29.DataField := 'TOTALLOADS';
    WebDBEdit29.DataSource := dsAContracts;
    WebDBEdit30.SetParentComponent(WebPanel9);
    WebDBEdit30.Name := 'WebDBEdit30';
    WebDBEdit30.Left := 241;
    WebDBEdit30.Top := 273;
    WebDBEdit30.Width := 121;
    WebDBEdit30.Height := 22;
    WebDBEdit30.ChildOrder := 37;
    WebDBEdit30.HeightPercent := 100.000000000000000000;
    WebDBEdit30.Text := 'WebDBEdit30';
    WebDBEdit30.Visible := False;
    WebDBEdit30.WidthPercent := 100.000000000000000000;
    WebDBEdit30.DataField := 'TOTALTONSORDER';
    WebDBEdit30.DataSource := dsAContracts;
    WebDBEdit31.SetParentComponent(WebPanel9);
    WebDBEdit31.Name := 'WebDBEdit31';
    WebDBEdit31.Left := 241;
    WebDBEdit31.Top := 345;
    WebDBEdit31.Width := 121;
    WebDBEdit31.Height := 22;
    WebDBEdit31.ChildOrder := 38;
    WebDBEdit31.HeightPercent := 100.000000000000000000;
    WebDBEdit31.Text := 'WebDBEdit31';
    WebDBEdit31.Visible := False;
    WebDBEdit31.WidthPercent := 100.000000000000000000;
    WebDBEdit31.DataField := 'LOADSORDER';
    WebDBEdit31.DataSource := dsAContracts;
    WebDBEdit32.SetParentComponent(WebPanel9);
    WebDBEdit32.Name := 'WebDBEdit32';
    WebDBEdit32.Left := 453;
    WebDBEdit32.Top := 273;
    WebDBEdit32.Width := 121;
    WebDBEdit32.Height := 22;
    WebDBEdit32.ChildOrder := 39;
    WebDBEdit32.HeightPercent := 100.000000000000000000;
    WebDBEdit32.Text := 'WebDBEdit32';
    WebDBEdit32.Visible := False;
    WebDBEdit32.WidthPercent := 100.000000000000000000;
    WebDBEdit32.DataField := 'TOTALTONSLOADED';
    WebDBEdit32.DataSource := dsAContracts;
    WebDBEdit33.SetParentComponent(WebPanel9);
    WebDBEdit33.Name := 'WebDBEdit33';
    WebDBEdit33.Left := 453;
    WebDBEdit33.Top := 345;
    WebDBEdit33.Width := 121;
    WebDBEdit33.Height := 22;
    WebDBEdit33.ChildOrder := 40;
    WebDBEdit33.HeightPercent := 100.000000000000000000;
    WebDBEdit33.Text := 'WebDBEdit33';
    WebDBEdit33.Visible := False;
    WebDBEdit33.WidthPercent := 100.000000000000000000;
    WebDBEdit33.DataField := 'LOADSLOADED';
    WebDBEdit33.DataSource := dsAContracts;
    WebDBEdit34.SetParentComponent(WebPanel9);
    WebDBEdit34.Name := 'WebDBEdit34';
    WebDBEdit34.Left := 669;
    WebDBEdit34.Top := 273;
    WebDBEdit34.Width := 121;
    WebDBEdit34.Height := 22;
    WebDBEdit34.ChildOrder := 41;
    WebDBEdit34.HeightPercent := 100.000000000000000000;
    WebDBEdit34.Text := 'WebDBEdit34';
    WebDBEdit34.Visible := False;
    WebDBEdit34.WidthPercent := 100.000000000000000000;
    WebDBEdit34.DataField := 'TOTALTONSOFFLOADED';
    WebDBEdit34.DataSource := dsAContracts;
    WebDBEdit35.SetParentComponent(WebPanel9);
    WebDBEdit35.Name := 'WebDBEdit35';
    WebDBEdit35.Left := 669;
    WebDBEdit35.Top := 345;
    WebDBEdit35.Width := 121;
    WebDBEdit35.Height := 22;
    WebDBEdit35.ChildOrder := 42;
    WebDBEdit35.HeightPercent := 100.000000000000000000;
    WebDBEdit35.Text := 'WebDBEdit35';
    WebDBEdit35.Visible := False;
    WebDBEdit35.WidthPercent := 100.000000000000000000;
    WebDBEdit35.DataField := 'LOADSOFFLOADED';
    WebDBEdit35.DataSource := dsAContracts;
    WebDBEdit36.SetParentComponent(WebPanel9);
    WebDBEdit36.Name := 'WebDBEdit36';
    WebDBEdit36.Left := 897;
    WebDBEdit36.Top := 273;
    WebDBEdit36.Width := 121;
    WebDBEdit36.Height := 22;
    WebDBEdit36.ChildOrder := 43;
    WebDBEdit36.HeightPercent := 100.000000000000000000;
    WebDBEdit36.Text := 'WebDBEdit36';
    WebDBEdit36.Visible := False;
    WebDBEdit36.WidthPercent := 100.000000000000000000;
    WebDBEdit36.DataField := 'TOTALTONSINVOICED';
    WebDBEdit36.DataSource := dsAContracts;
    WebDBEdit37.SetParentComponent(WebPanel9);
    WebDBEdit37.Name := 'WebDBEdit37';
    WebDBEdit37.Left := 897;
    WebDBEdit37.Top := 345;
    WebDBEdit37.Width := 121;
    WebDBEdit37.Height := 22;
    WebDBEdit37.ChildOrder := 44;
    WebDBEdit37.HeightPercent := 100.000000000000000000;
    WebDBEdit37.Text := 'WebDBEdit37';
    WebDBEdit37.Visible := False;
    WebDBEdit37.WidthPercent := 100.000000000000000000;
    WebDBEdit37.DataField := 'LOADSINVOICED';
    WebDBEdit37.DataSource := dsAContracts;
    WebPanel28.SetParentComponent(WebPanel9);
    WebPanel28.Name := 'WebPanel28';
    WebPanel28.Left := 0;
    WebPanel28.Top := 417;
    WebPanel28.Width := 1137;
    WebPanel28.Height := 60;
    WebPanel28.Align := alBottom;
    WebPanel28.ChildOrder := 1;
    WebPanel28.Color := clSilver;
    WebPanel28.TabOrder := 31;
    WebButton57.SetParentComponent(WebPanel28);
    WebButton57.Name := 'WebButton57';
    WebButton57.Left := 20;
    WebButton57.Top := 16;
    WebButton57.Width := 96;
    WebButton57.Height := 25;
    WebButton57.Caption := 'Price List';
    WebButton57.Color := clSkyBlue;
    WebButton57.HeightPercent := 100.000000000000000000;
    WebButton57.WidthPercent := 100.000000000000000000;
    btnSaveContract2.SetParentComponent(WebPanel28);
    btnSaveContract2.Name := 'btnSaveContract2';
    btnSaveContract2.Left := 143;
    btnSaveContract2.Top := 16;
    btnSaveContract2.Width := 96;
    btnSaveContract2.Height := 25;
    btnSaveContract2.Caption := 'Save';
    btnSaveContract2.Color := clGreenyellow;
    btnSaveContract2.ChildOrder := 1;
    btnSaveContract2.HeightPercent := 100.000000000000000000;
    btnSaveContract2.WidthPercent := 100.000000000000000000;
    SetEvent(btnSaveContract2, Self, 'OnClick', 'btnSaveContract2Click');
    WebButton59.SetParentComponent(WebPanel28);
    WebButton59.Name := 'WebButton59';
    WebButton59.Left := 259;
    WebButton59.Top := 16;
    WebButton59.Width := 96;
    WebButton59.Height := 25;
    WebButton59.Caption := 'Cancel';
    WebButton59.Color := clRed;
    WebButton59.ChildOrder := 2;
    WebButton59.HeightPercent := 100.000000000000000000;
    WebButton59.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton59, Self, 'OnClick', 'WebButton59Click');
    wpcsBillingInformation.SetParentComponent(wpcActiveContracts);
    wpcsBillingInformation.Name := 'wpcsBillingInformation';
    wpcsBillingInformation.Left := 0;
    wpcsBillingInformation.Top := 20;
    wpcsBillingInformation.Width := 1137;
    wpcsBillingInformation.Height := 477;
    wpcsBillingInformation.Caption := 'Billing Information';
    wpcsBillingInformation.ChildOrder := 2;
    WebPanel11.SetParentComponent(wpcsBillingInformation);
    WebPanel11.Name := 'WebPanel11';
    WebPanel11.Left := 0;
    WebPanel11.Top := 0;
    WebPanel11.Width := 1137;
    WebPanel11.Height := 477;
    WebPanel11.Align := alClient;
    WebPanel11.TabOrder := 0;
    WebLabel30.SetParentComponent(WebPanel11);
    WebLabel30.Name := 'WebLabel30';
    WebLabel30.Left := 32;
    WebLabel30.Top := 19;
    WebLabel30.Width := 49;
    WebLabel30.Height := 15;
    WebLabel30.Caption := 'Order No';
    WebLabel30.HeightPercent := 100.000000000000000000;
    WebLabel30.WidthPercent := 100.000000000000000000;
    WebLabel33.SetParentComponent(WebPanel11);
    WebLabel33.Name := 'WebLabel33';
    WebLabel33.Left := 32;
    WebLabel33.Top := 71;
    WebLabel33.Width := 75;
    WebLabel33.Height := 15;
    WebLabel33.Caption := 'Cut Off Date 1';
    WebLabel33.HeightPercent := 100.000000000000000000;
    WebLabel33.WidthPercent := 100.000000000000000000;
    WebLabel34.SetParentComponent(WebPanel11);
    WebLabel34.Name := 'WebLabel34';
    WebLabel34.Left := 32;
    WebLabel34.Top := 128;
    WebLabel34.Width := 75;
    WebLabel34.Height := 15;
    WebLabel34.Caption := 'Cut Off Date 2';
    WebLabel34.HeightPercent := 100.000000000000000000;
    WebLabel34.WidthPercent := 100.000000000000000000;
    WebLabel35.SetParentComponent(WebPanel11);
    WebLabel35.Name := 'WebLabel35';
    WebLabel35.Left := 552;
    WebLabel35.Top := 189;
    WebLabel35.Width := 89;
    WebLabel35.Height := 15;
    WebLabel35.Caption := 'Invoice Selection';
    WebLabel35.HeightPercent := 100.000000000000000000;
    WebLabel35.WidthPercent := 100.000000000000000000;
    WebLabel36.SetParentComponent(WebPanel11);
    WebLabel36.Name := 'WebLabel36';
    WebLabel36.Left := 552;
    WebLabel36.Top := 244;
    WebLabel36.Width := 71;
    WebLabel36.Height := 15;
    WebLabel36.Caption := 'Delivery Note';
    WebLabel36.HeightPercent := 100.000000000000000000;
    WebLabel36.WidthPercent := 100.000000000000000000;
    WebLabel37.SetParentComponent(WebPanel11);
    WebLabel37.Name := 'WebLabel37';
    WebLabel37.Left := 552;
    WebLabel37.Top := 300;
    WebLabel37.Width := 52;
    WebLabel37.Height := 15;
    WebLabel37.Caption := 'Trip Sheet';
    WebLabel37.HeightPercent := 100.000000000000000000;
    WebLabel37.WidthPercent := 100.000000000000000000;
    WebGroupBox4.SetParentComponent(WebPanel11);
    WebGroupBox4.Name := 'WebGroupBox4';
    WebGroupBox4.Left := 797;
    WebGroupBox4.Top := 16;
    WebGroupBox4.Width := 270;
    WebGroupBox4.Height := 393;
    WebGroupBox4.BorderColor := clSilver;
    WebGroupBox4.Caption := 'WebGroupBox4';
    WebDBCheckBox13.SetParentComponent(WebGroupBox4);
    WebDBCheckBox13.Name := 'WebDBCheckBox13';
    WebDBCheckBox13.Left := 16;
    WebDBCheckBox13.Top := 18;
    WebDBCheckBox13.Width := 185;
    WebDBCheckBox13.Height := 22;
    WebDBCheckBox13.Caption := 'Invoice On Loading Qty';
    WebDBCheckBox13.HeightPercent := 100.000000000000000000;
    WebDBCheckBox13.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox13, Self, 'OnClick', 'WebDBCheckBox13Click');
    WebDBCheckBox13.DataField := 'INVLOADING';
    WebDBCheckBox13.DataSource := dsAContracts;
    WebDBCheckBox13.ValueChecked := 'Y';
    WebDBCheckBox13.ValueUnChecked := 'N';
    WebDBCheckBox14.SetParentComponent(WebGroupBox4);
    WebDBCheckBox14.Name := 'WebDBCheckBox14';
    WebDBCheckBox14.Left := 16;
    WebDBCheckBox14.Top := 38;
    WebDBCheckBox14.Width := 185;
    WebDBCheckBox14.Height := 22;
    WebDBCheckBox14.Caption := 'Invoice on Off-Loading Qty';
    WebDBCheckBox14.ChildOrder := 1;
    WebDBCheckBox14.HeightPercent := 100.000000000000000000;
    WebDBCheckBox14.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox14, Self, 'OnClick', 'WebDBCheckBox14Click');
    WebDBCheckBox14.DataField := 'INVOFFLOADING';
    WebDBCheckBox14.DataSource := dsAContracts;
    WebDBCheckBox14.ValueChecked := 'Y';
    WebDBCheckBox14.ValueUnChecked := 'N';
    WebDBCheckBox15.SetParentComponent(WebGroupBox4);
    WebDBCheckBox15.Name := 'WebDBCheckBox15';
    WebDBCheckBox15.Left := 16;
    WebDBCheckBox15.Top := 57;
    WebDBCheckBox15.Width := 185;
    WebDBCheckBox15.Height := 22;
    WebDBCheckBox15.Caption := 'Invoice Straight Rate';
    WebDBCheckBox15.ChildOrder := 2;
    WebDBCheckBox15.HeightPercent := 100.000000000000000000;
    WebDBCheckBox15.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox15, Self, 'OnClick', 'WebDBCheckBox15Click');
    WebDBCheckBox15.DataField := 'STRATERATE';
    WebDBCheckBox15.DataSource := dsAContracts;
    WebDBCheckBox15.ValueChecked := 'Y';
    WebDBCheckBox15.ValueUnChecked := 'N';
    WebDBCheckBox16.SetParentComponent(WebGroupBox4);
    WebDBCheckBox16.Name := 'WebDBCheckBox16';
    WebDBCheckBox16.Left := 16;
    WebDBCheckBox16.Top := 77;
    WebDBCheckBox16.Width := 185;
    WebDBCheckBox16.Height := 22;
    WebDBCheckBox16.Caption := 'Change Off-Loading Information';
    WebDBCheckBox16.ChildOrder := 3;
    WebDBCheckBox16.HeightPercent := 100.000000000000000000;
    WebDBCheckBox16.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox16, Self, 'OnClick', 'WebDBCheckBox16Click');
    WebDBCheckBox16.DataField := 'CHGOFFLOAD';
    WebDBCheckBox16.DataSource := dsAContracts;
    WebDBCheckBox16.ValueChecked := 'Y';
    WebDBCheckBox16.ValueUnChecked := 'N';
    WebDBCheckBox17.SetParentComponent(WebGroupBox4);
    WebDBCheckBox17.Name := 'WebDBCheckBox17';
    WebDBCheckBox17.Left := 16;
    WebDBCheckBox17.Top := 97;
    WebDBCheckBox17.Width := 185;
    WebDBCheckBox17.Height := 22;
    WebDBCheckBox17.Caption := 'Change Loading Information';
    WebDBCheckBox17.ChildOrder := 4;
    WebDBCheckBox17.HeightPercent := 100.000000000000000000;
    WebDBCheckBox17.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox17, Self, 'OnClick', 'WebDBCheckBox17Click');
    WebDBCheckBox17.DataField := 'CHGLOAD';
    WebDBCheckBox17.DataSource := dsAContracts;
    WebDBCheckBox17.ValueChecked := 'Y';
    WebDBCheckBox17.ValueUnChecked := 'N';
    WebDBCheckBox18.SetParentComponent(WebGroupBox4);
    WebDBCheckBox18.Name := 'WebDBCheckBox18';
    WebDBCheckBox18.Left := 16;
    WebDBCheckBox18.Top := 117;
    WebDBCheckBox18.Width := 185;
    WebDBCheckBox18.Height := 22;
    WebDBCheckBox18.Caption := 'Change Client Price';
    WebDBCheckBox18.ChildOrder := 5;
    WebDBCheckBox18.HeightPercent := 100.000000000000000000;
    WebDBCheckBox18.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox18, Self, 'OnClick', 'WebDBCheckBox18Click');
    WebDBCheckBox18.DataField := 'CHGPRICE';
    WebDBCheckBox18.DataSource := dsAContracts;
    WebDBCheckBox18.ValueChecked := 'Y';
    WebDBCheckBox18.ValueUnChecked := 'N';
    WebDBCheckBox19.SetParentComponent(WebGroupBox4);
    WebDBCheckBox19.Name := 'WebDBCheckBox19';
    WebDBCheckBox19.Left := 16;
    WebDBCheckBox19.Top := 138;
    WebDBCheckBox19.Width := 185;
    WebDBCheckBox19.Height := 22;
    WebDBCheckBox19.Caption := 'Change Sub Price';
    WebDBCheckBox19.ChildOrder := 6;
    WebDBCheckBox19.HeightPercent := 100.000000000000000000;
    WebDBCheckBox19.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox19, Self, 'OnClick', 'WebDBCheckBox19Click');
    WebDBCheckBox19.DataField := 'CHGSUBPRICE';
    WebDBCheckBox19.DataSource := dsAContracts;
    WebDBCheckBox19.ValueChecked := 'Y';
    WebDBCheckBox19.ValueUnChecked := 'N';
    WebDBCheckBox20.SetParentComponent(WebGroupBox4);
    WebDBCheckBox20.Name := 'WebDBCheckBox20';
    WebDBCheckBox20.Left := 16;
    WebDBCheckBox20.Top := 159;
    WebDBCheckBox20.Width := 185;
    WebDBCheckBox20.Height := 22;
    WebDBCheckBox20.Caption := 'Customer Invoice without VAT';
    WebDBCheckBox20.ChildOrder := 7;
    WebDBCheckBox20.HeightPercent := 100.000000000000000000;
    WebDBCheckBox20.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox20, Self, 'OnClick', 'WebDBCheckBox20Click');
    WebDBCheckBox20.DataField := 'INVVAT';
    WebDBCheckBox20.DataSource := dsAContracts;
    WebDBCheckBox20.ValueChecked := 'Y';
    WebDBCheckBox20.ValueUnChecked := 'N';
    WebDBCheckBox21.SetParentComponent(WebGroupBox4);
    WebDBCheckBox21.Name := 'WebDBCheckBox21';
    WebDBCheckBox21.Left := 16;
    WebDBCheckBox21.Top := 180;
    WebDBCheckBox21.Width := 185;
    WebDBCheckBox21.Height := 22;
    WebDBCheckBox21.Caption := 'Supplier Invoice Without VAT';
    WebDBCheckBox21.ChildOrder := 8;
    WebDBCheckBox21.HeightPercent := 100.000000000000000000;
    WebDBCheckBox21.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox21, Self, 'OnClick', 'WebDBCheckBox21Click');
    WebDBCheckBox21.DataField := 'SINVVAT';
    WebDBCheckBox21.DataSource := dsAContracts;
    WebDBCheckBox21.ValueChecked := 'Y';
    WebDBCheckBox21.ValueUnChecked := 'N';
    WebDBCheckBox22.SetParentComponent(WebGroupBox4);
    WebDBCheckBox22.Name := 'WebDBCheckBox22';
    WebDBCheckBox22.Left := 16;
    WebDBCheckBox22.Top := 200;
    WebDBCheckBox22.Width := 185;
    WebDBCheckBox22.Height := 22;
    WebDBCheckBox22.Caption := 'Print Load Confirmation';
    WebDBCheckBox22.ChildOrder := 9;
    WebDBCheckBox22.HeightPercent := 100.000000000000000000;
    WebDBCheckBox22.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox22, Self, 'OnClick', 'WebDBCheckBox22Click');
    WebDBCheckBox22.DataField := 'PRINTLC';
    WebDBCheckBox22.DataSource := dsAContracts;
    WebDBCheckBox22.ValueChecked := 'Y';
    WebDBCheckBox22.ValueUnChecked := 'N';
    WebDBCheckBox23.SetParentComponent(WebGroupBox4);
    WebDBCheckBox23.Name := 'WebDBCheckBox23';
    WebDBCheckBox23.Left := 16;
    WebDBCheckBox23.Top := 220;
    WebDBCheckBox23.Width := 185;
    WebDBCheckBox23.Height := 22;
    WebDBCheckBox23.Caption := 'Print Delivery Note';
    WebDBCheckBox23.ChildOrder := 10;
    WebDBCheckBox23.HeightPercent := 100.000000000000000000;
    WebDBCheckBox23.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox23, Self, 'OnClick', 'WebDBCheckBox23Click');
    WebDBCheckBox23.DataField := 'PRINTDN';
    WebDBCheckBox23.DataSource := dsAContracts;
    WebDBCheckBox23.ValueChecked := 'Y';
    WebDBCheckBox23.ValueUnChecked := 'N';
    WebDBCheckBox24.SetParentComponent(WebGroupBox4);
    WebDBCheckBox24.Name := 'WebDBCheckBox24';
    WebDBCheckBox24.Left := 16;
    WebDBCheckBox24.Top := 240;
    WebDBCheckBox24.Width := 185;
    WebDBCheckBox24.Height := 22;
    WebDBCheckBox24.Caption := 'Print Trip Sheet';
    WebDBCheckBox24.ChildOrder := 11;
    WebDBCheckBox24.HeightPercent := 100.000000000000000000;
    WebDBCheckBox24.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox24, Self, 'OnClick', 'WebDBCheckBox24Click');
    WebDBCheckBox24.DataField := 'PRINTTS';
    WebDBCheckBox24.DataSource := dsAContracts;
    WebDBCheckBox24.ValueChecked := 'Y';
    WebDBCheckBox24.ValueUnChecked := 'N';
    WebDBCheckBox25.SetParentComponent(WebGroupBox4);
    WebDBCheckBox25.Name := 'WebDBCheckBox25';
    WebDBCheckBox25.Left := 16;
    WebDBCheckBox25.Top := 260;
    WebDBCheckBox25.Width := 185;
    WebDBCheckBox25.Height := 22;
    WebDBCheckBox25.Caption := 'No Additional Info Screen';
    WebDBCheckBox25.ChildOrder := 12;
    WebDBCheckBox25.HeightPercent := 100.000000000000000000;
    WebDBCheckBox25.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox25, Self, 'OnClick', 'WebDBCheckBox25Click');
    WebDBCheckBox25.DataField := 'OLDLOADSCREEN';
    WebDBCheckBox25.DataSource := dsAContracts;
    WebDBCheckBox25.ValueChecked := 'Y';
    WebDBCheckBox25.ValueUnChecked := 'N';
    WebDBCheckBox26.SetParentComponent(WebGroupBox4);
    WebDBCheckBox26.Name := 'WebDBCheckBox26';
    WebDBCheckBox26.Left := 16;
    WebDBCheckBox26.Top := 279;
    WebDBCheckBox26.Width := 184;
    WebDBCheckBox26.Height := 22;
    WebDBCheckBox26.Caption := 'Show Booking Screen';
    WebDBCheckBox26.ChildOrder := 13;
    WebDBCheckBox26.HeightPercent := 100.000000000000000000;
    WebDBCheckBox26.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox26, Self, 'OnClick', 'WebDBCheckBox26Click');
    WebDBCheckBox26.DataField := 'SHOWBOOKINGS';
    WebDBCheckBox26.DataSource := dsAContracts;
    WebDBCheckBox26.ValueChecked := 'Y';
    WebDBCheckBox26.ValueUnChecked := 'N';
    WebDBCheckBox27.SetParentComponent(WebGroupBox4);
    WebDBCheckBox27.Name := 'WebDBCheckBox27';
    WebDBCheckBox27.Left := 16;
    WebDBCheckBox27.Top := 300;
    WebDBCheckBox27.Width := 185;
    WebDBCheckBox27.Height := 22;
    WebDBCheckBox27.Caption := 'Show Additional Screen';
    WebDBCheckBox27.ChildOrder := 14;
    WebDBCheckBox27.HeightPercent := 100.000000000000000000;
    WebDBCheckBox27.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox27, Self, 'OnClick', 'WebDBCheckBox27Click');
    WebDBCheckBox27.DataField := 'SHOWADDITIONAL';
    WebDBCheckBox27.DataSource := dsAContracts;
    WebDBCheckBox27.ValueChecked := 'Y';
    WebDBCheckBox27.ValueUnChecked := 'N';
    WebDBCheckBox28.SetParentComponent(WebGroupBox4);
    WebDBCheckBox28.Name := 'WebDBCheckBox28';
    WebDBCheckBox28.Left := 16;
    WebDBCheckBox28.Top := 318;
    WebDBCheckBox28.Width := 185;
    WebDBCheckBox28.Height := 22;
    WebDBCheckBox28.Caption := 'Use Docket No For Invoice No';
    WebDBCheckBox28.ChildOrder := 15;
    WebDBCheckBox28.HeightPercent := 100.000000000000000000;
    WebDBCheckBox28.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox28, Self, 'OnClick', 'WebDBCheckBox28Click');
    WebDBCheckBox28.DataField := 'USEDOCKETINVNO';
    WebDBCheckBox28.DataSource := dsAContracts;
    WebDBCheckBox28.ValueChecked := 'Y';
    WebDBCheckBox28.ValueUnChecked := 'N';
    WebDBCheckBox29.SetParentComponent(WebGroupBox4);
    WebDBCheckBox29.Name := 'WebDBCheckBox29';
    WebDBCheckBox29.Left := 16;
    WebDBCheckBox29.Top := 337;
    WebDBCheckBox29.Width := 185;
    WebDBCheckBox29.Height := 22;
    WebDBCheckBox29.Caption := 'Allow 0.00 Load Linked on ML';
    WebDBCheckBox29.ChildOrder := 16;
    WebDBCheckBox29.HeightPercent := 100.000000000000000000;
    WebDBCheckBox29.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox29, Self, 'OnClick', 'WebDBCheckBox29Click');
    WebDBCheckBox29.DataField := 'LINKZEROML';
    WebDBCheckBox29.DataSource := dsAContracts;
    WebDBCheckBox29.ValueChecked := 'Y';
    WebDBCheckBox29.ValueUnChecked := 'N';
    WebDBCheckBox30.SetParentComponent(WebGroupBox4);
    WebDBCheckBox30.Name := 'WebDBCheckBox30';
    WebDBCheckBox30.Left := 16;
    WebDBCheckBox30.Top := 356;
    WebDBCheckBox30.Width := 185;
    WebDBCheckBox30.Height := 22;
    WebDBCheckBox30.Caption := 'Attatch Dockets for E-Mail';
    WebDBCheckBox30.ChildOrder := 17;
    WebDBCheckBox30.HeightPercent := 100.000000000000000000;
    WebDBCheckBox30.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBCheckBox30, Self, 'OnClick', 'WebDBCheckBox30Click');
    WebDBCheckBox30.DataField := 'ATTACHEDEMAIL';
    WebDBCheckBox30.DataSource := dsAContracts;
    WebDBCheckBox30.ValueChecked := 'Y';
    WebDBCheckBox30.ValueUnChecked := 'N';
    WebDBEdit38.SetParentComponent(WebPanel11);
    WebDBEdit38.Name := 'WebDBEdit38';
    WebDBEdit38.Left := 32;
    WebDBEdit38.Top := 37;
    WebDBEdit38.Width := 142;
    WebDBEdit38.Height := 22;
    WebDBEdit38.ChildOrder := 1;
    WebDBEdit38.HeightPercent := 100.000000000000000000;
    WebDBEdit38.Text := 'WebDBEdit38';
    WebDBEdit38.WidthPercent := 100.000000000000000000;
    WebDBEdit38.DataField := 'ORDERNO';
    WebDBEdit38.DataSource := dsAContracts;
    cbxMiltiLoadInvopice.SetParentComponent(WebPanel11);
    cbxMiltiLoadInvopice.Name := 'cbxMiltiLoadInvopice';
    cbxMiltiLoadInvopice.Left := 322;
    cbxMiltiLoadInvopice.Top := 40;
    cbxMiltiLoadInvopice.Width := 120;
    cbxMiltiLoadInvopice.Height := 22;
    cbxMiltiLoadInvopice.Caption := 'Multi Load Invoice';
    cbxMiltiLoadInvopice.ChildOrder := 3;
    cbxMiltiLoadInvopice.HeightPercent := 100.000000000000000000;
    cbxMiltiLoadInvopice.WidthPercent := 100.000000000000000000;
    SetEvent(cbxMiltiLoadInvopice, Self, 'OnClick', 'cbxMiltiLoadInvopiceClick');
    cbxMiltiLoadInvopice.DataField := 'MULTILOADINV';
    cbxMiltiLoadInvopice.DataSource := dsAContracts;
    cbxMiltiLoadInvopice.ValueChecked := 'Y';
    cbxMiltiLoadInvopice.ValueUnChecked := 'N';
    gbMiltiLoadInv.SetParentComponent(WebPanel11);
    gbMiltiLoadInv.Name := 'gbMiltiLoadInv';
    gbMiltiLoadInv.Left := 320;
    gbMiltiLoadInv.Top := 74;
    gbMiltiLoadInv.Width := 135;
    gbMiltiLoadInv.Height := 80;
    gbMiltiLoadInv.BorderColor := clSilver;
    gbMiltiLoadInv.Caption := 'Milti Invoice Type';
    gbMiltiLoadInv.ChildOrder := 6;
    gbMiltiLoadInv.Visible := False;
    WebDBCheckBox4.SetParentComponent(gbMiltiLoadInv);
    WebDBCheckBox4.Name := 'WebDBCheckBox4';
    WebDBCheckBox4.Left := 3;
    WebDBCheckBox4.Top := 24;
    WebDBCheckBox4.Width := 113;
    WebDBCheckBox4.Height := 22;
    WebDBCheckBox4.Caption := 'Pre-Listed';
    WebDBCheckBox4.ChildOrder := 5;
    WebDBCheckBox4.HeightPercent := 100.000000000000000000;
    WebDBCheckBox4.WidthPercent := 100.000000000000000000;
    WebDBCheckBox4.DataField := 'PRELISTING';
    WebDBCheckBox4.DataSource := dsAContracts;
    WebDBCheckBox4.ValueChecked := 'Y';
    WebDBCheckBox4.ValueUnChecked := 'N';
    WebDBCheckBox5.SetParentComponent(gbMiltiLoadInv);
    WebDBCheckBox5.Name := 'WebDBCheckBox5';
    WebDBCheckBox5.Left := 3;
    WebDBCheckBox5.Top := 52;
    WebDBCheckBox5.Width := 113;
    WebDBCheckBox5.Height := 22;
    WebDBCheckBox5.Caption := 'Post-Listed';
    WebDBCheckBox5.ChildOrder := 6;
    WebDBCheckBox5.HeightPercent := 100.000000000000000000;
    WebDBCheckBox5.WidthPercent := 100.000000000000000000;
    WebDBCheckBox5.DataField := 'POSTLISTING';
    WebDBCheckBox5.DataSource := dsAContracts;
    WebDBCheckBox5.ValueChecked := 'Y';
    WebDBCheckBox5.ValueUnChecked := 'N';
    WebPageControl1.SetParentComponent(WebPanel11);
    WebPageControl1.Name := 'WebPageControl1';
    WebPageControl1.Left := 469;
    WebPageControl1.Top := 16;
    WebPageControl1.Width := 291;
    WebPageControl1.Height := 109;
    WebPageControl1.ChildOrder := 5;
    WebPageControl1.TabIndex := 0;
    WebPageControl1.TabOrder := 4;
    wpcsSageLinkInformation1.SetParentComponent(WebPageControl1);
    wpcsSageLinkInformation1.Name := 'wpcsSageLinkInformation1';
    wpcsSageLinkInformation1.Left := 0;
    wpcsSageLinkInformation1.Top := 20;
    wpcsSageLinkInformation1.Width := 291;
    wpcsSageLinkInformation1.Height := 89;
    wpcsSageLinkInformation1.Caption := 'Sage Link Information ';
    WebPanel12.SetParentComponent(wpcsSageLinkInformation1);
    WebPanel12.Name := 'WebPanel12';
    WebPanel12.Left := 0;
    WebPanel12.Top := 0;
    WebPanel12.Width := 291;
    WebPanel12.Height := 89;
    WebPanel12.Align := alClient;
    WebPanel12.TabOrder := 0;
    WebLabel31.SetParentComponent(WebPanel12);
    WebLabel31.Name := 'WebLabel31';
    WebLabel31.Left := 7;
    WebLabel31.Top := 53;
    WebLabel31.Width := 108;
    WebLabel31.Height := 15;
    WebLabel31.Caption := 'GL Expence Account';
    WebLabel31.HeightPercent := 100.000000000000000000;
    WebLabel31.WidthPercent := 100.000000000000000000;
    WebDBCheckBox6.SetParentComponent(WebPanel12);
    WebDBCheckBox6.Name := 'WebDBCheckBox6';
    WebDBCheckBox6.Left := 7;
    WebDBCheckBox6.Top := 12;
    WebDBCheckBox6.Width := 131;
    WebDBCheckBox6.Height := 22;
    WebDBCheckBox6.Caption := 'GL Income Account';
    WebDBCheckBox6.HeightPercent := 100.000000000000000000;
    WebDBCheckBox6.WidthPercent := 100.000000000000000000;
    WebDBCheckBox6.DataField := 'SAGEINVENTORY';
    WebDBCheckBox6.DataSource := dsAContracts;
    WebDBCheckBox6.ValueChecked := 'Y';
    WebDBCheckBox6.ValueUnChecked := 'N';
    WebDBEdit39.SetParentComponent(WebPanel12);
    WebDBEdit39.Name := 'WebDBEdit39';
    WebDBEdit39.Left := 144;
    WebDBEdit39.Top := 12;
    WebDBEdit39.Width := 131;
    WebDBEdit39.Height := 22;
    WebDBEdit39.ChildOrder := 2;
    WebDBEdit39.HeightPercent := 100.000000000000000000;
    WebDBEdit39.Text := 'WebDBEdit39';
    WebDBEdit39.WidthPercent := 100.000000000000000000;
    WebDBEdit39.DataField := 'SAGECODE';
    WebDBEdit39.DataSource := dsAContracts;
    WebDBEdit40.SetParentComponent(WebPanel12);
    WebDBEdit40.Name := 'WebDBEdit40';
    WebDBEdit40.Left := 144;
    WebDBEdit40.Top := 51;
    WebDBEdit40.Width := 131;
    WebDBEdit40.Height := 22;
    WebDBEdit40.ChildOrder := 3;
    WebDBEdit40.HeightPercent := 100.000000000000000000;
    WebDBEdit40.Text := 'WebDBEdit40';
    WebDBEdit40.WidthPercent := 100.000000000000000000;
    WebDBEdit40.DataField := 'SAGEEXPCODE';
    WebDBEdit40.DataSource := dsAContracts;
    wpcsSageLinkInformation2.SetParentComponent(WebPageControl1);
    wpcsSageLinkInformation2.Name := 'wpcsSageLinkInformation2';
    wpcsSageLinkInformation2.Left := 0;
    wpcsSageLinkInformation2.Top := 20;
    wpcsSageLinkInformation2.Width := 291;
    wpcsSageLinkInformation2.Height := 89;
    wpcsSageLinkInformation2.Caption := 'Sage Link Information 2';
    wpcsSageLinkInformation2.ChildOrder := 1;
    WebPanel13.SetParentComponent(wpcsSageLinkInformation2);
    WebPanel13.Name := 'WebPanel13';
    WebPanel13.Left := 0;
    WebPanel13.Top := 0;
    WebPanel13.Width := 291;
    WebPanel13.Height := 89;
    WebPanel13.Align := alClient;
    WebPanel13.TabOrder := 0;
    WebLabel32.SetParentComponent(WebPanel13);
    WebLabel32.Name := 'WebLabel32';
    WebLabel32.Left := 7;
    WebLabel32.Top := 53;
    WebLabel32.Width := 108;
    WebLabel32.Height := 15;
    WebLabel32.Caption := 'GL Expence Account';
    WebLabel32.HeightPercent := 100.000000000000000000;
    WebLabel32.WidthPercent := 100.000000000000000000;
    WebDBCheckBox7.SetParentComponent(WebPanel13);
    WebDBCheckBox7.Name := 'WebDBCheckBox7';
    WebDBCheckBox7.Left := 7;
    WebDBCheckBox7.Top := 12;
    WebDBCheckBox7.Width := 135;
    WebDBCheckBox7.Height := 22;
    WebDBCheckBox7.Caption := 'GL Income Account';
    WebDBCheckBox7.HeightPercent := 100.000000000000000000;
    WebDBCheckBox7.WidthPercent := 100.000000000000000000;
    WebDBCheckBox7.DataField := 'SAGEINVENTORY2';
    WebDBCheckBox7.DataSource := dsAContracts;
    WebDBCheckBox7.ValueChecked := 'Y';
    WebDBCheckBox7.ValueUnChecked := 'N';
    WebDBEdit41.SetParentComponent(WebPanel13);
    WebDBEdit41.Name := 'WebDBEdit41';
    WebDBEdit41.Left := 144;
    WebDBEdit41.Top := 12;
    WebDBEdit41.Width := 131;
    WebDBEdit41.Height := 22;
    WebDBEdit41.ChildOrder := 2;
    WebDBEdit41.HeightPercent := 100.000000000000000000;
    WebDBEdit41.Text := 'WebDBEdit41';
    WebDBEdit41.WidthPercent := 100.000000000000000000;
    WebDBEdit41.DataField := 'SAGECODE2';
    WebDBEdit41.DataSource := dsAContracts;
    WebDBEdit42.SetParentComponent(WebPanel13);
    WebDBEdit42.Name := 'WebDBEdit42';
    WebDBEdit42.Left := 144;
    WebDBEdit42.Top := 51;
    WebDBEdit42.Width := 131;
    WebDBEdit42.Height := 22;
    WebDBEdit42.ChildOrder := 3;
    WebDBEdit42.HeightPercent := 100.000000000000000000;
    WebDBEdit42.Text := 'WebDBEdit42';
    WebDBEdit42.WidthPercent := 100.000000000000000000;
    WebDBEdit42.DataField := 'SAGEEXPCODE2';
    WebDBEdit42.DataSource := dsAContracts;
    WebDBEdit44.SetParentComponent(WebPanel11);
    WebDBEdit44.Name := 'WebDBEdit44';
    WebDBEdit44.Left := 136;
    WebDBEdit44.Top := 92;
    WebDBEdit44.Width := 121;
    WebDBEdit44.Height := 22;
    WebDBEdit44.ChildOrder := 8;
    WebDBEdit44.HeightPercent := 100.000000000000000000;
    WebDBEdit44.Text := 'WebDBEdit44';
    WebDBEdit44.WidthPercent := 100.000000000000000000;
    WebDBEdit44.DataField := 'CutOffPeriodDesc1';
    WebDBEdit44.DataSource := dsAContracts;
    WebButton18.SetParentComponent(WebPanel11);
    WebButton18.Name := 'WebButton18';
    WebButton18.Left := 263;
    WebButton18.Top := 91;
    WebButton18.Width := 25;
    WebButton18.Height := 25;
    WebButton18.Caption := '...';
    WebButton18.ChildOrder := 10;
    WebButton18.HeightPercent := 100.000000000000000000;
    WebButton18.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton18, Self, 'OnClick', 'WebButton18Click');
    WebDBEdit46.SetParentComponent(WebPanel11);
    WebDBEdit46.Name := 'WebDBEdit46';
    WebDBEdit46.Left := 136;
    WebDBEdit46.Top := 149;
    WebDBEdit46.Width := 121;
    WebDBEdit46.Height := 22;
    WebDBEdit46.ChildOrder := 13;
    WebDBEdit46.HeightPercent := 100.000000000000000000;
    WebDBEdit46.Text := 'WebDBEdit46';
    WebDBEdit46.WidthPercent := 100.000000000000000000;
    WebDBEdit46.DataField := 'CutOffPeriodDesc2';
    WebDBEdit46.DataSource := dsAContracts;
    WebButton20.SetParentComponent(WebPanel11);
    WebButton20.Name := 'WebButton20';
    WebButton20.Left := 263;
    WebButton20.Top := 148;
    WebButton20.Width := 25;
    WebButton20.Height := 25;
    WebButton20.Caption := '...';
    WebButton20.ChildOrder := 15;
    WebButton20.HeightPercent := 100.000000000000000000;
    WebButton20.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton20, Self, 'OnClick', 'WebButton20Click');
    WebDBRadioGroup2.SetParentComponent(WebPanel11);
    WebDBRadioGroup2.Name := 'WebDBRadioGroup2';
    WebDBRadioGroup2.Left := 32;
    WebDBRadioGroup2.Top := 188;
    WebDBRadioGroup2.Width := 256;
    WebDBRadioGroup2.Height := 91;
    WebDBRadioGroup2.Caption := 'Variance Tolerance';
    WebDBRadioGroup2.ChildOrder := 16;
    WebDBRadioGroup2.Columns := 1;
    WebDBRadioGroup2.ItemIndex := 0;
    WebDBRadioGroup2.Items.BeginUpdate;
    try
      WebDBRadioGroup2.Items.Clear;
      WebDBRadioGroup2.Items.Add('None');
      WebDBRadioGroup2.Items.Add('Percentage');
      WebDBRadioGroup2.Items.Add('Value');
    finally
      WebDBRadioGroup2.Items.EndUpdate;
    end;
    WebDBRadioGroup2.Role := '';
    WebDBRadioGroup2.TabOrder := 9;
    WebDBRadioGroup2.DataField := 'VARIANCETYPE';
    WebDBRadioGroup2.DataSource := dsAContracts;
    WebDBEdit47.SetParentComponent(WebPanel11);
    WebDBEdit47.Name := 'WebDBEdit47';
    WebDBEdit47.Left := 122;
    WebDBEdit47.Top := 229;
    WebDBEdit47.Width := 151;
    WebDBEdit47.Height := 22;
    WebDBEdit47.ChildOrder := 17;
    WebDBEdit47.HeightPercent := 100.000000000000000000;
    WebDBEdit47.Text := 'WebDBEdit47';
    WebDBEdit47.WidthPercent := 100.000000000000000000;
    WebDBEdit47.DataField := 'VARIANCEVALUE';
    WebDBEdit47.DataSource := dsAContracts;
    WebGroupBox6.SetParentComponent(WebPanel11);
    WebGroupBox6.Name := 'WebGroupBox6';
    WebGroupBox6.Left := 331;
    WebGroupBox6.Top := 196;
    WebGroupBox6.Width := 192;
    WebGroupBox6.Height := 164;
    WebGroupBox6.BorderColor := clSilver;
    WebGroupBox6.Caption := 'Sort Order';
    WebGroupBox6.ChildOrder := 18;
    WebDBCheckBox8.SetParentComponent(WebGroupBox6);
    WebDBCheckBox8.Name := 'WebDBCheckBox8';
    WebDBCheckBox8.Left := 16;
    WebDBCheckBox8.Top := 24;
    WebDBCheckBox8.Width := 113;
    WebDBCheckBox8.Height := 22;
    WebDBCheckBox8.Caption := 'Loading Date';
    WebDBCheckBox8.HeightPercent := 100.000000000000000000;
    WebDBCheckBox8.WidthPercent := 100.000000000000000000;
    WebDBCheckBox8.DataField := 'SORTLOADDATE';
    WebDBCheckBox8.DataSource := dsAContracts;
    WebDBCheckBox8.ValueChecked := 'Y';
    WebDBCheckBox8.ValueUnChecked := 'N';
    WebDBCheckBox9.SetParentComponent(WebGroupBox6);
    WebDBCheckBox9.Name := 'WebDBCheckBox9';
    WebDBCheckBox9.Left := 16;
    WebDBCheckBox9.Top := 52;
    WebDBCheckBox9.Width := 113;
    WebDBCheckBox9.Height := 22;
    WebDBCheckBox9.Caption := 'Off-Loaading Date';
    WebDBCheckBox9.ChildOrder := 1;
    WebDBCheckBox9.HeightPercent := 100.000000000000000000;
    WebDBCheckBox9.WidthPercent := 100.000000000000000000;
    WebDBCheckBox9.DataField := 'SORTOFFDATE';
    WebDBCheckBox9.DataSource := dsAContracts;
    WebDBCheckBox9.ValueChecked := 'Y';
    WebDBCheckBox9.ValueUnChecked := 'N';
    WebDBCheckBox10.SetParentComponent(WebGroupBox6);
    WebDBCheckBox10.Name := 'WebDBCheckBox10';
    WebDBCheckBox10.Left := 16;
    WebDBCheckBox10.Top := 80;
    WebDBCheckBox10.Width := 113;
    WebDBCheckBox10.Height := 22;
    WebDBCheckBox10.Caption := 'Loading Waybill';
    WebDBCheckBox10.ChildOrder := 2;
    WebDBCheckBox10.HeightPercent := 100.000000000000000000;
    WebDBCheckBox10.WidthPercent := 100.000000000000000000;
    WebDBCheckBox10.DataField := 'SORTLOADDATE';
    WebDBCheckBox10.DataSource := dsAContracts;
    WebDBCheckBox10.ValueChecked := 'Y';
    WebDBCheckBox10.ValueUnChecked := 'N';
    WebDBCheckBox11.SetParentComponent(WebGroupBox6);
    WebDBCheckBox11.Name := 'WebDBCheckBox11';
    WebDBCheckBox11.Left := 16;
    WebDBCheckBox11.Top := 108;
    WebDBCheckBox11.Width := 113;
    WebDBCheckBox11.Height := 22;
    WebDBCheckBox11.Caption := 'Off-Loading Waybill';
    WebDBCheckBox11.ChildOrder := 3;
    WebDBCheckBox11.HeightPercent := 100.000000000000000000;
    WebDBCheckBox11.WidthPercent := 100.000000000000000000;
    WebDBCheckBox11.DataField := 'SORTOFFWAY';
    WebDBCheckBox11.DataSource := dsAContracts;
    WebDBCheckBox11.ValueChecked := 'Y';
    WebDBCheckBox11.ValueUnChecked := 'N';
    WebDBCheckBox12.SetParentComponent(WebGroupBox6);
    WebDBCheckBox12.Name := 'WebDBCheckBox12';
    WebDBCheckBox12.Left := 16;
    WebDBCheckBox12.Top := 136;
    WebDBCheckBox12.Width := 113;
    WebDBCheckBox12.Height := 22;
    WebDBCheckBox12.Caption := 'Docket No';
    WebDBCheckBox12.ChildOrder := 4;
    WebDBCheckBox12.HeightPercent := 100.000000000000000000;
    WebDBCheckBox12.WidthPercent := 100.000000000000000000;
    WebDBCheckBox12.DataField := 'SORTDOCKET';
    WebDBCheckBox12.DataSource := dsAContracts;
    WebDBCheckBox12.ValueChecked := 'Y';
    WebDBCheckBox12.ValueUnChecked := 'N';
    edtInvoiceSelection.SetParentComponent(WebPanel11);
    edtInvoiceSelection.Name := 'edtInvoiceSelection';
    edtInvoiceSelection.Left := 552;
    edtInvoiceSelection.Top := 210;
    edtInvoiceSelection.Width := 199;
    edtInvoiceSelection.Height := 22;
    edtInvoiceSelection.ChildOrder := 22;
    edtInvoiceSelection.HeightPercent := 100.000000000000000000;
    edtInvoiceSelection.Text := 'edtInvoiceSelection';
    edtInvoiceSelection.WidthPercent := 100.000000000000000000;
    edtInvoiceSelection.DataField := 'INVOICETYPE';
    edtInvoiceSelection.DataSource := dsAContracts;
    WebDBEdit49.SetParentComponent(WebPanel11);
    WebDBEdit49.Name := 'WebDBEdit49';
    WebDBEdit49.Left := 552;
    WebDBEdit49.Top := 264;
    WebDBEdit49.Width := 199;
    WebDBEdit49.Height := 22;
    WebDBEdit49.ChildOrder := 23;
    WebDBEdit49.HeightPercent := 100.000000000000000000;
    WebDBEdit49.Text := 'WebDBEdit49';
    WebDBEdit49.WidthPercent := 100.000000000000000000;
    WebDBEdit49.DataField := 'DNTYPE';
    WebDBEdit49.DataSource := dsAContracts;
    WebDBEdit50.SetParentComponent(WebPanel11);
    WebDBEdit50.Name := 'WebDBEdit50';
    WebDBEdit50.Left := 552;
    WebDBEdit50.Top := 321;
    WebDBEdit50.Width := 199;
    WebDBEdit50.Height := 22;
    WebDBEdit50.ChildOrder := 24;
    WebDBEdit50.HeightPercent := 100.000000000000000000;
    WebDBEdit50.Text := 'WebDBEdit50';
    WebDBEdit50.WidthPercent := 100.000000000000000000;
    WebDBEdit50.DataField := 'TSTYPE';
    WebDBEdit50.DataSource := dsAContracts;
    WebButton21.SetParentComponent(WebPanel11);
    WebButton21.Name := 'WebButton21';
    WebButton21.Left := 757;
    WebButton21.Top := 208;
    WebButton21.Width := 25;
    WebButton21.Height := 25;
    WebButton21.Caption := '...';
    WebButton21.ChildOrder := 25;
    WebButton21.HeightPercent := 100.000000000000000000;
    WebButton21.WidthPercent := 100.000000000000000000;
    WebButton22.SetParentComponent(WebPanel11);
    WebButton22.Name := 'WebButton22';
    WebButton22.Left := 757;
    WebButton22.Top := 263;
    WebButton22.Width := 25;
    WebButton22.Height := 25;
    WebButton22.Caption := '...';
    WebButton22.ChildOrder := 26;
    WebButton22.HeightPercent := 100.000000000000000000;
    WebButton22.WidthPercent := 100.000000000000000000;
    WebButton23.SetParentComponent(WebPanel11);
    WebButton23.Name := 'WebButton23';
    WebButton23.Left := 757;
    WebButton23.Top := 320;
    WebButton23.Width := 25;
    WebButton23.Height := 25;
    WebButton23.Caption := '...';
    WebButton23.ChildOrder := 27;
    WebButton23.HeightPercent := 100.000000000000000000;
    WebButton23.WidthPercent := 100.000000000000000000;
    WebGroupBox7.SetParentComponent(WebPanel11);
    WebGroupBox7.Name := 'WebGroupBox7';
    WebGroupBox7.Left := 32;
    WebGroupBox7.Top := 285;
    WebGroupBox7.Width := 270;
    WebGroupBox7.Height := 112;
    WebGroupBox7.BorderColor := clSilver;
    WebGroupBox7.Caption := 'Sage Online Analysis Category';
    WebGroupBox7.ChildOrder := 28;
    WebLabel38.SetParentComponent(WebGroupBox7);
    WebLabel38.Name := 'WebLabel38';
    WebLabel38.Left := 16;
    WebLabel38.Top := 24;
    WebLabel38.Width := 12;
    WebLabel38.Height := 15;
    WebLabel38.Caption := '1 :';
    WebLabel38.HeightPercent := 100.000000000000000000;
    WebLabel38.WidthPercent := 100.000000000000000000;
    WebLabel39.SetParentComponent(WebGroupBox7);
    WebLabel39.Name := 'WebLabel39';
    WebLabel39.Left := 16;
    WebLabel39.Top := 52;
    WebLabel39.Width := 12;
    WebLabel39.Height := 15;
    WebLabel39.Caption := '2 :';
    WebLabel39.HeightPercent := 100.000000000000000000;
    WebLabel39.WidthPercent := 100.000000000000000000;
    WebLabel40.SetParentComponent(WebGroupBox7);
    WebLabel40.Name := 'WebLabel40';
    WebLabel40.Left := 16;
    WebLabel40.Top := 80;
    WebLabel40.Width := 12;
    WebLabel40.Height := 15;
    WebLabel40.Caption := '3 :';
    WebLabel40.HeightPercent := 100.000000000000000000;
    WebLabel40.WidthPercent := 100.000000000000000000;
    WebDBEdit51.SetParentComponent(WebGroupBox7);
    WebDBEdit51.Name := 'WebDBEdit51';
    WebDBEdit51.Left := 34;
    WebDBEdit51.Top := 22;
    WebDBEdit51.Width := 169;
    WebDBEdit51.Height := 22;
    WebDBEdit51.ChildOrder := 3;
    WebDBEdit51.HeightPercent := 100.000000000000000000;
    WebDBEdit51.Text := 'WebDBEdit51';
    WebDBEdit51.WidthPercent := 100.000000000000000000;
    WebDBEdit51.DataField := 'soanalysiscat1';
    WebDBEdit51.DataSource := dsAContracts;
    WebDBEdit52.SetParentComponent(WebGroupBox7);
    WebDBEdit52.Name := 'WebDBEdit52';
    WebDBEdit52.Left := 34;
    WebDBEdit52.Top := 50;
    WebDBEdit52.Width := 169;
    WebDBEdit52.Height := 22;
    WebDBEdit52.ChildOrder := 4;
    WebDBEdit52.HeightPercent := 100.000000000000000000;
    WebDBEdit52.Text := 'WebDBEdit52';
    WebDBEdit52.WidthPercent := 100.000000000000000000;
    WebDBEdit52.DataField := 'soanalysiscat2';
    WebDBEdit52.DataSource := dsAContracts;
    WebDBEdit53.SetParentComponent(WebGroupBox7);
    WebDBEdit53.Name := 'WebDBEdit53';
    WebDBEdit53.Left := 34;
    WebDBEdit53.Top := 78;
    WebDBEdit53.Width := 169;
    WebDBEdit53.Height := 22;
    WebDBEdit53.ChildOrder := 5;
    WebDBEdit53.HeightPercent := 100.000000000000000000;
    WebDBEdit53.Text := 'WebDBEdit53';
    WebDBEdit53.WidthPercent := 100.000000000000000000;
    WebDBEdit53.DataField := 'soanalysiscat3';
    WebDBEdit53.DataSource := dsAContracts;
    WebButton24.SetParentComponent(WebGroupBox7);
    WebButton24.Name := 'WebButton24';
    WebButton24.Left := 216;
    WebButton24.Top := 20;
    WebButton24.Width := 25;
    WebButton24.Height := 25;
    WebButton24.Caption := '...';
    WebButton24.ChildOrder := 6;
    WebButton24.HeightPercent := 100.000000000000000000;
    WebButton24.WidthPercent := 100.000000000000000000;
    WebButton25.SetParentComponent(WebGroupBox7);
    WebButton25.Name := 'WebButton25';
    WebButton25.Left := 216;
    WebButton25.Top := 49;
    WebButton25.Width := 25;
    WebButton25.Height := 25;
    WebButton25.Caption := '...';
    WebButton25.ChildOrder := 7;
    WebButton25.HeightPercent := 100.000000000000000000;
    WebButton25.WidthPercent := 100.000000000000000000;
    WebButton26.SetParentComponent(WebGroupBox7);
    WebButton26.Name := 'WebButton26';
    WebButton26.Left := 216;
    WebButton26.Top := 77;
    WebButton26.Width := 25;
    WebButton26.Height := 25;
    WebButton26.Caption := '...';
    WebButton26.ChildOrder := 8;
    WebButton26.HeightPercent := 100.000000000000000000;
    WebButton26.WidthPercent := 100.000000000000000000;
    WebPanel10.SetParentComponent(WebPanel11);
    WebPanel10.Name := 'WebPanel10';
    WebPanel10.Left := 0;
    WebPanel10.Top := 417;
    WebPanel10.Width := 1137;
    WebPanel10.Height := 60;
    WebPanel10.Align := alBottom;
    WebPanel10.ChildOrder := 1;
    WebPanel10.Color := clSilver;
    WebPanel10.TabOrder := 19;
    WebButton54.SetParentComponent(WebPanel10);
    WebButton54.Name := 'WebButton54';
    WebButton54.Left := 20;
    WebButton54.Top := 16;
    WebButton54.Width := 96;
    WebButton54.Height := 25;
    WebButton54.Caption := 'Price List';
    WebButton54.Color := clSkyBlue;
    WebButton54.HeightPercent := 100.000000000000000000;
    WebButton54.WidthPercent := 100.000000000000000000;
    btnSaveContract3.SetParentComponent(WebPanel10);
    btnSaveContract3.Name := 'btnSaveContract3';
    btnSaveContract3.Left := 142;
    btnSaveContract3.Top := 16;
    btnSaveContract3.Width := 96;
    btnSaveContract3.Height := 25;
    btnSaveContract3.Caption := 'Save';
    btnSaveContract3.Color := clGreenyellow;
    btnSaveContract3.ChildOrder := 1;
    btnSaveContract3.HeightPercent := 100.000000000000000000;
    btnSaveContract3.WidthPercent := 100.000000000000000000;
    SetEvent(btnSaveContract3, Self, 'OnClick', 'btnSaveContract3Click');
    WebButton56.SetParentComponent(WebPanel10);
    WebButton56.Name := 'WebButton56';
    WebButton56.Left := 259;
    WebButton56.Top := 16;
    WebButton56.Width := 96;
    WebButton56.Height := 25;
    WebButton56.Caption := 'Cancel';
    WebButton56.Color := clRed;
    WebButton56.ChildOrder := 2;
    WebButton56.HeightPercent := 100.000000000000000000;
    WebButton56.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton56, Self, 'OnClick', 'WebButton56Click');
    WebDBComboBox1.SetParentComponent(WebPanel11);
    WebDBComboBox1.Name := 'WebDBComboBox1';
    WebDBComboBox1.Left := 32;
    WebDBComboBox1.Top := 92;
    WebDBComboBox1.Width := 98;
    WebDBComboBox1.Height := 23;
    WebDBComboBox1.HeightPercent := 100.000000000000000000;
    WebDBComboBox1.Text := 'WebDBComboBox1';
    WebDBComboBox1.WidthPercent := 100.000000000000000000;
    WebDBComboBox1.ItemIndex := -1;
    WebDBComboBox1.Items.BeginUpdate;
    try
      WebDBComboBox1.Items.Clear;
      WebDBComboBox1.Items.Add('1');
      WebDBComboBox1.Items.Add('2');
      WebDBComboBox1.Items.Add('3');
      WebDBComboBox1.Items.Add('4');
      WebDBComboBox1.Items.Add('5');
      WebDBComboBox1.Items.Add('6');
      WebDBComboBox1.Items.Add('7');
      WebDBComboBox1.Items.Add('8');
      WebDBComboBox1.Items.Add('9');
      WebDBComboBox1.Items.Add('10');
      WebDBComboBox1.Items.Add('11');
      WebDBComboBox1.Items.Add('12');
      WebDBComboBox1.Items.Add('13');
      WebDBComboBox1.Items.Add('14');
      WebDBComboBox1.Items.Add('15');
      WebDBComboBox1.Items.Add('16');
      WebDBComboBox1.Items.Add('17');
      WebDBComboBox1.Items.Add('18');
      WebDBComboBox1.Items.Add('19');
      WebDBComboBox1.Items.Add('20');
      WebDBComboBox1.Items.Add('21');
      WebDBComboBox1.Items.Add('22');
      WebDBComboBox1.Items.Add('23');
      WebDBComboBox1.Items.Add('24');
      WebDBComboBox1.Items.Add('25');
      WebDBComboBox1.Items.Add('26');
      WebDBComboBox1.Items.Add('27');
      WebDBComboBox1.Items.Add('28');
      WebDBComboBox1.Items.Add('29');
      WebDBComboBox1.Items.Add('30');
      WebDBComboBox1.Items.Add('31');
    finally
      WebDBComboBox1.Items.EndUpdate;
    end;
    WebDBComboBox1.DataField := 'CUTOFF1';
    WebDBComboBox1.DataSource := dsAContracts;
    WebDBComboBox2.SetParentComponent(WebPanel11);
    WebDBComboBox2.Name := 'WebDBComboBox2';
    WebDBComboBox2.Left := 33;
    WebDBComboBox2.Top := 149;
    WebDBComboBox2.Width := 97;
    WebDBComboBox2.Height := 23;
    WebDBComboBox2.HeightPercent := 100.000000000000000000;
    WebDBComboBox2.Text := 'WebDBComboBox2';
    WebDBComboBox2.WidthPercent := 100.000000000000000000;
    WebDBComboBox2.ItemIndex := -1;
    WebDBComboBox2.Items.BeginUpdate;
    try
      WebDBComboBox2.Items.Clear;
      WebDBComboBox2.Items.Add('1');
      WebDBComboBox2.Items.Add('2');
      WebDBComboBox2.Items.Add('3');
      WebDBComboBox2.Items.Add('4');
      WebDBComboBox2.Items.Add('5');
      WebDBComboBox2.Items.Add('6');
      WebDBComboBox2.Items.Add('7');
      WebDBComboBox2.Items.Add('8');
      WebDBComboBox2.Items.Add('9');
      WebDBComboBox2.Items.Add('10');
      WebDBComboBox2.Items.Add('11');
      WebDBComboBox2.Items.Add('12');
      WebDBComboBox2.Items.Add('13');
      WebDBComboBox2.Items.Add('14');
      WebDBComboBox2.Items.Add('15');
      WebDBComboBox2.Items.Add('16');
      WebDBComboBox2.Items.Add('17');
      WebDBComboBox2.Items.Add('18');
      WebDBComboBox2.Items.Add('19');
      WebDBComboBox2.Items.Add('20');
      WebDBComboBox2.Items.Add('21');
      WebDBComboBox2.Items.Add('22');
      WebDBComboBox2.Items.Add('23');
      WebDBComboBox2.Items.Add('24');
      WebDBComboBox2.Items.Add('25');
      WebDBComboBox2.Items.Add('26');
      WebDBComboBox2.Items.Add('27');
      WebDBComboBox2.Items.Add('28');
      WebDBComboBox2.Items.Add('29');
      WebDBComboBox2.Items.Add('30');
      WebDBComboBox2.Items.Add('31');
    finally
      WebDBComboBox2.Items.EndUpdate;
    end;
    WebDBComboBox2.DataField := 'CUTOFF2';
    WebDBComboBox2.DataSource := dsAContracts;
    cbbInvoiceSelection.SetParentComponent(WebPanel11);
    cbbInvoiceSelection.Name := 'cbbInvoiceSelection';
    cbbInvoiceSelection.Left := 544;
    cbbInvoiceSelection.Top := 152;
    cbbInvoiceSelection.Width := 145;
    cbbInvoiceSelection.Height := 23;
    cbbInvoiceSelection.HeightPercent := 100.000000000000000000;
    cbbInvoiceSelection.Text := 'cbbInvoiceSelection';
    cbbInvoiceSelection.WidthPercent := 100.000000000000000000;
    cbbInvoiceSelection.ItemIndex := -1;
    wpcsContractPricing.SetParentComponent(wpcActiveContracts);
    wpcsContractPricing.Name := 'wpcsContractPricing';
    wpcsContractPricing.Left := 0;
    wpcsContractPricing.Top := 20;
    wpcsContractPricing.Width := 1137;
    wpcsContractPricing.Height := 477;
    wpcsContractPricing.Caption := 'Contract Pricing';
    wpcsContractPricing.ChildOrder := 3;
    WebPanel14.SetParentComponent(wpcsContractPricing);
    WebPanel14.Name := 'WebPanel14';
    WebPanel14.Left := 0;
    WebPanel14.Top := 0;
    WebPanel14.Width := 1137;
    WebPanel14.Height := 477;
    WebPanel14.Align := alClient;
    WebPanel14.TabOrder := 0;
    WebPanel15.SetParentComponent(WebPanel14);
    WebPanel15.Name := 'WebPanel15';
    WebPanel15.Left := 0;
    WebPanel15.Top := 0;
    WebPanel15.Width := 1137;
    WebPanel15.Height := 60;
    WebPanel15.Align := alTop;
    WebPanel15.ChildOrder := 6;
    WebPanel15.TabOrder := 0;
    WebButton27.SetParentComponent(WebPanel15);
    WebButton27.Name := 'WebButton27';
    WebButton27.Left := 20;
    WebButton27.Top := 15;
    WebButton27.Width := 96;
    WebButton27.Height := 25;
    WebButton27.Caption := 'New Price';
    WebButton27.Color := clSkyBlue;
    WebButton27.HeightPercent := 100.000000000000000000;
    WebButton27.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton27, Self, 'OnClick', 'WebButton27Click');
    WebButton29.SetParentComponent(WebPanel15);
    WebButton29.Name := 'WebButton29';
    WebButton29.Left := 135;
    WebButton29.Top := 15;
    WebButton29.Width := 96;
    WebButton29.Height := 25;
    WebButton29.Caption := 'Confirm Price';
    WebButton29.Color := clSkyBlue;
    WebButton29.ChildOrder := 2;
    WebButton29.HeightPercent := 100.000000000000000000;
    WebButton29.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton29, Self, 'OnClick', 'WebButton29Click');
    WebButton31.SetParentComponent(WebPanel15);
    WebButton31.Name := 'WebButton31';
    WebButton31.Left := 248;
    WebButton31.Top := 15;
    WebButton31.Width := 96;
    WebButton31.Height := 25;
    WebButton31.Caption := 'Open Price';
    WebButton31.Color := clSkyBlue;
    WebButton31.ChildOrder := 4;
    WebButton31.HeightPercent := 100.000000000000000000;
    WebButton31.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton31, Self, 'OnClick', 'WebButton31Click');
    WebButton32.SetParentComponent(WebPanel15);
    WebButton32.Name := 'WebButton32';
    WebButton32.Left := 350;
    WebButton32.Top := 15;
    WebButton32.Width := 25;
    WebButton32.Height := 25;
    WebButton32.Caption := '...';
    WebButton32.Color := clSkyBlue;
    WebButton32.ChildOrder := 5;
    WebButton32.HeightPercent := 100.000000000000000000;
    WebButton32.WidthPercent := 100.000000000000000000;
    dgContractPrices.SetParentComponent(WebPanel14);
    dgContractPrices.Name := 'dgContractPrices';
    dgContractPrices.Left := 0;
    dgContractPrices.Top := 60;
    dgContractPrices.Width := 1137;
    dgContractPrices.Height := 357;
    dgContractPrices.Align := alClient;
    dgContractPrices.ParentDoubleBuffered := False;
    dgContractPrices.DoubleBuffered := True;
    dgContractPrices.TabOrder := 1;
    dgContractPrices.ShowAcceleratorChar := False;
    dgContractPrices.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgContractPrices.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgContractPrices.Header.VisualGrouping.Layout.Font.Height := -12;
    dgContractPrices.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgContractPrices.Header.VisualGrouping.Layout.Font.Style := [];
    dgContractPrices.Adapter := dgdbaContractPrices;
    dgContractPrices.BitmapContainer := BitMapContainer1;
    dgContractPrices.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractPrices.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgContractPrices.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgContractPrices.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgContractPrices.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgContractPrices.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractPrices.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgContractPrices.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgContractPrices.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgContractPrices.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgContractPrices.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractPrices.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgContractPrices.CellAppearance.BandLayout.Font.Height := -12;
    dgContractPrices.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgContractPrices.CellAppearance.BandLayout.Font.Style := [];
    dgContractPrices.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractPrices.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgContractPrices.CellAppearance.FixedLayout.Font.Height := -12;
    dgContractPrices.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgContractPrices.CellAppearance.FixedLayout.Font.Style := [];
    dgContractPrices.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractPrices.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgContractPrices.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgContractPrices.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgContractPrices.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgContractPrices.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractPrices.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgContractPrices.CellAppearance.FocusedLayout.Font.Height := -12;
    dgContractPrices.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgContractPrices.CellAppearance.FocusedLayout.Font.Style := [];
    dgContractPrices.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractPrices.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgContractPrices.CellAppearance.GroupLayout.Font.Height := -12;
    dgContractPrices.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgContractPrices.CellAppearance.GroupLayout.Font.Style := [];
    dgContractPrices.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractPrices.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgContractPrices.CellAppearance.NormalLayout.Font.Height := -12;
    dgContractPrices.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgContractPrices.CellAppearance.NormalLayout.Font.Style := [];
    dgContractPrices.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractPrices.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgContractPrices.CellAppearance.SelectedLayout.Font.Height := -12;
    dgContractPrices.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgContractPrices.CellAppearance.SelectedLayout.Font.Style := [];
    dgContractPrices.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractPrices.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgContractPrices.CellAppearance.SummaryLayout.Font.Height := -12;
    dgContractPrices.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgContractPrices.CellAppearance.SummaryLayout.Font.Style := [];
    dgContractPrices.ColumnCount := 18;
    dgContractPrices.Columns.Clear;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := '.';
      Settings := [gcsEditorItems];
      Width := 25.000000000000000000;
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'AUTONO';
      Settings := [gcsEditorItems];
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CONTRACTNO';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'STARTDATE';
      Settings := [gcsEditorItems];
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ENDDATE';
      Settings := [gcsEditorItems];
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'COSTPRICE';
      Settings := [gcsEditorItems];
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SUBPRICE';
      Settings := [gcsEditorItems];
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'DEDPRICE';
      Settings := [gcsEditorItems];
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SPEPRICE';
      Settings := [gcsEditorItems];
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CONFIREMED';
      Settings := [gcsEditorItems];
      Width := 25.000000000000000000;
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'PRICELOADDATE';
      Settings := [gcsEditorItems];
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'PRICELOADBY';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'PRICECONFIRMDATE';
      Settings := [gcsEditorItems];
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'PRICECONFIRMBY';
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'kmsprice';
      Settings := [gcsEditorItems];
    end;
    with dgContractPrices.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'tollprice';
      Settings := [gcsEditorItems];
    end;
    with dgContractPrices.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Settings := [gcsType,gcsEditorItems];
    end;
    with dgContractPrices.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Delete';
      Settings := [gcsType,gcsEditorItems];
    end;
    dgContractPrices.Designer := False;
    dgContractPrices.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgContractPrices.FilterAppearance.Font.Color := clWindowText;
    dgContractPrices.FilterAppearance.Font.Height := -12;
    dgContractPrices.FilterAppearance.Font.Name := 'Segoe UI';
    dgContractPrices.FilterAppearance.Font.Style := [];
    dgContractPrices.Icons.ExpandIcon.LoadFromFile('Contracts.WebPanel14.dgContractPrices.Icons.ExpandIcon.svg');
    dgContractPrices.Icons.CollapseIcon.LoadFromFile('Contracts.WebPanel14.dgContractPrices.Icons.CollapseIcon.svg');
    dgContractPrices.Icons.FilterIcon.LoadFromFile('Contracts.WebPanel14.dgContractPrices.Icons.FilterIcon.svg');
    dgContractPrices.Icons.FilterActiveIcon.LoadFromFile('Contracts.WebPanel14.dgContractPrices.Icons.FilterActiveIcon.svg');
    dgContractPrices.Icons.FilterClearIcon.LoadFromFile('Contracts.WebPanel14.dgContractPrices.Icons.FilterClearIcon.svg');
    dgContractPrices.Icons.FilterTypeIcon.LoadFromFile('Contracts.WebPanel14.dgContractPrices.Icons.FilterTypeIcon.svg');
    dgContractPrices.Icons.SortAscendingIcon.LoadFromFile('Contracts.WebPanel14.dgContractPrices.Icons.SortAscendingIcon.svg');
    dgContractPrices.Icons.SortDescendingIcon.LoadFromFile('Contracts.WebPanel14.dgContractPrices.Icons.SortDescendingIcon.svg');
    dgContractPrices.Icons.CloseIcon.LoadFromFile('Contracts.WebPanel14.dgContractPrices.Icons.CloseIcon.svg');
    SetEvent(dgContractPrices, Self, 'OnCellClick', 'dgContractPricesCellClick');
    SetEvent(dgContractPrices, Self, 'OnGetCellLayout', 'dgContractPricesGetCellLayout');
    SetEvent(dgContractPrices, Self, 'OnGetCellProperties', 'dgContractPricesGetCellProperties');
    SetEvent(dgContractPrices, Self, 'OnSelectCell', 'dgContractPricesSelectCell');
    dgContractPrices.RowCount := 1;
    dgdbaContractPrices.SetParentComponent(dgContractPrices);
    dgdbaContractPrices.Name := 'dgdbaContractPrices';
    dgdbaContractPrices.Left := 1021;
    dgdbaContractPrices.Top := 33;
    dgdbaContractPrices.Width := 26;
    dgdbaContractPrices.Height := 26;
    dgdbaContractPrices.Visible := True;
    dgdbaContractPrices.AutoCreateColumns := False;
    dgdbaContractPrices.AutoRemoveColumns := False;
    dgdbaContractPrices.Columns.Clear;
    with dgdbaContractPrices.Columns.Add do
    begin
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'AUTONO';
      Header := 'AUTONO';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'CONTRACTNO';
      Header := 'CONTRACTNO';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'STARTDATE';
      Header := 'STARTDATE';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'ENDDATE';
      Header := 'ENDDATE';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'COSTPRICE';
      Header := 'COSTPRICE';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'SUBPRICE';
      Header := 'SUBPRICE';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'DEDPRICE';
      Header := 'DEDPRICE';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'SPEPRICE';
      Header := 'SPEPRICE';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'CONFIREMED';
      Header := 'CONFIREMED';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'PRICELOADDATE';
      Header := 'PRICELOADDATE';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'PRICELOADBY';
      Header := 'PRICELOADBY';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'PRICECONFIRMDATE';
      Header := 'PRICECONFIRMDATE';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'PRICECONFIRMBY';
      Header := 'PRICECONFIRMBY';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'kmsprice';
      Header := 'kmsprice';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      FieldName := 'tollprice';
      Header := 'tollprice';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    with dgdbaContractPrices.Columns.Add do
    begin
      Header := 'Delete';
      AutoCreated := False;
    end;
    dgdbaContractPrices.DataSource := dsContractPrices;
    msgdlgContractPriceList.SetParentComponent(dgContractPrices);
    msgdlgContractPriceList.Name := 'msgdlgContractPriceList';
    msgdlgContractPriceList.Left := 1008;
    msgdlgContractPriceList.Top := 288;
    msgdlgContractPriceList.Width := 24;
    msgdlgContractPriceList.Height := 24;
    msgdlgContractPriceList.Buttons := [];
    msgdlgContractPriceList.Opacity := 0.200000000000000000;
    WebPanel27.SetParentComponent(WebPanel14);
    WebPanel27.Name := 'WebPanel27';
    WebPanel27.Left := 0;
    WebPanel27.Top := 417;
    WebPanel27.Width := 1137;
    WebPanel27.Height := 60;
    WebPanel27.Align := alBottom;
    WebPanel27.ChildOrder := 1;
    WebPanel27.Color := clSilver;
    WebPanel27.TabOrder := 2;
    WebButton51.SetParentComponent(WebPanel27);
    WebButton51.Name := 'WebButton51';
    WebButton51.Left := 20;
    WebButton51.Top := 16;
    WebButton51.Width := 96;
    WebButton51.Height := 25;
    WebButton51.Caption := 'Price List';
    WebButton51.Color := clSkyBlue;
    WebButton51.HeightPercent := 100.000000000000000000;
    WebButton51.WidthPercent := 100.000000000000000000;
    btnSaveContract4.SetParentComponent(WebPanel27);
    btnSaveContract4.Name := 'btnSaveContract4';
    btnSaveContract4.Left := 142;
    btnSaveContract4.Top := 16;
    btnSaveContract4.Width := 96;
    btnSaveContract4.Height := 25;
    btnSaveContract4.Caption := 'Save';
    btnSaveContract4.Color := clGreenyellow;
    btnSaveContract4.ChildOrder := 1;
    btnSaveContract4.HeightPercent := 100.000000000000000000;
    btnSaveContract4.WidthPercent := 100.000000000000000000;
    SetEvent(btnSaveContract4, Self, 'OnClick', 'btnSaveContract4Click');
    WebButton53.SetParentComponent(WebPanel27);
    WebButton53.Name := 'WebButton53';
    WebButton53.Left := 259;
    WebButton53.Top := 16;
    WebButton53.Width := 96;
    WebButton53.Height := 25;
    WebButton53.Caption := 'Cancel';
    WebButton53.Color := clRed;
    WebButton53.ChildOrder := 2;
    WebButton53.HeightPercent := 100.000000000000000000;
    WebButton53.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton53, Self, 'OnClick', 'WebButton53Click');
    WebSpeedButton5.SetParentComponent(WebPanel27);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 424;
    WebSpeedButton5.Top := 16;
    WebSpeedButton5.Width := 24;
    WebSpeedButton5.Height := 24;
    WebSpeedButton5.Caption := '<<';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 3;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebSpeedButton6.SetParentComponent(WebPanel27);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 446;
    WebSpeedButton6.Top := 16;
    WebSpeedButton6.Width := 24;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Caption := '<';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.TabOrder := 4;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton7.SetParentComponent(WebPanel27);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 528;
    WebSpeedButton7.Top := 16;
    WebSpeedButton7.Width := 24;
    WebSpeedButton7.Height := 24;
    WebSpeedButton7.Caption := '>';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.TabOrder := 5;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    WebSpeedButton8.SetParentComponent(WebPanel27);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 551;
    WebSpeedButton8.Top := 16;
    WebSpeedButton8.Width := 24;
    WebSpeedButton8.Height := 24;
    WebSpeedButton8.Caption := '>>';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.TabOrder := 6;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    edtContractPriceListPC.SetParentComponent(WebPanel27);
    edtContractPriceListPC.Name := 'edtContractPriceListPC';
    edtContractPriceListPC.Left := 470;
    edtContractPriceListPC.Top := 16;
    edtContractPriceListPC.Width := 60;
    edtContractPriceListPC.Height := 22;
    edtContractPriceListPC.Alignment := taCenter;
    edtContractPriceListPC.ChildOrder := 7;
    edtContractPriceListPC.HeightPercent := 100.000000000000000000;
    edtContractPriceListPC.Text := '1 of 1';
    edtContractPriceListPC.WidthPercent := 100.000000000000000000;
    wpcsDirections.SetParentComponent(wpcActiveContracts);
    wpcsDirections.Name := 'wpcsDirections';
    wpcsDirections.Left := 0;
    wpcsDirections.Top := 20;
    wpcsDirections.Width := 1137;
    wpcsDirections.Height := 477;
    wpcsDirections.Caption := 'Directions';
    wpcsDirections.ChildOrder := 4;
    WebPanel16.SetParentComponent(wpcsDirections);
    WebPanel16.Name := 'WebPanel16';
    WebPanel16.Left := 0;
    WebPanel16.Top := 0;
    WebPanel16.Width := 1137;
    WebPanel16.Height := 477;
    WebPanel16.Align := alClient;
    WebPanel16.TabOrder := 0;
    WebDBMemo1.SetParentComponent(WebPanel16);
    WebDBMemo1.Name := 'WebDBMemo1';
    WebDBMemo1.Left := 0;
    WebDBMemo1.Top := 0;
    WebDBMemo1.Width := 1137;
    WebDBMemo1.Height := 417;
    WebDBMemo1.Align := alClient;
    WebDBMemo1.HeightPercent := 100.000000000000000000;
    WebDBMemo1.Lines.BeginUpdate;
    try
      WebDBMemo1.Lines.Clear;
      WebDBMemo1.Lines.Add('WebDBMemo1');
    finally
      WebDBMemo1.Lines.EndUpdate;
    end;
    WebDBMemo1.SelLength := 0;
    WebDBMemo1.SelStart := 0;
    WebDBMemo1.WidthPercent := 100.000000000000000000;
    WebDBMemo1.DataSource := dsAContracts;
    WebPanel26.SetParentComponent(WebPanel16);
    WebPanel26.Name := 'WebPanel26';
    WebPanel26.Left := 0;
    WebPanel26.Top := 417;
    WebPanel26.Width := 1137;
    WebPanel26.Height := 60;
    WebPanel26.Align := alBottom;
    WebPanel26.ChildOrder := 1;
    WebPanel26.Color := clSilver;
    WebPanel26.TabOrder := 1;
    WebButton48.SetParentComponent(WebPanel26);
    WebButton48.Name := 'WebButton48';
    WebButton48.Left := 20;
    WebButton48.Top := 16;
    WebButton48.Width := 96;
    WebButton48.Height := 25;
    WebButton48.Caption := 'Price List';
    WebButton48.Color := clSkyBlue;
    WebButton48.HeightPercent := 100.000000000000000000;
    WebButton48.WidthPercent := 100.000000000000000000;
    btnSaveContract5.SetParentComponent(WebPanel26);
    btnSaveContract5.Name := 'btnSaveContract5';
    btnSaveContract5.Left := 142;
    btnSaveContract5.Top := 16;
    btnSaveContract5.Width := 96;
    btnSaveContract5.Height := 25;
    btnSaveContract5.Caption := 'Save';
    btnSaveContract5.Color := clGreenyellow;
    btnSaveContract5.ChildOrder := 1;
    btnSaveContract5.HeightPercent := 100.000000000000000000;
    btnSaveContract5.WidthPercent := 100.000000000000000000;
    SetEvent(btnSaveContract5, Self, 'OnClick', 'btnSaveContract5Click');
    WebButton50.SetParentComponent(WebPanel26);
    WebButton50.Name := 'WebButton50';
    WebButton50.Left := 259;
    WebButton50.Top := 16;
    WebButton50.Width := 96;
    WebButton50.Height := 25;
    WebButton50.Caption := 'Cancel';
    WebButton50.Color := clRed;
    WebButton50.ChildOrder := 2;
    WebButton50.HeightPercent := 100.000000000000000000;
    WebButton50.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton50, Self, 'OnClick', 'WebButton50Click');
    wpcsAllActiveContracts.SetParentComponent(wpcActiveContracts);
    wpcsAllActiveContracts.Name := 'wpcsAllActiveContracts';
    wpcsAllActiveContracts.Left := 0;
    wpcsAllActiveContracts.Top := 20;
    wpcsAllActiveContracts.Width := 1137;
    wpcsAllActiveContracts.Height := 477;
    wpcsAllActiveContracts.Caption := 'Active Contract List';
    wpcsAllActiveContracts.ChildOrder := 5;
    WebPanel25.SetParentComponent(wpcsAllActiveContracts);
    WebPanel25.Name := 'WebPanel25';
    WebPanel25.Left := 0;
    WebPanel25.Top := 0;
    WebPanel25.Width := 1137;
    WebPanel25.Height := 477;
    WebPanel25.Align := alClient;
    WebPanel25.TabOrder := 0;
    WebPanel30.SetParentComponent(WebPanel25);
    WebPanel30.Name := 'WebPanel30';
    WebPanel30.Left := 0;
    WebPanel30.Top := 0;
    WebPanel30.Width := 1137;
    WebPanel30.Height := 70;
    WebPanel30.Align := alTop;
    WebPanel30.Color := clSilver;
    WebPanel30.TabOrder := 0;
    WebLabel55.SetParentComponent(WebPanel30);
    WebLabel55.Name := 'WebLabel55';
    WebLabel55.Left := 927;
    WebLabel55.Top := 15;
    WebLabel55.Width := 147;
    WebLabel55.Height := 15;
    WebLabel55.Caption := 'Search Contract Description';
    WebLabel55.HeightPercent := 100.000000000000000000;
    WebLabel55.WidthPercent := 100.000000000000000000;
    WebLabel57.SetParentComponent(WebPanel30);
    WebLabel57.Name := 'WebLabel57';
    WebLabel57.Left := 469;
    WebLabel57.Top := 15;
    WebLabel57.Width := 118;
    WebLabel57.Height := 15;
    WebLabel57.Caption := 'Search Client Contract';
    WebLabel57.HeightPercent := 100.000000000000000000;
    WebLabel57.WidthPercent := 100.000000000000000000;
    WebButton63.SetParentComponent(WebPanel30);
    WebButton63.Name := 'WebButton63';
    WebButton63.Left := 18;
    WebButton63.Top := 12;
    WebButton63.Width := 96;
    WebButton63.Height := 44;
    WebButton63.Caption := 'New Contract';
    WebButton63.Color := clSkyBlue;
    WebButton63.HeightPercent := 100.000000000000000000;
    WebButton63.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton63, Self, 'OnClick', 'WebButton63Click');
    WebButton65.SetParentComponent(WebPanel30);
    WebButton65.Name := 'WebButton65';
    WebButton65.Left := 122;
    WebButton65.Top := 12;
    WebButton65.Width := 96;
    WebButton65.Height := 43;
    WebButton65.Caption := 'Import '#13#10'Contract '#13#10'Prices';
    WebButton65.Color := clSkyBlue;
    WebButton65.ChildOrder := 2;
    WebButton65.HeightPercent := 100.000000000000000000;
    WebButton65.WidthPercent := 100.000000000000000000;
    btnCloseContract.SetParentComponent(WebPanel30);
    btnCloseContract.Name := 'btnCloseContract';
    btnCloseContract.Left := 224;
    btnCloseContract.Top := 11;
    btnCloseContract.Width := 96;
    btnCloseContract.Height := 43;
    btnCloseContract.Caption := 'Close '#13#10'Contract';
    btnCloseContract.Color := clSkyBlue;
    btnCloseContract.ChildOrder := 3;
    btnCloseContract.HeightPercent := 100.000000000000000000;
    btnCloseContract.WidthPercent := 100.000000000000000000;
    SetEvent(btnCloseContract, Self, 'OnClick', 'btnCloseContractClick');
    WebButton67.SetParentComponent(WebPanel30);
    WebButton67.Name := 'WebButton67';
    WebButton67.Left := 794;
    WebButton67.Top := 24;
    WebButton67.Width := 96;
    WebButton67.Height := 25;
    WebButton67.Caption := 'Search';
    WebButton67.Color := clSkyBlue;
    WebButton67.ChildOrder := 4;
    WebButton67.HeightPercent := 100.000000000000000000;
    WebButton67.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton67, Self, 'OnClick', 'WebButton67Click');
    edtSearchDescription.SetParentComponent(WebPanel30);
    edtSearchDescription.Name := 'edtSearchDescription';
    edtSearchDescription.Left := 924;
    edtSearchDescription.Top := 31;
    edtSearchDescription.Width := 173;
    edtSearchDescription.Height := 22;
    edtSearchDescription.ChildOrder := 5;
    edtSearchDescription.HeightPercent := 100.000000000000000000;
    edtSearchDescription.WidthPercent := 100.000000000000000000;
    SetEvent(edtSearchDescription, Self, 'OnChange', 'edtSearchDescriptionChange');
    WebButton68.SetParentComponent(WebPanel30);
    WebButton68.Name := 'WebButton68';
    WebButton68.Left := 744;
    WebButton68.Top := 29;
    WebButton68.Width := 25;
    WebButton68.Height := 25;
    WebButton68.Caption := '...';
    WebButton68.ChildOrder := 7;
    WebButton68.HeightPercent := 100.000000000000000000;
    WebButton68.WidthPercent := 100.000000000000000000;
    edtSearchActiveContracts.SetParentComponent(WebPanel30);
    edtSearchActiveContracts.Name := 'edtSearchActiveContracts';
    edtSearchActiveContracts.Left := 472;
    edtSearchActiveContracts.Top := 32;
    edtSearchActiveContracts.Width := 249;
    edtSearchActiveContracts.Height := 22;
    edtSearchActiveContracts.ChildOrder := 9;
    edtSearchActiveContracts.HeightPercent := 100.000000000000000000;
    edtSearchActiveContracts.WidthPercent := 100.000000000000000000;
    dgActiveContractsList.SetParentComponent(WebPanel25);
    dgActiveContractsList.Name := 'dgActiveContractsList';
    dgActiveContractsList.Left := 0;
    dgActiveContractsList.Top := 70;
    dgActiveContractsList.Width := 1137;
    dgActiveContractsList.Height := 347;
    dgActiveContractsList.Align := alClient;
    dgActiveContractsList.ParentDoubleBuffered := False;
    dgActiveContractsList.DoubleBuffered := True;
    dgActiveContractsList.TabOrder := 1;
    dgActiveContractsList.ShowAcceleratorChar := False;
    dgActiveContractsList.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgActiveContractsList.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgActiveContractsList.Header.VisualGrouping.Layout.Font.Height := -12;
    dgActiveContractsList.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgActiveContractsList.Header.VisualGrouping.Layout.Font.Style := [];
    dgActiveContractsList.Adapter := dgdbaActiveContractsList;
    dgActiveContractsList.BitmapContainer := BitMapContainer1;
    dgActiveContractsList.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgActiveContractsList.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgActiveContractsList.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgActiveContractsList.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgActiveContractsList.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgActiveContractsList.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgActiveContractsList.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgActiveContractsList.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgActiveContractsList.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgActiveContractsList.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgActiveContractsList.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgActiveContractsList.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgActiveContractsList.CellAppearance.BandLayout.Font.Height := -12;
    dgActiveContractsList.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgActiveContractsList.CellAppearance.BandLayout.Font.Style := [];
    dgActiveContractsList.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgActiveContractsList.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgActiveContractsList.CellAppearance.FixedLayout.Font.Height := -12;
    dgActiveContractsList.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgActiveContractsList.CellAppearance.FixedLayout.Font.Style := [];
    dgActiveContractsList.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgActiveContractsList.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgActiveContractsList.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgActiveContractsList.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgActiveContractsList.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgActiveContractsList.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgActiveContractsList.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgActiveContractsList.CellAppearance.FocusedLayout.Font.Height := -12;
    dgActiveContractsList.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgActiveContractsList.CellAppearance.FocusedLayout.Font.Style := [];
    dgActiveContractsList.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgActiveContractsList.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgActiveContractsList.CellAppearance.GroupLayout.Font.Height := -12;
    dgActiveContractsList.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgActiveContractsList.CellAppearance.GroupLayout.Font.Style := [];
    dgActiveContractsList.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgActiveContractsList.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgActiveContractsList.CellAppearance.NormalLayout.Font.Height := -12;
    dgActiveContractsList.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgActiveContractsList.CellAppearance.NormalLayout.Font.Style := [];
    dgActiveContractsList.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgActiveContractsList.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgActiveContractsList.CellAppearance.SelectedLayout.Font.Height := -12;
    dgActiveContractsList.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgActiveContractsList.CellAppearance.SelectedLayout.Font.Style := [];
    dgActiveContractsList.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgActiveContractsList.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgActiveContractsList.CellAppearance.SummaryLayout.Font.Height := -12;
    dgActiveContractsList.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgActiveContractsList.CellAppearance.SummaryLayout.Font.Style := [];
    dgActiveContractsList.ColumnCount := 90;
    dgActiveContractsList.Columns.Clear;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := '.';
      Settings := [gcsEditorItems];
      Width := 25.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Contract No';
      Settings := [gcsEditorItems];
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Contract Name';
      Settings := [gcsEditorItems];
      Width := 225.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Contract Description';
      Settings := [gcsEditorItems];
      Width := 225.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Comodity';
      Settings := [gcsEditorItems];
      Width := 150.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Settings := [gcsEditorItems];
      Width := 0.000000000000000000;
    end;
    with dgActiveContractsList.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Name := 'Edit';
      Settings := [gcsType,gcsEditorItems];
    end;
    dgActiveContractsList.Designer := False;
    dgActiveContractsList.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgActiveContractsList.FilterAppearance.Font.Color := clWindowText;
    dgActiveContractsList.FilterAppearance.Font.Height := -12;
    dgActiveContractsList.FilterAppearance.Font.Name := 'Segoe UI';
    dgActiveContractsList.FilterAppearance.Font.Style := [];
    dgActiveContractsList.Icons.ExpandIcon.LoadFromFile('Contracts.WebPanel25.dgActiveContractsList.Icons.ExpandIcon.svg');
    dgActiveContractsList.Icons.CollapseIcon.LoadFromFile('Contracts.WebPanel25.dgActiveContractsList.Icons.CollapseIcon.svg');
    dgActiveContractsList.Icons.FilterIcon.LoadFromFile('Contracts.WebPanel25.dgActiveContractsList.Icons.FilterIcon.svg');
    dgActiveContractsList.Icons.FilterActiveIcon.LoadFromFile('Contracts.WebPanel25.dgActiveContractsList.Icons.FilterActiveIcon.svg');
    dgActiveContractsList.Icons.FilterClearIcon.LoadFromFile('Contracts.WebPanel25.dgActiveContractsList.Icons.FilterClearIcon.svg');
    dgActiveContractsList.Icons.FilterTypeIcon.LoadFromFile('Contracts.WebPanel25.dgActiveContractsList.Icons.FilterTypeIcon.svg');
    dgActiveContractsList.Icons.SortAscendingIcon.LoadFromFile('Contracts.WebPanel25.dgActiveContractsList.Icons.SortAscendingIcon.svg');
    dgActiveContractsList.Icons.SortDescendingIcon.LoadFromFile('Contracts.WebPanel25.dgActiveContractsList.Icons.SortDescendingIcon.svg');
    dgActiveContractsList.Icons.CloseIcon.LoadFromFile('Contracts.WebPanel25.dgActiveContractsList.Icons.CloseIcon.svg');
    SetEvent(dgActiveContractsList, Self, 'OnCellClick', 'dgActiveContractsListCellClick');
    SetEvent(dgActiveContractsList, Self, 'OnGetCellProperties', 'dgActiveContractsListGetCellProperties');
    SetEvent(dgActiveContractsList, Self, 'OnSelectCell', 'dgActiveContractsListSelectCell');
    dgActiveContractsList.RowCount := 1;
    dgdbaActiveContractsList.SetParentComponent(dgActiveContractsList);
    dgdbaActiveContractsList.Name := 'dgdbaActiveContractsList';
    dgdbaActiveContractsList.Left := 231;
    dgdbaActiveContractsList.Top := 5;
    dgdbaActiveContractsList.Width := 26;
    dgdbaActiveContractsList.Height := 26;
    dgdbaActiveContractsList.Visible := True;
    dgdbaActiveContractsList.AutoCreateColumns := False;
    dgdbaActiveContractsList.AutoRemoveColumns := False;
    dgdbaActiveContractsList.Columns.Clear;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'CONTRACTNO';
      Header := 'Contract No';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'CONTRACTNAME';
      Header := 'Contract Name';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'DEBCODE';
      Header := 'Contract Description';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'COMMODITIESNO';
      Header := 'Comodity';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'LOADCOUNTRYNO';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'LOADPROVINCENO';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'LOADCITYNO';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'LOADINGNO';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'OFFLOADCOUNTRYNO';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'OFFLOADPROVINCENO';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'OFFLOADCITYNO';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'OFFLOADINGNO';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'INVLOADING';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'INVOFFLOADING';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'TOTALTONS';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'TOTALTONSORDER';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'TOTALTONSLOADED';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'TOTALTONSOFFLOADED';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'TOTALTONSINVOICED';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'STARTDATE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'COMPLETED';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'COMPDATE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'CONTROLLER';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'AVGTONS';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'TOTALLOADS';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'LOADSORDER';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'LOADSLOADED';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'LOADSOFFLOADED';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'LOADSINVOICED';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'PAYMENTTERMS';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'PAYMENTTYPE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'ADDHOC';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'DEDICATED';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'ORDERNO';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'INVVAT';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'MULTILOADINV';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SENDED';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SENDEDDATE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'PRELISTING';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'POSTLISTING';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'INVOICETYPE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'DISTANCE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'DRIVERRATIO';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'CUTOFF1';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'CUTOFFPERIOD1';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'CUTOFF2';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'CUTOFFPERIOD2';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SAGEINVENTORY';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SAGEGL';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SAGECODE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SAGEEXPCODE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'STRATERATE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'CHGOFFLOAD';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'CHGPRICE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'CAPTURETONS';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'INVOICETONS';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'CHGSUBPRICE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'MAXLOADORDERS';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'ADDDESCRIPTION';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'VARIANCETYPE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'VARIANCEVALUE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'PRINTLC';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'PRINTDN';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'PRINTTS';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'DNTYPE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'TSTYPE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SHORTDESC';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'OLDLOADSCREEN';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SHOWBOOKINGS';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SHOWADDITIONAL';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'PRICETYPE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'USEDOCKETINVNO';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SAGECODE2';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SAGEEXPCODE2';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SAGEINVENTORY2';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SAGEGL2';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'HAULAGETYPE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'LINKZEROML';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'ATTACHEDEMAIL';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'CLIENTLINKCONTRACT';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'QUOTEREFNO';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SORTLOADDATE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SORTOFFDATE';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SORTLOADWAY';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SORTOFFWAY';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SORTDOCKET';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'SINVVAT';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      FieldName := 'LOADINSTRUCTQTY';
      AutoCreated := False;
    end;
    with dgdbaActiveContractsList.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    dgdbaActiveContractsList.DataSource := dsAContracts;
    WebPanel31.SetParentComponent(WebPanel25);
    WebPanel31.Name := 'WebPanel31';
    WebPanel31.Left := 0;
    WebPanel31.Top := 417;
    WebPanel31.Width := 1137;
    WebPanel31.Height := 60;
    WebPanel31.Align := alBottom;
    WebPanel31.ChildOrder := 2;
    WebPanel31.Color := clSilver;
    WebPanel31.TabOrder := 2;
    WebSpeedButton1.SetParentComponent(WebPanel31);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 24;
    WebSpeedButton1.Top := 16;
    WebSpeedButton1.Width := 24;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(WebPanel31);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 48;
    WebSpeedButton2.Top := 16;
    WebSpeedButton2.Width := 24;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(WebPanel31);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 129;
    WebSpeedButton3.Top := 16;
    WebSpeedButton3.Width := 24;
    WebSpeedButton3.Height := 24;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(WebPanel31);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 153;
    WebSpeedButton4.Top := 16;
    WebSpeedButton4.Width := 24;
    WebSpeedButton4.Height := 24;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    edtActiveContractsPageCount.SetParentComponent(WebPanel31);
    edtActiveContractsPageCount.Name := 'edtActiveContractsPageCount';
    edtActiveContractsPageCount.Left := 72;
    edtActiveContractsPageCount.Top := 17;
    edtActiveContractsPageCount.Width := 57;
    edtActiveContractsPageCount.Height := 22;
    edtActiveContractsPageCount.Alignment := taCenter;
    edtActiveContractsPageCount.ChildOrder := 4;
    edtActiveContractsPageCount.HeightPercent := 100.000000000000000000;
    edtActiveContractsPageCount.Text := '1 of 1';
    edtActiveContractsPageCount.WidthPercent := 100.000000000000000000;
    wpcsClosedContracts.SetParentComponent(wpcContractInfo);
    wpcsClosedContracts.Name := 'wpcsClosedContracts';
    wpcsClosedContracts.Left := 0;
    wpcsClosedContracts.Top := 20;
    wpcsClosedContracts.Width := 1137;
    wpcsClosedContracts.Height := 497;
    wpcsClosedContracts.Caption := 'Closed Contracts';
    wpcsClosedContracts.ChildOrder := 1;
    WebPanel5.SetParentComponent(wpcsClosedContracts);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 0;
    WebPanel5.Top := 0;
    WebPanel5.Width := 1137;
    WebPanel5.Height := 497;
    WebPanel5.Align := alClient;
    WebPanel5.TabOrder := 0;
    WebPanel17.SetParentComponent(WebPanel5);
    WebPanel17.Name := 'WebPanel17';
    WebPanel17.Left := 0;
    WebPanel17.Top := 0;
    WebPanel17.Width := 1137;
    WebPanel17.Height := 70;
    WebPanel17.Align := alTop;
    WebPanel17.Color := clSilver;
    WebPanel17.TabOrder := 0;
    WebLabel41.SetParentComponent(WebPanel17);
    WebLabel41.Name := 'WebLabel41';
    WebLabel41.Left := 166;
    WebLabel41.Top := 7;
    WebLabel41.Width := 123;
    WebLabel41.Height := 15;
    WebLabel41.Caption := 'Search Client Contracts';
    WebLabel41.HeightPercent := 100.000000000000000000;
    WebLabel41.WidthPercent := 100.000000000000000000;
    WebLabel42.SetParentComponent(WebPanel17);
    WebLabel42.Name := 'WebLabel42';
    WebLabel42.Left := 670;
    WebLabel42.Top := 8;
    WebLabel42.Width := 147;
    WebLabel42.Height := 15;
    WebLabel42.Caption := 'Search Contract Description';
    WebLabel42.HeightPercent := 100.000000000000000000;
    WebLabel42.WidthPercent := 100.000000000000000000;
    btnOpenContract.SetParentComponent(WebPanel17);
    btnOpenContract.Name := 'btnOpenContract';
    btnOpenContract.Left := 33;
    btnOpenContract.Top := 8;
    btnOpenContract.Width := 96;
    btnOpenContract.Height := 43;
    btnOpenContract.Caption := 'Open Contract';
    btnOpenContract.Color := clSkyBlue;
    btnOpenContract.HeightPercent := 100.000000000000000000;
    btnOpenContract.WidthPercent := 100.000000000000000000;
    SetEvent(btnOpenContract, Self, 'OnClick', 'btnOpenContractClick');
    WebButton36.SetParentComponent(WebPanel17);
    WebButton36.Name := 'WebButton36';
    WebButton36.Left := 392;
    WebButton36.Top := 9;
    WebButton36.Width := 96;
    WebButton36.Height := 43;
    WebButton36.Caption := 'Search';
    WebButton36.Color := clSkyBlue;
    WebButton36.ChildOrder := 3;
    WebButton36.HeightPercent := 100.000000000000000000;
    WebButton36.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton36, Self, 'OnClick', 'WebButton36Click');
    edtSearchContractDescription.SetParentComponent(WebPanel17);
    edtSearchContractDescription.Name := 'edtSearchContractDescription';
    edtSearchContractDescription.Left := 670;
    edtSearchContractDescription.Top := 28;
    edtSearchContractDescription.Width := 220;
    edtSearchContractDescription.Height := 22;
    edtSearchContractDescription.ChildOrder := 5;
    edtSearchContractDescription.HeightPercent := 100.000000000000000000;
    edtSearchContractDescription.WidthPercent := 100.000000000000000000;
    SetEvent(edtSearchContractDescription, Self, 'OnChange', 'edtSearchContractDescriptionChange');
    edtSearchClosedContracts.SetParentComponent(WebPanel17);
    edtSearchClosedContracts.Name := 'edtSearchClosedContracts';
    edtSearchClosedContracts.Left := 166;
    edtSearchClosedContracts.Top := 29;
    edtSearchClosedContracts.Width := 209;
    edtSearchClosedContracts.Height := 22;
    edtSearchClosedContracts.ChildOrder := 5;
    edtSearchClosedContracts.HeightPercent := 100.000000000000000000;
    edtSearchClosedContracts.WidthPercent := 100.000000000000000000;
    dgClosedContracts.SetParentComponent(WebPanel5);
    dgClosedContracts.Name := 'dgClosedContracts';
    dgClosedContracts.Left := 0;
    dgClosedContracts.Top := 70;
    dgClosedContracts.Width := 1137;
    dgClosedContracts.Height := 367;
    dgClosedContracts.Align := alClient;
    dgClosedContracts.ParentDoubleBuffered := False;
    dgClosedContracts.DoubleBuffered := True;
    dgClosedContracts.TabOrder := 1;
    dgClosedContracts.ShowAcceleratorChar := False;
    dgClosedContracts.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgClosedContracts.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgClosedContracts.Header.VisualGrouping.Layout.Font.Height := -12;
    dgClosedContracts.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgClosedContracts.Header.VisualGrouping.Layout.Font.Style := [];
    dgClosedContracts.Adapter := dgdbaClosedContracts;
    dgClosedContracts.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgClosedContracts.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgClosedContracts.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgClosedContracts.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgClosedContracts.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgClosedContracts.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgClosedContracts.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgClosedContracts.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgClosedContracts.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgClosedContracts.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgClosedContracts.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgClosedContracts.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgClosedContracts.CellAppearance.BandLayout.Font.Height := -12;
    dgClosedContracts.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgClosedContracts.CellAppearance.BandLayout.Font.Style := [];
    dgClosedContracts.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgClosedContracts.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgClosedContracts.CellAppearance.FixedLayout.Font.Height := -12;
    dgClosedContracts.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgClosedContracts.CellAppearance.FixedLayout.Font.Style := [];
    dgClosedContracts.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgClosedContracts.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgClosedContracts.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgClosedContracts.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgClosedContracts.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgClosedContracts.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgClosedContracts.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgClosedContracts.CellAppearance.FocusedLayout.Font.Height := -12;
    dgClosedContracts.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgClosedContracts.CellAppearance.FocusedLayout.Font.Style := [];
    dgClosedContracts.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgClosedContracts.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgClosedContracts.CellAppearance.GroupLayout.Font.Height := -12;
    dgClosedContracts.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgClosedContracts.CellAppearance.GroupLayout.Font.Style := [];
    dgClosedContracts.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgClosedContracts.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgClosedContracts.CellAppearance.NormalLayout.Font.Height := -12;
    dgClosedContracts.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgClosedContracts.CellAppearance.NormalLayout.Font.Style := [];
    dgClosedContracts.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgClosedContracts.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgClosedContracts.CellAppearance.SelectedLayout.Font.Height := -12;
    dgClosedContracts.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgClosedContracts.CellAppearance.SelectedLayout.Font.Style := [];
    dgClosedContracts.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgClosedContracts.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgClosedContracts.CellAppearance.SummaryLayout.Font.Height := -12;
    dgClosedContracts.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgClosedContracts.CellAppearance.SummaryLayout.Font.Style := [];
    dgClosedContracts.ColumnCount := 89;
    dgClosedContracts.Columns.Clear;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := '.';
      Width := 25.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CONTRACTNO';
      Name := 'CONTRACTNO';
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CONTRACTNAME';
      Name := 'CONTRACTNAME';
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'DEBCODE';
      Name := 'DEBCODE';
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'COMMODITIESNO';
      Name := 'COMMODITIESNO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'LOADCOUNTRYNO';
      Name := 'LOADCOUNTRYNO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'LOADPROVINCENO';
      Name := 'LOADPROVINCENO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'LOADCITYNO';
      Name := 'LOADCITYNO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'LOADINGNO';
      Name := 'LOADINGNO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'OFFLOADCOUNTRYNO';
      Name := 'OFFLOADCOUNTRYNO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'OFFLOADPROVINCENO';
      Name := 'OFFLOADPROVINCENO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'OFFLOADCITYNO';
      Name := 'OFFLOADCITYNO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'OFFLOADINGNO';
      Name := 'OFFLOADINGNO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'INVLOADING';
      Name := 'INVLOADING';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'INVOFFLOADING';
      Name := 'INVOFFLOADING';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTALTONS';
      Name := 'TOTALTONS';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTALTONSORDER';
      Name := 'TOTALTONSORDER';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTALTONSLOADED';
      Name := 'TOTALTONSLOADED';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTALTONSOFFLOADED';
      Name := 'TOTALTONSOFFLOADED';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTALTONSINVOICED';
      Name := 'TOTALTONSINVOICED';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'STARTDATE';
      Name := 'STARTDATE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'COMPLETED';
      Name := 'COMPLETED';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'COMPDATE';
      Name := 'COMPDATE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CONTROLLER';
      Name := 'CONTROLLER';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'AVGTONS';
      Name := 'AVGTONS';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TOTALLOADS';
      Name := 'TOTALLOADS';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'LOADSORDER';
      Name := 'LOADSORDER';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'LOADSLOADED';
      Name := 'LOADSLOADED';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'LOADSOFFLOADED';
      Name := 'LOADSOFFLOADED';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'LOADSINVOICED';
      Name := 'LOADSINVOICED';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'PAYMENTTERMS';
      Name := 'PAYMENTTERMS';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'PAYMENTTYPE';
      Name := 'PAYMENTTYPE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ADDHOC';
      Name := 'ADDHOC';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'DEDICATED';
      Name := 'DEDICATED';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ORDERNO';
      Name := 'ORDERNO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'INVVAT';
      Name := 'INVVAT';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'MULTILOADINV';
      Name := 'MULTILOADINV';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SENDED';
      Name := 'SENDED';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SENDEDDATE';
      Name := 'SENDEDDATE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'PRELISTING';
      Name := 'PRELISTING';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'POSTLISTING';
      Name := 'POSTLISTING';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'INVOICETYPE';
      Name := 'INVOICETYPE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'DISTANCE';
      Name := 'DISTANCE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'DRIVERRATIO';
      Name := 'DRIVERRATIO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CUTOFF1';
      Name := 'CUTOFF1';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CUTOFFPERIOD1';
      Name := 'CUTOFFPERIOD1';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CUTOFF2';
      Name := 'CUTOFF2';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CUTOFFPERIOD2';
      Name := 'CUTOFFPERIOD2';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SAGEINVENTORY';
      Name := 'SAGEINVENTORY';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SAGEGL';
      Name := 'SAGEGL';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SAGECODE';
      Name := 'SAGECODE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SAGEEXPCODE';
      Name := 'SAGEEXPCODE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'STRATERATE';
      Name := 'STRATERATE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CHGOFFLOAD';
      Name := 'CHGOFFLOAD';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CHGPRICE';
      Name := 'CHGPRICE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CAPTURETONS';
      Name := 'CAPTURETONS';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'INVOICETONS';
      Name := 'INVOICETONS';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CHGSUBPRICE';
      Name := 'CHGSUBPRICE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'MAXLOADORDERS';
      Name := 'MAXLOADORDERS';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ADDDESCRIPTION';
      Name := 'ADDDESCRIPTION';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'VARIANCETYPE';
      Name := 'VARIANCETYPE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'VARIANCEVALUE';
      Name := 'VARIANCEVALUE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'PRINTLC';
      Name := 'PRINTLC';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'PRINTDN';
      Name := 'PRINTDN';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'PRINTTS';
      Name := 'PRINTTS';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'DNTYPE';
      Name := 'DNTYPE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'TSTYPE';
      Name := 'TSTYPE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SHORTDESC';
      Name := 'SHORTDESC';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'OLDLOADSCREEN';
      Name := 'OLDLOADSCREEN';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SHOWBOOKINGS';
      Name := 'SHOWBOOKINGS';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SHOWADDITIONAL';
      Name := 'SHOWADDITIONAL';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'PRICETYPE';
      Name := 'PRICETYPE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'USEDOCKETINVNO';
      Name := 'USEDOCKETINVNO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SAGECODE2';
      Name := 'SAGECODE2';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SAGEEXPCODE2';
      Name := 'SAGEEXPCODE2';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SAGEINVENTORY2';
      Name := 'SAGEINVENTORY2';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SAGEGL2';
      Name := 'SAGEGL2';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'HAULAGETYPE';
      Name := 'HAULAGETYPE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'LINKZEROML';
      Name := 'LINKZEROML';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ATTACHEDEMAIL';
      Name := 'ATTACHEDEMAIL';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'CLIENTLINKCONTRACT';
      Name := 'CLIENTLINKCONTRACT';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'QUOTEREFNO';
      Name := 'QUOTEREFNO';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SORTLOADDATE';
      Name := 'SORTLOADDATE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SORTOFFDATE';
      Name := 'SORTOFFDATE';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SORTLOADWAY';
      Name := 'SORTLOADWAY';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SORTOFFWAY';
      Name := 'SORTOFFWAY';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SORTDOCKET';
      Name := 'SORTDOCKET';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'SINVVAT';
      Name := 'SINVVAT';
      Width := 0.000000000000000000;
    end;
    with dgClosedContracts.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'LOADINSTRUCTQTY';
      Name := 'LOADINSTRUCTQTY';
      Width := 0.000000000000000000;
    end;
    dgClosedContracts.Designer := False;
    dgClosedContracts.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgClosedContracts.FilterAppearance.Font.Color := clWindowText;
    dgClosedContracts.FilterAppearance.Font.Height := -12;
    dgClosedContracts.FilterAppearance.Font.Name := 'Segoe UI';
    dgClosedContracts.FilterAppearance.Font.Style := [];
    dgClosedContracts.Icons.ExpandIcon.LoadFromFile('Contracts.WebPanel5.dgClosedContracts.Icons.ExpandIcon.svg');
    dgClosedContracts.Icons.CollapseIcon.LoadFromFile('Contracts.WebPanel5.dgClosedContracts.Icons.CollapseIcon.svg');
    dgClosedContracts.Icons.FilterIcon.LoadFromFile('Contracts.WebPanel5.dgClosedContracts.Icons.FilterIcon.svg');
    dgClosedContracts.Icons.FilterActiveIcon.LoadFromFile('Contracts.WebPanel5.dgClosedContracts.Icons.FilterActiveIcon.svg');
    dgClosedContracts.Icons.FilterClearIcon.LoadFromFile('Contracts.WebPanel5.dgClosedContracts.Icons.FilterClearIcon.svg');
    dgClosedContracts.Icons.FilterTypeIcon.LoadFromFile('Contracts.WebPanel5.dgClosedContracts.Icons.FilterTypeIcon.svg');
    dgClosedContracts.Icons.SortAscendingIcon.LoadFromFile('Contracts.WebPanel5.dgClosedContracts.Icons.SortAscendingIcon.svg');
    dgClosedContracts.Icons.SortDescendingIcon.LoadFromFile('Contracts.WebPanel5.dgClosedContracts.Icons.SortDescendingIcon.svg');
    dgClosedContracts.Icons.CloseIcon.LoadFromFile('Contracts.WebPanel5.dgClosedContracts.Icons.CloseIcon.svg');
    SetEvent(dgClosedContracts, Self, 'OnCellClick', 'dgClosedContractsCellClick');
    SetEvent(dgClosedContracts, Self, 'OnSelectCell', 'dgClosedContractsSelectCell');
    dgClosedContracts.RowCount := 1;
    dgdbaClosedContracts.SetParentComponent(dgClosedContracts);
    dgdbaClosedContracts.Name := 'dgdbaClosedContracts';
    dgdbaClosedContracts.Left := 237;
    dgdbaClosedContracts.Top := 180;
    dgdbaClosedContracts.Width := 26;
    dgdbaClosedContracts.Height := 26;
    dgdbaClosedContracts.Visible := True;
    dgdbaClosedContracts.AutoCreateColumns := False;
    dgdbaClosedContracts.AutoRemoveColumns := False;
    dgdbaClosedContracts.Columns.Clear;
    with dgdbaClosedContracts.Columns.Add do
    begin
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'CONTRACTNO';
      Header := 'Contract No';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'CONTRACTNAME';
      Header := 'Contract Name';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'DEBCODE';
      Header := 'Contract Description';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'COMMODITIESNO';
      Header := 'Comodity';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'LOADCOUNTRYNO';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'LOADPROVINCENO';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'LOADCITYNO';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'LOADINGNO';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'OFFLOADCOUNTRYNO';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'OFFLOADPROVINCENO';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'OFFLOADCITYNO';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'OFFLOADINGNO';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'INVLOADING';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'INVOFFLOADING';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'TOTALTONS';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'TOTALTONSORDER';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'TOTALTONSLOADED';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'TOTALTONSOFFLOADED';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'TOTALTONSINVOICED';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'STARTDATE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'COMPLETED';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'COMPDATE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'CONTROLLER';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'AVGTONS';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'TOTALLOADS';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'LOADSORDER';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'LOADSLOADED';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'LOADSOFFLOADED';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'LOADSINVOICED';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'PAYMENTTERMS';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'PAYMENTTYPE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'ADDHOC';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'DEDICATED';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'ORDERNO';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'INVVAT';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'MULTILOADINV';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SENDED';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SENDEDDATE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'PRELISTING';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'POSTLISTING';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'INVOICETYPE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'DISTANCE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'DRIVERRATIO';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'CUTOFF1';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'CUTOFFPERIOD1';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'CUTOFF2';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'CUTOFFPERIOD2';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SAGEINVENTORY';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SAGEGL';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SAGECODE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SAGEEXPCODE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'STRATERATE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'CHGOFFLOAD';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'CHGPRICE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'CAPTURETONS';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'INVOICETONS';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'CHGSUBPRICE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'MAXLOADORDERS';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'ADDDESCRIPTION';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'VARIANCETYPE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'VARIANCEVALUE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'PRINTLC';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'PRINTDN';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'PRINTTS';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'DNTYPE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'TSTYPE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SHORTDESC';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'OLDLOADSCREEN';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SHOWBOOKINGS';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SHOWADDITIONAL';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'PRICETYPE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'USEDOCKETINVNO';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SAGECODE2';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SAGEEXPCODE2';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SAGEINVENTORY2';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SAGEGL2';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'HAULAGETYPE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'LINKZEROML';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'ATTACHEDEMAIL';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'CLIENTLINKCONTRACT';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'QUOTEREFNO';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SORTLOADDATE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SORTOFFDATE';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SORTLOADWAY';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SORTOFFWAY';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SORTDOCKET';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'SINVVAT';
      AutoCreated := False;
    end;
    with dgdbaClosedContracts.Columns.Add do
    begin
      FieldName := 'LOADINSTRUCTQTY';
      AutoCreated := False;
    end;
    dgdbaClosedContracts.DataSource := dsClosedContracts;
    WebPanel32.SetParentComponent(WebPanel5);
    WebPanel32.Name := 'WebPanel32';
    WebPanel32.Left := 0;
    WebPanel32.Top := 437;
    WebPanel32.Width := 1137;
    WebPanel32.Height := 60;
    WebPanel32.Align := alBottom;
    WebPanel32.ChildOrder := 2;
    WebPanel32.TabOrder := 2;
    edtClosedContractsPC.SetParentComponent(WebPanel32);
    edtClosedContractsPC.Name := 'edtClosedContractsPC';
    edtClosedContractsPC.Left := 80;
    edtClosedContractsPC.Top := 25;
    edtClosedContractsPC.Width := 57;
    edtClosedContractsPC.Height := 22;
    edtClosedContractsPC.Alignment := taCenter;
    edtClosedContractsPC.ChildOrder := 4;
    edtClosedContractsPC.HeightPercent := 100.000000000000000000;
    edtClosedContractsPC.Text := '1 of 1';
    edtClosedContractsPC.WidthPercent := 100.000000000000000000;
    WebSpeedButton9.SetParentComponent(WebPanel32);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 32;
    WebSpeedButton9.Top := 24;
    WebSpeedButton9.Width := 24;
    WebSpeedButton9.Height := 24;
    WebSpeedButton9.Caption := '<<';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.TabOrder := 1;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton9, Self, 'OnClick', 'WebSpeedButton9Click');
    WebSpeedButton10.SetParentComponent(WebPanel32);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 56;
    WebSpeedButton10.Top := 24;
    WebSpeedButton10.Width := 24;
    WebSpeedButton10.Height := 24;
    WebSpeedButton10.Caption := '<';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.TabOrder := 2;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebSpeedButton11.SetParentComponent(WebPanel32);
    WebSpeedButton11.Name := 'WebSpeedButton11';
    WebSpeedButton11.Left := 135;
    WebSpeedButton11.Top := 24;
    WebSpeedButton11.Width := 24;
    WebSpeedButton11.Height := 24;
    WebSpeedButton11.Caption := '>';
    WebSpeedButton11.Color := clNone;
    WebSpeedButton11.HeightPercent := 100.000000000000000000;
    WebSpeedButton11.TabOrder := 3;
    WebSpeedButton11.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton11, Self, 'OnClick', 'WebSpeedButton11Click');
    WebSpeedButton12.SetParentComponent(WebPanel32);
    WebSpeedButton12.Name := 'WebSpeedButton12';
    WebSpeedButton12.Left := 159;
    WebSpeedButton12.Top := 24;
    WebSpeedButton12.Width := 24;
    WebSpeedButton12.Height := 24;
    WebSpeedButton12.Caption := '>>';
    WebSpeedButton12.Color := clNone;
    WebSpeedButton12.HeightPercent := 100.000000000000000000;
    WebSpeedButton12.TabOrder := 4;
    WebSpeedButton12.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton12, Self, 'OnClick', 'WebSpeedButton12Click');
    wpcsContractInportSetup.SetParentComponent(wpcContractInfo);
    wpcsContractInportSetup.Name := 'wpcsContractInportSetup';
    wpcsContractInportSetup.Left := 0;
    wpcsContractInportSetup.Top := 20;
    wpcsContractInportSetup.Width := 1137;
    wpcsContractInportSetup.Height := 497;
    wpcsContractInportSetup.Caption := 'Contract Import Setup';
    wpcsContractInportSetup.ChildOrder := 2;
    WebPanel6.SetParentComponent(wpcsContractInportSetup);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 0;
    WebPanel6.Top := 0;
    WebPanel6.Width := 1137;
    WebPanel6.Height := 497;
    WebPanel6.Align := alClient;
    WebPanel6.TabOrder := 0;
    WebPanel18.SetParentComponent(WebPanel6);
    WebPanel18.Name := 'WebPanel18';
    WebPanel18.Left := 0;
    WebPanel18.Top := 0;
    WebPanel18.Width := 1137;
    WebPanel18.Height := 70;
    WebPanel18.Align := alTop;
    WebPanel18.Color := clSilver;
    WebPanel18.TabOrder := 0;
    WebLabel43.SetParentComponent(WebPanel18);
    WebLabel43.Name := 'WebLabel43';
    WebLabel43.Left := 33;
    WebLabel43.Top := 11;
    WebLabel43.Width := 90;
    WebLabel43.Height := 15;
    WebLabel43.Caption := 'Search By Clients';
    WebLabel43.HeightPercent := 100.000000000000000000;
    WebLabel43.WidthPercent := 100.000000000000000000;
    edtActiveContractsImportSearch.SetParentComponent(WebPanel18);
    edtActiveContractsImportSearch.Name := 'edtActiveContractsImportSearch';
    edtActiveContractsImportSearch.Left := 31;
    edtActiveContractsImportSearch.Top := 29;
    edtActiveContractsImportSearch.Width := 210;
    edtActiveContractsImportSearch.Height := 22;
    edtActiveContractsImportSearch.HeightPercent := 100.000000000000000000;
    edtActiveContractsImportSearch.WidthPercent := 100.000000000000000000;
    WebButton17.SetParentComponent(WebPanel18);
    WebButton17.Name := 'WebButton17';
    WebButton17.Left := 247;
    WebButton17.Top := 29;
    WebButton17.Width := 25;
    WebButton17.Height := 25;
    WebButton17.Caption := '...';
    WebButton17.ChildOrder := 1;
    WebButton17.HeightPercent := 100.000000000000000000;
    WebButton17.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton17, Self, 'OnClick', 'WebButton17Click');
    WebRadioGroup3.SetParentComponent(WebPanel18);
    WebRadioGroup3.Name := 'WebRadioGroup3';
    WebRadioGroup3.Left := 402;
    WebRadioGroup3.Top := 3;
    WebRadioGroup3.Width := 160;
    WebRadioGroup3.Height := 63;
    WebRadioGroup3.Caption := 'Import Type';
    WebRadioGroup3.ChildOrder := 2;
    WebRadioGroup3.Columns := 1;
    WebRadioGroup3.ItemIndex := 0;
    WebRadioGroup3.Items.BeginUpdate;
    try
      WebRadioGroup3.Items.Clear;
      WebRadioGroup3.Items.Add('Contract Loads Setup');
      WebRadioGroup3.Items.Add('Contrasct Price Setup');
    finally
      WebRadioGroup3.Items.EndUpdate;
    end;
    WebRadioGroup3.Role := '';
    WebRadioGroup3.TabOrder := 2;
    WebButton19.SetParentComponent(WebPanel18);
    WebButton19.Name := 'WebButton19';
    WebButton19.Left := 568;
    WebButton19.Top := 25;
    WebButton19.Width := 96;
    WebButton19.Height := 25;
    WebButton19.Caption := 'Setup Import';
    WebButton19.Color := clSkyBlue;
    WebButton19.ChildOrder := 3;
    WebButton19.HeightPercent := 100.000000000000000000;
    WebButton19.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton19, Self, 'OnClick', 'WebButton19Click');
    WebButton28.SetParentComponent(WebPanel18);
    WebButton28.Name := 'WebButton28';
    WebButton28.Left := 278;
    WebButton28.Top := 29;
    WebButton28.Width := 96;
    WebButton28.Height := 25;
    WebButton28.Caption := 'Search';
    WebButton28.Color := clSkyBlue;
    WebButton28.ChildOrder := 4;
    WebButton28.HeightPercent := 100.000000000000000000;
    WebButton28.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton28, Self, 'OnClick', 'WebButton28Click');
    WebPanel19.SetParentComponent(WebPanel6);
    WebPanel19.Name := 'WebPanel19';
    WebPanel19.Left := 0;
    WebPanel19.Top := 70;
    WebPanel19.Width := 1137;
    WebPanel19.Height := 427;
    WebPanel19.Align := alClient;
    WebPanel19.ChildOrder := 1;
    WebPanel19.TabOrder := 1;
    dgContractImportsetup.SetParentComponent(WebPanel19);
    dgContractImportsetup.Name := 'dgContractImportsetup';
    dgContractImportsetup.Left := 0;
    dgContractImportsetup.Top := 0;
    dgContractImportsetup.Width := 1137;
    dgContractImportsetup.Height := 427;
    dgContractImportsetup.Align := alClient;
    dgContractImportsetup.ParentDoubleBuffered := False;
    dgContractImportsetup.DoubleBuffered := True;
    dgContractImportsetup.TabOrder := 0;
    dgContractImportsetup.ShowAcceleratorChar := False;
    dgContractImportsetup.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgContractImportsetup.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgContractImportsetup.Header.VisualGrouping.Layout.Font.Height := -12;
    dgContractImportsetup.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgContractImportsetup.Header.VisualGrouping.Layout.Font.Style := [];
    dgContractImportsetup.Adapter := dgdbaContractImportSetup;
    dgContractImportsetup.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractImportsetup.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgContractImportsetup.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgContractImportsetup.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgContractImportsetup.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgContractImportsetup.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractImportsetup.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgContractImportsetup.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgContractImportsetup.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgContractImportsetup.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgContractImportsetup.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractImportsetup.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgContractImportsetup.CellAppearance.BandLayout.Font.Height := -12;
    dgContractImportsetup.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgContractImportsetup.CellAppearance.BandLayout.Font.Style := [];
    dgContractImportsetup.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractImportsetup.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgContractImportsetup.CellAppearance.FixedLayout.Font.Height := -12;
    dgContractImportsetup.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgContractImportsetup.CellAppearance.FixedLayout.Font.Style := [];
    dgContractImportsetup.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractImportsetup.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgContractImportsetup.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgContractImportsetup.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgContractImportsetup.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgContractImportsetup.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractImportsetup.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgContractImportsetup.CellAppearance.FocusedLayout.Font.Height := -12;
    dgContractImportsetup.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgContractImportsetup.CellAppearance.FocusedLayout.Font.Style := [];
    dgContractImportsetup.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractImportsetup.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgContractImportsetup.CellAppearance.GroupLayout.Font.Height := -12;
    dgContractImportsetup.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgContractImportsetup.CellAppearance.GroupLayout.Font.Style := [];
    dgContractImportsetup.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractImportsetup.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgContractImportsetup.CellAppearance.NormalLayout.Font.Height := -12;
    dgContractImportsetup.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgContractImportsetup.CellAppearance.NormalLayout.Font.Style := [];
    dgContractImportsetup.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractImportsetup.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgContractImportsetup.CellAppearance.SelectedLayout.Font.Height := -12;
    dgContractImportsetup.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgContractImportsetup.CellAppearance.SelectedLayout.Font.Style := [];
    dgContractImportsetup.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgContractImportsetup.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgContractImportsetup.CellAppearance.SummaryLayout.Font.Height := -12;
    dgContractImportsetup.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgContractImportsetup.CellAppearance.SummaryLayout.Font.Style := [];
    dgContractImportsetup.ColumnCount := 90;
    dgContractImportsetup.Columns.Clear;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Contract No';
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Contract Name';
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Contract Desc';
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Width := 0.000000000000000000;
    end;
    with dgContractImportsetup.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Name := 'Edit';
    end;
    dgContractImportsetup.Designer := False;
    dgContractImportsetup.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgContractImportsetup.FilterAppearance.Font.Color := clWindowText;
    dgContractImportsetup.FilterAppearance.Font.Height := -12;
    dgContractImportsetup.FilterAppearance.Font.Name := 'Segoe UI';
    dgContractImportsetup.FilterAppearance.Font.Style := [];
    dgContractImportsetup.Icons.ExpandIcon.LoadFromFile('Contracts.WebPanel19.dgContractImportsetup.Icons.ExpandIcon.svg');
    dgContractImportsetup.Icons.CollapseIcon.LoadFromFile('Contracts.WebPanel19.dgContractImportsetup.Icons.CollapseIcon.svg');
    dgContractImportsetup.Icons.FilterIcon.LoadFromFile('Contracts.WebPanel19.dgContractImportsetup.Icons.FilterIcon.svg');
    dgContractImportsetup.Icons.FilterActiveIcon.LoadFromFile('Contracts.WebPanel19.dgContractImportsetup.Icons.FilterActiveIcon.svg');
    dgContractImportsetup.Icons.FilterClearIcon.LoadFromFile('Contracts.WebPanel19.dgContractImportsetup.Icons.FilterClearIcon.svg');
    dgContractImportsetup.Icons.FilterTypeIcon.LoadFromFile('Contracts.WebPanel19.dgContractImportsetup.Icons.FilterTypeIcon.svg');
    dgContractImportsetup.Icons.SortAscendingIcon.LoadFromFile('Contracts.WebPanel19.dgContractImportsetup.Icons.SortAscendingIcon.svg');
    dgContractImportsetup.Icons.SortDescendingIcon.LoadFromFile('Contracts.WebPanel19.dgContractImportsetup.Icons.SortDescendingIcon.svg');
    dgContractImportsetup.Icons.CloseIcon.LoadFromFile('Contracts.WebPanel19.dgContractImportsetup.Icons.CloseIcon.svg');
    SetEvent(dgContractImportsetup, Self, 'OnCellClick', 'dgContractImportsetupCellClick');
    SetEvent(dgContractImportsetup, Self, 'OnSelectCell', 'dgContractImportsetupSelectCell');
    dgContractImportsetup.RowCount := 1;
    dgdbaContractImportSetup.SetParentComponent(dgContractImportsetup);
    dgdbaContractImportSetup.Name := 'dgdbaContractImportSetup';
    dgdbaContractImportSetup.Left := 213;
    dgdbaContractImportSetup.Top := 65;
    dgdbaContractImportSetup.Width := 26;
    dgdbaContractImportSetup.Height := 26;
    dgdbaContractImportSetup.Visible := True;
    dgdbaContractImportSetup.Columns.Clear;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'CONTRACTNO';
      Header := 'Contract No';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'CONTRACTNAME';
      Header := 'Contract Name';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'DEBCODE';
      Header := 'Contract Description';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'COMMODITIESNO';
      Header := 'Comodity';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'LOADCOUNTRYNO';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'LOADPROVINCENO';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'LOADCITYNO';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'LOADINGNO';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'OFFLOADCOUNTRYNO';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'OFFLOADPROVINCENO';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'OFFLOADCITYNO';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'OFFLOADINGNO';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'INVLOADING';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'INVOFFLOADING';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'TOTALTONS';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'TOTALTONSORDER';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'TOTALTONSLOADED';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'TOTALTONSOFFLOADED';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'TOTALTONSINVOICED';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'STARTDATE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'COMPLETED';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'COMPDATE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'CONTROLLER';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'AVGTONS';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'TOTALLOADS';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'LOADSORDER';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'LOADSLOADED';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'LOADSOFFLOADED';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'LOADSINVOICED';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'PAYMENTTERMS';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'PAYMENTTYPE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'ADDHOC';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'DEDICATED';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'ORDERNO';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'INVVAT';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'MULTILOADINV';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SENDED';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SENDEDDATE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'PRELISTING';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'POSTLISTING';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'INVOICETYPE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'DISTANCE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'DRIVERRATIO';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'CUTOFF1';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'CUTOFFPERIOD1';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'CUTOFF2';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'CUTOFFPERIOD2';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SAGEINVENTORY';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SAGEGL';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SAGECODE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SAGEEXPCODE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'STRATERATE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'CHGOFFLOAD';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'CHGPRICE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'CAPTURETONS';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'INVOICETONS';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'CHGSUBPRICE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'MAXLOADORDERS';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'ADDDESCRIPTION';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'VARIANCETYPE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'VARIANCEVALUE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'PRINTLC';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'PRINTDN';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'PRINTTS';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'DNTYPE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'TSTYPE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SHORTDESC';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'OLDLOADSCREEN';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SHOWBOOKINGS';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SHOWADDITIONAL';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'PRICETYPE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'USEDOCKETINVNO';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SAGECODE2';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SAGEEXPCODE2';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SAGEINVENTORY2';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SAGEGL2';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'HAULAGETYPE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'LINKZEROML';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'ATTACHEDEMAIL';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'CLIENTLINKCONTRACT';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'QUOTEREFNO';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SORTLOADDATE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SORTOFFDATE';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SORTLOADWAY';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SORTOFFWAY';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SORTDOCKET';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'SINVVAT';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      FieldName := 'LOADINSTRUCTQTY';
      AutoCreated := False;
    end;
    with dgdbaContractImportSetup.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    dgdbaContractImportSetup.DataSource := dsAContractImportSetup;
    wpcsGlobalPriceIncrease.SetParentComponent(wpcContractInfo);
    wpcsGlobalPriceIncrease.Name := 'wpcsGlobalPriceIncrease';
    wpcsGlobalPriceIncrease.Left := 0;
    wpcsGlobalPriceIncrease.Top := 20;
    wpcsGlobalPriceIncrease.Width := 1137;
    wpcsGlobalPriceIncrease.Height := 497;
    wpcsGlobalPriceIncrease.Caption := 'Global Price Increase';
    wpcsGlobalPriceIncrease.ChildOrder := 3;
    WebPanel7.SetParentComponent(wpcsGlobalPriceIncrease);
    WebPanel7.Name := 'WebPanel7';
    WebPanel7.Left := 0;
    WebPanel7.Top := 0;
    WebPanel7.Width := 1137;
    WebPanel7.Height := 497;
    WebPanel7.Align := alClient;
    WebPanel7.TabOrder := 0;
    WebPanel21.SetParentComponent(WebPanel7);
    WebPanel21.Name := 'WebPanel21';
    WebPanel21.Left := 0;
    WebPanel21.Top := 0;
    WebPanel21.Width := 1137;
    WebPanel21.Height := 198;
    WebPanel21.Align := alTop;
    WebPanel21.TabOrder := 0;
    WebGroupBox11.SetParentComponent(WebPanel21);
    WebGroupBox11.Name := 'WebGroupBox11';
    WebGroupBox11.Left := 0;
    WebGroupBox11.Top := 65;
    WebGroupBox11.Width := 1137;
    WebGroupBox11.Height := 60;
    WebGroupBox11.Align := alTop;
    WebGroupBox11.BorderColor := clSilver;
    WebGroupBox11.Caption := 'Client Selection';
    WebGroupBox11.ChildOrder := 1;
    WebDBEdit65.SetParentComponent(WebGroupBox11);
    WebDBEdit65.Name := 'WebDBEdit65';
    WebDBEdit65.Left := 184;
    WebDBEdit65.Top := 24;
    WebDBEdit65.Width := 279;
    WebDBEdit65.Height := 22;
    WebDBEdit65.HeightPercent := 100.000000000000000000;
    WebDBEdit65.Text := 'WebDBEdit65';
    WebDBEdit65.WidthPercent := 100.000000000000000000;
    WebButton42.SetParentComponent(WebGroupBox11);
    WebButton42.Name := 'WebButton42';
    WebButton42.Left := 476;
    WebButton42.Top := 24;
    WebButton42.Width := 25;
    WebButton42.Height := 25;
    WebButton42.Caption := '...';
    WebButton42.ChildOrder := 1;
    WebButton42.HeightPercent := 100.000000000000000000;
    WebButton42.WidthPercent := 100.000000000000000000;
    WebGroupBox12.SetParentComponent(WebPanel21);
    WebGroupBox12.Name := 'WebGroupBox12';
    WebGroupBox12.Left := 0;
    WebGroupBox12.Top := 125;
    WebGroupBox12.Width := 1137;
    WebGroupBox12.Height := 64;
    WebGroupBox12.Align := alTop;
    WebGroupBox12.BorderColor := clSilver;
    WebGroupBox12.Caption := 'Group/Category';
    WebGroupBox12.ChildOrder := 2;
    WebRadioGroup1.SetParentComponent(WebPanel21);
    WebRadioGroup1.Name := 'WebRadioGroup1';
    WebRadioGroup1.Left := 0;
    WebRadioGroup1.Top := 0;
    WebRadioGroup1.Width := 1137;
    WebRadioGroup1.Height := 65;
    WebRadioGroup1.Align := alTop;
    WebRadioGroup1.Caption := 'Selection';
    WebRadioGroup1.ChildOrder := 2;
    WebRadioGroup1.Columns := 3;
    WebRadioGroup1.ItemIndex := 0;
    WebRadioGroup1.Items.BeginUpdate;
    try
      WebRadioGroup1.Items.Clear;
      WebRadioGroup1.Items.Add('All');
      WebRadioGroup1.Items.Add('Client Selection');
      WebRadioGroup1.Items.Add('Group/Chategory');
    finally
      WebRadioGroup1.Items.EndUpdate;
    end;
    WebRadioGroup1.Role := '';
    WebRadioGroup1.TabOrder := 2;
    WebPanel22.SetParentComponent(WebPanel7);
    WebPanel22.Name := 'WebPanel22';
    WebPanel22.Left := 0;
    WebPanel22.Top := 198;
    WebPanel22.Width := 1137;
    WebPanel22.Height := 60;
    WebPanel22.Align := alTop;
    WebPanel22.ChildOrder := 1;
    WebPanel22.Color := clSilver;
    WebPanel22.TabOrder := 1;
    WebRadioGroup2.SetParentComponent(WebPanel22);
    WebRadioGroup2.Name := 'WebRadioGroup2';
    WebRadioGroup2.Left := 3;
    WebRadioGroup2.Top := 4;
    WebRadioGroup2.Width := 304;
    WebRadioGroup2.Height := 53;
    WebRadioGroup2.Caption := 'Increase/Decrease Selection';
    WebRadioGroup2.Columns := 2;
    WebRadioGroup2.ItemIndex := 0;
    WebRadioGroup2.Items.BeginUpdate;
    try
      WebRadioGroup2.Items.Clear;
      WebRadioGroup2.Items.Add('Percentage');
      WebRadioGroup2.Items.Add('Value');
    finally
      WebRadioGroup2.Items.EndUpdate;
    end;
    WebRadioGroup2.Role := '';
    WebRadioGroup2.TabOrder := 0;
    WebPanel23.SetParentComponent(WebPanel7);
    WebPanel23.Name := 'WebPanel23';
    WebPanel23.Left := 0;
    WebPanel23.Top := 258;
    WebPanel23.Width := 1137;
    WebPanel23.Height := 66;
    WebPanel23.Align := alTop;
    WebPanel23.ChildOrder := 2;
    WebPanel23.Color := clSilver;
    WebPanel23.TabOrder := 2;
    WebButton43.SetParentComponent(WebPanel23);
    WebButton43.Name := 'WebButton43';
    WebButton43.Left := 24;
    WebButton43.Top := 16;
    WebButton43.Width := 96;
    WebButton43.Height := 25;
    WebButton43.Caption := 'Search';
    WebButton43.HeightPercent := 100.000000000000000000;
    WebButton43.WidthPercent := 100.000000000000000000;
    WebButton44.SetParentComponent(WebPanel23);
    WebButton44.Name := 'WebButton44';
    WebButton44.Left := 144;
    WebButton44.Top := 16;
    WebButton44.Width := 96;
    WebButton44.Height := 25;
    WebButton44.Caption := 'Select All';
    WebButton44.ChildOrder := 1;
    WebButton44.HeightPercent := 100.000000000000000000;
    WebButton44.WidthPercent := 100.000000000000000000;
    WebButton45.SetParentComponent(WebPanel23);
    WebButton45.Name := 'WebButton45';
    WebButton45.Left := 272;
    WebButton45.Top := 16;
    WebButton45.Width := 96;
    WebButton45.Height := 25;
    WebButton45.Caption := 'Un-Select All';
    WebButton45.ChildOrder := 2;
    WebButton45.HeightPercent := 100.000000000000000000;
    WebButton45.WidthPercent := 100.000000000000000000;
    WebButton46.SetParentComponent(WebPanel23);
    WebButton46.Name := 'WebButton46';
    WebButton46.Left := 400;
    WebButton46.Top := 16;
    WebButton46.Width := 96;
    WebButton46.Height := 25;
    WebButton46.Caption := 'Calculate';
    WebButton46.ChildOrder := 3;
    WebButton46.HeightPercent := 100.000000000000000000;
    WebButton46.WidthPercent := 100.000000000000000000;
    WebButton47.SetParentComponent(WebPanel23);
    WebButton47.Name := 'WebButton47';
    WebButton47.Left := 720;
    WebButton47.Top := 24;
    WebButton47.Width := 171;
    WebButton47.Height := 25;
    WebButton47.Caption := 'Update Contract Price';
    WebButton47.ChildOrder := 4;
    WebButton47.HeightPercent := 100.000000000000000000;
    WebButton47.WidthPercent := 100.000000000000000000;
    WebDateTimePicker1.SetParentComponent(WebPanel23);
    WebDateTimePicker1.Name := 'WebDateTimePicker1';
    WebDateTimePicker1.Left := 529;
    WebDateTimePicker1.Top := 27;
    WebDateTimePicker1.Width := 170;
    WebDateTimePicker1.Height := 22;
    WebDateTimePicker1.BorderStyle := bsSingle;
    WebDateTimePicker1.ChildOrder := 5;
    WebDateTimePicker1.Color := clWhite;
    WebDateTimePicker1.Date := 45932.453456053240000000;
    WebDateTimePicker1.Role := '';
    WebDateTimePicker1.Text := '';
    TMSFNCDataGrid4.SetParentComponent(WebPanel7);
    TMSFNCDataGrid4.Name := 'TMSFNCDataGrid4';
    TMSFNCDataGrid4.Left := 0;
    TMSFNCDataGrid4.Top := 324;
    TMSFNCDataGrid4.Width := 1137;
    TMSFNCDataGrid4.Height := 111;
    TMSFNCDataGrid4.Align := alTop;
    TMSFNCDataGrid4.ParentDoubleBuffered := False;
    TMSFNCDataGrid4.DoubleBuffered := True;
    TMSFNCDataGrid4.TabOrder := 3;
    TMSFNCDataGrid4.ShowAcceleratorChar := False;
    TMSFNCDataGrid4.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid4.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid4.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid4.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid4.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid4.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid4.Columns.Clear;
    with TMSFNCDataGrid4.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'ID';
      Width := 70.000000000000000000;
    end;
    with TMSFNCDataGrid4.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
      Width := 250.000000000000000000;
    end;
    with TMSFNCDataGrid4.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Joined';
      Width := 100.000000000000000000;
    end;
    with TMSFNCDataGrid4.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Status';
      Width := 100.000000000000000000;
    end;
    TMSFNCDataGrid4.Designer := False;
    TMSFNCDataGrid4.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid4.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid4.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid4.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid4.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid4.Icons.ExpandIcon.LoadFromFile('Contracts.WebPanel7.TMSFNCDataGrid4.Icons.ExpandIcon.svg');
    TMSFNCDataGrid4.Icons.CollapseIcon.LoadFromFile('Contracts.WebPanel7.TMSFNCDataGrid4.Icons.CollapseIcon.svg');
    TMSFNCDataGrid4.Icons.FilterIcon.LoadFromFile('Contracts.WebPanel7.TMSFNCDataGrid4.Icons.FilterIcon.svg');
    TMSFNCDataGrid4.Icons.FilterActiveIcon.LoadFromFile('Contracts.WebPanel7.TMSFNCDataGrid4.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid4.Icons.FilterClearIcon.LoadFromFile('Contracts.WebPanel7.TMSFNCDataGrid4.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid4.Icons.FilterTypeIcon.LoadFromFile('Contracts.WebPanel7.TMSFNCDataGrid4.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid4.Icons.SortAscendingIcon.LoadFromFile('Contracts.WebPanel7.TMSFNCDataGrid4.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid4.Icons.SortDescendingIcon.LoadFromFile('Contracts.WebPanel7.TMSFNCDataGrid4.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid4.Icons.CloseIcon.LoadFromFile('Contracts.WebPanel7.TMSFNCDataGrid4.Icons.CloseIcon.svg');
    WebPanel24.SetParentComponent(WebPanel7);
    WebPanel24.Name := 'WebPanel24';
    WebPanel24.Left := 0;
    WebPanel24.Top := 435;
    WebPanel24.Width := 1137;
    WebPanel24.Height := 62;
    WebPanel24.Align := alClient;
    WebPanel24.ChildOrder := 4;
    WebPanel24.TabOrder := 4;
    WebLabel54.SetParentComponent(WebPanel24);
    WebLabel54.Name := 'WebLabel54';
    WebLabel54.Left := 13;
    WebLabel54.Top := 8;
    WebLabel54.Width := 51;
    WebLabel54.Height := 15;
    WebLabel54.Caption := 'Last Cost:';
    WebLabel54.HeightPercent := 100.000000000000000000;
    WebLabel54.WidthPercent := 100.000000000000000000;
    WebLabel56.SetParentComponent(WebPanel24);
    WebLabel56.Name := 'WebLabel56';
    WebLabel56.Left := 135;
    WebLabel56.Top := 8;
    WebLabel56.Width := 48;
    WebLabel56.Height := 15;
    WebLabel56.Caption := 'Last STD:';
    WebLabel56.HeightPercent := 100.000000000000000000;
    WebLabel56.WidthPercent := 100.000000000000000000;
    WebLabel58.SetParentComponent(WebPanel24);
    WebLabel58.Name := 'WebLabel58';
    WebLabel58.Left := 263;
    WebLabel58.Top := 8;
    WebLabel58.Width := 48;
    WebLabel58.Height := 15;
    WebLabel58.Caption := 'Last Ded:';
    WebLabel58.HeightPercent := 100.000000000000000000;
    WebLabel58.WidthPercent := 100.000000000000000000;
    WebLabel60.SetParentComponent(WebPanel24);
    WebLabel60.Name := 'WebLabel60';
    WebLabel60.Left := 400;
    WebLabel60.Top := 8;
    WebLabel60.Width := 64;
    WebLabel60.Height := 15;
    WebLabel60.Caption := 'Last Special:';
    WebLabel60.HeightPercent := 100.000000000000000000;
    WebLabel60.WidthPercent := 100.000000000000000000;
    WebLabel62.SetParentComponent(WebPanel24);
    WebLabel62.Name := 'WebLabel62';
    WebLabel62.Left := 528;
    WebLabel62.Top := 8;
    WebLabel62.Width := 54;
    WebLabel62.Height := 15;
    WebLabel62.Caption := 'New Cost:';
    WebLabel62.HeightPercent := 100.000000000000000000;
    WebLabel62.WidthPercent := 100.000000000000000000;
    WebLabel64.SetParentComponent(WebPanel24);
    WebLabel64.Name := 'WebLabel64';
    WebLabel64.Left := 655;
    WebLabel64.Top := 8;
    WebLabel64.Width := 51;
    WebLabel64.Height := 15;
    WebLabel64.Caption := 'New STD:';
    WebLabel64.HeightPercent := 100.000000000000000000;
    WebLabel64.WidthPercent := 100.000000000000000000;
    WebLabel66.SetParentComponent(WebPanel24);
    WebLabel66.Name := 'WebLabel66';
    WebLabel66.Left := 782;
    WebLabel66.Top := 8;
    WebLabel66.Width := 51;
    WebLabel66.Height := 15;
    WebLabel66.Caption := 'New Ded:';
    WebLabel66.HeightPercent := 100.000000000000000000;
    WebLabel66.WidthPercent := 100.000000000000000000;
    WebLabel68.SetParentComponent(WebPanel24);
    WebLabel68.Name := 'WebLabel68';
    WebLabel68.Left := 904;
    WebLabel68.Top := 8;
    WebLabel68.Width := 67;
    WebLabel68.Height := 15;
    WebLabel68.Caption := 'New Special:';
    WebLabel68.HeightPercent := 100.000000000000000000;
    WebLabel68.WidthPercent := 100.000000000000000000;
    WebDBLabel4.SetParentComponent(WebPanel24);
    WebDBLabel4.Name := 'WebDBLabel4';
    WebDBLabel4.Left := 13;
    WebDBLabel4.Top := 34;
    WebDBLabel4.Width := 73;
    WebDBLabel4.Height := 15;
    WebDBLabel4.Caption := 'WebDBLabel4';
    WebDBLabel4.HeightPercent := 100.000000000000000000;
    WebDBLabel4.WidthPercent := 100.000000000000000000;
    WebDBLabel5.SetParentComponent(WebPanel24);
    WebDBLabel5.Name := 'WebDBLabel5';
    WebDBLabel5.Left := 135;
    WebDBLabel5.Top := 34;
    WebDBLabel5.Width := 73;
    WebDBLabel5.Height := 15;
    WebDBLabel5.Caption := 'WebDBLabel5';
    WebDBLabel5.HeightPercent := 100.000000000000000000;
    WebDBLabel5.WidthPercent := 100.000000000000000000;
    WebDBLabel6.SetParentComponent(WebPanel24);
    WebDBLabel6.Name := 'WebDBLabel6';
    WebDBLabel6.Left := 264;
    WebDBLabel6.Top := 32;
    WebDBLabel6.Width := 73;
    WebDBLabel6.Height := 15;
    WebDBLabel6.Caption := 'WebDBLabel6';
    WebDBLabel6.HeightPercent := 100.000000000000000000;
    WebDBLabel6.WidthPercent := 100.000000000000000000;
    WebDBLabel7.SetParentComponent(WebPanel24);
    WebDBLabel7.Name := 'WebDBLabel7';
    WebDBLabel7.Left := 400;
    WebDBLabel7.Top := 34;
    WebDBLabel7.Width := 73;
    WebDBLabel7.Height := 15;
    WebDBLabel7.Caption := 'WebDBLabel7';
    WebDBLabel7.HeightPercent := 100.000000000000000000;
    WebDBLabel7.WidthPercent := 100.000000000000000000;
    WebDBLabel8.SetParentComponent(WebPanel24);
    WebDBLabel8.Name := 'WebDBLabel8';
    WebDBLabel8.Left := 528;
    WebDBLabel8.Top := 34;
    WebDBLabel8.Width := 73;
    WebDBLabel8.Height := 15;
    WebDBLabel8.Caption := 'WebDBLabel8';
    WebDBLabel8.HeightPercent := 100.000000000000000000;
    WebDBLabel8.WidthPercent := 100.000000000000000000;
    WebDBLabel9.SetParentComponent(WebPanel24);
    WebDBLabel9.Name := 'WebDBLabel9';
    WebDBLabel9.Left := 657;
    WebDBLabel9.Top := 34;
    WebDBLabel9.Width := 73;
    WebDBLabel9.Height := 15;
    WebDBLabel9.Caption := 'WebDBLabel9';
    WebDBLabel9.HeightPercent := 100.000000000000000000;
    WebDBLabel9.WidthPercent := 100.000000000000000000;
    WebDBLabel10.SetParentComponent(WebPanel24);
    WebDBLabel10.Name := 'WebDBLabel10';
    WebDBLabel10.Left := 782;
    WebDBLabel10.Top := 34;
    WebDBLabel10.Width := 79;
    WebDBLabel10.Height := 15;
    WebDBLabel10.Caption := 'WebDBLabel10';
    WebDBLabel10.HeightPercent := 100.000000000000000000;
    WebDBLabel10.WidthPercent := 100.000000000000000000;
    WebDBLabel11.SetParentComponent(WebPanel24);
    WebDBLabel11.Name := 'WebDBLabel11';
    WebDBLabel11.Left := 904;
    WebDBLabel11.Top := 34;
    WebDBLabel11.Width := 79;
    WebDBLabel11.Height := 15;
    WebDBLabel11.Caption := 'WebDBLabel11';
    WebDBLabel11.HeightPercent := 100.000000000000000000;
    WebDBLabel11.WidthPercent := 100.000000000000000000;
    wcAContracts.SetParentComponent(Self);
    wcAContracts.Name := 'wcAContracts';
    wcAContracts.Connection := dmData.dbConnect;
    wcAContracts.Left := 32;
    wcAContracts.Top := 124;
    wdsAContracts.SetParentComponent(Self);
    wdsAContracts.Name := 'wdsAContracts';
    wdsAContracts.Connection := dmData.dbConnect;
    wdsAContracts.Left := 80;
    wdsAContracts.Top := 124;
    wdsAContractsCONTRACTNO.SetParentComponent(wdsAContracts);
    wdsAContractsCONTRACTNO.Name := 'wdsAContractsCONTRACTNO';
    wdsAContractsCONTRACTNO.FieldName := 'CONTRACTNO';
    wdsAContractsCONTRACTNAME.SetParentComponent(wdsAContracts);
    wdsAContractsCONTRACTNAME.Name := 'wdsAContractsCONTRACTNAME';
    wdsAContractsCONTRACTNAME.FieldName := 'CONTRACTNAME';
    wdsAContractsDEBCODE.SetParentComponent(wdsAContracts);
    wdsAContractsDEBCODE.Name := 'wdsAContractsDEBCODE';
    wdsAContractsDEBCODE.FieldName := 'DEBCODE';
    wdsAContractsCOMMODITIESNO.SetParentComponent(wdsAContracts);
    wdsAContractsCOMMODITIESNO.Name := 'wdsAContractsCOMMODITIESNO';
    wdsAContractsCOMMODITIESNO.FieldName := 'COMMODITIESNO';
    wdsAContractsLOADCOUNTRYNO.SetParentComponent(wdsAContracts);
    wdsAContractsLOADCOUNTRYNO.Name := 'wdsAContractsLOADCOUNTRYNO';
    wdsAContractsLOADCOUNTRYNO.FieldName := 'LOADCOUNTRYNO';
    wdsAContractsLOADPROVINCENO.SetParentComponent(wdsAContracts);
    wdsAContractsLOADPROVINCENO.Name := 'wdsAContractsLOADPROVINCENO';
    wdsAContractsLOADPROVINCENO.FieldName := 'LOADPROVINCENO';
    wdsAContractsLOADCITYNO.SetParentComponent(wdsAContracts);
    wdsAContractsLOADCITYNO.Name := 'wdsAContractsLOADCITYNO';
    wdsAContractsLOADCITYNO.FieldName := 'LOADCITYNO';
    wdsAContractsLOADINGNO.SetParentComponent(wdsAContracts);
    wdsAContractsLOADINGNO.Name := 'wdsAContractsLOADINGNO';
    wdsAContractsLOADINGNO.FieldName := 'LOADINGNO';
    wdsAContractsOFFLOADCOUNTRYNO.SetParentComponent(wdsAContracts);
    wdsAContractsOFFLOADCOUNTRYNO.Name := 'wdsAContractsOFFLOADCOUNTRYNO';
    wdsAContractsOFFLOADCOUNTRYNO.FieldName := 'OFFLOADCOUNTRYNO';
    wdsAContractsOFFLOADPROVINCENO.SetParentComponent(wdsAContracts);
    wdsAContractsOFFLOADPROVINCENO.Name := 'wdsAContractsOFFLOADPROVINCENO';
    wdsAContractsOFFLOADPROVINCENO.FieldName := 'OFFLOADPROVINCENO';
    wdsAContractsOFFLOADCITYNO.SetParentComponent(wdsAContracts);
    wdsAContractsOFFLOADCITYNO.Name := 'wdsAContractsOFFLOADCITYNO';
    wdsAContractsOFFLOADCITYNO.FieldName := 'OFFLOADCITYNO';
    wdsAContractsOFFLOADINGNO.SetParentComponent(wdsAContracts);
    wdsAContractsOFFLOADINGNO.Name := 'wdsAContractsOFFLOADINGNO';
    wdsAContractsOFFLOADINGNO.FieldName := 'OFFLOADINGNO';
    wdsAContractsINVLOADING.SetParentComponent(wdsAContracts);
    wdsAContractsINVLOADING.Name := 'wdsAContractsINVLOADING';
    wdsAContractsINVLOADING.FieldName := 'INVLOADING';
    wdsAContractsINVOFFLOADING.SetParentComponent(wdsAContracts);
    wdsAContractsINVOFFLOADING.Name := 'wdsAContractsINVOFFLOADING';
    wdsAContractsINVOFFLOADING.FieldName := 'INVOFFLOADING';
    wdsAContractsTOTALTONS.SetParentComponent(wdsAContracts);
    wdsAContractsTOTALTONS.Name := 'wdsAContractsTOTALTONS';
    wdsAContractsTOTALTONS.FieldName := 'TOTALTONS';
    wdsAContractsTOTALTONSORDER.SetParentComponent(wdsAContracts);
    wdsAContractsTOTALTONSORDER.Name := 'wdsAContractsTOTALTONSORDER';
    wdsAContractsTOTALTONSORDER.FieldName := 'TOTALTONSORDER';
    wdsAContractsTOTALTONSLOADED.SetParentComponent(wdsAContracts);
    wdsAContractsTOTALTONSLOADED.Name := 'wdsAContractsTOTALTONSLOADED';
    wdsAContractsTOTALTONSLOADED.FieldName := 'TOTALTONSLOADED';
    wdsAContractsTOTALTONSOFFLOADED.SetParentComponent(wdsAContracts);
    wdsAContractsTOTALTONSOFFLOADED.Name := 'wdsAContractsTOTALTONSOFFLOADED';
    wdsAContractsTOTALTONSOFFLOADED.FieldName := 'TOTALTONSOFFLOADED';
    wdsAContractsTOTALTONSINVOICED.SetParentComponent(wdsAContracts);
    wdsAContractsTOTALTONSINVOICED.Name := 'wdsAContractsTOTALTONSINVOICED';
    wdsAContractsTOTALTONSINVOICED.FieldName := 'TOTALTONSINVOICED';
    wdsAContractsCOMPLETED.SetParentComponent(wdsAContracts);
    wdsAContractsCOMPLETED.Name := 'wdsAContractsCOMPLETED';
    wdsAContractsCOMPLETED.FieldName := 'COMPLETED';
    wdsAContractsCONTROLLER.SetParentComponent(wdsAContracts);
    wdsAContractsCONTROLLER.Name := 'wdsAContractsCONTROLLER';
    wdsAContractsCONTROLLER.FieldName := 'CONTROLLER';
    wdsAContractsCONTROLLER.Size := 0;
    wdsAContractsAVGTONS.SetParentComponent(wdsAContracts);
    wdsAContractsAVGTONS.Name := 'wdsAContractsAVGTONS';
    wdsAContractsAVGTONS.FieldName := 'AVGTONS';
    wdsAContractsTOTALLOADS.SetParentComponent(wdsAContracts);
    wdsAContractsTOTALLOADS.Name := 'wdsAContractsTOTALLOADS';
    wdsAContractsTOTALLOADS.FieldName := 'TOTALLOADS';
    wdsAContractsLOADSORDER.SetParentComponent(wdsAContracts);
    wdsAContractsLOADSORDER.Name := 'wdsAContractsLOADSORDER';
    wdsAContractsLOADSORDER.FieldName := 'LOADSORDER';
    wdsAContractsLOADSLOADED.SetParentComponent(wdsAContracts);
    wdsAContractsLOADSLOADED.Name := 'wdsAContractsLOADSLOADED';
    wdsAContractsLOADSLOADED.FieldName := 'LOADSLOADED';
    wdsAContractsLOADSOFFLOADED.SetParentComponent(wdsAContracts);
    wdsAContractsLOADSOFFLOADED.Name := 'wdsAContractsLOADSOFFLOADED';
    wdsAContractsLOADSOFFLOADED.FieldName := 'LOADSOFFLOADED';
    wdsAContractsLOADSINVOICED.SetParentComponent(wdsAContracts);
    wdsAContractsLOADSINVOICED.Name := 'wdsAContractsLOADSINVOICED';
    wdsAContractsLOADSINVOICED.FieldName := 'LOADSINVOICED';
    wdsAContractsPAYMENTTERMS.SetParentComponent(wdsAContracts);
    wdsAContractsPAYMENTTERMS.Name := 'wdsAContractsPAYMENTTERMS';
    wdsAContractsPAYMENTTERMS.FieldName := 'PAYMENTTERMS';
    wdsAContractsPAYMENTTYPE.SetParentComponent(wdsAContracts);
    wdsAContractsPAYMENTTYPE.Name := 'wdsAContractsPAYMENTTYPE';
    wdsAContractsPAYMENTTYPE.FieldName := 'PAYMENTTYPE';
    wdsAContractsADDHOC.SetParentComponent(wdsAContracts);
    wdsAContractsADDHOC.Name := 'wdsAContractsADDHOC';
    wdsAContractsADDHOC.FieldName := 'ADDHOC';
    wdsAContractsDEDICATED.SetParentComponent(wdsAContracts);
    wdsAContractsDEDICATED.Name := 'wdsAContractsDEDICATED';
    wdsAContractsDEDICATED.FieldName := 'DEDICATED';
    wdsAContractsORDERNO.SetParentComponent(wdsAContracts);
    wdsAContractsORDERNO.Name := 'wdsAContractsORDERNO';
    wdsAContractsORDERNO.FieldName := 'ORDERNO';
    wdsAContractsINVVAT.SetParentComponent(wdsAContracts);
    wdsAContractsINVVAT.Name := 'wdsAContractsINVVAT';
    wdsAContractsINVVAT.FieldName := 'INVVAT';
    wdsAContractsMULTILOADINV.SetParentComponent(wdsAContracts);
    wdsAContractsMULTILOADINV.Name := 'wdsAContractsMULTILOADINV';
    wdsAContractsMULTILOADINV.FieldName := 'MULTILOADINV';
    wdsAContractsSENDED.SetParentComponent(wdsAContracts);
    wdsAContractsSENDED.Name := 'wdsAContractsSENDED';
    wdsAContractsSENDED.FieldName := 'SENDED';
    wdsAContractsPRELISTING.SetParentComponent(wdsAContracts);
    wdsAContractsPRELISTING.Name := 'wdsAContractsPRELISTING';
    wdsAContractsPRELISTING.FieldName := 'PRELISTING';
    wdsAContractsPOSTLISTING.SetParentComponent(wdsAContracts);
    wdsAContractsPOSTLISTING.Name := 'wdsAContractsPOSTLISTING';
    wdsAContractsPOSTLISTING.FieldName := 'POSTLISTING';
    wdsAContractsINVOICETYPE.SetParentComponent(wdsAContracts);
    wdsAContractsINVOICETYPE.Name := 'wdsAContractsINVOICETYPE';
    wdsAContractsINVOICETYPE.FieldName := 'INVOICETYPE';
    wdsAContractsDISTANCE.SetParentComponent(wdsAContracts);
    wdsAContractsDISTANCE.Name := 'wdsAContractsDISTANCE';
    wdsAContractsDISTANCE.FieldName := 'DISTANCE';
    wdsAContractsDRIVERRATIO.SetParentComponent(wdsAContracts);
    wdsAContractsDRIVERRATIO.Name := 'wdsAContractsDRIVERRATIO';
    wdsAContractsDRIVERRATIO.FieldName := 'DRIVERRATIO';
    wdsAContractsCUTOFF1.SetParentComponent(wdsAContracts);
    wdsAContractsCUTOFF1.Name := 'wdsAContractsCUTOFF1';
    wdsAContractsCUTOFF1.FieldName := 'CUTOFF1';
    wdsAContractsCUTOFFPERIOD1.SetParentComponent(wdsAContracts);
    wdsAContractsCUTOFFPERIOD1.Name := 'wdsAContractsCUTOFFPERIOD1';
    wdsAContractsCUTOFFPERIOD1.FieldName := 'CUTOFFPERIOD1';
    wdsAContractsCUTOFF2.SetParentComponent(wdsAContracts);
    wdsAContractsCUTOFF2.Name := 'wdsAContractsCUTOFF2';
    wdsAContractsCUTOFF2.FieldName := 'CUTOFF2';
    wdsAContractsCUTOFFPERIOD2.SetParentComponent(wdsAContracts);
    wdsAContractsCUTOFFPERIOD2.Name := 'wdsAContractsCUTOFFPERIOD2';
    wdsAContractsCUTOFFPERIOD2.FieldName := 'CUTOFFPERIOD2';
    wdsAContractsSAGEINVENTORY.SetParentComponent(wdsAContracts);
    wdsAContractsSAGEINVENTORY.Name := 'wdsAContractsSAGEINVENTORY';
    wdsAContractsSAGEINVENTORY.FieldName := 'SAGEINVENTORY';
    wdsAContractsSAGEGL.SetParentComponent(wdsAContracts);
    wdsAContractsSAGEGL.Name := 'wdsAContractsSAGEGL';
    wdsAContractsSAGEGL.FieldName := 'SAGEGL';
    wdsAContractsSAGECODE.SetParentComponent(wdsAContracts);
    wdsAContractsSAGECODE.Name := 'wdsAContractsSAGECODE';
    wdsAContractsSAGECODE.FieldName := 'SAGECODE';
    wdsAContractsSAGEEXPCODE.SetParentComponent(wdsAContracts);
    wdsAContractsSAGEEXPCODE.Name := 'wdsAContractsSAGEEXPCODE';
    wdsAContractsSAGEEXPCODE.FieldName := 'SAGEEXPCODE';
    wdsAContractsSTRATERATE.SetParentComponent(wdsAContracts);
    wdsAContractsSTRATERATE.Name := 'wdsAContractsSTRATERATE';
    wdsAContractsSTRATERATE.FieldName := 'STRATERATE';
    wdsAContractsCHGOFFLOAD.SetParentComponent(wdsAContracts);
    wdsAContractsCHGOFFLOAD.Name := 'wdsAContractsCHGOFFLOAD';
    wdsAContractsCHGOFFLOAD.FieldName := 'CHGOFFLOAD';
    wdsAContractsCHGPRICE.SetParentComponent(wdsAContracts);
    wdsAContractsCHGPRICE.Name := 'wdsAContractsCHGPRICE';
    wdsAContractsCHGPRICE.FieldName := 'CHGPRICE';
    wdsAContractsCAPTURETONS.SetParentComponent(wdsAContracts);
    wdsAContractsCAPTURETONS.Name := 'wdsAContractsCAPTURETONS';
    wdsAContractsCAPTURETONS.FieldName := 'CAPTURETONS';
    wdsAContractsINVOICETONS.SetParentComponent(wdsAContracts);
    wdsAContractsINVOICETONS.Name := 'wdsAContractsINVOICETONS';
    wdsAContractsINVOICETONS.FieldName := 'INVOICETONS';
    wdsAContractsCHGSUBPRICE.SetParentComponent(wdsAContracts);
    wdsAContractsCHGSUBPRICE.Name := 'wdsAContractsCHGSUBPRICE';
    wdsAContractsCHGSUBPRICE.FieldName := 'CHGSUBPRICE';
    wdsAContractsMAXLOADORDERS.SetParentComponent(wdsAContracts);
    wdsAContractsMAXLOADORDERS.Name := 'wdsAContractsMAXLOADORDERS';
    wdsAContractsMAXLOADORDERS.FieldName := 'MAXLOADORDERS';
    wdsAContractsADDDESCRIPTION.SetParentComponent(wdsAContracts);
    wdsAContractsADDDESCRIPTION.Name := 'wdsAContractsADDDESCRIPTION';
    wdsAContractsADDDESCRIPTION.FieldName := 'ADDDESCRIPTION';
    wdsAContractsVARIANCETYPE.SetParentComponent(wdsAContracts);
    wdsAContractsVARIANCETYPE.Name := 'wdsAContractsVARIANCETYPE';
    wdsAContractsVARIANCETYPE.FieldName := 'VARIANCETYPE';
    wdsAContractsVARIANCEVALUE.SetParentComponent(wdsAContracts);
    wdsAContractsVARIANCEVALUE.Name := 'wdsAContractsVARIANCEVALUE';
    wdsAContractsVARIANCEVALUE.FieldName := 'VARIANCEVALUE';
    wdsAContractsPRINTLC.SetParentComponent(wdsAContracts);
    wdsAContractsPRINTLC.Name := 'wdsAContractsPRINTLC';
    wdsAContractsPRINTLC.FieldName := 'PRINTLC';
    wdsAContractsPRINTDN.SetParentComponent(wdsAContracts);
    wdsAContractsPRINTDN.Name := 'wdsAContractsPRINTDN';
    wdsAContractsPRINTDN.FieldName := 'PRINTDN';
    wdsAContractsPRINTTS.SetParentComponent(wdsAContracts);
    wdsAContractsPRINTTS.Name := 'wdsAContractsPRINTTS';
    wdsAContractsPRINTTS.FieldName := 'PRINTTS';
    wdsAContractsDNTYPE.SetParentComponent(wdsAContracts);
    wdsAContractsDNTYPE.Name := 'wdsAContractsDNTYPE';
    wdsAContractsDNTYPE.FieldName := 'DNTYPE';
    wdsAContractsTSTYPE.SetParentComponent(wdsAContracts);
    wdsAContractsTSTYPE.Name := 'wdsAContractsTSTYPE';
    wdsAContractsTSTYPE.FieldName := 'TSTYPE';
    wdsAContractsSHORTDESC.SetParentComponent(wdsAContracts);
    wdsAContractsSHORTDESC.Name := 'wdsAContractsSHORTDESC';
    wdsAContractsSHORTDESC.FieldName := 'SHORTDESC';
    wdsAContractsOLDLOADSCREEN.SetParentComponent(wdsAContracts);
    wdsAContractsOLDLOADSCREEN.Name := 'wdsAContractsOLDLOADSCREEN';
    wdsAContractsOLDLOADSCREEN.FieldName := 'OLDLOADSCREEN';
    wdsAContractsSHOWBOOKINGS.SetParentComponent(wdsAContracts);
    wdsAContractsSHOWBOOKINGS.Name := 'wdsAContractsSHOWBOOKINGS';
    wdsAContractsSHOWBOOKINGS.FieldName := 'SHOWBOOKINGS';
    wdsAContractsSHOWADDITIONAL.SetParentComponent(wdsAContracts);
    wdsAContractsSHOWADDITIONAL.Name := 'wdsAContractsSHOWADDITIONAL';
    wdsAContractsSHOWADDITIONAL.FieldName := 'SHOWADDITIONAL';
    wdsAContractsPRICETYPE.SetParentComponent(wdsAContracts);
    wdsAContractsPRICETYPE.Name := 'wdsAContractsPRICETYPE';
    wdsAContractsPRICETYPE.FieldName := 'PRICETYPE';
    wdsAContractsUSEDOCKETINVNO.SetParentComponent(wdsAContracts);
    wdsAContractsUSEDOCKETINVNO.Name := 'wdsAContractsUSEDOCKETINVNO';
    wdsAContractsUSEDOCKETINVNO.FieldName := 'USEDOCKETINVNO';
    wdsAContractsSAGECODE2.SetParentComponent(wdsAContracts);
    wdsAContractsSAGECODE2.Name := 'wdsAContractsSAGECODE2';
    wdsAContractsSAGECODE2.FieldName := 'SAGECODE2';
    wdsAContractsSAGEEXPCODE2.SetParentComponent(wdsAContracts);
    wdsAContractsSAGEEXPCODE2.Name := 'wdsAContractsSAGEEXPCODE2';
    wdsAContractsSAGEEXPCODE2.FieldName := 'SAGEEXPCODE2';
    wdsAContractsSAGEINVENTORY2.SetParentComponent(wdsAContracts);
    wdsAContractsSAGEINVENTORY2.Name := 'wdsAContractsSAGEINVENTORY2';
    wdsAContractsSAGEINVENTORY2.FieldName := 'SAGEINVENTORY2';
    wdsAContractsSAGEGL2.SetParentComponent(wdsAContracts);
    wdsAContractsSAGEGL2.Name := 'wdsAContractsSAGEGL2';
    wdsAContractsSAGEGL2.FieldName := 'SAGEGL2';
    wdsAContractsHAULAGETYPE.SetParentComponent(wdsAContracts);
    wdsAContractsHAULAGETYPE.Name := 'wdsAContractsHAULAGETYPE';
    wdsAContractsHAULAGETYPE.FieldName := 'HAULAGETYPE';
    wdsAContractsLINKZEROML.SetParentComponent(wdsAContracts);
    wdsAContractsLINKZEROML.Name := 'wdsAContractsLINKZEROML';
    wdsAContractsLINKZEROML.FieldName := 'LINKZEROML';
    wdsAContractsATTACHEDEMAIL.SetParentComponent(wdsAContracts);
    wdsAContractsATTACHEDEMAIL.Name := 'wdsAContractsATTACHEDEMAIL';
    wdsAContractsATTACHEDEMAIL.FieldName := 'ATTACHEDEMAIL';
    wdsAContractsCLIENTLINKCONTRACT.SetParentComponent(wdsAContracts);
    wdsAContractsCLIENTLINKCONTRACT.Name := 'wdsAContractsCLIENTLINKCONTRACT';
    wdsAContractsCLIENTLINKCONTRACT.FieldName := 'CLIENTLINKCONTRACT';
    wdsAContractsQUOTEREFNO.SetParentComponent(wdsAContracts);
    wdsAContractsQUOTEREFNO.Name := 'wdsAContractsQUOTEREFNO';
    wdsAContractsQUOTEREFNO.FieldName := 'QUOTEREFNO';
    wdsAContractsSORTLOADDATE.SetParentComponent(wdsAContracts);
    wdsAContractsSORTLOADDATE.Name := 'wdsAContractsSORTLOADDATE';
    wdsAContractsSORTLOADDATE.FieldName := 'SORTLOADDATE';
    wdsAContractsSORTOFFDATE.SetParentComponent(wdsAContracts);
    wdsAContractsSORTOFFDATE.Name := 'wdsAContractsSORTOFFDATE';
    wdsAContractsSORTOFFDATE.FieldName := 'SORTOFFDATE';
    wdsAContractsSORTLOADWAY.SetParentComponent(wdsAContracts);
    wdsAContractsSORTLOADWAY.Name := 'wdsAContractsSORTLOADWAY';
    wdsAContractsSORTLOADWAY.FieldName := 'SORTLOADWAY';
    wdsAContractsSORTOFFWAY.SetParentComponent(wdsAContracts);
    wdsAContractsSORTOFFWAY.Name := 'wdsAContractsSORTOFFWAY';
    wdsAContractsSORTOFFWAY.FieldName := 'SORTOFFWAY';
    wdsAContractsSORTDOCKET.SetParentComponent(wdsAContracts);
    wdsAContractsSORTDOCKET.Name := 'wdsAContractsSORTDOCKET';
    wdsAContractsSORTDOCKET.FieldName := 'SORTDOCKET';
    wdsAContractsSINVVAT.SetParentComponent(wdsAContracts);
    wdsAContractsSINVVAT.Name := 'wdsAContractsSINVVAT';
    wdsAContractsSINVVAT.FieldName := 'SINVVAT';
    wdsAContractsLOADINSTRUCTQTY.SetParentComponent(wdsAContracts);
    wdsAContractsLOADINSTRUCTQTY.Name := 'wdsAContractsLOADINSTRUCTQTY';
    wdsAContractsLOADINSTRUCTQTY.FieldName := 'LOADINSTRUCTQTY';
    wdsAContractsCHGLOAD.SetParentComponent(wdsAContracts);
    wdsAContractsCHGLOAD.Name := 'wdsAContractsCHGLOAD';
    wdsAContractsCHGLOAD.FieldName := 'CHGLOAD';
    wdsAContractsCHGLOAD.Size := 0;
    wdsAContractssoanalysiscat1.SetParentComponent(wdsAContracts);
    wdsAContractssoanalysiscat1.Name := 'wdsAContractssoanalysiscat1';
    wdsAContractssoanalysiscat1.FieldName := 'soanalysiscat1';
    wdsAContractssoanalysiscat2.SetParentComponent(wdsAContracts);
    wdsAContractssoanalysiscat2.Name := 'wdsAContractssoanalysiscat2';
    wdsAContractssoanalysiscat2.FieldName := 'soanalysiscat2';
    wdsAContractssoanalysiscat3.SetParentComponent(wdsAContracts);
    wdsAContractssoanalysiscat3.Name := 'wdsAContractssoanalysiscat3';
    wdsAContractssoanalysiscat3.FieldName := 'soanalysiscat3';
    wdsAContractsmaxdrivetime.SetParentComponent(wdsAContracts);
    wdsAContractsmaxdrivetime.Name := 'wdsAContractsmaxdrivetime';
    wdsAContractsmaxdrivetime.FieldName := 'maxdrivetime';
    wdsAContractsmaxtrafeltime.SetParentComponent(wdsAContracts);
    wdsAContractsmaxtrafeltime.Name := 'wdsAContractsmaxtrafeltime';
    wdsAContractsmaxtrafeltime.FieldName := 'maxtrafeltime';
    wdsAContractsfirstwarning.SetParentComponent(wdsAContracts);
    wdsAContractsfirstwarning.Name := 'wdsAContractsfirstwarning';
    wdsAContractsfirstwarning.FieldName := 'firstwarning';
    wdsAContractssecondwarning.SetParentComponent(wdsAContracts);
    wdsAContractssecondwarning.Name := 'wdsAContractssecondwarning';
    wdsAContractssecondwarning.FieldName := 'secondwarning';
    wdsAContractsslots.SetParentComponent(wdsAContracts);
    wdsAContractsslots.Name := 'wdsAContractsslots';
    wdsAContractsslots.FieldName := 'slots';
    wdsAContractsSTARTDATE.SetParentComponent(wdsAContracts);
    wdsAContractsSTARTDATE.Name := 'wdsAContractsSTARTDATE';
    wdsAContractsSTARTDATE.FieldName := 'STARTDATE';
    wdsAContractsCOMPDATE.SetParentComponent(wdsAContracts);
    wdsAContractsCOMPDATE.Name := 'wdsAContractsCOMPDATE';
    wdsAContractsCOMPDATE.FieldName := 'COMPDATE';
    wdsAContractsSENDEDDATE.SetParentComponent(wdsAContracts);
    wdsAContractsSENDEDDATE.Name := 'wdsAContractsSENDEDDATE';
    wdsAContractsSENDEDDATE.FieldName := 'SENDEDDATE';
    wdsAContractsDEB_CODE.SetParentComponent(wdsAContracts);
    wdsAContractsDEB_CODE.Name := 'wdsAContractsDEB_CODE';
    wdsAContractsDEB_CODE.FieldName := 'DEB_CODE';
    wdsAContractsDEB_NAME.SetParentComponent(wdsAContracts);
    wdsAContractsDEB_NAME.Name := 'wdsAContractsDEB_NAME';
    wdsAContractsDEB_NAME.FieldName := 'DEB_NAME';
    wdsAContractsSUSPENDED.SetParentComponent(wdsAContracts);
    wdsAContractsSUSPENDED.Name := 'wdsAContractsSUSPENDED';
    wdsAContractsSUSPENDED.FieldName := 'SUSPENDED';
    wdsAContractsCREDITLIMIT.SetParentComponent(wdsAContracts);
    wdsAContractsCREDITLIMIT.Name := 'wdsAContractsCREDITLIMIT';
    wdsAContractsCREDITLIMIT.FieldName := 'CREDITLIMIT';
    wdsAContractsORDERBALANCE.SetParentComponent(wdsAContracts);
    wdsAContractsORDERBALANCE.Name := 'wdsAContractsORDERBALANCE';
    wdsAContractsORDERBALANCE.FieldName := 'ORDERBALANCE';
    wdsAContractsINVOICEBALANCE.SetParentComponent(wdsAContracts);
    wdsAContractsINVOICEBALANCE.Name := 'wdsAContractsINVOICEBALANCE';
    wdsAContractsINVOICEBALANCE.FieldName := 'INVOICEBALANCE';
    wdsAContractsAVAILIBLECL.SetParentComponent(wdsAContracts);
    wdsAContractsAVAILIBLECL.Name := 'wdsAContractsAVAILIBLECL';
    wdsAContractsAVAILIBLECL.FieldName := 'AVAILIBLECL';
    wdsAContractsCLIENTMULTILOADINV.SetParentComponent(wdsAContracts);
    wdsAContractsCLIENTMULTILOADINV.Name := 'wdsAContractsCLIENTMULTILOADINV';
    wdsAContractsCLIENTMULTILOADINV.FieldName := 'CLIENTMULTILOADINV';
    wdsAContractsMULTILOADDESC.SetParentComponent(wdsAContracts);
    wdsAContractsMULTILOADDESC.Name := 'wdsAContractsMULTILOADDESC';
    wdsAContractsMULTILOADDESC.FieldName := 'MULTILOADDESC';
    wdsAContractsCLIENTINVOICETYPE.SetParentComponent(wdsAContracts);
    wdsAContractsCLIENTINVOICETYPE.Name := 'wdsAContractsCLIENTINVOICETYPE';
    wdsAContractsCLIENTINVOICETYPE.FieldName := 'CLIENTINVOICETYPE';
    wdsAContractsMULTICONTRACT.SetParentComponent(wdsAContracts);
    wdsAContractsMULTICONTRACT.Name := 'wdsAContractsMULTICONTRACT';
    wdsAContractsMULTICONTRACT.FieldName := 'MULTICONTRACT';
    wdsAContractsCLIENTLINKED.SetParentComponent(wdsAContracts);
    wdsAContractsCLIENTLINKED.Name := 'wdsAContractsCLIENTLINKED';
    wdsAContractsCLIENTLINKED.FieldName := 'CLIENTLINKED';
    wdsAContractsCLIENTEMAIL.SetParentComponent(wdsAContracts);
    wdsAContractsCLIENTEMAIL.Name := 'wdsAContractsCLIENTEMAIL';
    wdsAContractsCLIENTEMAIL.FieldName := 'CLIENTEMAIL';
    wdsAContractsLINKEDCONFIG.SetParentComponent(wdsAContracts);
    wdsAContractsLINKEDCONFIG.Name := 'wdsAContractsLINKEDCONFIG';
    wdsAContractsLINKEDCONFIG.FieldName := 'LINKEDCONFIG';
    wdsAContractsACCOUNTNUMBER.SetParentComponent(wdsAContracts);
    wdsAContractsACCOUNTNUMBER.Name := 'wdsAContractsACCOUNTNUMBER';
    wdsAContractsACCOUNTNUMBER.FieldName := 'ACCOUNTNUMBER';
    wdsAContractsMAINBALANCE.SetParentComponent(wdsAContracts);
    wdsAContractsMAINBALANCE.Name := 'wdsAContractsMAINBALANCE';
    wdsAContractsMAINBALANCE.FieldName := 'MAINBALANCE';
    wdsAContractsMAINTENANCELINKACCOUNT.SetParentComponent(wdsAContracts);
    wdsAContractsMAINTENANCELINKACCOUNT.Name := 'wdsAContractsMAINTENANCELINKACCOUNT';
    wdsAContractsMAINTENANCELINKACCOUNT.FieldName := 'MAINTENANCELINKACCOUNT';
    wdsAContractsEXPORTLIST.SetParentComponent(wdsAContracts);
    wdsAContractsEXPORTLIST.Name := 'wdsAContractsEXPORTLIST';
    wdsAContractsEXPORTLIST.FieldName := 'EXPORTLIST';
    wdsAContractsEXPORTLOADS.SetParentComponent(wdsAContracts);
    wdsAContractsEXPORTLOADS.Name := 'wdsAContractsEXPORTLOADS';
    wdsAContractsEXPORTLOADS.FieldName := 'EXPORTLOADS';
    wdsAContractsRENAMEFIELD.SetParentComponent(wdsAContracts);
    wdsAContractsRENAMEFIELD.Name := 'wdsAContractsRENAMEFIELD';
    wdsAContractsRENAMEFIELD.FieldName := 'RENAMEFIELD';
    wdsAContractsEXPORTPATH.SetParentComponent(wdsAContracts);
    wdsAContractsEXPORTPATH.Name := 'wdsAContractsEXPORTPATH';
    wdsAContractsEXPORTPATH.FieldName := 'EXPORTPATH';
    wdsAContractsPREVCL.SetParentComponent(wdsAContracts);
    wdsAContractsPREVCL.Name := 'wdsAContractsPREVCL';
    wdsAContractsPREVCL.FieldName := 'PREVCL';
    wdsAContractsSECUREBOOK.SetParentComponent(wdsAContracts);
    wdsAContractsSECUREBOOK.Name := 'wdsAContractsSECUREBOOK';
    wdsAContractsSECUREBOOK.FieldName := 'SECUREBOOK';
    wdsAContractsQUOTESYSTEM.SetParentComponent(wdsAContracts);
    wdsAContractsQUOTESYSTEM.Name := 'wdsAContractsQUOTESYSTEM';
    wdsAContractsQUOTESYSTEM.FieldName := 'QUOTESYSTEM';
    wdsAContractsQUOTETYPE.SetParentComponent(wdsAContracts);
    wdsAContractsQUOTETYPE.Name := 'wdsAContractsQUOTETYPE';
    wdsAContractsQUOTETYPE.FieldName := 'QUOTETYPE';
    wdsAContractsEMAILLOADDOCS.SetParentComponent(wdsAContracts);
    wdsAContractsEMAILLOADDOCS.Name := 'wdsAContractsEMAILLOADDOCS';
    wdsAContractsEMAILLOADDOCS.FieldName := 'EMAILLOADDOCS';
    wdsAContractsSTATEMENTTYPE.SetParentComponent(wdsAContracts);
    wdsAContractsSTATEMENTTYPE.Name := 'wdsAContractsSTATEMENTTYPE';
    wdsAContractsSTATEMENTTYPE.FieldName := 'STATEMENTTYPE';
    wdsAContractsSHOWRECLOADS.SetParentComponent(wdsAContracts);
    wdsAContractsSHOWRECLOADS.Name := 'wdsAContractsSHOWRECLOADS';
    wdsAContractsSHOWRECLOADS.FieldName := 'SHOWRECLOADS';
    wdsAContractsLINKEDINVTYPE.SetParentComponent(wdsAContracts);
    wdsAContractsLINKEDINVTYPE.Name := 'wdsAContractsLINKEDINVTYPE';
    wdsAContractsLINKEDINVTYPE.FieldName := 'LINKEDINVTYPE';
    wdsAContractsDEFINVCOMPNO.SetParentComponent(wdsAContracts);
    wdsAContractsDEFINVCOMPNO.Name := 'wdsAContractsDEFINVCOMPNO';
    wdsAContractsDEFINVCOMPNO.FieldName := 'DEFINVCOMPNO';
    wdsAContractsinvoicetypenoncon.SetParentComponent(wdsAContracts);
    wdsAContractsinvoicetypenoncon.Name := 'wdsAContractsinvoicetypenoncon';
    wdsAContractsinvoicetypenoncon.FieldName := 'invoicetypenoncon';
    wdsAContractsinvoicetypenoncon.Size := 0;
    wdsAContractssinglenoncon.SetParentComponent(wdsAContracts);
    wdsAContractssinglenoncon.Name := 'wdsAContractssinglenoncon';
    wdsAContractssinglenoncon.FieldName := 'singlenoncon';
    wdsAContractsLINKSERIAL.SetParentComponent(wdsAContracts);
    wdsAContractsLINKSERIAL.Name := 'wdsAContractsLINKSERIAL';
    wdsAContractsLINKSERIAL.FieldName := 'LINKSERIAL';
    wdsAContractsLINKAPI.SetParentComponent(wdsAContracts);
    wdsAContractsLINKAPI.Name := 'wdsAContractsLINKAPI';
    wdsAContractsLINKAPI.FieldName := 'LINKAPI';
    wdsAContractsserverip.SetParentComponent(wdsAContracts);
    wdsAContractsserverip.Name := 'wdsAContractsserverip';
    wdsAContractsserverip.FieldName := 'serverip';
    wdsAContractsserverport.SetParentComponent(wdsAContracts);
    wdsAContractsserverport.Name := 'wdsAContractsserverport';
    wdsAContractsserverport.FieldName := 'serverport';
    wdsAContractsserveruser.SetParentComponent(wdsAContracts);
    wdsAContractsserveruser.Name := 'wdsAContractsserveruser';
    wdsAContractsserveruser.FieldName := 'serveruser';
    wdsAContractsserverpassword.SetParentComponent(wdsAContracts);
    wdsAContractsserverpassword.Name := 'wdsAContractsserverpassword';
    wdsAContractsserverpassword.FieldName := 'serverpassword';
    wdsAContractsserveraccount.SetParentComponent(wdsAContracts);
    wdsAContractsserveraccount.Name := 'wdsAContractsserveraccount';
    wdsAContractsserveraccount.FieldName := 'serveraccount';
    wdsAContractsaltserverip.SetParentComponent(wdsAContracts);
    wdsAContractsaltserverip.Name := 'wdsAContractsaltserverip';
    wdsAContractsaltserverip.FieldName := 'altserverip';
    wdsAContractsaltserverport.SetParentComponent(wdsAContracts);
    wdsAContractsaltserverport.Name := 'wdsAContractsaltserverport';
    wdsAContractsaltserverport.FieldName := 'altserverport';
    wdsAContractsaltserveruser.SetParentComponent(wdsAContracts);
    wdsAContractsaltserveruser.Name := 'wdsAContractsaltserveruser';
    wdsAContractsaltserveruser.FieldName := 'altserveruser';
    wdsAContractsaltserverpassword.SetParentComponent(wdsAContracts);
    wdsAContractsaltserverpassword.Name := 'wdsAContractsaltserverpassword';
    wdsAContractsaltserverpassword.FieldName := 'altserverpassword';
    wdsAContractsserversystem.SetParentComponent(wdsAContracts);
    wdsAContractsserversystem.Name := 'wdsAContractsserversystem';
    wdsAContractsserversystem.FieldName := 'serversystem';
    wdsAContractsNo.SetParentComponent(wdsAContracts);
    wdsAContractsNo.Name := 'wdsAContractsNo';
    wdsAContractsNo.FieldName := 'No';
    wdsAContractsNAME.SetParentComponent(wdsAContracts);
    wdsAContractsNAME.Name := 'wdsAContractsNAME';
    wdsAContractsNAME.FieldName := 'NAME';
    wdsAContractsITEMCODE.SetParentComponent(wdsAContracts);
    wdsAContractsITEMCODE.Name := 'wdsAContractsITEMCODE';
    wdsAContractsITEMCODE.FieldName := 'ITEMCODE';
    wdsAContractsSTORE.SetParentComponent(wdsAContracts);
    wdsAContractsSTORE.Name := 'wdsAContractsSTORE';
    wdsAContractsSTORE.FieldName := 'STORE';
    wdsAContractsUNITNUMBER.SetParentComponent(wdsAContracts);
    wdsAContractsUNITNUMBER.Name := 'wdsAContractsUNITNUMBER';
    wdsAContractsUNITNUMBER.FieldName := 'UNITNUMBER';
    wdsAContractsDENSITY.SetParentComponent(wdsAContracts);
    wdsAContractsDENSITY.Name := 'wdsAContractsDENSITY';
    wdsAContractsDENSITY.FieldName := 'DENSITY';
    wdsAContractsLoadCountryName.SetParentComponent(wdsAContracts);
    wdsAContractsLoadCountryName.Name := 'wdsAContractsLoadCountryName';
    wdsAContractsLoadCountryName.FieldName := 'LoadCountryName';
    wdsAContractsLoadProvinceName.SetParentComponent(wdsAContracts);
    wdsAContractsLoadProvinceName.Name := 'wdsAContractsLoadProvinceName';
    wdsAContractsLoadProvinceName.FieldName := 'LoadProvinceName';
    wdsAContractsLoadCityName.SetParentComponent(wdsAContracts);
    wdsAContractsLoadCityName.Name := 'wdsAContractsLoadCityName';
    wdsAContractsLoadCityName.FieldName := 'LoadCityName';
    wdsAContractsLoadInfoName.SetParentComponent(wdsAContracts);
    wdsAContractsLoadInfoName.Name := 'wdsAContractsLoadInfoName';
    wdsAContractsLoadInfoName.FieldName := 'LoadInfoName';
    wdsAContractsOffLoadCountryName.SetParentComponent(wdsAContracts);
    wdsAContractsOffLoadCountryName.Name := 'wdsAContractsOffLoadCountryName';
    wdsAContractsOffLoadCountryName.FieldName := 'OffLoadCountryName';
    wdsAContractsOffLoadProvinceName.SetParentComponent(wdsAContracts);
    wdsAContractsOffLoadProvinceName.Name := 'wdsAContractsOffLoadProvinceName';
    wdsAContractsOffLoadProvinceName.FieldName := 'OffLoadProvinceName';
    wdsAContractsOffLoadCityName.SetParentComponent(wdsAContracts);
    wdsAContractsOffLoadCityName.Name := 'wdsAContractsOffLoadCityName';
    wdsAContractsOffLoadCityName.FieldName := 'OffLoadCityName';
    wdsAContractsOffLoadInfoName.SetParentComponent(wdsAContracts);
    wdsAContractsOffLoadInfoName.Name := 'wdsAContractsOffLoadInfoName';
    wdsAContractsOffLoadInfoName.FieldName := 'OffLoadInfoName';
    wdsAContractsCommodityName.SetParentComponent(wdsAContracts);
    wdsAContractsCommodityName.Name := 'wdsAContractsCommodityName';
    wdsAContractsCommodityName.FieldName := 'CommodityName';
    wdsAContractsPayTermsName.SetParentComponent(wdsAContracts);
    wdsAContractsPayTermsName.Name := 'wdsAContractsPayTermsName';
    wdsAContractsPayTermsName.FieldName := 'PayTermsName';
    wdsAContractsCONTROLLERName.SetParentComponent(wdsAContracts);
    wdsAContractsCONTROLLERName.Name := 'wdsAContractsCONTROLLERName';
    wdsAContractsCONTROLLERName.FieldName := 'CONTROLLERName';
    wdsAContractsCutOffPeriodDesc1.SetParentComponent(wdsAContracts);
    wdsAContractsCutOffPeriodDesc1.Name := 'wdsAContractsCutOffPeriodDesc1';
    wdsAContractsCutOffPeriodDesc1.FieldName := 'CutOffPeriodDesc1';
    wdsAContractsCutOffPeriodDesc2.SetParentComponent(wdsAContracts);
    wdsAContractsCutOffPeriodDesc2.Name := 'wdsAContractsCutOffPeriodDesc2';
    wdsAContractsCutOffPeriodDesc2.FieldName := 'cutoff';
    wdsAContractsCutOffPeriodDesc22.SetParentComponent(wdsAContracts);
    wdsAContractsCutOffPeriodDesc22.Name := 'wdsAContractsCutOffPeriodDesc22';
    wdsAContractsCutOffPeriodDesc22.FieldName := 'CutOffPeriodDesc2';
    wdsAContractsClientName.SetParentComponent(wdsAContracts);
    wdsAContractsClientName.Name := 'wdsAContractsClientName';
    wdsAContractsClientName.FieldName := 'ClientName';
    dsAContracts.SetParentComponent(Self);
    dsAContracts.Name := 'dsAContracts';
    dsAContracts.DataSet := wdsAContracts;
    dsAContracts.Left := 120;
    dsAContracts.Top := 124;
    wcContractPrices.SetParentComponent(Self);
    wcContractPrices.Name := 'wcContractPrices';
    wcContractPrices.Connection := dmData.dbConnect;
    wcContractPrices.Left := 848;
    wcContractPrices.Top := 112;
    wdsContractPrices.SetParentComponent(Self);
    wdsContractPrices.Name := 'wdsContractPrices';
    wdsContractPrices.Connection := dmData.dbConnect;
    wdsContractPrices.Left := 896;
    wdsContractPrices.Top := 112;
    wdsContractPricesAUTONO.SetParentComponent(wdsContractPrices);
    wdsContractPricesAUTONO.Name := 'wdsContractPricesAUTONO';
    wdsContractPricesAUTONO.FieldName := 'AUTONO';
    wdsContractPricesCONTRACTNO.SetParentComponent(wdsContractPrices);
    wdsContractPricesCONTRACTNO.Name := 'wdsContractPricesCONTRACTNO';
    wdsContractPricesCONTRACTNO.FieldName := 'CONTRACTNO';
    wdsContractPricesSTARTDATE.SetParentComponent(wdsContractPrices);
    wdsContractPricesSTARTDATE.Name := 'wdsContractPricesSTARTDATE';
    wdsContractPricesSTARTDATE.FieldName := 'STARTDATE';
    wdsContractPricesENDDATE.SetParentComponent(wdsContractPrices);
    wdsContractPricesENDDATE.Name := 'wdsContractPricesENDDATE';
    wdsContractPricesENDDATE.FieldName := 'ENDDATE';
    wdsContractPricesCOSTPRICE.SetParentComponent(wdsContractPrices);
    wdsContractPricesCOSTPRICE.Name := 'wdsContractPricesCOSTPRICE';
    wdsContractPricesCOSTPRICE.FieldName := 'COSTPRICE';
    wdsContractPricesSUBPRICE.SetParentComponent(wdsContractPrices);
    wdsContractPricesSUBPRICE.Name := 'wdsContractPricesSUBPRICE';
    wdsContractPricesSUBPRICE.FieldName := 'SUBPRICE';
    wdsContractPricesDEDPRICE.SetParentComponent(wdsContractPrices);
    wdsContractPricesDEDPRICE.Name := 'wdsContractPricesDEDPRICE';
    wdsContractPricesDEDPRICE.FieldName := 'DEDPRICE';
    wdsContractPricesSPEPRICE.SetParentComponent(wdsContractPrices);
    wdsContractPricesSPEPRICE.Name := 'wdsContractPricesSPEPRICE';
    wdsContractPricesSPEPRICE.FieldName := 'SPEPRICE';
    wdsContractPricesCONFIREMED.SetParentComponent(wdsContractPrices);
    wdsContractPricesCONFIREMED.Name := 'wdsContractPricesCONFIREMED';
    wdsContractPricesCONFIREMED.FieldName := 'CONFIREMED';
    wdsContractPricesPRICELOADDATE.SetParentComponent(wdsContractPrices);
    wdsContractPricesPRICELOADDATE.Name := 'wdsContractPricesPRICELOADDATE';
    wdsContractPricesPRICELOADDATE.FieldName := 'PRICELOADDATE';
    wdsContractPricesPRICELOADBY.SetParentComponent(wdsContractPrices);
    wdsContractPricesPRICELOADBY.Name := 'wdsContractPricesPRICELOADBY';
    wdsContractPricesPRICELOADBY.FieldName := 'PRICELOADBY';
    wdsContractPricesPRICECONFIRMDATE.SetParentComponent(wdsContractPrices);
    wdsContractPricesPRICECONFIRMDATE.Name := 'wdsContractPricesPRICECONFIRMDATE';
    wdsContractPricesPRICECONFIRMDATE.FieldName := 'PRICECONFIRMDATE';
    wdsContractPricesPRICECONFIRMBY.SetParentComponent(wdsContractPrices);
    wdsContractPricesPRICECONFIRMBY.Name := 'wdsContractPricesPRICECONFIRMBY';
    wdsContractPricesPRICECONFIRMBY.FieldName := 'PRICECONFIRMBY';
    wdsContractPriceskmsprice.SetParentComponent(wdsContractPrices);
    wdsContractPriceskmsprice.Name := 'wdsContractPriceskmsprice';
    wdsContractPriceskmsprice.FieldName := 'kmsprice';
    wdsContractPricestollprice.SetParentComponent(wdsContractPrices);
    wdsContractPricestollprice.Name := 'wdsContractPricestollprice';
    wdsContractPricestollprice.FieldName := 'tollprice';
    dsContractPrices.SetParentComponent(Self);
    dsContractPrices.Name := 'dsContractPrices';
    dsContractPrices.DataSet := wdsContractPrices;
    dsContractPrices.Left := 960;
    dsContractPrices.Top := 112;
    wdsClosedContracts.SetParentComponent(Self);
    wdsClosedContracts.Name := 'wdsClosedContracts';
    wdsClosedContracts.Connection := dmData.dbConnect;
    wdsClosedContracts.Left := 72;
    wdsClosedContracts.Top := 300;
    IntegerField1.SetParentComponent(wdsClosedContracts);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'CONTRACTNO';
    StringField1.SetParentComponent(wdsClosedContracts);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'CONTRACTNAME';
    StringField2.SetParentComponent(wdsClosedContracts);
    StringField2.Name := 'StringField2';
    StringField2.FieldName := 'DEBCODE';
    IntegerField2.SetParentComponent(wdsClosedContracts);
    IntegerField2.Name := 'IntegerField2';
    IntegerField2.FieldName := 'COMMODITIESNO';
    IntegerField3.SetParentComponent(wdsClosedContracts);
    IntegerField3.Name := 'IntegerField3';
    IntegerField3.FieldName := 'LOADCOUNTRYNO';
    IntegerField4.SetParentComponent(wdsClosedContracts);
    IntegerField4.Name := 'IntegerField4';
    IntegerField4.FieldName := 'LOADPROVINCENO';
    IntegerField5.SetParentComponent(wdsClosedContracts);
    IntegerField5.Name := 'IntegerField5';
    IntegerField5.FieldName := 'LOADCITYNO';
    IntegerField6.SetParentComponent(wdsClosedContracts);
    IntegerField6.Name := 'IntegerField6';
    IntegerField6.FieldName := 'LOADINGNO';
    IntegerField7.SetParentComponent(wdsClosedContracts);
    IntegerField7.Name := 'IntegerField7';
    IntegerField7.FieldName := 'OFFLOADCOUNTRYNO';
    IntegerField8.SetParentComponent(wdsClosedContracts);
    IntegerField8.Name := 'IntegerField8';
    IntegerField8.FieldName := 'OFFLOADPROVINCENO';
    IntegerField9.SetParentComponent(wdsClosedContracts);
    IntegerField9.Name := 'IntegerField9';
    IntegerField9.FieldName := 'OFFLOADCITYNO';
    IntegerField10.SetParentComponent(wdsClosedContracts);
    IntegerField10.Name := 'IntegerField10';
    IntegerField10.FieldName := 'OFFLOADINGNO';
    StringField3.SetParentComponent(wdsClosedContracts);
    StringField3.Name := 'StringField3';
    StringField3.FieldName := 'INVLOADING';
    StringField4.SetParentComponent(wdsClosedContracts);
    StringField4.Name := 'StringField4';
    StringField4.FieldName := 'INVOFFLOADING';
    FloatField1.SetParentComponent(wdsClosedContracts);
    FloatField1.Name := 'FloatField1';
    FloatField1.FieldName := 'TOTALTONS';
    FloatField2.SetParentComponent(wdsClosedContracts);
    FloatField2.Name := 'FloatField2';
    FloatField2.FieldName := 'TOTALTONSORDER';
    FloatField3.SetParentComponent(wdsClosedContracts);
    FloatField3.Name := 'FloatField3';
    FloatField3.FieldName := 'TOTALTONSLOADED';
    FloatField4.SetParentComponent(wdsClosedContracts);
    FloatField4.Name := 'FloatField4';
    FloatField4.FieldName := 'TOTALTONSOFFLOADED';
    FloatField5.SetParentComponent(wdsClosedContracts);
    FloatField5.Name := 'FloatField5';
    FloatField5.FieldName := 'TOTALTONSINVOICED';
    StringField5.SetParentComponent(wdsClosedContracts);
    StringField5.Name := 'StringField5';
    StringField5.FieldName := 'COMPLETED';
    StringField6.SetParentComponent(wdsClosedContracts);
    StringField6.Name := 'StringField6';
    StringField6.FieldName := 'CONTROLLER';
    StringField6.Size := 0;
    FloatField6.SetParentComponent(wdsClosedContracts);
    FloatField6.Name := 'FloatField6';
    FloatField6.FieldName := 'AVGTONS';
    IntegerField11.SetParentComponent(wdsClosedContracts);
    IntegerField11.Name := 'IntegerField11';
    IntegerField11.FieldName := 'TOTALLOADS';
    IntegerField12.SetParentComponent(wdsClosedContracts);
    IntegerField12.Name := 'IntegerField12';
    IntegerField12.FieldName := 'LOADSORDER';
    IntegerField13.SetParentComponent(wdsClosedContracts);
    IntegerField13.Name := 'IntegerField13';
    IntegerField13.FieldName := 'LOADSLOADED';
    IntegerField14.SetParentComponent(wdsClosedContracts);
    IntegerField14.Name := 'IntegerField14';
    IntegerField14.FieldName := 'LOADSOFFLOADED';
    IntegerField15.SetParentComponent(wdsClosedContracts);
    IntegerField15.Name := 'IntegerField15';
    IntegerField15.FieldName := 'LOADSINVOICED';
    IntegerField16.SetParentComponent(wdsClosedContracts);
    IntegerField16.Name := 'IntegerField16';
    IntegerField16.FieldName := 'PAYMENTTERMS';
    IntegerField17.SetParentComponent(wdsClosedContracts);
    IntegerField17.Name := 'IntegerField17';
    IntegerField17.FieldName := 'PAYMENTTYPE';
    StringField7.SetParentComponent(wdsClosedContracts);
    StringField7.Name := 'StringField7';
    StringField7.FieldName := 'ADDHOC';
    StringField8.SetParentComponent(wdsClosedContracts);
    StringField8.Name := 'StringField8';
    StringField8.FieldName := 'DEDICATED';
    StringField9.SetParentComponent(wdsClosedContracts);
    StringField9.Name := 'StringField9';
    StringField9.FieldName := 'ORDERNO';
    StringField10.SetParentComponent(wdsClosedContracts);
    StringField10.Name := 'StringField10';
    StringField10.FieldName := 'INVVAT';
    StringField11.SetParentComponent(wdsClosedContracts);
    StringField11.Name := 'StringField11';
    StringField11.FieldName := 'MULTILOADINV';
    StringField12.SetParentComponent(wdsClosedContracts);
    StringField12.Name := 'StringField12';
    StringField12.FieldName := 'SENDED';
    StringField13.SetParentComponent(wdsClosedContracts);
    StringField13.Name := 'StringField13';
    StringField13.FieldName := 'PRELISTING';
    StringField14.SetParentComponent(wdsClosedContracts);
    StringField14.Name := 'StringField14';
    StringField14.FieldName := 'POSTLISTING';
    StringField15.SetParentComponent(wdsClosedContracts);
    StringField15.Name := 'StringField15';
    StringField15.FieldName := 'INVOICETYPE';
    FloatField7.SetParentComponent(wdsClosedContracts);
    FloatField7.Name := 'FloatField7';
    FloatField7.FieldName := 'DISTANCE';
    SmallintField1.SetParentComponent(wdsClosedContracts);
    SmallintField1.Name := 'SmallintField1';
    SmallintField1.FieldName := 'DRIVERRATIO';
    SmallintField2.SetParentComponent(wdsClosedContracts);
    SmallintField2.Name := 'SmallintField2';
    SmallintField2.FieldName := 'CUTOFF1';
    IntegerField18.SetParentComponent(wdsClosedContracts);
    IntegerField18.Name := 'IntegerField18';
    IntegerField18.FieldName := 'CUTOFFPERIOD1';
    SmallintField3.SetParentComponent(wdsClosedContracts);
    SmallintField3.Name := 'SmallintField3';
    SmallintField3.FieldName := 'CUTOFF2';
    IntegerField19.SetParentComponent(wdsClosedContracts);
    IntegerField19.Name := 'IntegerField19';
    IntegerField19.FieldName := 'CUTOFFPERIOD2';
    StringField16.SetParentComponent(wdsClosedContracts);
    StringField16.Name := 'StringField16';
    StringField16.FieldName := 'SAGEINVENTORY';
    StringField17.SetParentComponent(wdsClosedContracts);
    StringField17.Name := 'StringField17';
    StringField17.FieldName := 'SAGEGL';
    StringField18.SetParentComponent(wdsClosedContracts);
    StringField18.Name := 'StringField18';
    StringField18.FieldName := 'SAGECODE';
    StringField19.SetParentComponent(wdsClosedContracts);
    StringField19.Name := 'StringField19';
    StringField19.FieldName := 'SAGEEXPCODE';
    StringField20.SetParentComponent(wdsClosedContracts);
    StringField20.Name := 'StringField20';
    StringField20.FieldName := 'STRATERATE';
    StringField21.SetParentComponent(wdsClosedContracts);
    StringField21.Name := 'StringField21';
    StringField21.FieldName := 'CHGOFFLOAD';
    StringField22.SetParentComponent(wdsClosedContracts);
    StringField22.Name := 'StringField22';
    StringField22.FieldName := 'CHGPRICE';
    StringField23.SetParentComponent(wdsClosedContracts);
    StringField23.Name := 'StringField23';
    StringField23.FieldName := 'CAPTURETONS';
    StringField24.SetParentComponent(wdsClosedContracts);
    StringField24.Name := 'StringField24';
    StringField24.FieldName := 'INVOICETONS';
    StringField25.SetParentComponent(wdsClosedContracts);
    StringField25.Name := 'StringField25';
    StringField25.FieldName := 'CHGSUBPRICE';
    IntegerField20.SetParentComponent(wdsClosedContracts);
    IntegerField20.Name := 'IntegerField20';
    IntegerField20.FieldName := 'MAXLOADORDERS';
    StringField26.SetParentComponent(wdsClosedContracts);
    StringField26.Name := 'StringField26';
    StringField26.FieldName := 'ADDDESCRIPTION';
    IntegerField21.SetParentComponent(wdsClosedContracts);
    IntegerField21.Name := 'IntegerField21';
    IntegerField21.FieldName := 'VARIANCETYPE';
    FloatField8.SetParentComponent(wdsClosedContracts);
    FloatField8.Name := 'FloatField8';
    FloatField8.FieldName := 'VARIANCEVALUE';
    StringField27.SetParentComponent(wdsClosedContracts);
    StringField27.Name := 'StringField27';
    StringField27.FieldName := 'PRINTLC';
    StringField28.SetParentComponent(wdsClosedContracts);
    StringField28.Name := 'StringField28';
    StringField28.FieldName := 'PRINTDN';
    StringField29.SetParentComponent(wdsClosedContracts);
    StringField29.Name := 'StringField29';
    StringField29.FieldName := 'PRINTTS';
    StringField30.SetParentComponent(wdsClosedContracts);
    StringField30.Name := 'StringField30';
    StringField30.FieldName := 'DNTYPE';
    StringField31.SetParentComponent(wdsClosedContracts);
    StringField31.Name := 'StringField31';
    StringField31.FieldName := 'TSTYPE';
    StringField32.SetParentComponent(wdsClosedContracts);
    StringField32.Name := 'StringField32';
    StringField32.FieldName := 'SHORTDESC';
    StringField33.SetParentComponent(wdsClosedContracts);
    StringField33.Name := 'StringField33';
    StringField33.FieldName := 'OLDLOADSCREEN';
    StringField34.SetParentComponent(wdsClosedContracts);
    StringField34.Name := 'StringField34';
    StringField34.FieldName := 'SHOWBOOKINGS';
    StringField35.SetParentComponent(wdsClosedContracts);
    StringField35.Name := 'StringField35';
    StringField35.FieldName := 'SHOWADDITIONAL';
    IntegerField22.SetParentComponent(wdsClosedContracts);
    IntegerField22.Name := 'IntegerField22';
    IntegerField22.FieldName := 'PRICETYPE';
    StringField36.SetParentComponent(wdsClosedContracts);
    StringField36.Name := 'StringField36';
    StringField36.FieldName := 'USEDOCKETINVNO';
    StringField37.SetParentComponent(wdsClosedContracts);
    StringField37.Name := 'StringField37';
    StringField37.FieldName := 'SAGECODE2';
    StringField38.SetParentComponent(wdsClosedContracts);
    StringField38.Name := 'StringField38';
    StringField38.FieldName := 'SAGEEXPCODE2';
    StringField39.SetParentComponent(wdsClosedContracts);
    StringField39.Name := 'StringField39';
    StringField39.FieldName := 'SAGEINVENTORY2';
    StringField40.SetParentComponent(wdsClosedContracts);
    StringField40.Name := 'StringField40';
    StringField40.FieldName := 'SAGEGL2';
    StringField41.SetParentComponent(wdsClosedContracts);
    StringField41.Name := 'StringField41';
    StringField41.FieldName := 'HAULAGETYPE';
    StringField42.SetParentComponent(wdsClosedContracts);
    StringField42.Name := 'StringField42';
    StringField42.FieldName := 'LINKZEROML';
    StringField43.SetParentComponent(wdsClosedContracts);
    StringField43.Name := 'StringField43';
    StringField43.FieldName := 'ATTACHEDEMAIL';
    IntegerField23.SetParentComponent(wdsClosedContracts);
    IntegerField23.Name := 'IntegerField23';
    IntegerField23.FieldName := 'CLIENTLINKCONTRACT';
    StringField44.SetParentComponent(wdsClosedContracts);
    StringField44.Name := 'StringField44';
    StringField44.FieldName := 'QUOTEREFNO';
    StringField45.SetParentComponent(wdsClosedContracts);
    StringField45.Name := 'StringField45';
    StringField45.FieldName := 'SORTLOADDATE';
    StringField46.SetParentComponent(wdsClosedContracts);
    StringField46.Name := 'StringField46';
    StringField46.FieldName := 'SORTOFFDATE';
    StringField47.SetParentComponent(wdsClosedContracts);
    StringField47.Name := 'StringField47';
    StringField47.FieldName := 'SORTLOADWAY';
    StringField48.SetParentComponent(wdsClosedContracts);
    StringField48.Name := 'StringField48';
    StringField48.FieldName := 'SORTOFFWAY';
    StringField49.SetParentComponent(wdsClosedContracts);
    StringField49.Name := 'StringField49';
    StringField49.FieldName := 'SORTDOCKET';
    StringField50.SetParentComponent(wdsClosedContracts);
    StringField50.Name := 'StringField50';
    StringField50.FieldName := 'SINVVAT';
    FloatField9.SetParentComponent(wdsClosedContracts);
    FloatField9.Name := 'FloatField9';
    FloatField9.FieldName := 'LOADINSTRUCTQTY';
    StringField51.SetParentComponent(wdsClosedContracts);
    StringField51.Name := 'StringField51';
    StringField51.FieldName := 'CHGLOAD';
    StringField51.Size := 0;
    StringField52.SetParentComponent(wdsClosedContracts);
    StringField52.Name := 'StringField52';
    StringField52.FieldName := 'soanalysiscat1';
    StringField53.SetParentComponent(wdsClosedContracts);
    StringField53.Name := 'StringField53';
    StringField53.FieldName := 'soanalysiscat2';
    StringField54.SetParentComponent(wdsClosedContracts);
    StringField54.Name := 'StringField54';
    StringField54.FieldName := 'soanalysiscat3';
    StringField55.SetParentComponent(wdsClosedContracts);
    StringField55.Name := 'StringField55';
    StringField55.FieldName := 'maxdrivetime';
    TimeField1.SetParentComponent(wdsClosedContracts);
    TimeField1.Name := 'TimeField1';
    TimeField1.FieldName := 'maxtrafeltime';
    IntegerField24.SetParentComponent(wdsClosedContracts);
    IntegerField24.Name := 'IntegerField24';
    IntegerField24.FieldName := 'firstwarning';
    IntegerField25.SetParentComponent(wdsClosedContracts);
    IntegerField25.Name := 'IntegerField25';
    IntegerField25.FieldName := 'secondwarning';
    IntegerField26.SetParentComponent(wdsClosedContracts);
    IntegerField26.Name := 'IntegerField26';
    IntegerField26.FieldName := 'slots';
    DateField1.SetParentComponent(wdsClosedContracts);
    DateField1.Name := 'DateField1';
    DateField1.FieldName := 'STARTDATE';
    DateField2.SetParentComponent(wdsClosedContracts);
    DateField2.Name := 'DateField2';
    DateField2.FieldName := 'COMPDATE';
    DateField3.SetParentComponent(wdsClosedContracts);
    DateField3.Name := 'DateField3';
    DateField3.FieldName := 'SENDEDDATE';
    StringField56.SetParentComponent(wdsClosedContracts);
    StringField56.Name := 'StringField56';
    StringField56.FieldName := 'DEB_CODE';
    StringField57.SetParentComponent(wdsClosedContracts);
    StringField57.Name := 'StringField57';
    StringField57.FieldName := 'DEB_NAME';
    StringField58.SetParentComponent(wdsClosedContracts);
    StringField58.Name := 'StringField58';
    StringField58.FieldName := 'SUSPENDED';
    FloatField10.SetParentComponent(wdsClosedContracts);
    FloatField10.Name := 'FloatField10';
    FloatField10.FieldName := 'CREDITLIMIT';
    FloatField11.SetParentComponent(wdsClosedContracts);
    FloatField11.Name := 'FloatField11';
    FloatField11.FieldName := 'ORDERBALANCE';
    FloatField12.SetParentComponent(wdsClosedContracts);
    FloatField12.Name := 'FloatField12';
    FloatField12.FieldName := 'INVOICEBALANCE';
    FloatField13.SetParentComponent(wdsClosedContracts);
    FloatField13.Name := 'FloatField13';
    FloatField13.FieldName := 'AVAILIBLECL';
    StringField59.SetParentComponent(wdsClosedContracts);
    StringField59.Name := 'StringField59';
    StringField59.FieldName := 'CLIENTMULTILOADINV';
    StringField60.SetParentComponent(wdsClosedContracts);
    StringField60.Name := 'StringField60';
    StringField60.FieldName := 'MULTILOADDESC';
    StringField61.SetParentComponent(wdsClosedContracts);
    StringField61.Name := 'StringField61';
    StringField61.FieldName := 'CLIENTINVOICETYPE';
    StringField62.SetParentComponent(wdsClosedContracts);
    StringField62.Name := 'StringField62';
    StringField62.FieldName := 'MULTICONTRACT';
    StringField63.SetParentComponent(wdsClosedContracts);
    StringField63.Name := 'StringField63';
    StringField63.FieldName := 'CLIENTLINKED';
    StringField64.SetParentComponent(wdsClosedContracts);
    StringField64.Name := 'StringField64';
    StringField64.FieldName := 'CLIENTEMAIL';
    StringField65.SetParentComponent(wdsClosedContracts);
    StringField65.Name := 'StringField65';
    StringField65.FieldName := 'LINKEDCONFIG';
    StringField66.SetParentComponent(wdsClosedContracts);
    StringField66.Name := 'StringField66';
    StringField66.FieldName := 'ACCOUNTNUMBER';
    FloatField14.SetParentComponent(wdsClosedContracts);
    FloatField14.Name := 'FloatField14';
    FloatField14.FieldName := 'MAINBALANCE';
    StringField67.SetParentComponent(wdsClosedContracts);
    StringField67.Name := 'StringField67';
    StringField67.FieldName := 'MAINTENANCELINKACCOUNT';
    StringField68.SetParentComponent(wdsClosedContracts);
    StringField68.Name := 'StringField68';
    StringField68.FieldName := 'EXPORTLIST';
    StringField69.SetParentComponent(wdsClosedContracts);
    StringField69.Name := 'StringField69';
    StringField69.FieldName := 'EXPORTLOADS';
    StringField70.SetParentComponent(wdsClosedContracts);
    StringField70.Name := 'StringField70';
    StringField70.FieldName := 'RENAMEFIELD';
    StringField71.SetParentComponent(wdsClosedContracts);
    StringField71.Name := 'StringField71';
    StringField71.FieldName := 'EXPORTPATH';
    FloatField15.SetParentComponent(wdsClosedContracts);
    FloatField15.Name := 'FloatField15';
    FloatField15.FieldName := 'PREVCL';
    StringField72.SetParentComponent(wdsClosedContracts);
    StringField72.Name := 'StringField72';
    StringField72.FieldName := 'SECUREBOOK';
    StringField73.SetParentComponent(wdsClosedContracts);
    StringField73.Name := 'StringField73';
    StringField73.FieldName := 'QUOTESYSTEM';
    StringField74.SetParentComponent(wdsClosedContracts);
    StringField74.Name := 'StringField74';
    StringField74.FieldName := 'QUOTETYPE';
    StringField75.SetParentComponent(wdsClosedContracts);
    StringField75.Name := 'StringField75';
    StringField75.FieldName := 'EMAILLOADDOCS';
    StringField76.SetParentComponent(wdsClosedContracts);
    StringField76.Name := 'StringField76';
    StringField76.FieldName := 'STATEMENTTYPE';
    StringField77.SetParentComponent(wdsClosedContracts);
    StringField77.Name := 'StringField77';
    StringField77.FieldName := 'SHOWRECLOADS';
    StringField78.SetParentComponent(wdsClosedContracts);
    StringField78.Name := 'StringField78';
    StringField78.FieldName := 'LINKEDINVTYPE';
    IntegerField27.SetParentComponent(wdsClosedContracts);
    IntegerField27.Name := 'IntegerField27';
    IntegerField27.FieldName := 'DEFINVCOMPNO';
    StringField79.SetParentComponent(wdsClosedContracts);
    StringField79.Name := 'StringField79';
    StringField79.FieldName := 'invoicetypenoncon';
    StringField79.Size := 0;
    StringField80.SetParentComponent(wdsClosedContracts);
    StringField80.Name := 'StringField80';
    StringField80.FieldName := 'singlenoncon';
    StringField81.SetParentComponent(wdsClosedContracts);
    StringField81.Name := 'StringField81';
    StringField81.FieldName := 'LINKSERIAL';
    StringField82.SetParentComponent(wdsClosedContracts);
    StringField82.Name := 'StringField82';
    StringField82.FieldName := 'LINKAPI';
    StringField83.SetParentComponent(wdsClosedContracts);
    StringField83.Name := 'StringField83';
    StringField83.FieldName := 'serverip';
    IntegerField28.SetParentComponent(wdsClosedContracts);
    IntegerField28.Name := 'IntegerField28';
    IntegerField28.FieldName := 'serverport';
    StringField84.SetParentComponent(wdsClosedContracts);
    StringField84.Name := 'StringField84';
    StringField84.FieldName := 'serveruser';
    StringField85.SetParentComponent(wdsClosedContracts);
    StringField85.Name := 'StringField85';
    StringField85.FieldName := 'serverpassword';
    StringField86.SetParentComponent(wdsClosedContracts);
    StringField86.Name := 'StringField86';
    StringField86.FieldName := 'serveraccount';
    StringField87.SetParentComponent(wdsClosedContracts);
    StringField87.Name := 'StringField87';
    StringField87.FieldName := 'altserverip';
    IntegerField29.SetParentComponent(wdsClosedContracts);
    IntegerField29.Name := 'IntegerField29';
    IntegerField29.FieldName := 'altserverport';
    StringField88.SetParentComponent(wdsClosedContracts);
    StringField88.Name := 'StringField88';
    StringField88.FieldName := 'altserveruser';
    StringField89.SetParentComponent(wdsClosedContracts);
    StringField89.Name := 'StringField89';
    StringField89.FieldName := 'altserverpassword';
    StringField90.SetParentComponent(wdsClosedContracts);
    StringField90.Name := 'StringField90';
    StringField90.FieldName := 'serversystem';
    IntegerField30.SetParentComponent(wdsClosedContracts);
    IntegerField30.Name := 'IntegerField30';
    IntegerField30.FieldName := 'No';
    StringField91.SetParentComponent(wdsClosedContracts);
    StringField91.Name := 'StringField91';
    StringField91.FieldName := 'NAME';
    StringField92.SetParentComponent(wdsClosedContracts);
    StringField92.Name := 'StringField92';
    StringField92.FieldName := 'ITEMCODE';
    IntegerField31.SetParentComponent(wdsClosedContracts);
    IntegerField31.Name := 'IntegerField31';
    IntegerField31.FieldName := 'STORE';
    StringField93.SetParentComponent(wdsClosedContracts);
    StringField93.Name := 'StringField93';
    StringField93.FieldName := 'UNITNUMBER';
    FloatField16.SetParentComponent(wdsClosedContracts);
    FloatField16.Name := 'FloatField16';
    FloatField16.FieldName := 'DENSITY';
    wcClosedContracts.SetParentComponent(Self);
    wcClosedContracts.Name := 'wcClosedContracts';
    wcClosedContracts.Connection := dmData.dbConnect;
    wcClosedContracts.Left := 32;
    wcClosedContracts.Top := 300;
    dsClosedContracts.SetParentComponent(Self);
    dsClosedContracts.Name := 'dsClosedContracts';
    dsClosedContracts.DataSet := wdsClosedContracts;
    dsClosedContracts.Left := 120;
    dsClosedContracts.Top := 300;
    WebRESTClient1.SetParentComponent(Self);
    WebRESTClient1.Name := 'WebRESTClient1';
    WebRESTClient1.LoginHeight := 0;
    WebRESTClient1.LoginWidth := 0;
    WebRESTClient1.Left := 1048;
    WebRESTClient1.Top := 528;
    wcAContractImportSetup.SetParentComponent(Self);
    wcAContractImportSetup.Name := 'wcAContractImportSetup';
    wcAContractImportSetup.Connection := dmData.dbConnect;
    wcAContractImportSetup.Left := 32;
    wcAContractImportSetup.Top := 212;
    wdsAContractImportSetup.SetParentComponent(Self);
    wdsAContractImportSetup.Name := 'wdsAContractImportSetup';
    wdsAContractImportSetup.Connection := dmData.dbConnect;
    wdsAContractImportSetup.Left := 80;
    wdsAContractImportSetup.Top := 212;
    IntegerField32.SetParentComponent(wdsAContractImportSetup);
    IntegerField32.Name := 'IntegerField32';
    IntegerField32.FieldName := 'CONTRACTNO';
    StringField94.SetParentComponent(wdsAContractImportSetup);
    StringField94.Name := 'StringField94';
    StringField94.FieldName := 'CONTRACTNAME';
    StringField95.SetParentComponent(wdsAContractImportSetup);
    StringField95.Name := 'StringField95';
    StringField95.FieldName := 'DEBCODE';
    IntegerField33.SetParentComponent(wdsAContractImportSetup);
    IntegerField33.Name := 'IntegerField33';
    IntegerField33.FieldName := 'COMMODITIESNO';
    IntegerField34.SetParentComponent(wdsAContractImportSetup);
    IntegerField34.Name := 'IntegerField34';
    IntegerField34.FieldName := 'LOADCOUNTRYNO';
    IntegerField35.SetParentComponent(wdsAContractImportSetup);
    IntegerField35.Name := 'IntegerField35';
    IntegerField35.FieldName := 'LOADPROVINCENO';
    IntegerField36.SetParentComponent(wdsAContractImportSetup);
    IntegerField36.Name := 'IntegerField36';
    IntegerField36.FieldName := 'LOADCITYNO';
    IntegerField37.SetParentComponent(wdsAContractImportSetup);
    IntegerField37.Name := 'IntegerField37';
    IntegerField37.FieldName := 'LOADINGNO';
    IntegerField38.SetParentComponent(wdsAContractImportSetup);
    IntegerField38.Name := 'IntegerField38';
    IntegerField38.FieldName := 'OFFLOADCOUNTRYNO';
    IntegerField39.SetParentComponent(wdsAContractImportSetup);
    IntegerField39.Name := 'IntegerField39';
    IntegerField39.FieldName := 'OFFLOADPROVINCENO';
    IntegerField40.SetParentComponent(wdsAContractImportSetup);
    IntegerField40.Name := 'IntegerField40';
    IntegerField40.FieldName := 'OFFLOADCITYNO';
    IntegerField41.SetParentComponent(wdsAContractImportSetup);
    IntegerField41.Name := 'IntegerField41';
    IntegerField41.FieldName := 'OFFLOADINGNO';
    StringField96.SetParentComponent(wdsAContractImportSetup);
    StringField96.Name := 'StringField96';
    StringField96.FieldName := 'INVLOADING';
    StringField97.SetParentComponent(wdsAContractImportSetup);
    StringField97.Name := 'StringField97';
    StringField97.FieldName := 'INVOFFLOADING';
    FloatField17.SetParentComponent(wdsAContractImportSetup);
    FloatField17.Name := 'FloatField17';
    FloatField17.FieldName := 'TOTALTONS';
    FloatField18.SetParentComponent(wdsAContractImportSetup);
    FloatField18.Name := 'FloatField18';
    FloatField18.FieldName := 'TOTALTONSORDER';
    FloatField19.SetParentComponent(wdsAContractImportSetup);
    FloatField19.Name := 'FloatField19';
    FloatField19.FieldName := 'TOTALTONSLOADED';
    FloatField20.SetParentComponent(wdsAContractImportSetup);
    FloatField20.Name := 'FloatField20';
    FloatField20.FieldName := 'TOTALTONSOFFLOADED';
    FloatField21.SetParentComponent(wdsAContractImportSetup);
    FloatField21.Name := 'FloatField21';
    FloatField21.FieldName := 'TOTALTONSINVOICED';
    StringField98.SetParentComponent(wdsAContractImportSetup);
    StringField98.Name := 'StringField98';
    StringField98.FieldName := 'COMPLETED';
    StringField99.SetParentComponent(wdsAContractImportSetup);
    StringField99.Name := 'StringField99';
    StringField99.FieldName := 'CONTROLLER';
    StringField99.Size := 0;
    FloatField22.SetParentComponent(wdsAContractImportSetup);
    FloatField22.Name := 'FloatField22';
    FloatField22.FieldName := 'AVGTONS';
    IntegerField42.SetParentComponent(wdsAContractImportSetup);
    IntegerField42.Name := 'IntegerField42';
    IntegerField42.FieldName := 'TOTALLOADS';
    IntegerField43.SetParentComponent(wdsAContractImportSetup);
    IntegerField43.Name := 'IntegerField43';
    IntegerField43.FieldName := 'LOADSORDER';
    IntegerField44.SetParentComponent(wdsAContractImportSetup);
    IntegerField44.Name := 'IntegerField44';
    IntegerField44.FieldName := 'LOADSLOADED';
    IntegerField45.SetParentComponent(wdsAContractImportSetup);
    IntegerField45.Name := 'IntegerField45';
    IntegerField45.FieldName := 'LOADSOFFLOADED';
    IntegerField46.SetParentComponent(wdsAContractImportSetup);
    IntegerField46.Name := 'IntegerField46';
    IntegerField46.FieldName := 'LOADSINVOICED';
    IntegerField47.SetParentComponent(wdsAContractImportSetup);
    IntegerField47.Name := 'IntegerField47';
    IntegerField47.FieldName := 'PAYMENTTERMS';
    IntegerField48.SetParentComponent(wdsAContractImportSetup);
    IntegerField48.Name := 'IntegerField48';
    IntegerField48.FieldName := 'PAYMENTTYPE';
    StringField100.SetParentComponent(wdsAContractImportSetup);
    StringField100.Name := 'StringField100';
    StringField100.FieldName := 'ADDHOC';
    StringField101.SetParentComponent(wdsAContractImportSetup);
    StringField101.Name := 'StringField101';
    StringField101.FieldName := 'DEDICATED';
    StringField102.SetParentComponent(wdsAContractImportSetup);
    StringField102.Name := 'StringField102';
    StringField102.FieldName := 'ORDERNO';
    StringField103.SetParentComponent(wdsAContractImportSetup);
    StringField103.Name := 'StringField103';
    StringField103.FieldName := 'INVVAT';
    StringField104.SetParentComponent(wdsAContractImportSetup);
    StringField104.Name := 'StringField104';
    StringField104.FieldName := 'MULTILOADINV';
    StringField105.SetParentComponent(wdsAContractImportSetup);
    StringField105.Name := 'StringField105';
    StringField105.FieldName := 'SENDED';
    StringField106.SetParentComponent(wdsAContractImportSetup);
    StringField106.Name := 'StringField106';
    StringField106.FieldName := 'PRELISTING';
    StringField107.SetParentComponent(wdsAContractImportSetup);
    StringField107.Name := 'StringField107';
    StringField107.FieldName := 'POSTLISTING';
    StringField108.SetParentComponent(wdsAContractImportSetup);
    StringField108.Name := 'StringField108';
    StringField108.FieldName := 'INVOICETYPE';
    FloatField23.SetParentComponent(wdsAContractImportSetup);
    FloatField23.Name := 'FloatField23';
    FloatField23.FieldName := 'DISTANCE';
    SmallintField4.SetParentComponent(wdsAContractImportSetup);
    SmallintField4.Name := 'SmallintField4';
    SmallintField4.FieldName := 'DRIVERRATIO';
    SmallintField5.SetParentComponent(wdsAContractImportSetup);
    SmallintField5.Name := 'SmallintField5';
    SmallintField5.FieldName := 'CUTOFF1';
    IntegerField49.SetParentComponent(wdsAContractImportSetup);
    IntegerField49.Name := 'IntegerField49';
    IntegerField49.FieldName := 'CUTOFFPERIOD1';
    SmallintField6.SetParentComponent(wdsAContractImportSetup);
    SmallintField6.Name := 'SmallintField6';
    SmallintField6.FieldName := 'CUTOFF2';
    IntegerField50.SetParentComponent(wdsAContractImportSetup);
    IntegerField50.Name := 'IntegerField50';
    IntegerField50.FieldName := 'CUTOFFPERIOD2';
    StringField109.SetParentComponent(wdsAContractImportSetup);
    StringField109.Name := 'StringField109';
    StringField109.FieldName := 'SAGEINVENTORY';
    StringField110.SetParentComponent(wdsAContractImportSetup);
    StringField110.Name := 'StringField110';
    StringField110.FieldName := 'SAGEGL';
    StringField111.SetParentComponent(wdsAContractImportSetup);
    StringField111.Name := 'StringField111';
    StringField111.FieldName := 'SAGECODE';
    StringField112.SetParentComponent(wdsAContractImportSetup);
    StringField112.Name := 'StringField112';
    StringField112.FieldName := 'SAGEEXPCODE';
    StringField113.SetParentComponent(wdsAContractImportSetup);
    StringField113.Name := 'StringField113';
    StringField113.FieldName := 'STRATERATE';
    StringField114.SetParentComponent(wdsAContractImportSetup);
    StringField114.Name := 'StringField114';
    StringField114.FieldName := 'CHGOFFLOAD';
    StringField115.SetParentComponent(wdsAContractImportSetup);
    StringField115.Name := 'StringField115';
    StringField115.FieldName := 'CHGPRICE';
    StringField116.SetParentComponent(wdsAContractImportSetup);
    StringField116.Name := 'StringField116';
    StringField116.FieldName := 'CAPTURETONS';
    StringField117.SetParentComponent(wdsAContractImportSetup);
    StringField117.Name := 'StringField117';
    StringField117.FieldName := 'INVOICETONS';
    StringField118.SetParentComponent(wdsAContractImportSetup);
    StringField118.Name := 'StringField118';
    StringField118.FieldName := 'CHGSUBPRICE';
    IntegerField51.SetParentComponent(wdsAContractImportSetup);
    IntegerField51.Name := 'IntegerField51';
    IntegerField51.FieldName := 'MAXLOADORDERS';
    StringField119.SetParentComponent(wdsAContractImportSetup);
    StringField119.Name := 'StringField119';
    StringField119.FieldName := 'ADDDESCRIPTION';
    IntegerField52.SetParentComponent(wdsAContractImportSetup);
    IntegerField52.Name := 'IntegerField52';
    IntegerField52.FieldName := 'VARIANCETYPE';
    FloatField24.SetParentComponent(wdsAContractImportSetup);
    FloatField24.Name := 'FloatField24';
    FloatField24.FieldName := 'VARIANCEVALUE';
    StringField120.SetParentComponent(wdsAContractImportSetup);
    StringField120.Name := 'StringField120';
    StringField120.FieldName := 'PRINTLC';
    StringField121.SetParentComponent(wdsAContractImportSetup);
    StringField121.Name := 'StringField121';
    StringField121.FieldName := 'PRINTDN';
    StringField122.SetParentComponent(wdsAContractImportSetup);
    StringField122.Name := 'StringField122';
    StringField122.FieldName := 'PRINTTS';
    StringField123.SetParentComponent(wdsAContractImportSetup);
    StringField123.Name := 'StringField123';
    StringField123.FieldName := 'DNTYPE';
    StringField124.SetParentComponent(wdsAContractImportSetup);
    StringField124.Name := 'StringField124';
    StringField124.FieldName := 'TSTYPE';
    StringField125.SetParentComponent(wdsAContractImportSetup);
    StringField125.Name := 'StringField125';
    StringField125.FieldName := 'SHORTDESC';
    StringField126.SetParentComponent(wdsAContractImportSetup);
    StringField126.Name := 'StringField126';
    StringField126.FieldName := 'OLDLOADSCREEN';
    StringField127.SetParentComponent(wdsAContractImportSetup);
    StringField127.Name := 'StringField127';
    StringField127.FieldName := 'SHOWBOOKINGS';
    StringField128.SetParentComponent(wdsAContractImportSetup);
    StringField128.Name := 'StringField128';
    StringField128.FieldName := 'SHOWADDITIONAL';
    IntegerField53.SetParentComponent(wdsAContractImportSetup);
    IntegerField53.Name := 'IntegerField53';
    IntegerField53.FieldName := 'PRICETYPE';
    StringField129.SetParentComponent(wdsAContractImportSetup);
    StringField129.Name := 'StringField129';
    StringField129.FieldName := 'USEDOCKETINVNO';
    StringField130.SetParentComponent(wdsAContractImportSetup);
    StringField130.Name := 'StringField130';
    StringField130.FieldName := 'SAGECODE2';
    StringField131.SetParentComponent(wdsAContractImportSetup);
    StringField131.Name := 'StringField131';
    StringField131.FieldName := 'SAGEEXPCODE2';
    StringField132.SetParentComponent(wdsAContractImportSetup);
    StringField132.Name := 'StringField132';
    StringField132.FieldName := 'SAGEINVENTORY2';
    StringField133.SetParentComponent(wdsAContractImportSetup);
    StringField133.Name := 'StringField133';
    StringField133.FieldName := 'SAGEGL2';
    StringField134.SetParentComponent(wdsAContractImportSetup);
    StringField134.Name := 'StringField134';
    StringField134.FieldName := 'HAULAGETYPE';
    StringField135.SetParentComponent(wdsAContractImportSetup);
    StringField135.Name := 'StringField135';
    StringField135.FieldName := 'LINKZEROML';
    StringField136.SetParentComponent(wdsAContractImportSetup);
    StringField136.Name := 'StringField136';
    StringField136.FieldName := 'ATTACHEDEMAIL';
    IntegerField54.SetParentComponent(wdsAContractImportSetup);
    IntegerField54.Name := 'IntegerField54';
    IntegerField54.FieldName := 'CLIENTLINKCONTRACT';
    StringField137.SetParentComponent(wdsAContractImportSetup);
    StringField137.Name := 'StringField137';
    StringField137.FieldName := 'QUOTEREFNO';
    StringField138.SetParentComponent(wdsAContractImportSetup);
    StringField138.Name := 'StringField138';
    StringField138.FieldName := 'SORTLOADDATE';
    StringField139.SetParentComponent(wdsAContractImportSetup);
    StringField139.Name := 'StringField139';
    StringField139.FieldName := 'SORTOFFDATE';
    StringField140.SetParentComponent(wdsAContractImportSetup);
    StringField140.Name := 'StringField140';
    StringField140.FieldName := 'SORTLOADWAY';
    StringField141.SetParentComponent(wdsAContractImportSetup);
    StringField141.Name := 'StringField141';
    StringField141.FieldName := 'SORTOFFWAY';
    StringField142.SetParentComponent(wdsAContractImportSetup);
    StringField142.Name := 'StringField142';
    StringField142.FieldName := 'SORTDOCKET';
    StringField143.SetParentComponent(wdsAContractImportSetup);
    StringField143.Name := 'StringField143';
    StringField143.FieldName := 'SINVVAT';
    FloatField25.SetParentComponent(wdsAContractImportSetup);
    FloatField25.Name := 'FloatField25';
    FloatField25.FieldName := 'LOADINSTRUCTQTY';
    StringField144.SetParentComponent(wdsAContractImportSetup);
    StringField144.Name := 'StringField144';
    StringField144.FieldName := 'CHGLOAD';
    StringField144.Size := 0;
    StringField145.SetParentComponent(wdsAContractImportSetup);
    StringField145.Name := 'StringField145';
    StringField145.FieldName := 'soanalysiscat1';
    StringField146.SetParentComponent(wdsAContractImportSetup);
    StringField146.Name := 'StringField146';
    StringField146.FieldName := 'soanalysiscat2';
    StringField147.SetParentComponent(wdsAContractImportSetup);
    StringField147.Name := 'StringField147';
    StringField147.FieldName := 'soanalysiscat3';
    StringField148.SetParentComponent(wdsAContractImportSetup);
    StringField148.Name := 'StringField148';
    StringField148.FieldName := 'maxdrivetime';
    TimeField2.SetParentComponent(wdsAContractImportSetup);
    TimeField2.Name := 'TimeField2';
    TimeField2.FieldName := 'maxtrafeltime';
    IntegerField55.SetParentComponent(wdsAContractImportSetup);
    IntegerField55.Name := 'IntegerField55';
    IntegerField55.FieldName := 'firstwarning';
    IntegerField56.SetParentComponent(wdsAContractImportSetup);
    IntegerField56.Name := 'IntegerField56';
    IntegerField56.FieldName := 'secondwarning';
    IntegerField57.SetParentComponent(wdsAContractImportSetup);
    IntegerField57.Name := 'IntegerField57';
    IntegerField57.FieldName := 'slots';
    DateField4.SetParentComponent(wdsAContractImportSetup);
    DateField4.Name := 'DateField4';
    DateField4.FieldName := 'STARTDATE';
    DateField5.SetParentComponent(wdsAContractImportSetup);
    DateField5.Name := 'DateField5';
    DateField5.FieldName := 'COMPDATE';
    DateField6.SetParentComponent(wdsAContractImportSetup);
    DateField6.Name := 'DateField6';
    DateField6.FieldName := 'SENDEDDATE';
    StringField149.SetParentComponent(wdsAContractImportSetup);
    StringField149.Name := 'StringField149';
    StringField149.FieldName := 'DEB_CODE';
    StringField150.SetParentComponent(wdsAContractImportSetup);
    StringField150.Name := 'StringField150';
    StringField150.FieldName := 'DEB_NAME';
    StringField151.SetParentComponent(wdsAContractImportSetup);
    StringField151.Name := 'StringField151';
    StringField151.FieldName := 'SUSPENDED';
    FloatField26.SetParentComponent(wdsAContractImportSetup);
    FloatField26.Name := 'FloatField26';
    FloatField26.FieldName := 'CREDITLIMIT';
    FloatField27.SetParentComponent(wdsAContractImportSetup);
    FloatField27.Name := 'FloatField27';
    FloatField27.FieldName := 'ORDERBALANCE';
    FloatField28.SetParentComponent(wdsAContractImportSetup);
    FloatField28.Name := 'FloatField28';
    FloatField28.FieldName := 'INVOICEBALANCE';
    FloatField29.SetParentComponent(wdsAContractImportSetup);
    FloatField29.Name := 'FloatField29';
    FloatField29.FieldName := 'AVAILIBLECL';
    StringField152.SetParentComponent(wdsAContractImportSetup);
    StringField152.Name := 'StringField152';
    StringField152.FieldName := 'CLIENTMULTILOADINV';
    StringField153.SetParentComponent(wdsAContractImportSetup);
    StringField153.Name := 'StringField153';
    StringField153.FieldName := 'MULTILOADDESC';
    StringField154.SetParentComponent(wdsAContractImportSetup);
    StringField154.Name := 'StringField154';
    StringField154.FieldName := 'CLIENTINVOICETYPE';
    StringField155.SetParentComponent(wdsAContractImportSetup);
    StringField155.Name := 'StringField155';
    StringField155.FieldName := 'MULTICONTRACT';
    StringField156.SetParentComponent(wdsAContractImportSetup);
    StringField156.Name := 'StringField156';
    StringField156.FieldName := 'CLIENTLINKED';
    StringField157.SetParentComponent(wdsAContractImportSetup);
    StringField157.Name := 'StringField157';
    StringField157.FieldName := 'CLIENTEMAIL';
    StringField158.SetParentComponent(wdsAContractImportSetup);
    StringField158.Name := 'StringField158';
    StringField158.FieldName := 'LINKEDCONFIG';
    StringField159.SetParentComponent(wdsAContractImportSetup);
    StringField159.Name := 'StringField159';
    StringField159.FieldName := 'ACCOUNTNUMBER';
    FloatField30.SetParentComponent(wdsAContractImportSetup);
    FloatField30.Name := 'FloatField30';
    FloatField30.FieldName := 'MAINBALANCE';
    StringField160.SetParentComponent(wdsAContractImportSetup);
    StringField160.Name := 'StringField160';
    StringField160.FieldName := 'MAINTENANCELINKACCOUNT';
    StringField161.SetParentComponent(wdsAContractImportSetup);
    StringField161.Name := 'StringField161';
    StringField161.FieldName := 'EXPORTLIST';
    StringField162.SetParentComponent(wdsAContractImportSetup);
    StringField162.Name := 'StringField162';
    StringField162.FieldName := 'EXPORTLOADS';
    StringField163.SetParentComponent(wdsAContractImportSetup);
    StringField163.Name := 'StringField163';
    StringField163.FieldName := 'RENAMEFIELD';
    StringField164.SetParentComponent(wdsAContractImportSetup);
    StringField164.Name := 'StringField164';
    StringField164.FieldName := 'EXPORTPATH';
    FloatField31.SetParentComponent(wdsAContractImportSetup);
    FloatField31.Name := 'FloatField31';
    FloatField31.FieldName := 'PREVCL';
    StringField165.SetParentComponent(wdsAContractImportSetup);
    StringField165.Name := 'StringField165';
    StringField165.FieldName := 'SECUREBOOK';
    StringField166.SetParentComponent(wdsAContractImportSetup);
    StringField166.Name := 'StringField166';
    StringField166.FieldName := 'QUOTESYSTEM';
    StringField167.SetParentComponent(wdsAContractImportSetup);
    StringField167.Name := 'StringField167';
    StringField167.FieldName := 'QUOTETYPE';
    StringField168.SetParentComponent(wdsAContractImportSetup);
    StringField168.Name := 'StringField168';
    StringField168.FieldName := 'EMAILLOADDOCS';
    StringField169.SetParentComponent(wdsAContractImportSetup);
    StringField169.Name := 'StringField169';
    StringField169.FieldName := 'STATEMENTTYPE';
    StringField170.SetParentComponent(wdsAContractImportSetup);
    StringField170.Name := 'StringField170';
    StringField170.FieldName := 'SHOWRECLOADS';
    StringField171.SetParentComponent(wdsAContractImportSetup);
    StringField171.Name := 'StringField171';
    StringField171.FieldName := 'LINKEDINVTYPE';
    IntegerField58.SetParentComponent(wdsAContractImportSetup);
    IntegerField58.Name := 'IntegerField58';
    IntegerField58.FieldName := 'DEFINVCOMPNO';
    StringField172.SetParentComponent(wdsAContractImportSetup);
    StringField172.Name := 'StringField172';
    StringField172.FieldName := 'invoicetypenoncon';
    StringField172.Size := 0;
    StringField173.SetParentComponent(wdsAContractImportSetup);
    StringField173.Name := 'StringField173';
    StringField173.FieldName := 'singlenoncon';
    StringField174.SetParentComponent(wdsAContractImportSetup);
    StringField174.Name := 'StringField174';
    StringField174.FieldName := 'LINKSERIAL';
    StringField175.SetParentComponent(wdsAContractImportSetup);
    StringField175.Name := 'StringField175';
    StringField175.FieldName := 'LINKAPI';
    StringField176.SetParentComponent(wdsAContractImportSetup);
    StringField176.Name := 'StringField176';
    StringField176.FieldName := 'serverip';
    IntegerField59.SetParentComponent(wdsAContractImportSetup);
    IntegerField59.Name := 'IntegerField59';
    IntegerField59.FieldName := 'serverport';
    StringField177.SetParentComponent(wdsAContractImportSetup);
    StringField177.Name := 'StringField177';
    StringField177.FieldName := 'serveruser';
    StringField178.SetParentComponent(wdsAContractImportSetup);
    StringField178.Name := 'StringField178';
    StringField178.FieldName := 'serverpassword';
    StringField179.SetParentComponent(wdsAContractImportSetup);
    StringField179.Name := 'StringField179';
    StringField179.FieldName := 'serveraccount';
    StringField180.SetParentComponent(wdsAContractImportSetup);
    StringField180.Name := 'StringField180';
    StringField180.FieldName := 'altserverip';
    IntegerField60.SetParentComponent(wdsAContractImportSetup);
    IntegerField60.Name := 'IntegerField60';
    IntegerField60.FieldName := 'altserverport';
    StringField181.SetParentComponent(wdsAContractImportSetup);
    StringField181.Name := 'StringField181';
    StringField181.FieldName := 'altserveruser';
    StringField182.SetParentComponent(wdsAContractImportSetup);
    StringField182.Name := 'StringField182';
    StringField182.FieldName := 'altserverpassword';
    StringField183.SetParentComponent(wdsAContractImportSetup);
    StringField183.Name := 'StringField183';
    StringField183.FieldName := 'serversystem';
    IntegerField61.SetParentComponent(wdsAContractImportSetup);
    IntegerField61.Name := 'IntegerField61';
    IntegerField61.FieldName := 'No';
    StringField184.SetParentComponent(wdsAContractImportSetup);
    StringField184.Name := 'StringField184';
    StringField184.FieldName := 'NAME';
    StringField185.SetParentComponent(wdsAContractImportSetup);
    StringField185.Name := 'StringField185';
    StringField185.FieldName := 'ITEMCODE';
    IntegerField62.SetParentComponent(wdsAContractImportSetup);
    IntegerField62.Name := 'IntegerField62';
    IntegerField62.FieldName := 'STORE';
    StringField186.SetParentComponent(wdsAContractImportSetup);
    StringField186.Name := 'StringField186';
    StringField186.FieldName := 'UNITNUMBER';
    FloatField32.SetParentComponent(wdsAContractImportSetup);
    FloatField32.Name := 'FloatField32';
    FloatField32.FieldName := 'DENSITY';
    StringField187.SetParentComponent(wdsAContractImportSetup);
    StringField187.Name := 'StringField187';
    StringField187.FieldName := 'LoadCountryName';
    StringField188.SetParentComponent(wdsAContractImportSetup);
    StringField188.Name := 'StringField188';
    StringField188.FieldName := 'LoadProvinceName';
    StringField189.SetParentComponent(wdsAContractImportSetup);
    StringField189.Name := 'StringField189';
    StringField189.FieldName := 'LoadCityName';
    StringField190.SetParentComponent(wdsAContractImportSetup);
    StringField190.Name := 'StringField190';
    StringField190.FieldName := 'LoadInfoName';
    StringField191.SetParentComponent(wdsAContractImportSetup);
    StringField191.Name := 'StringField191';
    StringField191.FieldName := 'OffLoadCountryName';
    StringField192.SetParentComponent(wdsAContractImportSetup);
    StringField192.Name := 'StringField192';
    StringField192.FieldName := 'OffLoadProvinceName';
    StringField193.SetParentComponent(wdsAContractImportSetup);
    StringField193.Name := 'StringField193';
    StringField193.FieldName := 'OffLoadCityName';
    StringField194.SetParentComponent(wdsAContractImportSetup);
    StringField194.Name := 'StringField194';
    StringField194.FieldName := 'OffLoadInfoName';
    StringField195.SetParentComponent(wdsAContractImportSetup);
    StringField195.Name := 'StringField195';
    StringField195.FieldName := 'CommodityName';
    StringField196.SetParentComponent(wdsAContractImportSetup);
    StringField196.Name := 'StringField196';
    StringField196.FieldName := 'PayTermsName';
    StringField197.SetParentComponent(wdsAContractImportSetup);
    StringField197.Name := 'StringField197';
    StringField197.FieldName := 'CONTROLLERName';
    StringField198.SetParentComponent(wdsAContractImportSetup);
    StringField198.Name := 'StringField198';
    StringField198.FieldName := 'CutOffPeriodDesc1';
    IntegerField63.SetParentComponent(wdsAContractImportSetup);
    IntegerField63.Name := 'IntegerField63';
    IntegerField63.FieldName := 'cutoff';
    StringField199.SetParentComponent(wdsAContractImportSetup);
    StringField199.Name := 'StringField199';
    StringField199.FieldName := 'CutOffPeriodDesc2';
    dsAContractImportSetup.SetParentComponent(Self);
    dsAContractImportSetup.Name := 'dsAContractImportSetup';
    dsAContractImportSetup.DataSet := wdsAContractImportSetup;
    dsAContractImportSetup.Left := 120;
    dsAContractImportSetup.Top := 212;
  finally
    WebDBLabel12.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    BitMapContainer1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebSpeedButton13.AfterLoadDFMValues;
    WebSpeedButton14.AfterLoadDFMValues;
    WebSpeedButton15.AfterLoadDFMValues;
    WebSpeedButton16.AfterLoadDFMValues;
    edtActiveContractImportPC.AfterLoadDFMValues;
    wpcContractInfo.AfterLoadDFMValues;
    wpcsActiveContracts.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    wpcActiveContracts.AfterLoadDFMValues;
    wpcsContractInfo.AfterLoadDFMValues;
    WebPanel8.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebDBLabel13.AfterLoadDFMValues;
    dbedtClientName.AfterLoadDFMValues;
    dbedtShortdescription.AfterLoadDFMValues;
    dbedtLongDescription.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    dbedtLoadType.AfterLoadDFMValues;
    WebDBRadioGroup1.AfterLoadDFMValues;
    WebGroupBox1.AfterLoadDFMValues;
    WebDBEdit7.AfterLoadDFMValues;
    WebDBEdit8.AfterLoadDFMValues;
    WebDBEdit9.AfterLoadDFMValues;
    WebDBEdit10.AfterLoadDFMValues;
    WebButton3.AfterLoadDFMValues;
    WebButton4.AfterLoadDFMValues;
    WebButton5.AfterLoadDFMValues;
    WebButton6.AfterLoadDFMValues;
    WebGroupBox2.AfterLoadDFMValues;
    WebDBEdit11.AfterLoadDFMValues;
    WebDBEdit12.AfterLoadDFMValues;
    WebDBEdit13.AfterLoadDFMValues;
    WebDBEdit14.AfterLoadDFMValues;
    WebButton7.AfterLoadDFMValues;
    WebButton8.AfterLoadDFMValues;
    WebButton9.AfterLoadDFMValues;
    WebButton10.AfterLoadDFMValues;
    WebGroupBox3.AfterLoadDFMValues;
    WebDBEdit15.AfterLoadDFMValues;
    WebButton11.AfterLoadDFMValues;
    WebButton33.AfterLoadDFMValues;
    WebButton34.AfterLoadDFMValues;
    WebPanel29.AfterLoadDFMValues;
    WebButton60.AfterLoadDFMValues;
    btnSaveContract1.AfterLoadDFMValues;
    WebButton62.AfterLoadDFMValues;
    WebButton30.AfterLoadDFMValues;
    wpcsAdditionalInfo.AfterLoadDFMValues;
    WebPanel9.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebLabel26.AfterLoadDFMValues;
    WebLabel27.AfterLoadDFMValues;
    WebLabel28.AfterLoadDFMValues;
    WebLabel29.AfterLoadDFMValues;
    dbedtCpatureType.AfterLoadDFMValues;
    WebDBEdit17.AfterLoadDFMValues;
    WebDBEdit18.AfterLoadDFMValues;
    WebDBEdit19.AfterLoadDFMValues;
    WebDBEdit20.AfterLoadDFMValues;
    WebDBEdit21.AfterLoadDFMValues;
    WebDBEdit23.AfterLoadDFMValues;
    WebDBEdit24.AfterLoadDFMValues;
    WebDBEdit25.AfterLoadDFMValues;
    WebDBDateTimePicker1.AfterLoadDFMValues;
    WebButton12.AfterLoadDFMValues;
    cbxDedicated.AfterLoadDFMValues;
    cbxADHOC.AfterLoadDFMValues;
    WebButton13.AfterLoadDFMValues;
    WebDBEdit22.AfterLoadDFMValues;
    WebDBEdit26.AfterLoadDFMValues;
    WebDBEdit27.AfterLoadDFMValues;
    WebDBMaskEdit1.AfterLoadDFMValues;
    WebButton14.AfterLoadDFMValues;
    WebButton15.AfterLoadDFMValues;
    WebButton16.AfterLoadDFMValues;
    WebDBEdit28.AfterLoadDFMValues;
    WebDBEdit29.AfterLoadDFMValues;
    WebDBEdit30.AfterLoadDFMValues;
    WebDBEdit31.AfterLoadDFMValues;
    WebDBEdit32.AfterLoadDFMValues;
    WebDBEdit33.AfterLoadDFMValues;
    WebDBEdit34.AfterLoadDFMValues;
    WebDBEdit35.AfterLoadDFMValues;
    WebDBEdit36.AfterLoadDFMValues;
    WebDBEdit37.AfterLoadDFMValues;
    WebPanel28.AfterLoadDFMValues;
    WebButton57.AfterLoadDFMValues;
    btnSaveContract2.AfterLoadDFMValues;
    WebButton59.AfterLoadDFMValues;
    wpcsBillingInformation.AfterLoadDFMValues;
    WebPanel11.AfterLoadDFMValues;
    WebLabel30.AfterLoadDFMValues;
    WebLabel33.AfterLoadDFMValues;
    WebLabel34.AfterLoadDFMValues;
    WebLabel35.AfterLoadDFMValues;
    WebLabel36.AfterLoadDFMValues;
    WebLabel37.AfterLoadDFMValues;
    WebGroupBox4.AfterLoadDFMValues;
    WebDBCheckBox13.AfterLoadDFMValues;
    WebDBCheckBox14.AfterLoadDFMValues;
    WebDBCheckBox15.AfterLoadDFMValues;
    WebDBCheckBox16.AfterLoadDFMValues;
    WebDBCheckBox17.AfterLoadDFMValues;
    WebDBCheckBox18.AfterLoadDFMValues;
    WebDBCheckBox19.AfterLoadDFMValues;
    WebDBCheckBox20.AfterLoadDFMValues;
    WebDBCheckBox21.AfterLoadDFMValues;
    WebDBCheckBox22.AfterLoadDFMValues;
    WebDBCheckBox23.AfterLoadDFMValues;
    WebDBCheckBox24.AfterLoadDFMValues;
    WebDBCheckBox25.AfterLoadDFMValues;
    WebDBCheckBox26.AfterLoadDFMValues;
    WebDBCheckBox27.AfterLoadDFMValues;
    WebDBCheckBox28.AfterLoadDFMValues;
    WebDBCheckBox29.AfterLoadDFMValues;
    WebDBCheckBox30.AfterLoadDFMValues;
    WebDBEdit38.AfterLoadDFMValues;
    cbxMiltiLoadInvopice.AfterLoadDFMValues;
    gbMiltiLoadInv.AfterLoadDFMValues;
    WebDBCheckBox4.AfterLoadDFMValues;
    WebDBCheckBox5.AfterLoadDFMValues;
    WebPageControl1.AfterLoadDFMValues;
    wpcsSageLinkInformation1.AfterLoadDFMValues;
    WebPanel12.AfterLoadDFMValues;
    WebLabel31.AfterLoadDFMValues;
    WebDBCheckBox6.AfterLoadDFMValues;
    WebDBEdit39.AfterLoadDFMValues;
    WebDBEdit40.AfterLoadDFMValues;
    wpcsSageLinkInformation2.AfterLoadDFMValues;
    WebPanel13.AfterLoadDFMValues;
    WebLabel32.AfterLoadDFMValues;
    WebDBCheckBox7.AfterLoadDFMValues;
    WebDBEdit41.AfterLoadDFMValues;
    WebDBEdit42.AfterLoadDFMValues;
    WebDBEdit44.AfterLoadDFMValues;
    WebButton18.AfterLoadDFMValues;
    WebDBEdit46.AfterLoadDFMValues;
    WebButton20.AfterLoadDFMValues;
    WebDBRadioGroup2.AfterLoadDFMValues;
    WebDBEdit47.AfterLoadDFMValues;
    WebGroupBox6.AfterLoadDFMValues;
    WebDBCheckBox8.AfterLoadDFMValues;
    WebDBCheckBox9.AfterLoadDFMValues;
    WebDBCheckBox10.AfterLoadDFMValues;
    WebDBCheckBox11.AfterLoadDFMValues;
    WebDBCheckBox12.AfterLoadDFMValues;
    edtInvoiceSelection.AfterLoadDFMValues;
    WebDBEdit49.AfterLoadDFMValues;
    WebDBEdit50.AfterLoadDFMValues;
    WebButton21.AfterLoadDFMValues;
    WebButton22.AfterLoadDFMValues;
    WebButton23.AfterLoadDFMValues;
    WebGroupBox7.AfterLoadDFMValues;
    WebLabel38.AfterLoadDFMValues;
    WebLabel39.AfterLoadDFMValues;
    WebLabel40.AfterLoadDFMValues;
    WebDBEdit51.AfterLoadDFMValues;
    WebDBEdit52.AfterLoadDFMValues;
    WebDBEdit53.AfterLoadDFMValues;
    WebButton24.AfterLoadDFMValues;
    WebButton25.AfterLoadDFMValues;
    WebButton26.AfterLoadDFMValues;
    WebPanel10.AfterLoadDFMValues;
    WebButton54.AfterLoadDFMValues;
    btnSaveContract3.AfterLoadDFMValues;
    WebButton56.AfterLoadDFMValues;
    WebDBComboBox1.AfterLoadDFMValues;
    WebDBComboBox2.AfterLoadDFMValues;
    cbbInvoiceSelection.AfterLoadDFMValues;
    wpcsContractPricing.AfterLoadDFMValues;
    WebPanel14.AfterLoadDFMValues;
    WebPanel15.AfterLoadDFMValues;
    WebButton27.AfterLoadDFMValues;
    WebButton29.AfterLoadDFMValues;
    WebButton31.AfterLoadDFMValues;
    WebButton32.AfterLoadDFMValues;
    dgContractPrices.AfterLoadDFMValues;
    dgdbaContractPrices.AfterLoadDFMValues;
    msgdlgContractPriceList.AfterLoadDFMValues;
    WebPanel27.AfterLoadDFMValues;
    WebButton51.AfterLoadDFMValues;
    btnSaveContract4.AfterLoadDFMValues;
    WebButton53.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    edtContractPriceListPC.AfterLoadDFMValues;
    wpcsDirections.AfterLoadDFMValues;
    WebPanel16.AfterLoadDFMValues;
    WebDBMemo1.AfterLoadDFMValues;
    WebPanel26.AfterLoadDFMValues;
    WebButton48.AfterLoadDFMValues;
    btnSaveContract5.AfterLoadDFMValues;
    WebButton50.AfterLoadDFMValues;
    wpcsAllActiveContracts.AfterLoadDFMValues;
    WebPanel25.AfterLoadDFMValues;
    WebPanel30.AfterLoadDFMValues;
    WebLabel55.AfterLoadDFMValues;
    WebLabel57.AfterLoadDFMValues;
    WebButton63.AfterLoadDFMValues;
    WebButton65.AfterLoadDFMValues;
    btnCloseContract.AfterLoadDFMValues;
    WebButton67.AfterLoadDFMValues;
    edtSearchDescription.AfterLoadDFMValues;
    WebButton68.AfterLoadDFMValues;
    edtSearchActiveContracts.AfterLoadDFMValues;
    dgActiveContractsList.AfterLoadDFMValues;
    dgdbaActiveContractsList.AfterLoadDFMValues;
    WebPanel31.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    edtActiveContractsPageCount.AfterLoadDFMValues;
    wpcsClosedContracts.AfterLoadDFMValues;
    WebPanel5.AfterLoadDFMValues;
    WebPanel17.AfterLoadDFMValues;
    WebLabel41.AfterLoadDFMValues;
    WebLabel42.AfterLoadDFMValues;
    btnOpenContract.AfterLoadDFMValues;
    WebButton36.AfterLoadDFMValues;
    edtSearchContractDescription.AfterLoadDFMValues;
    edtSearchClosedContracts.AfterLoadDFMValues;
    dgClosedContracts.AfterLoadDFMValues;
    dgdbaClosedContracts.AfterLoadDFMValues;
    WebPanel32.AfterLoadDFMValues;
    edtClosedContractsPC.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebSpeedButton11.AfterLoadDFMValues;
    WebSpeedButton12.AfterLoadDFMValues;
    wpcsContractInportSetup.AfterLoadDFMValues;
    WebPanel6.AfterLoadDFMValues;
    WebPanel18.AfterLoadDFMValues;
    WebLabel43.AfterLoadDFMValues;
    edtActiveContractsImportSearch.AfterLoadDFMValues;
    WebButton17.AfterLoadDFMValues;
    WebRadioGroup3.AfterLoadDFMValues;
    WebButton19.AfterLoadDFMValues;
    WebButton28.AfterLoadDFMValues;
    WebPanel19.AfterLoadDFMValues;
    dgContractImportsetup.AfterLoadDFMValues;
    dgdbaContractImportSetup.AfterLoadDFMValues;
    wpcsGlobalPriceIncrease.AfterLoadDFMValues;
    WebPanel7.AfterLoadDFMValues;
    WebPanel21.AfterLoadDFMValues;
    WebGroupBox11.AfterLoadDFMValues;
    WebDBEdit65.AfterLoadDFMValues;
    WebButton42.AfterLoadDFMValues;
    WebGroupBox12.AfterLoadDFMValues;
    WebRadioGroup1.AfterLoadDFMValues;
    WebPanel22.AfterLoadDFMValues;
    WebRadioGroup2.AfterLoadDFMValues;
    WebPanel23.AfterLoadDFMValues;
    WebButton43.AfterLoadDFMValues;
    WebButton44.AfterLoadDFMValues;
    WebButton45.AfterLoadDFMValues;
    WebButton46.AfterLoadDFMValues;
    WebButton47.AfterLoadDFMValues;
    WebDateTimePicker1.AfterLoadDFMValues;
    TMSFNCDataGrid4.AfterLoadDFMValues;
    WebPanel24.AfterLoadDFMValues;
    WebLabel54.AfterLoadDFMValues;
    WebLabel56.AfterLoadDFMValues;
    WebLabel58.AfterLoadDFMValues;
    WebLabel60.AfterLoadDFMValues;
    WebLabel62.AfterLoadDFMValues;
    WebLabel64.AfterLoadDFMValues;
    WebLabel66.AfterLoadDFMValues;
    WebLabel68.AfterLoadDFMValues;
    WebDBLabel4.AfterLoadDFMValues;
    WebDBLabel5.AfterLoadDFMValues;
    WebDBLabel6.AfterLoadDFMValues;
    WebDBLabel7.AfterLoadDFMValues;
    WebDBLabel8.AfterLoadDFMValues;
    WebDBLabel9.AfterLoadDFMValues;
    WebDBLabel10.AfterLoadDFMValues;
    WebDBLabel11.AfterLoadDFMValues;
    wcAContracts.AfterLoadDFMValues;
    wdsAContracts.AfterLoadDFMValues;
    wdsAContractsCONTRACTNO.AfterLoadDFMValues;
    wdsAContractsCONTRACTNAME.AfterLoadDFMValues;
    wdsAContractsDEBCODE.AfterLoadDFMValues;
    wdsAContractsCOMMODITIESNO.AfterLoadDFMValues;
    wdsAContractsLOADCOUNTRYNO.AfterLoadDFMValues;
    wdsAContractsLOADPROVINCENO.AfterLoadDFMValues;
    wdsAContractsLOADCITYNO.AfterLoadDFMValues;
    wdsAContractsLOADINGNO.AfterLoadDFMValues;
    wdsAContractsOFFLOADCOUNTRYNO.AfterLoadDFMValues;
    wdsAContractsOFFLOADPROVINCENO.AfterLoadDFMValues;
    wdsAContractsOFFLOADCITYNO.AfterLoadDFMValues;
    wdsAContractsOFFLOADINGNO.AfterLoadDFMValues;
    wdsAContractsINVLOADING.AfterLoadDFMValues;
    wdsAContractsINVOFFLOADING.AfterLoadDFMValues;
    wdsAContractsTOTALTONS.AfterLoadDFMValues;
    wdsAContractsTOTALTONSORDER.AfterLoadDFMValues;
    wdsAContractsTOTALTONSLOADED.AfterLoadDFMValues;
    wdsAContractsTOTALTONSOFFLOADED.AfterLoadDFMValues;
    wdsAContractsTOTALTONSINVOICED.AfterLoadDFMValues;
    wdsAContractsCOMPLETED.AfterLoadDFMValues;
    wdsAContractsCONTROLLER.AfterLoadDFMValues;
    wdsAContractsAVGTONS.AfterLoadDFMValues;
    wdsAContractsTOTALLOADS.AfterLoadDFMValues;
    wdsAContractsLOADSORDER.AfterLoadDFMValues;
    wdsAContractsLOADSLOADED.AfterLoadDFMValues;
    wdsAContractsLOADSOFFLOADED.AfterLoadDFMValues;
    wdsAContractsLOADSINVOICED.AfterLoadDFMValues;
    wdsAContractsPAYMENTTERMS.AfterLoadDFMValues;
    wdsAContractsPAYMENTTYPE.AfterLoadDFMValues;
    wdsAContractsADDHOC.AfterLoadDFMValues;
    wdsAContractsDEDICATED.AfterLoadDFMValues;
    wdsAContractsORDERNO.AfterLoadDFMValues;
    wdsAContractsINVVAT.AfterLoadDFMValues;
    wdsAContractsMULTILOADINV.AfterLoadDFMValues;
    wdsAContractsSENDED.AfterLoadDFMValues;
    wdsAContractsPRELISTING.AfterLoadDFMValues;
    wdsAContractsPOSTLISTING.AfterLoadDFMValues;
    wdsAContractsINVOICETYPE.AfterLoadDFMValues;
    wdsAContractsDISTANCE.AfterLoadDFMValues;
    wdsAContractsDRIVERRATIO.AfterLoadDFMValues;
    wdsAContractsCUTOFF1.AfterLoadDFMValues;
    wdsAContractsCUTOFFPERIOD1.AfterLoadDFMValues;
    wdsAContractsCUTOFF2.AfterLoadDFMValues;
    wdsAContractsCUTOFFPERIOD2.AfterLoadDFMValues;
    wdsAContractsSAGEINVENTORY.AfterLoadDFMValues;
    wdsAContractsSAGEGL.AfterLoadDFMValues;
    wdsAContractsSAGECODE.AfterLoadDFMValues;
    wdsAContractsSAGEEXPCODE.AfterLoadDFMValues;
    wdsAContractsSTRATERATE.AfterLoadDFMValues;
    wdsAContractsCHGOFFLOAD.AfterLoadDFMValues;
    wdsAContractsCHGPRICE.AfterLoadDFMValues;
    wdsAContractsCAPTURETONS.AfterLoadDFMValues;
    wdsAContractsINVOICETONS.AfterLoadDFMValues;
    wdsAContractsCHGSUBPRICE.AfterLoadDFMValues;
    wdsAContractsMAXLOADORDERS.AfterLoadDFMValues;
    wdsAContractsADDDESCRIPTION.AfterLoadDFMValues;
    wdsAContractsVARIANCETYPE.AfterLoadDFMValues;
    wdsAContractsVARIANCEVALUE.AfterLoadDFMValues;
    wdsAContractsPRINTLC.AfterLoadDFMValues;
    wdsAContractsPRINTDN.AfterLoadDFMValues;
    wdsAContractsPRINTTS.AfterLoadDFMValues;
    wdsAContractsDNTYPE.AfterLoadDFMValues;
    wdsAContractsTSTYPE.AfterLoadDFMValues;
    wdsAContractsSHORTDESC.AfterLoadDFMValues;
    wdsAContractsOLDLOADSCREEN.AfterLoadDFMValues;
    wdsAContractsSHOWBOOKINGS.AfterLoadDFMValues;
    wdsAContractsSHOWADDITIONAL.AfterLoadDFMValues;
    wdsAContractsPRICETYPE.AfterLoadDFMValues;
    wdsAContractsUSEDOCKETINVNO.AfterLoadDFMValues;
    wdsAContractsSAGECODE2.AfterLoadDFMValues;
    wdsAContractsSAGEEXPCODE2.AfterLoadDFMValues;
    wdsAContractsSAGEINVENTORY2.AfterLoadDFMValues;
    wdsAContractsSAGEGL2.AfterLoadDFMValues;
    wdsAContractsHAULAGETYPE.AfterLoadDFMValues;
    wdsAContractsLINKZEROML.AfterLoadDFMValues;
    wdsAContractsATTACHEDEMAIL.AfterLoadDFMValues;
    wdsAContractsCLIENTLINKCONTRACT.AfterLoadDFMValues;
    wdsAContractsQUOTEREFNO.AfterLoadDFMValues;
    wdsAContractsSORTLOADDATE.AfterLoadDFMValues;
    wdsAContractsSORTOFFDATE.AfterLoadDFMValues;
    wdsAContractsSORTLOADWAY.AfterLoadDFMValues;
    wdsAContractsSORTOFFWAY.AfterLoadDFMValues;
    wdsAContractsSORTDOCKET.AfterLoadDFMValues;
    wdsAContractsSINVVAT.AfterLoadDFMValues;
    wdsAContractsLOADINSTRUCTQTY.AfterLoadDFMValues;
    wdsAContractsCHGLOAD.AfterLoadDFMValues;
    wdsAContractssoanalysiscat1.AfterLoadDFMValues;
    wdsAContractssoanalysiscat2.AfterLoadDFMValues;
    wdsAContractssoanalysiscat3.AfterLoadDFMValues;
    wdsAContractsmaxdrivetime.AfterLoadDFMValues;
    wdsAContractsmaxtrafeltime.AfterLoadDFMValues;
    wdsAContractsfirstwarning.AfterLoadDFMValues;
    wdsAContractssecondwarning.AfterLoadDFMValues;
    wdsAContractsslots.AfterLoadDFMValues;
    wdsAContractsSTARTDATE.AfterLoadDFMValues;
    wdsAContractsCOMPDATE.AfterLoadDFMValues;
    wdsAContractsSENDEDDATE.AfterLoadDFMValues;
    wdsAContractsDEB_CODE.AfterLoadDFMValues;
    wdsAContractsDEB_NAME.AfterLoadDFMValues;
    wdsAContractsSUSPENDED.AfterLoadDFMValues;
    wdsAContractsCREDITLIMIT.AfterLoadDFMValues;
    wdsAContractsORDERBALANCE.AfterLoadDFMValues;
    wdsAContractsINVOICEBALANCE.AfterLoadDFMValues;
    wdsAContractsAVAILIBLECL.AfterLoadDFMValues;
    wdsAContractsCLIENTMULTILOADINV.AfterLoadDFMValues;
    wdsAContractsMULTILOADDESC.AfterLoadDFMValues;
    wdsAContractsCLIENTINVOICETYPE.AfterLoadDFMValues;
    wdsAContractsMULTICONTRACT.AfterLoadDFMValues;
    wdsAContractsCLIENTLINKED.AfterLoadDFMValues;
    wdsAContractsCLIENTEMAIL.AfterLoadDFMValues;
    wdsAContractsLINKEDCONFIG.AfterLoadDFMValues;
    wdsAContractsACCOUNTNUMBER.AfterLoadDFMValues;
    wdsAContractsMAINBALANCE.AfterLoadDFMValues;
    wdsAContractsMAINTENANCELINKACCOUNT.AfterLoadDFMValues;
    wdsAContractsEXPORTLIST.AfterLoadDFMValues;
    wdsAContractsEXPORTLOADS.AfterLoadDFMValues;
    wdsAContractsRENAMEFIELD.AfterLoadDFMValues;
    wdsAContractsEXPORTPATH.AfterLoadDFMValues;
    wdsAContractsPREVCL.AfterLoadDFMValues;
    wdsAContractsSECUREBOOK.AfterLoadDFMValues;
    wdsAContractsQUOTESYSTEM.AfterLoadDFMValues;
    wdsAContractsQUOTETYPE.AfterLoadDFMValues;
    wdsAContractsEMAILLOADDOCS.AfterLoadDFMValues;
    wdsAContractsSTATEMENTTYPE.AfterLoadDFMValues;
    wdsAContractsSHOWRECLOADS.AfterLoadDFMValues;
    wdsAContractsLINKEDINVTYPE.AfterLoadDFMValues;
    wdsAContractsDEFINVCOMPNO.AfterLoadDFMValues;
    wdsAContractsinvoicetypenoncon.AfterLoadDFMValues;
    wdsAContractssinglenoncon.AfterLoadDFMValues;
    wdsAContractsLINKSERIAL.AfterLoadDFMValues;
    wdsAContractsLINKAPI.AfterLoadDFMValues;
    wdsAContractsserverip.AfterLoadDFMValues;
    wdsAContractsserverport.AfterLoadDFMValues;
    wdsAContractsserveruser.AfterLoadDFMValues;
    wdsAContractsserverpassword.AfterLoadDFMValues;
    wdsAContractsserveraccount.AfterLoadDFMValues;
    wdsAContractsaltserverip.AfterLoadDFMValues;
    wdsAContractsaltserverport.AfterLoadDFMValues;
    wdsAContractsaltserveruser.AfterLoadDFMValues;
    wdsAContractsaltserverpassword.AfterLoadDFMValues;
    wdsAContractsserversystem.AfterLoadDFMValues;
    wdsAContractsNo.AfterLoadDFMValues;
    wdsAContractsNAME.AfterLoadDFMValues;
    wdsAContractsITEMCODE.AfterLoadDFMValues;
    wdsAContractsSTORE.AfterLoadDFMValues;
    wdsAContractsUNITNUMBER.AfterLoadDFMValues;
    wdsAContractsDENSITY.AfterLoadDFMValues;
    wdsAContractsLoadCountryName.AfterLoadDFMValues;
    wdsAContractsLoadProvinceName.AfterLoadDFMValues;
    wdsAContractsLoadCityName.AfterLoadDFMValues;
    wdsAContractsLoadInfoName.AfterLoadDFMValues;
    wdsAContractsOffLoadCountryName.AfterLoadDFMValues;
    wdsAContractsOffLoadProvinceName.AfterLoadDFMValues;
    wdsAContractsOffLoadCityName.AfterLoadDFMValues;
    wdsAContractsOffLoadInfoName.AfterLoadDFMValues;
    wdsAContractsCommodityName.AfterLoadDFMValues;
    wdsAContractsPayTermsName.AfterLoadDFMValues;
    wdsAContractsCONTROLLERName.AfterLoadDFMValues;
    wdsAContractsCutOffPeriodDesc1.AfterLoadDFMValues;
    wdsAContractsCutOffPeriodDesc2.AfterLoadDFMValues;
    wdsAContractsCutOffPeriodDesc22.AfterLoadDFMValues;
    wdsAContractsClientName.AfterLoadDFMValues;
    dsAContracts.AfterLoadDFMValues;
    wcContractPrices.AfterLoadDFMValues;
    wdsContractPrices.AfterLoadDFMValues;
    wdsContractPricesAUTONO.AfterLoadDFMValues;
    wdsContractPricesCONTRACTNO.AfterLoadDFMValues;
    wdsContractPricesSTARTDATE.AfterLoadDFMValues;
    wdsContractPricesENDDATE.AfterLoadDFMValues;
    wdsContractPricesCOSTPRICE.AfterLoadDFMValues;
    wdsContractPricesSUBPRICE.AfterLoadDFMValues;
    wdsContractPricesDEDPRICE.AfterLoadDFMValues;
    wdsContractPricesSPEPRICE.AfterLoadDFMValues;
    wdsContractPricesCONFIREMED.AfterLoadDFMValues;
    wdsContractPricesPRICELOADDATE.AfterLoadDFMValues;
    wdsContractPricesPRICELOADBY.AfterLoadDFMValues;
    wdsContractPricesPRICECONFIRMDATE.AfterLoadDFMValues;
    wdsContractPricesPRICECONFIRMBY.AfterLoadDFMValues;
    wdsContractPriceskmsprice.AfterLoadDFMValues;
    wdsContractPricestollprice.AfterLoadDFMValues;
    dsContractPrices.AfterLoadDFMValues;
    wdsClosedContracts.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    StringField2.AfterLoadDFMValues;
    IntegerField2.AfterLoadDFMValues;
    IntegerField3.AfterLoadDFMValues;
    IntegerField4.AfterLoadDFMValues;
    IntegerField5.AfterLoadDFMValues;
    IntegerField6.AfterLoadDFMValues;
    IntegerField7.AfterLoadDFMValues;
    IntegerField8.AfterLoadDFMValues;
    IntegerField9.AfterLoadDFMValues;
    IntegerField10.AfterLoadDFMValues;
    StringField3.AfterLoadDFMValues;
    StringField4.AfterLoadDFMValues;
    FloatField1.AfterLoadDFMValues;
    FloatField2.AfterLoadDFMValues;
    FloatField3.AfterLoadDFMValues;
    FloatField4.AfterLoadDFMValues;
    FloatField5.AfterLoadDFMValues;
    StringField5.AfterLoadDFMValues;
    StringField6.AfterLoadDFMValues;
    FloatField6.AfterLoadDFMValues;
    IntegerField11.AfterLoadDFMValues;
    IntegerField12.AfterLoadDFMValues;
    IntegerField13.AfterLoadDFMValues;
    IntegerField14.AfterLoadDFMValues;
    IntegerField15.AfterLoadDFMValues;
    IntegerField16.AfterLoadDFMValues;
    IntegerField17.AfterLoadDFMValues;
    StringField7.AfterLoadDFMValues;
    StringField8.AfterLoadDFMValues;
    StringField9.AfterLoadDFMValues;
    StringField10.AfterLoadDFMValues;
    StringField11.AfterLoadDFMValues;
    StringField12.AfterLoadDFMValues;
    StringField13.AfterLoadDFMValues;
    StringField14.AfterLoadDFMValues;
    StringField15.AfterLoadDFMValues;
    FloatField7.AfterLoadDFMValues;
    SmallintField1.AfterLoadDFMValues;
    SmallintField2.AfterLoadDFMValues;
    IntegerField18.AfterLoadDFMValues;
    SmallintField3.AfterLoadDFMValues;
    IntegerField19.AfterLoadDFMValues;
    StringField16.AfterLoadDFMValues;
    StringField17.AfterLoadDFMValues;
    StringField18.AfterLoadDFMValues;
    StringField19.AfterLoadDFMValues;
    StringField20.AfterLoadDFMValues;
    StringField21.AfterLoadDFMValues;
    StringField22.AfterLoadDFMValues;
    StringField23.AfterLoadDFMValues;
    StringField24.AfterLoadDFMValues;
    StringField25.AfterLoadDFMValues;
    IntegerField20.AfterLoadDFMValues;
    StringField26.AfterLoadDFMValues;
    IntegerField21.AfterLoadDFMValues;
    FloatField8.AfterLoadDFMValues;
    StringField27.AfterLoadDFMValues;
    StringField28.AfterLoadDFMValues;
    StringField29.AfterLoadDFMValues;
    StringField30.AfterLoadDFMValues;
    StringField31.AfterLoadDFMValues;
    StringField32.AfterLoadDFMValues;
    StringField33.AfterLoadDFMValues;
    StringField34.AfterLoadDFMValues;
    StringField35.AfterLoadDFMValues;
    IntegerField22.AfterLoadDFMValues;
    StringField36.AfterLoadDFMValues;
    StringField37.AfterLoadDFMValues;
    StringField38.AfterLoadDFMValues;
    StringField39.AfterLoadDFMValues;
    StringField40.AfterLoadDFMValues;
    StringField41.AfterLoadDFMValues;
    StringField42.AfterLoadDFMValues;
    StringField43.AfterLoadDFMValues;
    IntegerField23.AfterLoadDFMValues;
    StringField44.AfterLoadDFMValues;
    StringField45.AfterLoadDFMValues;
    StringField46.AfterLoadDFMValues;
    StringField47.AfterLoadDFMValues;
    StringField48.AfterLoadDFMValues;
    StringField49.AfterLoadDFMValues;
    StringField50.AfterLoadDFMValues;
    FloatField9.AfterLoadDFMValues;
    StringField51.AfterLoadDFMValues;
    StringField52.AfterLoadDFMValues;
    StringField53.AfterLoadDFMValues;
    StringField54.AfterLoadDFMValues;
    StringField55.AfterLoadDFMValues;
    TimeField1.AfterLoadDFMValues;
    IntegerField24.AfterLoadDFMValues;
    IntegerField25.AfterLoadDFMValues;
    IntegerField26.AfterLoadDFMValues;
    DateField1.AfterLoadDFMValues;
    DateField2.AfterLoadDFMValues;
    DateField3.AfterLoadDFMValues;
    StringField56.AfterLoadDFMValues;
    StringField57.AfterLoadDFMValues;
    StringField58.AfterLoadDFMValues;
    FloatField10.AfterLoadDFMValues;
    FloatField11.AfterLoadDFMValues;
    FloatField12.AfterLoadDFMValues;
    FloatField13.AfterLoadDFMValues;
    StringField59.AfterLoadDFMValues;
    StringField60.AfterLoadDFMValues;
    StringField61.AfterLoadDFMValues;
    StringField62.AfterLoadDFMValues;
    StringField63.AfterLoadDFMValues;
    StringField64.AfterLoadDFMValues;
    StringField65.AfterLoadDFMValues;
    StringField66.AfterLoadDFMValues;
    FloatField14.AfterLoadDFMValues;
    StringField67.AfterLoadDFMValues;
    StringField68.AfterLoadDFMValues;
    StringField69.AfterLoadDFMValues;
    StringField70.AfterLoadDFMValues;
    StringField71.AfterLoadDFMValues;
    FloatField15.AfterLoadDFMValues;
    StringField72.AfterLoadDFMValues;
    StringField73.AfterLoadDFMValues;
    StringField74.AfterLoadDFMValues;
    StringField75.AfterLoadDFMValues;
    StringField76.AfterLoadDFMValues;
    StringField77.AfterLoadDFMValues;
    StringField78.AfterLoadDFMValues;
    IntegerField27.AfterLoadDFMValues;
    StringField79.AfterLoadDFMValues;
    StringField80.AfterLoadDFMValues;
    StringField81.AfterLoadDFMValues;
    StringField82.AfterLoadDFMValues;
    StringField83.AfterLoadDFMValues;
    IntegerField28.AfterLoadDFMValues;
    StringField84.AfterLoadDFMValues;
    StringField85.AfterLoadDFMValues;
    StringField86.AfterLoadDFMValues;
    StringField87.AfterLoadDFMValues;
    IntegerField29.AfterLoadDFMValues;
    StringField88.AfterLoadDFMValues;
    StringField89.AfterLoadDFMValues;
    StringField90.AfterLoadDFMValues;
    IntegerField30.AfterLoadDFMValues;
    StringField91.AfterLoadDFMValues;
    StringField92.AfterLoadDFMValues;
    IntegerField31.AfterLoadDFMValues;
    StringField93.AfterLoadDFMValues;
    FloatField16.AfterLoadDFMValues;
    wcClosedContracts.AfterLoadDFMValues;
    dsClosedContracts.AfterLoadDFMValues;
    WebRESTClient1.AfterLoadDFMValues;
    wcAContractImportSetup.AfterLoadDFMValues;
    wdsAContractImportSetup.AfterLoadDFMValues;
    IntegerField32.AfterLoadDFMValues;
    StringField94.AfterLoadDFMValues;
    StringField95.AfterLoadDFMValues;
    IntegerField33.AfterLoadDFMValues;
    IntegerField34.AfterLoadDFMValues;
    IntegerField35.AfterLoadDFMValues;
    IntegerField36.AfterLoadDFMValues;
    IntegerField37.AfterLoadDFMValues;
    IntegerField38.AfterLoadDFMValues;
    IntegerField39.AfterLoadDFMValues;
    IntegerField40.AfterLoadDFMValues;
    IntegerField41.AfterLoadDFMValues;
    StringField96.AfterLoadDFMValues;
    StringField97.AfterLoadDFMValues;
    FloatField17.AfterLoadDFMValues;
    FloatField18.AfterLoadDFMValues;
    FloatField19.AfterLoadDFMValues;
    FloatField20.AfterLoadDFMValues;
    FloatField21.AfterLoadDFMValues;
    StringField98.AfterLoadDFMValues;
    StringField99.AfterLoadDFMValues;
    FloatField22.AfterLoadDFMValues;
    IntegerField42.AfterLoadDFMValues;
    IntegerField43.AfterLoadDFMValues;
    IntegerField44.AfterLoadDFMValues;
    IntegerField45.AfterLoadDFMValues;
    IntegerField46.AfterLoadDFMValues;
    IntegerField47.AfterLoadDFMValues;
    IntegerField48.AfterLoadDFMValues;
    StringField100.AfterLoadDFMValues;
    StringField101.AfterLoadDFMValues;
    StringField102.AfterLoadDFMValues;
    StringField103.AfterLoadDFMValues;
    StringField104.AfterLoadDFMValues;
    StringField105.AfterLoadDFMValues;
    StringField106.AfterLoadDFMValues;
    StringField107.AfterLoadDFMValues;
    StringField108.AfterLoadDFMValues;
    FloatField23.AfterLoadDFMValues;
    SmallintField4.AfterLoadDFMValues;
    SmallintField5.AfterLoadDFMValues;
    IntegerField49.AfterLoadDFMValues;
    SmallintField6.AfterLoadDFMValues;
    IntegerField50.AfterLoadDFMValues;
    StringField109.AfterLoadDFMValues;
    StringField110.AfterLoadDFMValues;
    StringField111.AfterLoadDFMValues;
    StringField112.AfterLoadDFMValues;
    StringField113.AfterLoadDFMValues;
    StringField114.AfterLoadDFMValues;
    StringField115.AfterLoadDFMValues;
    StringField116.AfterLoadDFMValues;
    StringField117.AfterLoadDFMValues;
    StringField118.AfterLoadDFMValues;
    IntegerField51.AfterLoadDFMValues;
    StringField119.AfterLoadDFMValues;
    IntegerField52.AfterLoadDFMValues;
    FloatField24.AfterLoadDFMValues;
    StringField120.AfterLoadDFMValues;
    StringField121.AfterLoadDFMValues;
    StringField122.AfterLoadDFMValues;
    StringField123.AfterLoadDFMValues;
    StringField124.AfterLoadDFMValues;
    StringField125.AfterLoadDFMValues;
    StringField126.AfterLoadDFMValues;
    StringField127.AfterLoadDFMValues;
    StringField128.AfterLoadDFMValues;
    IntegerField53.AfterLoadDFMValues;
    StringField129.AfterLoadDFMValues;
    StringField130.AfterLoadDFMValues;
    StringField131.AfterLoadDFMValues;
    StringField132.AfterLoadDFMValues;
    StringField133.AfterLoadDFMValues;
    StringField134.AfterLoadDFMValues;
    StringField135.AfterLoadDFMValues;
    StringField136.AfterLoadDFMValues;
    IntegerField54.AfterLoadDFMValues;
    StringField137.AfterLoadDFMValues;
    StringField138.AfterLoadDFMValues;
    StringField139.AfterLoadDFMValues;
    StringField140.AfterLoadDFMValues;
    StringField141.AfterLoadDFMValues;
    StringField142.AfterLoadDFMValues;
    StringField143.AfterLoadDFMValues;
    FloatField25.AfterLoadDFMValues;
    StringField144.AfterLoadDFMValues;
    StringField145.AfterLoadDFMValues;
    StringField146.AfterLoadDFMValues;
    StringField147.AfterLoadDFMValues;
    StringField148.AfterLoadDFMValues;
    TimeField2.AfterLoadDFMValues;
    IntegerField55.AfterLoadDFMValues;
    IntegerField56.AfterLoadDFMValues;
    IntegerField57.AfterLoadDFMValues;
    DateField4.AfterLoadDFMValues;
    DateField5.AfterLoadDFMValues;
    DateField6.AfterLoadDFMValues;
    StringField149.AfterLoadDFMValues;
    StringField150.AfterLoadDFMValues;
    StringField151.AfterLoadDFMValues;
    FloatField26.AfterLoadDFMValues;
    FloatField27.AfterLoadDFMValues;
    FloatField28.AfterLoadDFMValues;
    FloatField29.AfterLoadDFMValues;
    StringField152.AfterLoadDFMValues;
    StringField153.AfterLoadDFMValues;
    StringField154.AfterLoadDFMValues;
    StringField155.AfterLoadDFMValues;
    StringField156.AfterLoadDFMValues;
    StringField157.AfterLoadDFMValues;
    StringField158.AfterLoadDFMValues;
    StringField159.AfterLoadDFMValues;
    FloatField30.AfterLoadDFMValues;
    StringField160.AfterLoadDFMValues;
    StringField161.AfterLoadDFMValues;
    StringField162.AfterLoadDFMValues;
    StringField163.AfterLoadDFMValues;
    StringField164.AfterLoadDFMValues;
    FloatField31.AfterLoadDFMValues;
    StringField165.AfterLoadDFMValues;
    StringField166.AfterLoadDFMValues;
    StringField167.AfterLoadDFMValues;
    StringField168.AfterLoadDFMValues;
    StringField169.AfterLoadDFMValues;
    StringField170.AfterLoadDFMValues;
    StringField171.AfterLoadDFMValues;
    IntegerField58.AfterLoadDFMValues;
    StringField172.AfterLoadDFMValues;
    StringField173.AfterLoadDFMValues;
    StringField174.AfterLoadDFMValues;
    StringField175.AfterLoadDFMValues;
    StringField176.AfterLoadDFMValues;
    IntegerField59.AfterLoadDFMValues;
    StringField177.AfterLoadDFMValues;
    StringField178.AfterLoadDFMValues;
    StringField179.AfterLoadDFMValues;
    StringField180.AfterLoadDFMValues;
    IntegerField60.AfterLoadDFMValues;
    StringField181.AfterLoadDFMValues;
    StringField182.AfterLoadDFMValues;
    StringField183.AfterLoadDFMValues;
    IntegerField61.AfterLoadDFMValues;
    StringField184.AfterLoadDFMValues;
    StringField185.AfterLoadDFMValues;
    IntegerField62.AfterLoadDFMValues;
    StringField186.AfterLoadDFMValues;
    FloatField32.AfterLoadDFMValues;
    StringField187.AfterLoadDFMValues;
    StringField188.AfterLoadDFMValues;
    StringField189.AfterLoadDFMValues;
    StringField190.AfterLoadDFMValues;
    StringField191.AfterLoadDFMValues;
    StringField192.AfterLoadDFMValues;
    StringField193.AfterLoadDFMValues;
    StringField194.AfterLoadDFMValues;
    StringField195.AfterLoadDFMValues;
    StringField196.AfterLoadDFMValues;
    StringField197.AfterLoadDFMValues;
    StringField198.AfterLoadDFMValues;
    IntegerField63.AfterLoadDFMValues;
    StringField199.AfterLoadDFMValues;
    dsAContractImportSetup.AfterLoadDFMValues;
  end;
end;

end.
